import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AllowedBankType: { input: any; output: any; }
  JSON: { input: any; output: any; }
  StringifiedNumber: { input: any; output: any; }
};

export type AmlRisFilterInput = {
  category?: InputMaybe<Array<InputMaybe<AmlRiskCategory>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  highRiskReason?: InputMaybe<Array<InputMaybe<AmlRiskReason>>>;
  renewalDate?: InputMaybe<StringRangeInput>;
  renewalDateReason?: InputMaybe<Scalars['String']['input']>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type AmlRisk = {
  __typename?: 'AMLRisk';
  category?: Maybe<AmlRiskCategory>;
  description?: Maybe<Scalars['String']['output']>;
  highRiskReason?: Maybe<AmlRiskReason>;
  renewalDate?: Maybe<Scalars['String']['output']>;
  renewalDateReason?: Maybe<Scalars['String']['output']>;
  totalScore?: Maybe<Scalars['String']['output']>;
};

export enum AmlRiskCategory {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Unacceptable = 'UNACCEPTABLE'
}

export type AmlRiskInput = {
  category?: InputMaybe<AmlRiskCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  highRiskReason?: InputMaybe<AmlRiskReason>;
  renewalDate?: InputMaybe<Scalars['String']['input']>;
  renewalDateReason?: InputMaybe<Scalars['String']['input']>;
  totalScore?: InputMaybe<Scalars['String']['input']>;
};

export enum AmlRiskReason {
  ComplexOwnershipStructure = 'COMPLEX_OWNERSHIP_STRUCTURE',
  DecisionToClassifyAsHr = 'DECISION_TO_CLASSIFY_AS_HR',
  FraudAlerts = 'FRAUD_ALERTS',
  HighBrandRiskMerchants = 'HIGH_BRAND_RISK_MERCHANTS',
  HighValueProcessing = 'HIGH_VALUE_PROCESSING',
  InvestmentFundsAndFinancialServices = 'INVESTMENT_FUNDS_AND_FINANCIAL_SERVICES',
  LinksToHrThirdCountries = 'LINKS_TO_HR_THIRD_COUNTRIES',
  None = 'NONE',
  Other = 'OTHER',
  Pep = 'PEP',
  RegulatoryEnforcement = 'REGULATORY_ENFORCEMENT',
  RestrictedIndustry = 'RESTRICTED_INDUSTRY',
  SarCompleted = 'SAR_COMPLETED'
}

export type ApmConfigurationObject = {
  __typename?: 'APMConfigurationObject';
  callGateway?: Maybe<Scalars['Boolean']['output']>;
  callInitializeOnStoredPm?: Maybe<Scalars['Boolean']['output']>;
  color: Scalars['String']['output'];
  dashboardConfiguration?: Maybe<DashboardConfigurationTypeObject>;
  fields: Array<CustomFieldsTypeObject>;
  footer?: Maybe<FrontendContentTypeObject>;
  gridIcon?: Maybe<Scalars['String']['output']>;
  gridSelectedBackgroundColor?: Maybe<Scalars['String']['output']>;
  header?: Maybe<FrontendContentTypeObject>;
  icon: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paymentMethodType: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  redirect?: Maybe<Scalars['Boolean']['output']>;
  type: ApmConfigurationType;
};

export type ApmConfigurationQueryResponse = {
  __typename?: 'APMConfigurationQueryResponse';
  apmConfigurations: Array<ApmConfigurationObject>;
};

export enum ApmConfigurationType {
  Custom = 'CUSTOM',
  Form = 'FORM'
}

export type AbandonBreakdownByLastVisitedStep = {
  __typename?: 'AbandonBreakdownByLastVisitedStep';
  abandonRate: Scalars['Float']['output'];
  step: Scalars['String']['output'];
};

export type AcceptDisputeResponse = {
  __typename?: 'AcceptDisputeResponse';
  disputeId: Scalars['String']['output'];
  status: DisputeStatus;
};

export enum AccountType {
  Checking = 'checking',
  Deposit = 'deposit',
  GeneralLedger = 'general_ledger',
  Loan = 'loan',
  Savings = 'savings',
  Trust = 'trust'
}

export enum AchPaymentTypeEnum {
  NextDay = 'next_day',
  Rtp = 'rtp',
  SameDay = 'same_day'
}

export type AcquirerContactInfo = {
  __typename?: 'AcquirerContactInfo';
  bankName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export enum AcquiringProvider {
  Crb = 'crb',
  Paycomcy = 'paycomcy'
}

export enum AcquiringService {
  Acquirer = 'acquirer',
  Gateway = 'gateway',
  Payfac = 'payfac'
}

export type ActionInputObject = {
  basisPoints?: InputMaybe<Scalars['String']['input']>;
  fixedFee?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
};

export type ActionObject = {
  __typename?: 'ActionObject';
  basisPoints?: Maybe<Scalars['String']['output']>;
  fixedFee?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
};

export type AddCrmFieldValues = {
  companyId: Scalars['ID']['input'];
  merchantId: Scalars['ID']['input'];
  values?: InputMaybe<Array<CrmFieldValue>>;
};

export type AddCrmFieldValuesResponse = {
  __typename?: 'AddCrmFieldValuesResponse';
  merchantId: Scalars['ID']['output'];
};

export type AddEvidenceMutationInput = {
  disputeId: Scalars['String']['input'];
  files: Array<Scalars['String']['input']>;
  receivedOn: Scalars['String']['input'];
  text: Scalars['String']['input'];
  type: EvidenceType;
};

export type AddEvidenceMutationPayload = {
  __typename?: 'AddEvidenceMutationPayload';
  disputeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  merchantId: Scalars['String']['output'];
};

export type AddEvidenceMutationResponse = {
  __typename?: 'AddEvidenceMutationResponse';
  payload: AddEvidenceMutationPayload;
  success: Scalars['Boolean']['output'];
};

export type AddRiskListValuesMutationInput = {
  listId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  value: Array<Scalars['ID']['input']>;
};

export type AddTaskNote = {
  note: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
};

export type AddToListMutationInput = {
  alias: ListAlias;
  itemId: Scalars['String']['input'];
};

export type AddVerificationCheckCommentInput = {
  addedAt?: InputMaybe<Scalars['String']['input']>;
  addedBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verificationCheckId?: InputMaybe<Scalars['String']['input']>;
};

export type Address = {
  __typename?: 'Address';
  addressLine?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  countryAlpha2?: Maybe<CountryAlpha2>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  addressLine?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryAlpha2?: InputMaybe<CountryAlpha2>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressListInput = {
  addressLine?: InputMaybe<Array<Scalars['String']['input']>>;
  addressLine2?: InputMaybe<Array<Scalars['String']['input']>>;
  city?: InputMaybe<Array<Scalars['String']['input']>>;
  countryAlpha2?: InputMaybe<Array<CountryAlpha2>>;
  state?: InputMaybe<Array<Scalars['String']['input']>>;
  zip?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AddressMatchFormat = {
  __typename?: 'AddressMatchFormat';
  addressLineOne?: Maybe<Scalars['String']['output']>;
  addressLineTwo?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countrySubdivision?: Maybe<Scalars['String']['output']>;
  isOtherCity?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
};

export type AddressObject = {
  __typename?: 'AddressObject';
  address: Address;
  id: Scalars['ID']['output'];
};

export type AdjustmentBreakdown = {
  __typename?: 'AdjustmentBreakdown';
  amount: Scalars['Float']['output'];
  currency: CurrencyAlpha3;
  description?: Maybe<Scalars['String']['output']>;
  identifier: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  total: Scalars['Float']['output'];
};

export type AdjustmentBreakdownInputFilter = {
  and?: InputMaybe<Array<AdjustmentBreakdownInputFilter>>;
  between?: InputMaybe<AdjustmentBreakdownQueryRangeFilterInputValues>;
  equal?: InputMaybe<AdjustmentBreakdownQueryExactFilterInputValues>;
  greater?: InputMaybe<AdjustmentBreakdownQueryExactFilterInputValues>;
  greaterOrEquals?: InputMaybe<AdjustmentBreakdownQueryExactFilterInputValues>;
  iLike?: InputMaybe<AdjustmentBreakdownQueryExactFilterInputValues>;
  in?: InputMaybe<AdjustmentBreakdownQueryInFilterInputValues>;
  less?: InputMaybe<AdjustmentBreakdownQueryExactFilterInputValues>;
  lessOrEquals?: InputMaybe<AdjustmentBreakdownQueryExactFilterInputValues>;
  like?: InputMaybe<AdjustmentBreakdownQueryExactFilterInputValues>;
  notBetween?: InputMaybe<AdjustmentBreakdownQueryRangeFilterInputValues>;
  notEqual?: InputMaybe<AdjustmentBreakdownQueryExactFilterInputValues>;
  notIn?: InputMaybe<AdjustmentBreakdownQueryInFilterInputValues>;
  notLike?: InputMaybe<AdjustmentBreakdownQueryExactFilterInputValues>;
  or?: InputMaybe<Array<AdjustmentBreakdownInputFilter>>;
  textSearchCaseInsensitive?: InputMaybe<AdjustmentBreakdownQueryExactFilterInputValues>;
};

export type AdjustmentBreakdownQueryExactFilterInputValues = {
  currency?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  settlementId?: InputMaybe<Scalars['String']['input']>;
};

export type AdjustmentBreakdownQueryInFilterInputValues = {
  currency?: InputMaybe<Array<InputMaybe<CurrencyAlpha3>>>;
};

export type AdjustmentBreakdownQueryInput = {
  filter?: InputMaybe<AdjustmentBreakdownInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type AdjustmentBreakdownQueryRangeFilterInputValues = {
  amount?: InputMaybe<IntRangeInput>;
  createdAt?: InputMaybe<StringRangeInput>;
  total?: InputMaybe<IntRangeInput>;
};

export type AdjustmentBreakdownQueryResponse = {
  __typename?: 'AdjustmentBreakdownQueryResponse';
  adjustmentBreakdown?: Maybe<Array<AdjustmentBreakdown>>;
  pageInfo: PageInfo;
};

export type AllEmployeesEntity = {
  __typename?: 'AllEmployeesEntity';
  id: Scalars['String']['output'];
  primaryEmail: Scalars['String']['output'];
};

export type AllEmployeesResponse = {
  __typename?: 'AllEmployeesResponse';
  employees?: Maybe<Array<AllEmployeesEntity>>;
};

export type AlternativeCurrencies = {
  __typename?: 'AlternativeCurrencies';
  actions?: Maybe<Array<ActionObject>>;
  key: Scalars['String']['output'];
};

export type AlternativeCurrenciesInput = {
  actions?: InputMaybe<Array<ActionInputObject>>;
  key: Scalars['String']['input'];
};

export type AmountLimitsInput = {
  max?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
};

export enum AmountTypeEnum {
  Dynamic = 'dynamic',
  Fixed = 'fixed'
}

export type ApiKeyEndpointPermission = {
  __typename?: 'ApiKeyEndpointPermission';
  key: Scalars['String']['output'];
  value: EndpointPermission;
};

export type ApiKeyEndpointPermissionInput = {
  key: Scalars['String']['input'];
  value: EndpointPermission;
};

export type ApiKeyObject = {
  __typename?: 'ApiKeyObject';
  allowedEndpoints?: Maybe<Array<ApiKeyEndpointPermission>>;
  companyId?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ipRanges?: Maybe<Array<Scalars['String']['output']>>;
  lastSixDigits?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pciCompliant?: Maybe<Scalars['Boolean']['output']>;
};

export type ApiKeyResponse = {
  __typename?: 'ApiKeyResponse';
  apiKey?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ApiKeysQueryResponse = {
  __typename?: 'ApiKeysQueryResponse';
  apiKeys?: Maybe<Array<Maybe<ApiKeyObject>>>;
};

export type ApplePayDomainError = {
  __typename?: 'ApplePayDomainError';
  domain: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['String']['output']>;
};

export type ApplePayDomainSuccess = {
  __typename?: 'ApplePayDomainSuccess';
  success: Scalars['Boolean']['output'];
};

export type ApplepayCollectionShippingAddress = {
  __typename?: 'ApplepayCollectionShippingAddress';
  enabled: Scalars['Boolean']['output'];
  includePhoneNumber: Scalars['Boolean']['output'];
};

export type ApplepayPaymentMethodOptions = {
  __typename?: 'ApplepayPaymentMethodOptions';
  collection?: Maybe<ApplepayPaymentMethodOptionsCollection>;
};

export type ApplepayPaymentMethodOptionsCollection = {
  __typename?: 'ApplepayPaymentMethodOptionsCollection';
  billingAddress?: Maybe<PaymentMethodOptionsCollectionItem>;
  email?: Maybe<PaymentMethodOptionsCollectionItem>;
  name?: Maybe<PaymentMethodOptionsCollectionItem>;
  phoneNumber?: Maybe<PaymentMethodOptionsCollectionItem>;
  shippingAddress?: Maybe<ApplepayCollectionShippingAddress>;
};

export type AssessmentFormInputObject = {
  companyId: Scalars['ID']['input'];
  merchantId: Scalars['ID']['input'];
  saveAsDraft: Scalars['Boolean']['input'];
};

export type AssessmentFormResponse = {
  __typename?: 'AssessmentFormResponse';
  documentFilename: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  documentUrl: Scalars['String']['output'];
};

export type AssignTask = {
  assignee?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export enum AuditsSystem {
  Api = 'API',
  Backoffice = 'BACKOFFICE',
  Crm = 'CRM',
  Onboarding = 'ONBOARDING',
  Portal = 'PORTAL'
}

export type AuthenticateWithVerificationCodeInput = {
  code: Scalars['String']['input'];
  shouldStayLoggedIn: Scalars['Boolean']['input'];
};

export type AuthenticateWithVerificationCodePayload = {
  __typename?: 'AuthenticateWithVerificationCodePayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum BackofficePermissions {
  AddDisputeEvidence = 'add_dispute_evidence',
  AddRiskListValues = 'add_risk_list_values',
  BlockCard = 'block_card',
  CreateAutomaticVerificationCheck = 'create_automatic_verification_check',
  CreateBankAccount = 'create_bank_account',
  CreateCommission = 'create_commission',
  CreateCost = 'create_cost',
  CreateCrmField = 'create_crm_field',
  CreateDashboard = 'create_dashboard',
  CreateDocumentNote = 'create_document_note',
  CreateDocumentType = 'create_document_type',
  CreateEntityMcc = 'create_entity_mcc',
  CreateEntityTasksFromGroupTemplates = 'create_entity_tasks_from_group_templates',
  CreateEntityWebsiteNote = 'create_entity_website_note',
  CreateExportField = 'create_export_field',
  CreateFailureCodeMessage = 'create_failure_code_message',
  CreateFeatureFlag = 'create_feature_flag',
  CreateFinance = 'create_finance',
  CreateIndividual = 'create_individual',
  CreateIndividualNote = 'create_individual_note',
  CreateIssuerResponseCode = 'create_issuer_response_code',
  CreateLogicField = 'create_logic_field',
  CreateMerchantApplicationNote = 'create_merchant_application_note',
  CreateMerchantSettings = 'create_merchant_settings',
  CreateOnboardingPricing = 'create_onboarding_pricing',
  CreateOnboardingPricingField = 'create_onboarding_pricing_field',
  CreateOnboardingRiskRule = 'create_onboarding_risk_rule',
  CreatePricing = 'create_pricing',
  CreatePricingAction = 'create_pricing_action',
  CreateProviderFeatures = 'create_provider_features',
  CreateProvisioningTemplate = 'create_provisioning_template',
  CreateReconciliationConfig = 'create_reconciliation_config',
  CreateReferral = 'create_referral',
  CreateReportsConfig = 'create_reports_config',
  CreateRiskCalculation = 'create_risk_calculation',
  CreateRiskList = 'create_risk_list',
  CreateRiskReviewNote = 'create_risk_review_note',
  CreateRiskRule = 'create_risk_rule',
  CreateRiskRuleNote = 'create_risk_rule_note',
  CreateRoutineTemplate = 'create_routine_template',
  CreateSandboxMerchant = 'create_sandbox_merchant',
  CreateSettlementAccount = 'create_settlement_account',
  CreateSnowflakeIds = 'create_snowflake_ids',
  CreateStructure = 'create_structure',
  CreateTask = 'create_task',
  CreateTaskTemplate = 'create_task_template',
  CreateTransactionNote = 'create_transaction_note',
  CreateVerificationCheck = 'create_verification_check',
  CreateWebsite = 'create_website',
  DeleteDashboard = 'delete_dashboard',
  DeleteLogicField = 'delete_logic_field',
  DeleteRiskListValue = 'delete_risk_list_value',
  DeleteTaskTemplate = 'delete_task_template',
  FinalizeSignUpMerchant = 'finalize_sign_up_merchant',
  GenerateAssessmentForm = 'generate_assessment_form',
  GenerateOnboardingMpaDocument = 'generate_onboarding_mpa_document',
  GetAllDashboards = 'get_all_dashboards',
  GetAllDocumentTypes = 'get_all_document_types',
  GetAllFailureCodeMessages = 'get_all_failure_code_messages',
  GetAllIssuerResponseCodes = 'get_all_issuer_response_codes',
  GetAllLegalEntityDocuments = 'get_all_legal_entity_documents',
  GetAllOnboardingPricingFields = 'get_all_onboarding_pricing_fields',
  GetAllProvisioningTemplates = 'get_all_provisioning_templates',
  GetAssessmentForm = 'get_assessment_form',
  GetAudits = 'get_audits',
  GetBankAccounts = 'get_bank_accounts',
  GetChargebackReason = 'get_chargeback_reason',
  GetChargebackReasons = 'get_chargeback_reasons',
  GetCollaborations = 'get_collaborations',
  GetCommissions = 'get_commissions',
  GetCost = 'get_cost',
  GetCosts = 'get_costs',
  GetCountry = 'get_country',
  GetCrmFieldsDefinitions = 'get_crm_fields_definitions',
  GetCsvReport = 'get_csv_report',
  GetDashboardFeatureFlags = 'get_dashboard_feature_flags',
  GetDispute = 'get_dispute',
  GetDisputes = 'get_disputes',
  GetDisputesByMerchants = 'get_disputes_by_merchants',
  GetDisputesOverview = 'get_disputes_overview',
  GetDisputesTasks = 'get_disputes_tasks',
  GetDocumentNotes = 'get_document_notes',
  GetDocumentUploadToken = 'get_document_upload_token',
  GetDocuments = 'get_documents',
  GetEmployeeGroups = 'get_employee_groups',
  GetEntityMccs = 'get_entity_mccs',
  GetEntityWebsiteNotes = 'get_entity_website_notes',
  GetEntityWebsites = 'get_entity_websites',
  GetExportFields = 'get_export_fields',
  GetFailureCodeMessages = 'get_failure_code_messages',
  GetFinance = 'get_finance',
  GetIndividual = 'get_individual',
  GetIndividualNotes = 'get_individual_notes',
  GetIndividuals = 'get_individuals',
  GetLogicFields = 'get_logic_fields',
  GetLogs = 'get_logs',
  GetMcc = 'get_mcc',
  GetMerchant = 'get_merchant',
  GetMerchantApplication = 'get_merchant_application',
  GetMerchantApplicationNotes = 'get_merchant_application_notes',
  GetMerchantApprovals = 'get_merchant_approvals',
  GetMerchantConnections = 'get_merchant_connections',
  GetMerchantLogicFields = 'get_merchant_logic_fields',
  GetMerchantPaymentMethodConfigs = 'get_merchant_payment_method_configs',
  GetMerchantPaymentMethodConfigsPreview = 'get_merchant_payment_method_configs_preview',
  GetMerchantPricingConfigs = 'get_merchant_pricing_configs',
  GetMerchantSettings = 'get_merchant_settings',
  GetMerchants = 'get_merchants',
  GetMerchantsPreview = 'get_merchants_preview',
  GetMerchantsTasks = 'get_merchants_tasks',
  GetMerchantsUnderRule = 'get_merchants_under_rule',
  GetOnboardingEvents = 'get_onboarding_events',
  GetOnboardingPricing = 'get_onboarding_pricing',
  GetOnboardingPricingFields = 'get_onboarding_pricing_fields',
  GetOnboardingPricingList = 'get_onboarding_pricing_list',
  GetOnboardingRiskRule = 'get_onboarding_risk_rule',
  GetOnboardingRiskRules = 'get_onboarding_risk_rules',
  GetOnboardingTasks = 'get_onboarding_tasks',
  GetOpenPrs = 'get_open_prs',
  GetPaymentFeesByParams = 'get_payment_fees_by_params',
  GetPotentialDuplicateIndividuals = 'get_potential_duplicate_individuals',
  GetPricingActions = 'get_pricing_actions',
  GetProviderFeatures = 'get_provider_features',
  GetProviderRequests = 'get_provider_requests',
  GetProvidersFeatures = 'get_providers_features',
  GetProvisioning = 'get_provisioning',
  GetProvisioningTemplate = 'get_provisioning_template',
  GetProvisioningTemplates = 'get_provisioning_templates',
  GetProvisionings = 'get_provisionings',
  GetRawReports = 'get_raw_reports',
  GetReconciliationConfigs = 'get_reconciliation_configs',
  GetReconciliationsTasks = 'get_reconciliations_tasks',
  GetReferral = 'get_referral',
  GetReferrals = 'get_referrals',
  GetReportsConfig = 'get_reports_config',
  GetReserves = 'get_reserves',
  GetRiskAlert = 'get_risk_alert',
  GetRiskAlerts = 'get_risk_alerts',
  GetRiskAlertsByMerchants = 'get_risk_alerts_by_merchants',
  GetRiskAllListValues = 'get_risk_all_list_values',
  GetRiskCalculations = 'get_risk_calculations',
  GetRiskCalculatorConfig = 'get_risk_calculator_config',
  GetRiskList = 'get_risk_list',
  GetRiskLists = 'get_risk_lists',
  GetRiskReviewNotes = 'get_risk_review_notes',
  GetRiskRuleNotes = 'get_risk_rule_notes',
  GetRole = 'get_role',
  GetRoles = 'get_roles',
  GetRoutineLogs = 'get_routine_logs',
  GetRoutineTemplate = 'get_routine_template',
  GetRoutineTemplateConfig = 'get_routine_template_config',
  GetRoutineTemplates = 'get_routine_templates',
  GetRoutineTemplatesConfig = 'get_routine_templates_config',
  GetRule = 'get_rule',
  GetRuleLogs = 'get_rule_logs',
  GetRules = 'get_rules',
  GetSdkEvents = 'get_sdk_events',
  GetSettlement = 'get_settlement',
  GetSettlementAccount = 'get_settlement_account',
  GetSettlementAccountTasks = 'get_settlement_account_tasks',
  GetSettlementAccounts = 'get_settlement_accounts',
  GetSettlements = 'get_settlements',
  GetStructure = 'get_structure',
  GetSubscriptionPackages = 'get_subscription_packages',
  GetSubscriptions = 'get_subscriptions',
  GetSupersetDashboardToken = 'get_superset_dashboard_token',
  GetTask = 'get_task',
  GetTaskGroupTemplates = 'get_task_group_templates',
  GetTaskTemplate = 'get_task_template',
  GetTaskTemplates = 'get_task_templates',
  GetTasks = 'get_tasks',
  GetTransaction = 'get_transaction',
  GetTransactionNotes = 'get_transaction_notes',
  GetTransactions = 'get_transactions',
  GetVerificationChecks = 'get_verification_checks',
  GetWorkflows = 'get_workflows',
  ManageAllTasks = 'manage_all_tasks',
  ManageOnboardingPricing = 'manage_onboarding_pricing',
  OverrideRiskCalculation = 'override_risk_calculation',
  PaymentCancellation = 'payment_cancellation',
  PaymentCapture = 'payment_capture',
  PaymentRefund = 'payment_refund',
  RemoveCost = 'remove_cost',
  RemoveExportField = 'remove_export_field',
  RemoveFailureCodeMessage = 'remove_failure_code_message',
  RemoveIndividual = 'remove_individual',
  RemoveIndividualRelation = 'remove_individual_relation',
  RemoveIssuerResponseCode = 'remove_issuer_response_code',
  RemovePricing = 'remove_pricing',
  RemoveReconciliationConfig = 'remove_reconciliation_config',
  RemoveRoutineTemplate = 'remove_routine_template',
  RemoveTransactionNote = 'remove_transaction_note',
  RequestInformation = 'request_information',
  RequestSettlementAccountBlock = 'request_settlement_account_block',
  SendPaypassUrl = 'send_paypass_url',
  StandaloneMerchantSignup = 'standalone_merchant_signup',
  StartProvisioning = 'start_provisioning',
  StartRoutine = 'start_routine',
  SubmitMerchantApproval = 'submit_merchant_approval',
  SubmitTask = 'submit_task',
  SyncOnboardingPricing = 'sync_onboarding_pricing',
  ToggleArchiveBankAccount = 'toggle_archive_bank_account',
  UpdateActiveMerchantApplication = 'update_active_merchant_application',
  UpdateBankAccount = 'update_bank_account',
  UpdateChargebackReason = 'update_chargeback_reason',
  UpdateCommission = 'update_commission',
  UpdateCost = 'update_cost',
  UpdateCountry = 'update_country',
  UpdateCrmField = 'update_crm_field',
  UpdateDashboard = 'update_dashboard',
  UpdateDispute = 'update_dispute',
  UpdateDocument = 'update_document',
  UpdateDocumentType = 'update_document_type',
  UpdateEntityArchiveMcc = 'update_entity_archive_mcc',
  UpdateEntityMcc = 'update_entity_mcc',
  UpdateExportField = 'update_export_field',
  UpdateFailureCodeMessage = 'update_failure_code_message',
  UpdateFeatureFlag = 'update_feature_flag',
  UpdateFinance = 'update_finance',
  UpdateIndividual = 'update_individual',
  UpdateIssuerResponseCode = 'update_issuer_response_code',
  UpdateLogicField = 'update_logic_field',
  UpdateMcc = 'update_mcc',
  UpdateMerchant = 'update_merchant',
  UpdateMerchantApplication = 'update_merchant_application',
  UpdateMerchantApplicationRiskData = 'update_merchant_application_risk_data',
  UpdateMerchantCrmFieldValues = 'update_merchant_crm_field_values',
  UpdateMerchantPaymentMethodConfigsPreview = 'update_merchant_payment_method_configs_preview',
  UpdateMerchantSettings = 'update_merchant_settings',
  UpdateOnboardingPricing = 'update_onboarding_pricing',
  UpdateOnboardingPricingField = 'update_onboarding_pricing_field',
  UpdateOnboardingRiskRule = 'update_onboarding_risk_rule',
  UpdatePricing = 'update_pricing',
  UpdatePricingAction = 'update_pricing_action',
  UpdateProviderFeatures = 'update_provider_features',
  UpdateProvisioningTemplate = 'update_provisioning_template',
  UpdateReconciliationConfig = 'update_reconciliation_config',
  UpdateReferral = 'update_referral',
  UpdateReportsConfig = 'update_reports_config',
  UpdateRiskAlert = 'update_risk_alert',
  UpdateRiskAlerts = 'update_risk_alerts',
  UpdateRiskCalculatorConfig = 'update_risk_calculator_config',
  UpdateRiskList = 'update_risk_list',
  UpdateRiskRule = 'update_risk_rule',
  UpdateRole = 'update_role',
  UpdateRoutineTemplate = 'update_routine_template',
  UpdateSettlementAccount = 'update_settlement_account',
  UpdateSettlementAccountStatus = 'update_settlement_account_status',
  UpdateStructure = 'update_structure',
  UpdateTaskTemplate = 'update_task_template',
  UpdateTransactionNote = 'update_transaction_note',
  UpdateVerificationCheck = 'update_verification_check',
  UpdateWebsite = 'update_website',
  UpdateWebsiteCredentials = 'update_website_credentials',
  UploadLegalEntityDocument = 'upload_legal_entity_document',
  UploadSettlementAccountDocument = 'upload_settlement_account_document'
}

export type BankAccount = {
  __typename?: 'BankAccount';
  accountHolderName?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  accountType?: Maybe<AccountType>;
  bankAddress?: Maybe<Scalars['String']['output']>;
  bankCity?: Maybe<Scalars['String']['output']>;
  bankCountry?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  beneficiaryAddress?: Maybe<Scalars['String']['output']>;
  beneficiaryName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  region?: Maybe<BankAccountRegion>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  sortCode?: Maybe<Scalars['String']['output']>;
  swiftBic?: Maybe<Scalars['String']['output']>;
};

export type BankAccountByTypeQueryInput = {
  currency: Scalars['String']['input'];
  type: Scalars['AllowedBankType']['input'];
};

export type BankAccountMutationResponse = {
  __typename?: 'BankAccountMutationResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum BankAccountRegion {
  Eu = 'EU',
  Uk = 'UK',
  Us = 'US'
}

export enum BankAccountType {
  Operational = 'operational',
  Reserve = 'reserve',
  Safeguarding = 'safeguarding',
  Settlement = 'settlement'
}

export type BankAccountsByParamsQueryInput = {
  filter?: InputMaybe<BankAccountsQueryInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type BankAccountsByParamsResponse = {
  __typename?: 'BankAccountsByParamsResponse';
  bankAccounts: Array<BankAccount>;
  pageInfo: PageInfo;
};

export type BankAccountsQueryExactFilterInputValues = {
  accountHolderName?: InputMaybe<Scalars['String']['input']>;
  accountIdentifier?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<AccountType>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  bank?: InputMaybe<Scalars['String']['input']>;
  bankCountry?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  master__accountIdentifier?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
  swiftBic?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankAccountType>;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BankAccountsQueryInFilterInputValues = {
  currency?: InputMaybe<Array<Scalars['String']['input']>>;
  master__accountIdentifier?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<BankAccountType>>;
};

export type BankAccountsQueryInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankAccountType>;
};

export type BankAccountsQueryInputFilter = {
  equal?: InputMaybe<BankAccountsQueryExactFilterInputValues>;
  in?: InputMaybe<BankAccountsQueryInFilterInputValues>;
  notEqual?: InputMaybe<BankAccountsQueryExactFilterInputValues>;
};

export type BankCountryOption = {
  __typename?: 'BankCountryOption';
  alpha2: CountryAlpha2;
  name: Scalars['String']['output'];
  region: BankAccountRegion;
};

export type BankPaymentMethodOptions = {
  __typename?: 'BankPaymentMethodOptions';
  allowedCountries?: Maybe<Array<Scalars['String']['output']>>;
};

export type BankTransfer = {
  __typename?: 'BankTransfer';
  amount?: Maybe<Scalars['String']['output']>;
  chargeBearer?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  destinationAccountId: Scalars['ID']['output'];
  destinationAccountIdentifier?: Maybe<Scalars['String']['output']>;
  destinationAccountNumber?: Maybe<Scalars['String']['output']>;
  destinationBank?: Maybe<Scalars['String']['output']>;
  destinationCompanyId: Scalars['ID']['output'];
  destinationCurrency?: Maybe<Scalars['String']['output']>;
  destinationIban?: Maybe<Scalars['String']['output']>;
  destinationMaster?: Maybe<TransferAccount>;
  destinationMerchantId: Scalars['ID']['output'];
  destinationProvider?: Maybe<Scalars['String']['output']>;
  destinationRegion?: Maybe<Scalars['String']['output']>;
  destinationRoutingNumber?: Maybe<Scalars['String']['output']>;
  destinationSortCode?: Maybe<Scalars['String']['output']>;
  destinationSwiftBic?: Maybe<Scalars['String']['output']>;
  destinationType?: Maybe<BankAccountType>;
  direction?: Maybe<Scalars['String']['output']>;
  rail?: Maybe<Scalars['String']['output']>;
  sourceAccountId: Scalars['ID']['output'];
  sourceAccountIdentifier?: Maybe<Scalars['String']['output']>;
  sourceAccountNumber?: Maybe<Scalars['String']['output']>;
  sourceBank?: Maybe<Scalars['String']['output']>;
  sourceCompanyId: Scalars['ID']['output'];
  sourceCurrency?: Maybe<Scalars['String']['output']>;
  sourceIban?: Maybe<Scalars['String']['output']>;
  sourceMaster?: Maybe<TransferAccount>;
  sourceMerchantId: Scalars['ID']['output'];
  sourceProvider?: Maybe<Scalars['String']['output']>;
  sourceRegion?: Maybe<Scalars['String']['output']>;
  sourceRoutingNumber?: Maybe<Scalars['String']['output']>;
  sourceSortCode?: Maybe<Scalars['String']['output']>;
  sourceSwiftBic?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<BankAccountType>;
  status?: Maybe<Scalars['String']['output']>;
  transferReference?: Maybe<Scalars['String']['output']>;
  transferType?: Maybe<Scalars['String']['output']>;
  valueDate?: Maybe<Scalars['String']['output']>;
};

export type BankTransfersQueryExactFilterInputValues = {
  amount?: InputMaybe<Scalars['String']['input']>;
  chargeBearer?: InputMaybe<Scalars['String']['input']>;
  destinationAccountId?: InputMaybe<Scalars['ID']['input']>;
  destinationAccountIdentifier?: InputMaybe<Scalars['String']['input']>;
  destinationAccountNumber?: InputMaybe<Scalars['String']['input']>;
  destinationBank?: InputMaybe<Scalars['String']['input']>;
  destinationCompanyId?: InputMaybe<Scalars['ID']['input']>;
  destinationIban?: InputMaybe<Scalars['String']['input']>;
  destinationMaster?: InputMaybe<TransferAccountInput>;
  destinationMerchantId?: InputMaybe<Scalars['ID']['input']>;
  destinationProvider?: InputMaybe<Scalars['String']['input']>;
  destinationRegion?: InputMaybe<Scalars['String']['input']>;
  destinationRoutingNumber?: InputMaybe<Scalars['String']['input']>;
  destinationSortCode?: InputMaybe<Scalars['String']['input']>;
  destinationSwiftBic?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  rail?: InputMaybe<Scalars['String']['input']>;
  sourceAccountId?: InputMaybe<Scalars['ID']['input']>;
  sourceAccountIdentifier?: InputMaybe<Scalars['String']['input']>;
  sourceAccountNumber?: InputMaybe<Scalars['String']['input']>;
  sourceBank?: InputMaybe<Scalars['String']['input']>;
  sourceCompanyId?: InputMaybe<Scalars['ID']['input']>;
  sourceIban?: InputMaybe<Scalars['String']['input']>;
  sourceMaster?: InputMaybe<TransferAccountInput>;
  sourceMerchantId?: InputMaybe<Scalars['ID']['input']>;
  sourceProvider?: InputMaybe<Scalars['String']['input']>;
  sourceRegion?: InputMaybe<Scalars['String']['input']>;
  sourceRoutingNumber?: InputMaybe<Scalars['String']['input']>;
  sourceSortCode?: InputMaybe<Scalars['String']['input']>;
  sourceSwiftBic?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  transferReference?: InputMaybe<Scalars['String']['input']>;
  transferType?: InputMaybe<Scalars['String']['input']>;
  valueDate?: InputMaybe<Scalars['String']['input']>;
};

export type BankTransfersQueryFilterInput = {
  equal?: InputMaybe<BankTransfersQueryExactFilterInputValues>;
  greater?: InputMaybe<BankTransfersQueryExactFilterInputValues>;
  greaterOrEquals?: InputMaybe<BankTransfersQueryExactFilterInputValues>;
  iLike?: InputMaybe<BankTransfersQueryExactFilterInputValues>;
  in?: InputMaybe<BankTransfersQueryInFilterInputValues>;
  less?: InputMaybe<BankTransfersQueryExactFilterInputValues>;
  lessOrEquals?: InputMaybe<BankTransfersQueryExactFilterInputValues>;
  like?: InputMaybe<BankTransfersQueryExactFilterInputValues>;
  notEqual?: InputMaybe<BankTransfersQueryExactFilterInputValues>;
  notIn?: InputMaybe<BankTransfersQueryInFilterInputValues>;
  notLike?: InputMaybe<BankTransfersQueryExactFilterInputValues>;
};

export type BankTransfersQueryInFilterInputValues = {
  createdAt?: InputMaybe<Array<Scalars['String']['input']>>;
  currency?: InputMaybe<Array<Scalars['String']['input']>>;
  destinationCurrency?: InputMaybe<Array<Scalars['String']['input']>>;
  destinationType?: InputMaybe<Array<BankAccountType>>;
  sourceCurrency?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceType?: InputMaybe<Array<BankAccountType>>;
};

export type BankTransfersQueryInput = {
  filter?: InputMaybe<BankTransfersQueryFilterInput>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type BankTransfersResponse = {
  __typename?: 'BankTransfersResponse';
  bankTransfers: Array<BankTransfer>;
  pageInfo: PageInfo;
};

export type Branding = {
  __typename?: 'Branding';
  color?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<CheckoutCtaText>;
  customerSupport?: Maybe<CustomerSupport>;
  displayName?: Maybe<Scalars['String']['output']>;
  fallbackUrl?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
};

export type BrandingInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  ctaText?: InputMaybe<CheckoutCtaText>;
  customerSupport?: InputMaybe<CustomerSupportInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fallbackUrl?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
};

export type BrandingListInput = {
  color?: InputMaybe<Array<Scalars['String']['input']>>;
  ctaText?: InputMaybe<Array<CheckoutCtaText>>;
};

export type BreakdownByPaymentMethod = {
  __typename?: 'BreakdownByPaymentMethod';
  declinedCount: Scalars['Int']['output'];
  paymentMethod: Scalars['String']['output'];
  successfulCount: Scalars['Int']['output'];
};

export type BreakdownBySettlementAccount = {
  __typename?: 'BreakdownBySettlementAccount';
  id: Scalars['String']['output'];
  successfulCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  volume: Scalars['Float']['output'];
};

export type BulkAddCardToBlacklistMutationInput = {
  cardIds: Array<Scalars['String']['input']>;
};

export type BulkAddToBlacklistMutationResponse = {
  __typename?: 'BulkAddToBlacklistMutationResponse';
  listId: Scalars['String']['output'];
};

export type BusinessActivityFilterInput = {
  annualAmexVolumeExceeds?: InputMaybe<Scalars['Boolean']['input']>;
  applyingReason?: InputMaybe<Scalars['String']['input']>;
  averageTransactionAmount?: InputMaybe<Scalars['String']['input']>;
  averageTransactionCurrency?: InputMaybe<Array<InputMaybe<CurrencyAlpha3>>>;
  blacklistedCountries?: InputMaybe<Array<InputMaybe<CountryAlpha2>>>;
  businessToBusinessBasisPoints?: InputMaybe<Scalars['Float']['input']>;
  cardPresentBasisPoints?: InputMaybe<Scalars['Float']['input']>;
  currentPaymentProcessor?: InputMaybe<Scalars['String']['input']>;
  customersAbroad?: InputMaybe<Scalars['Boolean']['input']>;
  customersAbroadCountries?: InputMaybe<Array<InputMaybe<CountryAlpha2>>>;
  ecommerceBasisPoints?: InputMaybe<Scalars['Float']['input']>;
  esaNumber?: InputMaybe<Scalars['String']['input']>;
  highRiskCountries?: InputMaybe<Array<InputMaybe<CountryAlpha2>>>;
  licenseJurisdictionCountry?: InputMaybe<Array<InputMaybe<CountryAlpha2>>>;
  licenseType?: InputMaybe<Scalars['String']['input']>;
  manuallyKeyedCnpMotoBasisPoints?: InputMaybe<Scalars['Float']['input']>;
  manuallyKeyedCpImprintBasisPoints?: InputMaybe<Scalars['Float']['input']>;
  maximumMonthlyCardVolumeAmount?: InputMaybe<Scalars['Float']['input']>;
  maximumMonthlyCardVolumeCurrency?: InputMaybe<Array<InputMaybe<CurrencyAlpha3>>>;
  maximumTransactionAmount?: InputMaybe<Scalars['String']['input']>;
  maximumTransactionCurrency?: InputMaybe<Array<InputMaybe<CurrencyAlpha3>>>;
  minimumTransactionAmount?: InputMaybe<Scalars['String']['input']>;
  minimumTransactionCurrency?: InputMaybe<Array<InputMaybe<CurrencyAlpha3>>>;
  monthlyAverageVolumeAmount?: InputMaybe<Scalars['String']['input']>;
  monthlyAverageVolumeCurrency?: InputMaybe<Array<InputMaybe<CurrencyAlpha3>>>;
  monthlyCardVolumeAmount?: InputMaybe<Scalars['String']['input']>;
  monthlyCardVolumeCurrency?: InputMaybe<Array<InputMaybe<CurrencyAlpha3>>>;
  motoOptions?: InputMaybe<Scalars['Boolean']['input']>;
  originsOfFunds?: InputMaybe<Array<InputMaybe<CountryAlpha2>>>;
  paymentChannels?: InputMaybe<Array<InputMaybe<PaymentChannel>>>;
  physicalProductsOrigins?: InputMaybe<Array<InputMaybe<CountryAlpha2>>>;
  processingCurrencies?: InputMaybe<Array<InputMaybe<CurrencyAlpha3>>>;
  productCompany?: InputMaybe<Scalars['Boolean']['input']>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  productSupplyTimeRange?: InputMaybe<Array<InputMaybe<ProductSupplyTimeRange>>>;
  projectedCardTurnover?: InputMaybe<Scalars['String']['input']>;
  projectedCardVolume?: InputMaybe<Scalars['String']['input']>;
  projectedCardVolumeCurrency?: InputMaybe<Array<InputMaybe<CurrencyAlpha3>>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  requestingPayoutsToCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  requiresAuthorizationFromAuthority?: InputMaybe<Scalars['Boolean']['input']>;
  requiresAuthorizationFromAuthorityDesc?: InputMaybe<Scalars['String']['input']>;
  seasonalBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  seasonalBusinessMonths?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settlementCurrencies?: InputMaybe<Array<InputMaybe<CurrencyAlpha3>>>;
  sourcesOfFunds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subscriptionBasedService?: InputMaybe<Scalars['Boolean']['input']>;
  targetMarketsCountriesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  yearlyVolume?: InputMaybe<Scalars['String']['input']>;
  yearlyVolumeCurrency?: InputMaybe<Array<InputMaybe<CurrencyAlpha3>>>;
};

export type BusinessDetails = {
  __typename?: 'BusinessDetails';
  businessDescription?: Maybe<Scalars['String']['output']>;
  companyRegistrationNumber?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  email?: Maybe<Scalars['String']['output']>;
  mcc?: Maybe<Mcc>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type BusinessDetailsFilterInput = {
  businessLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  companyRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  doingBusinessAs?: InputMaybe<Scalars['String']['input']>;
  employerIdNumber?: InputMaybe<Scalars['String']['input']>;
  implementation?: InputMaybe<ImplementationInput>;
  industryDescription?: InputMaybe<Scalars['String']['input']>;
  issuingAuthority?: InputMaybe<Scalars['String']['input']>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  monthlyProcessingVolume?: InputMaybe<Scalars['String']['input']>;
  monthlyProcessingVolumeCurrency?: InputMaybe<Scalars['String']['input']>;
  noOnlinePresence?: InputMaybe<Scalars['Boolean']['input']>;
  noVatNumber?: InputMaybe<Scalars['Boolean']['input']>;
  noWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  specialProducts?: InputMaybe<Array<InputMaybe<SpecialProducts>>>;
  specialProductsDescription?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  websiteUnderConstruction?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BusinessDetailsInput = {
  businessDescription?: InputMaybe<Scalars['String']['input']>;
  companyRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  countryAlpha2?: InputMaybe<CountryAlpha2>;
  email?: InputMaybe<Scalars['String']['input']>;
  mcc?: InputMaybe<Scalars['Int']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessDetailsListInput = {
  businessDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  companyRegistrationNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Array<CountryAlpha2>>;
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  mcc?: InputMaybe<Array<Scalars['Int']['input']>>;
  vatNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  website?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BusinessProcessingInfoFilterInput = {
  applyingForAdditionalLocations?: InputMaybe<Scalars['Boolean']['input']>;
  chargebackProcedureDescription?: InputMaybe<Scalars['String']['input']>;
  customerAccessType?: InputMaybe<Array<InputMaybe<CustomerAccessPlatformType>>>;
  emailReceipts?: InputMaybe<Scalars['Boolean']['input']>;
  existingPaycomMerchantId?: InputMaybe<Scalars['String']['input']>;
  fraudPreventionServiceDescription?: InputMaybe<Scalars['String']['input']>;
  fraudPreventionServiceUsed?: InputMaybe<Scalars['Boolean']['input']>;
  hasAcceptedCcBeforeDescription?: InputMaybe<Scalars['String']['input']>;
  hasAcceptedCreditCardsBefore?: InputMaybe<Scalars['Boolean']['input']>;
  isWebsitePciCompliant?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfPhysicalLocations?: InputMaybe<Scalars['Int']['input']>;
  ordersFulfilledDirectly?: InputMaybe<Scalars['Boolean']['input']>;
  platformRequiresTestUser?: InputMaybe<Scalars['Boolean']['input']>;
  returnAndRefundPolicy?: InputMaybe<Scalars['String']['input']>;
  saqType?: InputMaybe<Array<InputMaybe<SaqType>>>;
  terminatedByPreviousProcessor?: InputMaybe<Scalars['Boolean']['input']>;
  testPassword?: InputMaybe<Scalars['String']['input']>;
  testUsername?: InputMaybe<Scalars['String']['input']>;
  thirdPartyIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  thirdPartyIntegrationDescription?: InputMaybe<Scalars['String']['input']>;
  wantsAmexMarketingMaterials?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BusinessStructure {
  AnonymousInvestmentServicesCompanyAeney = 'anonymous_investment_services_company_aeney',
  CommercialPartnershipSocieteEnNomCollectifSnc = 'commercial_partnership_societe_en_nom_collectif_snc',
  CooperativeCompanyWithLimitedLiabilityScrl = 'cooperative_company_with_limited_liability_scrl',
  CooperativePartnershipWithUnlimitedLiabilityScri = 'cooperative_partnership_with_unlimited_liability_scri',
  DesignatedActivityCompanyDacLimitedByShares = 'designated_activity_company_dac_limited_by_shares',
  EntitiesGovernedByPublicLawPubLaw = 'entities_governed_by_public_law_pub_law',
  Establishment = 'establishment',
  GeneralPartnership = 'general_partnership',
  GeneralPartnershipAnsDa = 'general_partnership_ans_da',
  GeneralPartnershipAy = 'general_partnership_ay',
  GeneralPartnershipFirm = 'general_partnership_firm',
  GeneralPartnershipIS = 'general_partnership_i_s',
  GeneralPartnershipJTD = 'general_partnership_j_t_d',
  GeneralPartnershipKktLimitedPartnershipBt = 'general_partnership_kkt_limited_partnership_bt',
  GeneralPartnershipOe = 'general_partnership_oe',
  GeneralPartnershipOg = 'general_partnership_og',
  GeneralPartnershipOhg = 'general_partnership_ohg',
  GeneralPartnershipPs = 'general_partnership_ps',
  GeneralPartnershipSc = 'general_partnership_sc',
  GeneralPartnershipSd = 'general_partnership_sd',
  GeneralPartnershipSenc = 'general_partnership_senc',
  GeneralPartnershipSnc = 'general_partnership_snc',
  GeneralPartnershipTu = 'general_partnership_tu',
  GeneralPartnershipTub = 'general_partnership_tub',
  GeneralPartnershipVOS = 'general_partnership_v_o_s',
  GeneralPartnershipVof = 'general_partnership_vof',
  GeneralPartnershipVos = 'general_partnership_vos',
  InternalPartnershipIs = 'internal_partnership_is',
  JointStockCompanyAS = 'joint_stock_company_a_s',
  JointStockCompanyAd = 'joint_stock_company_ad',
  JointStockCompanyAs = 'joint_stock_company_as',
  JointStockCompanyDD = 'joint_stock_company_d_d',
  JointStockCompanySA = 'joint_stock_company_s_a',
  JointStockCompanySa = 'joint_stock_company_sa',
  JointStockCompanySocieteAnonymeSa = 'joint_stock_company_societe_anonyme_sa',
  JointStockPartnershipSca = 'joint_stock_partnership_sca',
  JointVenture = 'joint_venture',
  LimitedCompanyAS = 'limited_company_a_s',
  LimitedCompanyOy = 'limited_company_oy',
  LimitedCompanyRt = 'limited_company_rt',
  LimitedJointStockPartnershipSKA = 'limited_joint_stock_partnership_s_k_a',
  LimitedLiabilityCompany = 'limited_liability_company',
  LimitedLiabilityCompanyDOO = 'limited_liability_company_d_o_o',
  LimitedLiabilityCompanyEhf = 'limited_liability_company_ehf',
  LimitedLiabilityCompanyEpe = 'limited_liability_company_epe',
  LimitedLiabilityCompanyGmbh = 'limited_liability_company_gmbh',
  LimitedLiabilityCompanyOod = 'limited_liability_company_ood',
  LimitedLiabilityCompanySMBA = 'limited_liability_company_s_m_b_a',
  LimitedLiabilityCompanySRO = 'limited_liability_company_s_r_o',
  LimitedLiabilityCompanySarl = 'limited_liability_company_sarl',
  LimitedLiabilityCompanySia = 'limited_liability_company_sia',
  LimitedLiabilityCompanySocieteAResponsabiliteLimiteeSarl = 'limited_liability_company_societe_a_responsabilite_limitee_sarl',
  LimitedLiabilityCompanySpZOO = 'limited_liability_company_sp_z_o_o',
  LimitedLiabilityCompanySrl = 'limited_liability_company_srl',
  LimitedLiabilityLimitedPartnershipLllp = 'limited_liability_limited_partnership_lllp',
  LimitedLiabilityPartnershipLlp = 'limited_liability_partnership_llp',
  LimitedPartnership = 'limited_partnership',
  LimitedPartnershipComan = 'limited_partnership_coman',
  LimitedPartnershipCv = 'limited_partnership_cv',
  LimitedPartnershipEe = 'limited_partnership_ee',
  LimitedPartnershipHb = 'limited_partnership_hb',
  LimitedPartnershipKD = 'limited_partnership_k_d',
  LimitedPartnershipKS = 'limited_partnership_k_s',
  LimitedPartnershipKd = 'limited_partnership_kd',
  LimitedPartnershipKg = 'limited_partnership_kg',
  LimitedPartnershipKs = 'limited_partnership_ks',
  LimitedPartnershipKub = 'limited_partnership_kub',
  LimitedPartnershipKy = 'limited_partnership_ky',
  LimitedPartnershipLp = 'limited_partnership_lp',
  LimitedPartnershipSas = 'limited_partnership_sas',
  LimitedPartnershipScomm = 'limited_partnership_scomm',
  LimitedPartnershipScs = 'limited_partnership_scs',
  LimitedPartnershipSecs = 'limited_partnership_secs',
  LimitedPartnershipSpK = 'limited_partnership_sp_k',
  LimitedPartnershipUu = 'limited_partnership_uu',
  LimitedStockPartnershipSComPA = 'limited_stock_partnership_s_com_p_a',
  MultiMemberLlc = 'multi_member_llc',
  OrdinaryLimitedPartnershipScs = 'ordinary_limited_partnership_scs',
  Partnership = 'partnership',
  PartnershipLimitedBySharesKda = 'partnership_limited_by_shares_kda',
  PartnershipLimitedBySharesKgaa = 'partnership_limited_by_shares_kgaa',
  PartnershipLimitedBySharesSaa = 'partnership_limited_by_shares_saa',
  PartnershipLimitedBySharesSca = 'partnership_limited_by_shares_sca',
  PartnershipSdc = 'partnership_sdc',
  PartnershipSf = 'partnership_sf',
  PrivateCompanyLimitedBySharesLtd = 'private_company_limited_by_shares_ltd',
  PrivateCorporation = 'private_corporation',
  PrivateLimitedCompanyAg = 'private_limited_company_ag',
  PrivateLimitedCompanyAps = 'private_limited_company_aps',
  PrivateLimitedCompanyBv = 'private_limited_company_bv',
  PrivateLimitedCompanyGmbh = 'private_limited_company_gmbh',
  PrivateLimitedCompanyLda = 'private_limited_company_lda',
  PrivateLimitedCompanyLtd = 'private_limited_company_ltd',
  PrivateLimitedCompanyOu = 'private_limited_company_ou',
  PrivateLimitedCompanySRO = 'private_limited_company_s_r_o',
  PrivateLimitedCompanySl = 'private_limited_company_sl',
  PrivateLimitedCompanyUab = 'private_limited_company_uab',
  PrivateLimitedLiabilityCompanyAs = 'private_limited_liability_company_as',
  PrivateLimitedLiabilityCompanyKft = 'private_limited_liability_company_kft',
  PrivateLimitedLiabilityCompanySprl = 'private_limited_liability_company_sprl',
  PrivatePartnership = 'private_partnership',
  PublicBodyKor = 'public_body_kor',
  PublicCommercialCompanyVOS = 'public_commercial_company_v_o_s',
  PublicCompany = 'public_company',
  PublicCompanyAg = 'public_company_ag',
  PublicCompanyAsa = 'public_company_asa',
  PublicCompanyNyrt = 'public_company_nyrt',
  PublicCompanyPlc = 'public_company_plc',
  PublicCompanyRa = 'public_company_ra',
  PublicLimitedCompany = 'public_limited_company',
  PublicLimitedCompanyAS = 'public_limited_company_a_s',
  PublicLimitedCompanyAb = 'public_limited_company_ab',
  PublicLimitedCompanyAe = 'public_limited_company_ae',
  PublicLimitedCompanyAg = 'public_limited_company_ag',
  PublicLimitedCompanyAs = 'public_limited_company_as',
  PublicLimitedCompanyBySharesSpa = 'public_limited_company_by_shares_spa',
  PublicLimitedCompanyHf = 'public_limited_company_hf',
  PublicLimitedCompanyNvCooperative = 'public_limited_company_nv_cooperative',
  PublicLimitedCompanyOyj = 'public_limited_company_oyj',
  PublicLimitedCompanyPlc = 'public_limited_company_plc',
  PublicLimitedCompanySa = 'public_limited_company_sa',
  PublicPartnership = 'public_partnership',
  RegisteredPartnershipSJ = 'registered_partnership_s_j',
  SimpleLimitedLiabilityCompanyJDOOPublicCompanyDD = 'simple_limited_liability_company_j_d_o_o_public_company_d_d',
  SimpleLimitedPartnershipSEnCOSCom = 'simple_limited_partnership_s_en_c_o_s_com',
  SingleMemberLlc = 'single_member_llc',
  SinglePersonJointStockCompanyEad = 'single_person_joint_stock_company_ead',
  SinglePersonLimitedLiabilityCompanyEood = 'single_person_limited_liability_company_eood',
  SoleProprietorship = 'sole_proprietorship',
  SoleTrader = 'sole_trader',
  UnlimitedPartnershipDNO = 'unlimited_partnership_d_n_o',
  VariableCapitalInvestmentCompany = 'variable_capital_investment_company'
}

export type BusinessStructureDetails = {
  __typename?: 'BusinessStructureDetails';
  bankruptcyProceedings?: Maybe<Scalars['Boolean']['output']>;
  businessConductionLocation?: Maybe<Scalars['String']['output']>;
  businessEmail?: Maybe<Scalars['String']['output']>;
  businessPhoneNumber?: Maybe<Scalars['String']['output']>;
  businessStructure?: Maybe<Scalars['String']['output']>;
  businessType?: Maybe<BusinessType>;
  businessTypeDescription?: Maybe<Scalars['String']['output']>;
  companiesGroup?: Maybe<Scalars['Boolean']['output']>;
  countryOfIncorporation?: Maybe<CountryAlpha2>;
  dateOfIncorporation?: Maybe<Scalars['String']['output']>;
  dbaPhoneNumber?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  groupWebsite?: Maybe<Scalars['String']['output']>;
  numberOfEmployees?: Maybe<Scalars['String']['output']>;
  physicalAddrSameAsRegistered?: Maybe<Scalars['Boolean']['output']>;
  physicalBusinessAddress?: Maybe<Address>;
  psdTwoClassification?: Maybe<PsdTwoClassification>;
  psdTwoClassificationDescription?: Maybe<Scalars['String']['output']>;
  publicCompany?: Maybe<Scalars['Boolean']['output']>;
  publiclyTradedCorpExchange?: Maybe<Scalars['String']['output']>;
  publiclyTradedCorporationSymbol?: Maybe<Scalars['String']['output']>;
  registeredBusinessAddress?: Maybe<Address>;
};

export type BusinessStructureDetailsFilterInput = {
  bankruptcyProceedings?: InputMaybe<Scalars['Boolean']['input']>;
  businessConductionLocation?: InputMaybe<Scalars['String']['input']>;
  businessEmail?: InputMaybe<Scalars['String']['input']>;
  businessPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  businessStructure?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<Scalars['String']['input']>;
  businessTypeDescription?: InputMaybe<Scalars['String']['input']>;
  companiesGroup?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfIncorporation?: InputMaybe<StringRangeInput>;
  dbaPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  groupWebsite?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['String']['input']>;
  pba?: InputMaybe<AddressInput>;
  physicalAddrSameAsRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  psdTwoClassification?: InputMaybe<PsdTwoClassification>;
  psdTwoClassificationDescription?: InputMaybe<Scalars['String']['input']>;
  publicCompany?: InputMaybe<Scalars['Boolean']['input']>;
  publiclyTradedCorpExchange?: InputMaybe<Scalars['String']['input']>;
  publiclyTradedCorporationSymbol?: InputMaybe<Scalars['String']['input']>;
  rba?: InputMaybe<AddressInput>;
};

export type BusinessStructureDetailsInFilterInput = {
  countryOfIncorporation?: InputMaybe<Array<InputMaybe<CountryAlpha2>>>;
  pba?: InputMaybe<AddressListInput>;
  psdTwoClassification?: InputMaybe<Array<InputMaybe<PsdTwoClassification>>>;
  rba?: InputMaybe<AddressListInput>;
};

export type BusinessStructureDetailsInput = {
  bankruptcyProceedings?: InputMaybe<Scalars['Boolean']['input']>;
  businessConductionLocation?: InputMaybe<Scalars['String']['input']>;
  businessEmail?: InputMaybe<Scalars['String']['input']>;
  businessPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  businessStructure?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<BusinessType>;
  businessTypeDescription?: InputMaybe<Scalars['String']['input']>;
  companiesGroup?: InputMaybe<Scalars['Boolean']['input']>;
  countryOfIncorporation?: InputMaybe<CountryAlpha2>;
  dateOfIncorporation?: InputMaybe<Scalars['String']['input']>;
  dbaPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  groupWebsite?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['String']['input']>;
  physicalAddrSameAsRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  physicalBusinessAddress?: InputMaybe<AddressInput>;
  psdTwoClassification?: InputMaybe<PsdTwoClassification>;
  psdTwoClassificationDescription?: InputMaybe<Scalars['String']['input']>;
  publicCompany?: InputMaybe<Scalars['Boolean']['input']>;
  publiclyTradedCorpExchange?: InputMaybe<Scalars['String']['input']>;
  publiclyTradedCorporationSymbol?: InputMaybe<Scalars['String']['input']>;
  registeredBusinessAddress?: InputMaybe<AddressInput>;
};

export type BusinessStructureDetailsPreview = {
  __typename?: 'BusinessStructureDetailsPreview';
  bankruptcyProceedings?: Maybe<Scalars['Boolean']['output']>;
  businessConductionLocation?: Maybe<Scalars['String']['output']>;
  businessEmail?: Maybe<Scalars['String']['output']>;
  businessPhoneNumber?: Maybe<Scalars['String']['output']>;
  businessStructure?: Maybe<Scalars['String']['output']>;
  businessType?: Maybe<Scalars['String']['output']>;
  businessTypeDescription?: Maybe<Scalars['String']['output']>;
  companiesGroup?: Maybe<Scalars['Boolean']['output']>;
  countryOfIncorporation?: Maybe<CountryAlpha2>;
  dateOfIncorporation?: Maybe<Scalars['String']['output']>;
  dbaPhoneNumber?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  groupWebsite?: Maybe<Scalars['String']['output']>;
  numberOfEmployees?: Maybe<Scalars['String']['output']>;
  pba?: Maybe<Address>;
  physicalAddrSameAsRegistered?: Maybe<Scalars['Boolean']['output']>;
  psdTwoClassification?: Maybe<PsdTwoClassification>;
  psdTwoClassificationDescription?: Maybe<Scalars['String']['output']>;
  publicCompany?: Maybe<Scalars['Boolean']['output']>;
  publiclyTradedCorpExchange?: Maybe<Scalars['String']['output']>;
  publiclyTradedCorporationSymbol?: Maybe<Scalars['String']['output']>;
  rba?: Maybe<Address>;
};

export enum BusinessType {
  Internet = 'internet',
  Moto = 'moto',
  Other = 'other',
  Pharmacy = 'pharmacy',
  Restaurant = 'restaurant',
  Retail = 'retail',
  RetailWithTips = 'retail_with_tips',
  Supermarket = 'supermarket',
  Utility = 'utility'
}

export type CancelSubscriptionInput = {
  cancelAt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  immediately?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CancelTask = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export enum CancellationReasonEnum {
  CancellationRequested = 'cancellation_requested',
  ChargeDisputed = 'charge_disputed',
  ChargeFailed = 'charge_failed',
  Ended = 'ended'
}

export type CardBillingAddress = {
  addressLine: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  countryAlpha2: CountryAlpha2;
  state?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export enum CardBrandTypes {
  Amex = 'AMEX',
  Discover = 'Discover',
  Jcb = 'JCB',
  MasterCard = 'MasterCard',
  UnionPay = 'UnionPay',
  Visa = 'Visa',
  Diners = 'diners'
}

export enum CardBrandsEnum {
  Amex = 'amex',
  Diners = 'diners',
  Discover = 'discover',
  Jcb = 'jcb',
  Mastercard = 'mastercard',
  Unionpay = 'unionpay',
  Visa = 'visa'
}

export enum CardCategory {
  Business = 'BUSINESS',
  Consumer = 'CONSUMER',
  Unknown = 'UNKNOWN'
}

export type CardPaymentMethodOptions = {
  __typename?: 'CardPaymentMethodOptions';
  acceptedCardBrands?: Maybe<Array<CardBrandsEnum>>;
  acceptedCardCategories?: Maybe<Array<CardCategory>>;
  acceptedCardCountries?: Maybe<Array<Scalars['String']['output']>>;
  acceptedCardFunding?: Maybe<Array<CardType>>;
  acceptedCardJurisdictions?: Maybe<Array<TransactionJurisdiction>>;
  acceptedEciValues?: Maybe<Array<Scalars['String']['output']>>;
  duplicateCardCheck: Scalars['Boolean']['output'];
  dynamicCurrencyConversion?: Maybe<Scalars['Boolean']['output']>;
  enforceCustomerNameAsCardholderName?: Maybe<Scalars['Boolean']['output']>;
  exemptionType?: Maybe<ExemptionTypeEnum>;
  instantRefund?: Maybe<Scalars['Boolean']['output']>;
  moto?: Maybe<Scalars['Boolean']['output']>;
  networkToken?: Maybe<CardPaymentMethodOptionsNetworkToken>;
  partialApproval?: Maybe<CardPaymentMethodOptionsPartialApproval>;
  providers?: Maybe<Array<Scalars['String']['output']>>;
  requestThreedSecure?: Maybe<ChallengePreferenceEnum>;
  securityChecks?: Maybe<SecurityChecksOptions>;
};

export type CardPaymentMethodOptionsNetworkToken = {
  __typename?: 'CardPaymentMethodOptionsNetworkToken';
  authorization?: Maybe<CardPaymentMethodOptionsNetworkTokenAuthorization>;
  provision?: Maybe<CardPaymentMethodOptionsNetworkTokenProvision>;
};

export type CardPaymentMethodOptionsNetworkTokenAuthorization = {
  __typename?: 'CardPaymentMethodOptionsNetworkTokenAuthorization';
  enabled: Scalars['Boolean']['output'];
  fullPanFallback: Scalars['Boolean']['output'];
};

export type CardPaymentMethodOptionsNetworkTokenProvision = {
  __typename?: 'CardPaymentMethodOptionsNetworkTokenProvision';
  declineOnFailure: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
};

export type CardPaymentMethodOptionsPartialApproval = {
  __typename?: 'CardPaymentMethodOptionsPartialApproval';
  accept: Scalars['Boolean']['output'];
  allowTopUp: Scalars['Boolean']['output'];
  amountThreshold: Scalars['String']['output'];
  approvedByDefault: Scalars['Boolean']['output'];
  percentageThreshold: Scalars['Int']['output'];
  requireFullAmount: Scalars['Boolean']['output'];
};

export type CardSchemaProviderScreeningResult = {
  __typename?: 'CardSchemaProviderScreeningResult';
  id?: Maybe<Scalars['String']['output']>;
  providerRequestParams?: Maybe<ScreeningCallRequestParams>;
  terminatedAt?: Maybe<Scalars['String']['output']>;
  terminatedByAcquirerDetails?: Maybe<Array<AcquirerContactInfo>>;
  terminatedByAcquirerId?: Maybe<Scalars['String']['output']>;
  terminatedMerchantResult: ScreeningTerminatedMerchantResult;
  terminatedWithComment?: Maybe<Scalars['String']['output']>;
  terminatedWithDetails?: Maybe<TerminatedWithDetails>;
  terminationCode?: Maybe<Scalars['String']['output']>;
  terminationDescription?: Maybe<Scalars['String']['output']>;
  terminationReason?: Maybe<TerminationReason>;
  verificationCheckId?: Maybe<Scalars['String']['output']>;
};

export type CardSchemaProviderScreeningResultInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  terminatedAt?: InputMaybe<Scalars['String']['input']>;
  terminatedByAcquirerId?: InputMaybe<Scalars['String']['input']>;
  terminatedMerchantResult: ScreeningTerminatedMerchantResultInput;
  terminatedWithComment?: InputMaybe<Scalars['String']['input']>;
  terminationCode?: InputMaybe<Scalars['String']['input']>;
  terminationDescription?: InputMaybe<Scalars['String']['input']>;
  terminationReason?: InputMaybe<TerminationReason>;
  verificationCheckId?: InputMaybe<Scalars['String']['input']>;
};

/** REFERENCE: https://github.com/pay-com/libs-types/blob/main/protos/common.proto#L546 */
export enum CardType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  DeferredDebit = 'DEFERRED_DEBIT',
  Prepaid = 'PREPAID',
  Unknown = 'UNKNOWN'
}

export enum ChallengePreferenceEnum {
  Challenge = 'CHALLENGE',
  Exemption = 'EXEMPTION',
  External = 'EXTERNAL',
  Frictionless = 'FRICTIONLESS'
}

export type ChannelOnboarding = {
  __typename?: 'ChannelOnboarding';
  channel?: Maybe<OnboardingChannel>;
  solicitor?: Maybe<Solicitor>;
  solicitorEmail?: Maybe<Scalars['String']['output']>;
  solicitorName?: Maybe<Scalars['String']['output']>;
};

export type ChannelOnboardingFilterInput = {
  channel?: InputMaybe<Array<InputMaybe<OnboardingChannel>>>;
  solicitor?: InputMaybe<Array<InputMaybe<Solicitor>>>;
  solicitorEmail?: InputMaybe<Scalars['String']['input']>;
  solicitorName?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelOnboardingInput = {
  channel?: InputMaybe<OnboardingChannel>;
  solicitor?: InputMaybe<Solicitor>;
  solicitorEmail?: InputMaybe<Scalars['String']['input']>;
  solicitorName?: InputMaybe<Scalars['String']['input']>;
};

export type ChargebackBreakdown = {
  __typename?: 'ChargebackBreakdown';
  amex?: Maybe<ChargebackDetail>;
  discover?: Maybe<ChargebackDetail>;
  mastercard?: Maybe<ChargebackDetail>;
  visa?: Maybe<ChargebackDetail>;
};

export type ChargebackBreakdownInput = {
  amex?: InputMaybe<ChargebackDetailInput>;
  discover?: InputMaybe<ChargebackDetailInput>;
  mastercard?: InputMaybe<ChargebackDetailInput>;
  visa?: InputMaybe<ChargebackDetailInput>;
};

export type ChargebackDetail = {
  __typename?: 'ChargebackDetail';
  chargebackAmount: Scalars['Float']['output'];
  chargebackCount: Scalars['Int']['output'];
  chargebackFees: Scalars['Float']['output'];
};

export type ChargebackDetailInput = {
  chargebackAmount?: InputMaybe<Scalars['Float']['input']>;
  chargebackCount?: InputMaybe<Scalars['Int']['input']>;
  chargebackFees?: InputMaybe<Scalars['Float']['input']>;
};

export type ChargebackReason = {
  __typename?: 'ChargebackReason';
  category?: Maybe<ChargebackReasonCategory>;
  code: Scalars['String']['output'];
  codeUsaOrCa?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  network: Scalars['String']['output'];
  reasonDescription?: Maybe<Scalars['String']['output']>;
  reasonTitle?: Maybe<Scalars['String']['output']>;
  requiredDocumentation?: Maybe<Scalars['String']['output']>;
};

export enum ChargebackReasonCategory {
  Authorization = 'AUTHORIZATION',
  ConsumerDisputes = 'CONSUMER_DISPUTES',
  Fraud = 'FRAUD',
  ProcessingErrors = 'PROCESSING_ERRORS'
}

export type ChargebackReasonMutationResponse = {
  __typename?: 'ChargebackReasonMutationResponse';
  payload: ChargebackReasonPayload;
  success: Scalars['Boolean']['output'];
};

export type ChargebackReasonPayload = {
  __typename?: 'ChargebackReasonPayload';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  network: Scalars['String']['output'];
};

export type ChargebackReasonQueryInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
};

export type ChargebackReasonsQueryResponse = {
  __typename?: 'ChargebackReasonsQueryResponse';
  chargebackReasons: Array<ChargebackReason>;
};

export type CheckTenantAuthInput = {
  accessibleTenantIds: Array<InputMaybe<Scalars['String']['input']>>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
};

export type CheckTenantAuthResponse = {
  __typename?: 'CheckTenantAuthResponse';
  isAuthorized: Scalars['Boolean']['output'];
  tenantId?: Maybe<Scalars['String']['output']>;
};

export enum CheckoutCtaText {
  Deposit = 'DEPOSIT',
  OrderNow = 'ORDER_NOW',
  Pay = 'PAY',
  PayNow = 'PAY_NOW',
  PlaceYourOrder = 'PLACE_YOUR_ORDER'
}

export enum CheckoutSessionType {
  Checkout = 'checkout',
  Invoice = 'invoice',
  Payment = 'payment',
  Setup = 'setup',
  Subscription = 'subscription'
}

export type Collaboration = {
  __typename?: 'Collaboration';
  amount?: Maybe<Scalars['String']['output']>;
  arn?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  refundableUntilDate?: Maybe<Scalars['String']['output']>;
  source?: Maybe<CollaborationSource>;
  status?: Maybe<CollaborationStatus>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export enum CollaborationMatchFilter {
  All = 'ALL',
  MatchedOnly = 'MATCHED_ONLY',
  UnmatchedOnly = 'UNMATCHED_ONLY'
}

export enum CollaborationSource {
  Cdrn = 'cdrn',
  Ethoca = 'ethoca',
  McCollaboration = 'mc_collaboration'
}

export enum CollaborationStatus {
  Escalated = 'escalated',
  Ignored = 'ignored',
  Open = 'open',
  Resolved = 'resolved'
}

export type CollaborationsCsvReportQueryInput = {
  filter?: InputMaybe<CollaborationsQueryInputFilter>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  reportName: Scalars['String']['input'];
  select: Array<Scalars['String']['input']>;
};

export type CollaborationsCsvReportResponse = {
  __typename?: 'CollaborationsCsvReportResponse';
  url: Scalars['String']['output'];
};

export type CollaborationsQueryExactFilterInputValues = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  billingDetails__countryAlpha2?: InputMaybe<Scalars['String']['input']>;
  billingDetails__state?: InputMaybe<Scalars['String']['input']>;
  billingDetails__zip?: InputMaybe<Scalars['String']['input']>;
  consumerEmail?: InputMaybe<Scalars['String']['input']>;
  consumerFirstName?: InputMaybe<Scalars['String']['input']>;
  consumerFullName?: InputMaybe<Scalars['String']['input']>;
  consumerId?: InputMaybe<Scalars['String']['input']>;
  consumerLastName?: InputMaybe<Scalars['String']['input']>;
  consumerMerchantConsumerId?: InputMaybe<Scalars['String']['input']>;
  consumerPhone?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__addressLine1Check?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__addressPostalCodeCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__bin?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__brand?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__cvcCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__expiryMonth?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__expiryYear?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__fingerprint?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__funding?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__issuerCountry?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__lastFourDigits?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__network?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__walletTokenizedCardLast4?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__addressLine1Check?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__addressPostalCodeCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__bin?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__brand?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__cvcCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__expiryMonth?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__expiryYear?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__fingerprint?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__funding?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__issuerCountry?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__lastFourDigits?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__network?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__generic__type?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__addressLine1Check?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__addressPostalCodeCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__bin?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__brand?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__cvcCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__expiryMonth?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__expiryYear?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__fingerprint?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__funding?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__issuerCountry?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__lastFourDigits?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__network?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__walletTokenizedCardLast4?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__paypal__email?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__paypal__firstName?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__paypal__isBillingAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod__paypal__lastName?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__paypal__payerId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__type?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<CollaborationSource>;
  status?: InputMaybe<CollaborationStatus>;
  threeDsResult?: InputMaybe<TransactionThreeDsResult>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationsQueryInFilterInputValues = {
  currency?: InputMaybe<Array<Scalars['String']['input']>>;
  network?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__addressLine1Check?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__addressPostalCodeCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__brand?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__cardCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__cardType?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__cvcCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__network?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__addressLine1Check?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__addressPostalCodeCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__brand?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__cardCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__cardType?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__cvcCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__network?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__generic__type?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__addressLine1Check?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__addressPostalCodeCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__brand?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__cardCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__cardType?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__cvcCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__network?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__type?: InputMaybe<Array<Scalars['String']['input']>>;
  source?: InputMaybe<Array<CollaborationSource>>;
  status?: InputMaybe<Array<CollaborationStatus>>;
  threeDsResult?: InputMaybe<Array<TransactionThreeDsResult>>;
};

export type CollaborationsQueryInput = {
  filter?: InputMaybe<CollaborationsQueryInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchFilter?: InputMaybe<CollaborationMatchFilter>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type CollaborationsQueryInputFilter = {
  and?: InputMaybe<Array<InputMaybe<CollaborationsQueryInputFilter>>>;
  between?: InputMaybe<CollaborationsQueryRangeFilterInputValues>;
  equal?: InputMaybe<CollaborationsQueryExactFilterInputValues>;
  greater?: InputMaybe<CollaborationsQueryExactFilterInputValues>;
  greaterOrEquals?: InputMaybe<CollaborationsQueryExactFilterInputValues>;
  iLike?: InputMaybe<CollaborationsQueryExactFilterInputValues>;
  in?: InputMaybe<CollaborationsQueryInFilterInputValues>;
  less?: InputMaybe<CollaborationsQueryExactFilterInputValues>;
  lessOrEquals?: InputMaybe<CollaborationsQueryExactFilterInputValues>;
  like?: InputMaybe<CollaborationsQueryExactFilterInputValues>;
  notBetween?: InputMaybe<CollaborationsQueryRangeFilterInputValues>;
  notEqual?: InputMaybe<CollaborationsQueryExactFilterInputValues>;
  notIn?: InputMaybe<CollaborationsQueryInFilterInputValues>;
  notLike?: InputMaybe<CollaborationsQueryExactFilterInputValues>;
  or?: InputMaybe<Array<CollaborationsQueryInputFilter>>;
};

export type CollaborationsQueryRangeFilterInputValues = {
  amount?: InputMaybe<FloatRangeInput>;
  createdAt?: InputMaybe<StringRangeInput>;
  refundableUntilDate?: InputMaybe<StringRangeInput>;
};

export type CollaborationsQueryResponse = {
  __typename?: 'CollaborationsQueryResponse';
  collaborations?: Maybe<Array<Collaboration>>;
  pageInfo: PageInfo;
};

export type CollaborationsRefundMutationInput = {
  collaborationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CollaborationsRefundResponse = {
  __typename?: 'CollaborationsRefundResponse';
  success: Scalars['Boolean']['output'];
};

export type Commission = {
  __typename?: 'Commission';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CommonSettingsAmountInputObject = {
  amount: Scalars['String']['input'];
  dynamicAmountUrl?: InputMaybe<Scalars['String']['input']>;
  type: AmountTypeEnum;
};

export type CommonSettingsAmountObject = {
  __typename?: 'CommonSettingsAmountObject';
  amount: Scalars['String']['output'];
  dynamicAmountUrl?: Maybe<Scalars['String']['output']>;
  type: AmountTypeEnum;
};

export type CommonSettingsDisputeObject = {
  __typename?: 'CommonSettingsDisputeObject';
  created?: Maybe<CommonSettingsSubscriptionStatusObject>;
  lost?: Maybe<CommonSettingsSubscriptionStatusObject>;
};

export type CommonSettingsInputObject = {
  amount: CommonSettingsAmountInputObject;
  currency: CurrencyAlpha3;
  failure?: InputMaybe<FailureEnum>;
  retries?: InputMaybe<CommonSettingsRetriesInputObject>;
  schedule: CommonSettingsIntervalInputObject;
};

export type CommonSettingsIntervalInputObject = {
  interval: IntervalEnum;
  intervalCount: Scalars['Int']['input'];
};

export type CommonSettingsIntervalObject = {
  __typename?: 'CommonSettingsIntervalObject';
  interval: IntervalEnum;
  intervalCount?: Maybe<Scalars['Int']['output']>;
};

export type CommonSettingsObject = {
  __typename?: 'CommonSettingsObject';
  amount: CommonSettingsAmountObject;
  cancel?: Maybe<CommonSettingsIntervalObject>;
  currency: CurrencyAlpha3;
  dispute?: Maybe<CommonSettingsDisputeObject>;
  failure?: Maybe<FailureEnum>;
  fraudWarning?: Maybe<CommonSettingsSubscriptionStatusObject>;
  pause?: Maybe<PauseEnum>;
  retries?: Maybe<CommonSettingsRetriesObject>;
  schedule?: Maybe<CommonSettingsIntervalObject>;
  trial?: Maybe<CommonSettingsIntervalObject>;
};

export type CommonSettingsRetriesInputObject = {
  attempts: Scalars['Int']['input'];
  interval: IntervalEnum;
  intervalCount: Scalars['Int']['input'];
};

export type CommonSettingsRetriesObject = {
  __typename?: 'CommonSettingsRetriesObject';
  attempts: Scalars['Int']['output'];
  interval: IntervalEnum;
  intervalCount?: Maybe<Scalars['Int']['output']>;
};

export type CommonSettingsSubscriptionStatusObject = {
  __typename?: 'CommonSettingsSubscriptionStatusObject';
  currentSubscription?: Maybe<DisputeHandlingEnum>;
  otherSubscriptions?: Maybe<DisputeHandlingEnum>;
};

export type CommonSubscriptionMutationResponse = {
  __typename?: 'CommonSubscriptionMutationResponse';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type CompanyAndMerchantInput = {
  companyId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};

export type CompanyMerchantIndividualInput = {
  individualId: Scalars['String']['input'];
};

export type Config = {
  __typename?: 'Config';
  email?: Maybe<Email>;
  s3?: Maybe<S3>;
  sftp?: Maybe<Sftp>;
};

export type ConfigInput = {
  email?: InputMaybe<EmailInput>;
  s3?: InputMaybe<S3Input>;
  sftp?: InputMaybe<SftpInput>;
};

export type ConfirmationModalConfig = {
  __typename?: 'ConfirmationModalConfig';
  cancelButtonLabel?: Maybe<Scalars['String']['output']>;
  confirmButtonLabel?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ConfirmationModalConfigInput = {
  cancelButtonLabel?: InputMaybe<Scalars['String']['input']>;
  confirmButtonLabel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ConsumerBlockedQueryInput = {
  merchantConsumerId: Scalars['String']['input'];
};

export type ConsumerBlockedQueryResponse = {
  __typename?: 'ConsumerBlockedQueryResponse';
  blocked: Scalars['Boolean']['output'];
  listId?: Maybe<Scalars['String']['output']>;
};

export type ConsumerExcludedFromAllRulesQueryInput = {
  merchantConsumerId: Scalars['String']['input'];
};

export type ConsumerExcludedFromAllRulesQueryResponse = {
  __typename?: 'ConsumerExcludedFromAllRulesQueryResponse';
  excluded: Scalars['Boolean']['output'];
  listId?: Maybe<Scalars['String']['output']>;
};

export type ConsumerInsightsResponse = {
  __typename?: 'ConsumerInsightsResponse';
  activeSubscriptions?: Maybe<Scalars['String']['output']>;
  disputesCount: Scalars['String']['output'];
  disputesVolume: Scalars['String']['output'];
  paymentsCount: Scalars['String']['output'];
  paymentsVolume: Scalars['String']['output'];
  payoutsCount?: Maybe<Scalars['String']['output']>;
  payoutsVolume?: Maybe<Scalars['String']['output']>;
  refundsCount: Scalars['String']['output'];
  refundsVolume: Scalars['String']['output'];
  sessionsCompleted: Scalars['String']['output'];
  sessionsInitiated: Scalars['String']['output'];
  totalSubscriptions?: Maybe<Scalars['String']['output']>;
};

export type ConsumerObject = {
  __typename?: 'ConsumerObject';
  billingDetails: Array<Maybe<AddressObject>>;
  blacklistedCards?: Maybe<Array<Scalars['String']['output']>>;
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  defaultSource?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastTransactionDate?: Maybe<Scalars['String']['output']>;
  merchantConsumerId?: Maybe<Scalars['ID']['output']>;
  merchantId: Scalars['String']['output'];
  /** metadata is serialized object */
  metadata?: Maybe<Scalars['String']['output']>;
  nationalIdentificationNumber?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  shippingDetails: Array<Maybe<AddressObject>>;
  sources?: Maybe<Array<Maybe<ConsumerSourceObject>>>;
  taxId?: Maybe<Scalars['ID']['output']>;
  termsAndConditionsAcceptedOnTransaction?: Maybe<Scalars['String']['output']>;
};

export type ConsumerQueryInput = {
  id: Scalars['String']['input'];
};

export type ConsumerRuleExclusion = {
  __typename?: 'ConsumerRuleExclusion';
  checkout?: Maybe<Scalars['Boolean']['output']>;
  consumerId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  excludedBy?: Maybe<Scalars['String']['output']>;
  excludedUntilDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  ignoredUntilDate?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  originalTransaction?: Maybe<Scalars['Boolean']['output']>;
  outcomes: Array<RiskRuleOutcome>;
  paymentAttempt?: Maybe<Scalars['Int']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  retryAttemptCounter?: Maybe<Scalars['Int']['output']>;
  ruleId: Scalars['String']['output'];
  status: ConsumerRuleExclusionStatus;
  transactionAttemptId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<TransactionTypes>;
  updatedAt: Scalars['String']['output'];
};

export type ConsumerRuleExclusionMutationResponse = {
  __typename?: 'ConsumerRuleExclusionMutationResponse';
  success: Scalars['Boolean']['output'];
};

export enum ConsumerRuleExclusionStatus {
  Closed = 'closed',
  Created = 'created',
  Excluded = 'excluded',
  ExcludedTemporary = 'excluded_temporary',
  Expired = 'expired',
  IgnoredTemporary = 'ignored_temporary'
}

export type ConsumerRuleExclusionsCsvReportQueryInput = {
  filter?: InputMaybe<ConsumerRuleExclusionsInputFilter>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  reportName: Scalars['String']['input'];
  select: Array<Scalars['String']['input']>;
};

export type ConsumerRuleExclusionsCsvReportResponse = {
  __typename?: 'ConsumerRuleExclusionsCsvReportResponse';
  url: Scalars['String']['output'];
};

export type ConsumerRuleExclusionsExactInputFilter = {
  checkout?: InputMaybe<Scalars['Boolean']['input']>;
  consumerId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  excludedBy?: InputMaybe<Scalars['String']['input']>;
  originalTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  paymentAttempt?: InputMaybe<Scalars['Int']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  retryAttemptCounter?: InputMaybe<Scalars['Int']['input']>;
  ruleId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConsumerRuleExclusionStatus>;
  transactionAttemptId?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<TransactionTypes>;
};

export type ConsumerRuleExclusionsInInputFilter = {
  status?: InputMaybe<Array<ConsumerRuleExclusionStatus>>;
  transactionId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ConsumerRuleExclusionsInputFilter = {
  and?: InputMaybe<Array<InputMaybe<ConsumerRuleExclusionsInputFilter>>>;
  between?: InputMaybe<ConsumerRuleExclusionsRangeFilterInput>;
  equal?: InputMaybe<ConsumerRuleExclusionsExactInputFilter>;
  greater?: InputMaybe<ConsumerRuleExclusionsExactInputFilter>;
  greaterOrEquals?: InputMaybe<ConsumerRuleExclusionsExactInputFilter>;
  iLike?: InputMaybe<ConsumerRuleExclusionsExactInputFilter>;
  in?: InputMaybe<ConsumerRuleExclusionsInInputFilter>;
  less?: InputMaybe<ConsumerRuleExclusionsExactInputFilter>;
  lessOrEquals?: InputMaybe<ConsumerRuleExclusionsExactInputFilter>;
  like?: InputMaybe<ConsumerRuleExclusionsExactInputFilter>;
  notBetween?: InputMaybe<ConsumerRuleExclusionsRangeFilterInput>;
  notEqual?: InputMaybe<ConsumerRuleExclusionsExactInputFilter>;
  notIn?: InputMaybe<ConsumerRuleExclusionsInInputFilter>;
  notLike?: InputMaybe<ConsumerRuleExclusionsExactInputFilter>;
  or?: InputMaybe<Array<InputMaybe<ConsumerRuleExclusionsInputFilter>>>;
  textSearchCaseInsensitive?: InputMaybe<ConsumerRuleExclusionsExactInputFilter>;
};

export type ConsumerRuleExclusionsQueryInput = {
  filter?: InputMaybe<ConsumerRuleExclusionsInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ConsumerRuleExclusionsQueryResponse = {
  __typename?: 'ConsumerRuleExclusionsQueryResponse';
  consumerRuleExclusions: Array<ConsumerRuleExclusion>;
  pageInfo: PageInfo;
};

export type ConsumerRuleExclusionsRangeFilterInput = {
  createdAt?: InputMaybe<StringRangeInput>;
  excludedUntilDate?: InputMaybe<StringRangeInput>;
  ignoredUntilDate?: InputMaybe<StringRangeInput>;
  updatedAt?: InputMaybe<StringRangeInput>;
};

export type ConsumerSourceObject = {
  __typename?: 'ConsumerSourceObject';
  id: Scalars['String']['output'];
  networkTransactionTxId?: Maybe<Scalars['String']['output']>;
  paymentMethodDetails?: Maybe<PaymentMethod>;
  reusablePayments?: Maybe<Scalars['Boolean']['output']>;
  reusablePayouts?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  uniqueIdentifier?: Maybe<Scalars['String']['output']>;
};

export type ConsumersObject = {
  __typename?: 'ConsumersObject';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  merchantConsumerId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ConsumersQueryInput = {
  filter: Scalars['String']['input'];
};

export type ConsumersResponse = {
  __typename?: 'ConsumersResponse';
  items?: Maybe<Array<Maybe<ConsumersObject>>>;
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ContactInfoInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ContactInfoListInput = {
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ContinentAlpha2 {
  Af = 'AF',
  An = 'AN',
  As = 'AS',
  Eu = 'EU',
  Na = 'NA',
  Oc = 'OC',
  Sa = 'SA',
  Uk = 'UK'
}

/** REFERENCE: https://github.com/pay-com/grpc-core-costs/blob/main/service.proto#L38 */
export type Cost = {
  __typename?: 'Cost';
  action: Scalars['String']['output'];
  basisFeeDescription?: Maybe<Scalars['String']['output']>;
  basisPoints: Scalars['String']['output'];
  costTypeBasisPoints?: Maybe<CostType>;
  costTypeFixed?: Maybe<CostType>;
  currency: CurrencyAlpha3;
  fixedFee: Scalars['String']['output'];
  fixedFeeDescription?: Maybe<Scalars['String']['output']>;
  paymentMethodType: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  revShareFixedPercentage?: Maybe<Scalars['String']['output']>;
};

export type CostMutationResponse = {
  __typename?: 'CostMutationResponse';
  payload: CostPayload;
  success: Scalars['Boolean']['output'];
};

export type CostPayload = {
  __typename?: 'CostPayload';
  action: Scalars['String']['output'];
  provider: Scalars['String']['output'];
};

export type CostQueryInput = {
  action: Scalars['ID']['input'];
  currency: CurrencyAlpha3;
  paymentMethodType: Scalars['String']['input'];
  provider: Scalars['ID']['input'];
};

/** REFERENCE: https://github.com/pay-com/libs-types/blob/main/protos/common.proto#L1033 */
export enum CostType {
  Invoice = 'invoice',
  Net = 'net',
  Receivable = 'receivable'
}

export type Country = {
  __typename?: 'Country';
  alpha2: CountryAlpha2;
  enabled: Scalars['Boolean']['output'];
  highRiskBin: Scalars['Boolean']['output'];
  highRiskIp: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  ofacSanctionProgram: Scalars['Boolean']['output'];
  prohibited: Scalars['Boolean']['output'];
  region: Scalars['String']['output'];
  riskLevel: Scalars['Int']['output'];
  subcontinent: Scalars['String']['output'];
  supportedMerchantJurisdiction: Scalars['Boolean']['output'];
};

export enum CountryAlpha2 {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  T1 = 'T1',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Uk = 'UK',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Xk = 'XK',
  Xx = 'XX',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export type CountryMutationResponse = {
  __typename?: 'CountryMutationResponse';
  success: Scalars['Boolean']['output'];
};

export type CountryQueryInput = {
  alpha2: CountryAlpha2;
};

export type CountryVolumeShare = {
  __typename?: 'CountryVolumeShare';
  countries?: Maybe<Array<CountryAlpha2>>;
  percentage?: Maybe<Scalars['String']['output']>;
  region?: Maybe<OnboardingCountryRegion>;
};

export type CountryVolumeShareInput = {
  countries?: InputMaybe<Array<CountryAlpha2>>;
  percentage?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<OnboardingCountryRegion>;
};

export type CreateApiKeyMutationInput = {
  allowedEndpoints?: InputMaybe<Array<ApiKeyEndpointPermissionInput>>;
  ipRanges?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pciCompliant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateAutomaticVerificationCheckObjectInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  mcc?: InputMaybe<Scalars['Int']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  provider: VerificationCheckProviderName;
  websites?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateBankAccountInput = {
  accountHolderName?: InputMaybe<Scalars['String']['input']>;
  accountIdentifier?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<AccountType>;
  bank?: InputMaybe<Scalars['String']['input']>;
  bankCountry?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  master?: InputMaybe<MasterAccountDetailsInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
  swiftBic?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BankAccountType>;
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCardPaymentMutationInput = {
  billingDetails?: InputMaybe<CardBillingAddress>;
  consumerId?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  receiptEmail?: InputMaybe<Scalars['String']['input']>;
  requestedAmount: Scalars['String']['input'];
  sendPaymentLinkEmail?: InputMaybe<Scalars['String']['input']>;
  statementDescriptorSuffix?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type CreateCardPaymentMutationResponse = {
  __typename?: 'CreateCardPaymentMutationResponse';
  jwt?: Maybe<Scalars['String']['output']>;
  paymentLink?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type CreateChargebackReasonMutationInput = {
  category?: InputMaybe<ChargebackReasonCategory>;
  code: Scalars['String']['input'];
  codeUsaOrCa?: InputMaybe<Scalars['String']['input']>;
  network: Scalars['String']['input'];
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
  reasonTitle?: InputMaybe<Scalars['String']['input']>;
  requiredDocumentation?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommissionInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateConsumerMutationInput = {
  billingDetails: Array<InputMaybe<AddressInput>>;
  defaultSource?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  merchantConsumerId?: InputMaybe<Scalars['ID']['input']>;
  nationalIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  shippingDetails: Array<InputMaybe<AddressInput>>;
  taxId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateConsumerMutationResponse = {
  __typename?: 'CreateConsumerMutationResponse';
  billingDetails: Array<Maybe<AddressObject>>;
  companyId: Scalars['String']['output'];
  defaultSource?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastTransactionDate?: Maybe<Scalars['String']['output']>;
  merchantConsumerId?: Maybe<Scalars['ID']['output']>;
  merchantId: Scalars['String']['output'];
  nationalIdentificationNumber?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  shippingDetails: Array<Maybe<AddressObject>>;
  taxId?: Maybe<Scalars['ID']['output']>;
  termsAndConditionsAcceptedOnTransaction?: Maybe<Scalars['String']['output']>;
};

export type CreateCostMutationInput = {
  action: Scalars['String']['input'];
  basisFeeDescription?: InputMaybe<Scalars['String']['input']>;
  basisPoints: Scalars['String']['input'];
  costTypeBasisPoints?: InputMaybe<CostType>;
  costTypeFixed?: InputMaybe<CostType>;
  currency: CurrencyAlpha3;
  fixedFee: Scalars['String']['input'];
  fixedFeeDescription?: InputMaybe<Scalars['String']['input']>;
  paymentMethodType: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  revShareFixedPercentage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCountryInput = {
  alpha2: CountryAlpha2;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  highRiskBin?: InputMaybe<Scalars['Boolean']['input']>;
  highRiskIp?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  ofacSanctionProgram?: InputMaybe<Scalars['Boolean']['input']>;
  prohibited?: InputMaybe<Scalars['Boolean']['input']>;
  region: Scalars['String']['input'];
  riskLevel?: InputMaybe<Scalars['Int']['input']>;
  subcontinent: Scalars['String']['input'];
  supportedMerchantJurisdiction?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCrmFieldInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  formType?: InputMaybe<CustomFieldType>;
  id: Scalars['ID']['input'];
  inputType?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<CustomFieldsOptionInput>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  type: CrmFieldType;
  validation?: InputMaybe<CustomFieldsValidationInput>;
};

export type CreateCrmFieldMutationResponse = {
  __typename?: 'CreateCrmFieldMutationResponse';
  id: Scalars['ID']['output'];
};

export type CreateCsvReportFilterInputValues = {
  additionalQueryParams?: InputMaybe<Scalars['JSON']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  isRaw?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  reportName: Scalars['String']['input'];
  select: Array<Scalars['String']['input']>;
  tableName: Scalars['String']['input'];
};

export type CreateCsvReportQueryResponse = {
  __typename?: 'CreateCsvReportQueryResponse';
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateDashboard = {
  dashboardId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  groups?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  type?: InputMaybe<DashboardType>;
};

export type CreateDocumentTypeInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  defaultDocumentTags?: InputMaybe<Array<Scalars['String']['input']>>;
  label: Scalars['String']['input'];
  regions: Array<DocumentTypeRegion>;
  type: DocumentEntityType;
  value: Scalars['String']['input'];
};

export type CreateEntityTasksFromGroupTemplates = {
  companyId: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  groupTemplateSlugs: Array<Scalars['String']['input']>;
};

export type CreateFeatureFlagMutationInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateFinanceInput = {
  commissionSetup?: InputMaybe<Array<EntityShareSetupInput>>;
  companyId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
  referralId?: InputMaybe<Scalars['String']['input']>;
  revShareTiers?: InputMaybe<Array<RevShareTiersInput>>;
};

export type CreateIndividualInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentType?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  nationalities?: InputMaybe<Array<CountryAlpha2>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  residentialAddress?: InputMaybe<AddressInput>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  type: IndividualType;
};

export type CreateIndividualRelationInput = {
  contactTypes?: InputMaybe<Array<IndividualContactType>>;
  isContact?: InputMaybe<Scalars['Boolean']['input']>;
  isShareholder?: InputMaybe<Scalars['Boolean']['input']>;
  isUbo?: InputMaybe<Scalars['Boolean']['input']>;
  percentageOfShares?: InputMaybe<Scalars['String']['input']>;
  relatedCompanyId?: InputMaybe<Scalars['ID']['input']>;
  relatedEntityId?: InputMaybe<Scalars['ID']['input']>;
  relatedIndividualId?: InputMaybe<Scalars['ID']['input']>;
  relatedPartnerId?: InputMaybe<Scalars['ID']['input']>;
  signsTaxDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIndividualWithRelationInput = {
  individual: CreateIndividualInput;
  individualRelation: CreateIndividualRelationInput;
};

export type CreateIndividualWithRelationResponse = {
  __typename?: 'CreateIndividualWithRelationResponse';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateLogicFieldInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  options?: InputMaybe<Array<LogicFieldOptionInput>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  regex?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LogicType>;
  valueFieldType: LogicFieldsValueFieldType;
};

export type CreateMccInput = {
  cardSchemas: Array<MccCardScheme>;
  code: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  transactionTypeCodes?: InputMaybe<Array<TransactionTypeCodesInput>>;
  type?: InputMaybe<MccType>;
};

export type CreateMccMutationInput = {
  amlRank: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  exposureFactor: Scalars['Float']['input'];
  exposureRiskCategory?: InputMaybe<ExposureRiskCategory>;
  mcc: Scalars['Int']['input'];
  primaryCategory: Scalars['String']['input'];
  riskTier: Scalars['Int']['input'];
};

export type CreateMerchantDashboardInput = {
  dashboardId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateMerchantDashboardResponse = {
  __typename?: 'CreateMerchantDashboardResponse';
  success: Scalars['Boolean']['output'];
};

export type CreateMerchantSettingsResponse = {
  __typename?: 'CreateMerchantSettingsResponse';
  success: Scalars['Boolean']['output'];
};

export type CreateNoteMutationInput = {
  content: Scalars['String']['input'];
  context?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  resource: NoteResource;
  resourceId: Scalars['ID']['input'];
};

export type CreateNoteMutationResponse = {
  __typename?: 'CreateNoteMutationResponse';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
  userDisplayName: Scalars['String']['output'];
};

export type CreateOnboardingJwtMutationResponse = {
  __typename?: 'CreateOnboardingJWTMutationResponse';
  jti: Scalars['String']['output'];
  jwt: Scalars['String']['output'];
};

export type CreateOnboardingPricingFieldInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  categories: Array<OnboardingPricingFieldCategory>;
  contractTypes?: InputMaybe<Array<OnboardingPricingContractType>>;
  fieldTypes?: InputMaybe<Array<OnboardingPricingFieldFieldType>>;
  frequency?: InputMaybe<Array<OnboardingPricingFieldFrequency>>;
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  regions?: InputMaybe<Array<OnboardingPricingRegion>>;
  tieredTypeConfig?: InputMaybe<OnboardingPricingFieldTieredTypeConfigInput>;
  type: OnboardingPricingFieldType;
};

export type CreateOnboardingPricingInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  categories?: InputMaybe<Array<OnboardingPricingCategoryInput>>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<OnboardingPricingContractType>;
  currency?: InputMaybe<CurrencyAlpha3>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pricingType?: InputMaybe<OnboardingPricingType>;
  primaryContact?: InputMaybe<OnboardingPricingPrimaryContactInput>;
  region?: InputMaybe<OnboardingPricingRegion>;
  salesAssignee?: InputMaybe<Scalars['String']['input']>;
  settlementTerms?: InputMaybe<OnboardingPricingSettlementTermsInput>;
  status?: InputMaybe<OnboardingPricingStatus>;
};

export type CreateOnboardingPricingMutationResponse = {
  __typename?: 'CreateOnboardingPricingMutationResponse';
  id: Scalars['ID']['output'];
};

export type CreateOrUpdateFailureCodeMessageQueryInput = {
  dashboardMessage: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endUserMessage: Scalars['String']['input'];
  errorCode: Scalars['String']['input'];
  fallbackable?: InputMaybe<Scalars['Boolean']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOrUpdateIssuerResponseCodeQueryInput = {
  code: Scalars['String']['input'];
  failureCode: Scalars['String']['input'];
  failureDescription?: InputMaybe<Scalars['String']['input']>;
  networkCode?: InputMaybe<Scalars['String']['input']>;
  subType: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreatePaymentLinkMutationInput = {
  allowedCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  amount: Scalars['String']['input'];
  amountLimits?: InputMaybe<AmountLimitsInput>;
  currency: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isBillingAddressEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailAddressEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFullNameEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isShippingAddressEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  paymentMethods: Array<Scalars['String']['input']>;
  sendReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  statementDescriptorSuffix?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PaymentLinkType>;
};

export type CreatePaymentLinkMutationResponse = {
  __typename?: 'CreatePaymentLinkMutationResponse';
  paymentLink?: Maybe<Scalars['String']['output']>;
  paymentLinkId?: Maybe<Scalars['String']['output']>;
};

export type CreatePayoutInput = {
  /** The amount to be paid out. */
  amount: Scalars['Float']['input'];
  /** The currency of the payout. */
  currency: CurrencyAlpha3;
  /** The ID of the customer to which the payout should be made. (consumerId) */
  customerId: Scalars['String']['input'];
  /** The unique ID of the payment method (sourceId) that the funds will be send to. */
  destinationId: Scalars['String']['input'];
};

export type CreatePayoutResponse = {
  __typename?: 'CreatePayoutResponse';
  message?: Maybe<Scalars['String']['output']>;
  payout?: Maybe<Payout>;
  success: Scalars['Boolean']['output'];
};

export type CreateProviderFeaturesMutationInput = {
  amex?: InputMaybe<Scalars['Boolean']['input']>;
  authorization?: InputMaybe<Scalars['Boolean']['input']>;
  cancelMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  cancelPartial?: InputMaybe<Scalars['Boolean']['input']>;
  captureMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  capturePartial?: InputMaybe<Scalars['Boolean']['input']>;
  defaultPrecision?: InputMaybe<Scalars['String']['input']>;
  discover?: InputMaybe<Scalars['Boolean']['input']>;
  externalSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  incrementalAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  interchangeFeeCostType?: InputMaybe<Scalars['String']['input']>;
  internalSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  mastercard?: InputMaybe<Scalars['Boolean']['input']>;
  networkFeeCostType?: InputMaybe<Scalars['String']['input']>;
  paymentMethodType: Scalars['String']['input'];
  payout?: InputMaybe<Scalars['Boolean']['input']>;
  processingCurrencyCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** map<string, string> */
  processingToSettlementsCurrencyCodes?: InputMaybe<Scalars['JSON']['input']>;
  provider: Scalars['String']['input'];
  refundMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  refundPartial?: InputMaybe<Scalars['Boolean']['input']>;
  sale?: InputMaybe<Scalars['Boolean']['input']>;
  settlementCurrencyCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  verification?: InputMaybe<Scalars['Boolean']['input']>;
  visa?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateProvisioningTemplateMutationInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  disposable?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Array<TaskFieldsInput>>;
  groups?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantFacing?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  requirePricingActions?: InputMaybe<Array<Scalars['String']['input']>>;
  requirePricingOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  shouldCreateSettlementAccount?: InputMaybe<Scalars['Boolean']['input']>;
  validationConfig?: InputMaybe<Array<ValidationConfigInput>>;
  workflowName: Scalars['String']['input'];
};

export type CreateProvisioningTemplateMutationResponse = {
  __typename?: 'CreateProvisioningTemplateMutationResponse';
  id: Scalars['ID']['output'];
};

export type CreateReconciliationConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  example?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  reconciliationType?: InputMaybe<Scalars['String']['input']>;
  regex: Scalars['String']['input'];
  workflow: Scalars['String']['input'];
};

export type CreateReferralInput = {
  alternativeCurrencies?: InputMaybe<Array<AlternativeCurrenciesInput>>;
  commissionSetup?: InputMaybe<Array<EntityShareSetupInput>>;
  currency: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expiresInYears?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  periodCountStartsFrom?: InputMaybe<Scalars['String']['input']>;
  revShareTiers?: InputMaybe<Array<RevShareTiersInput>>;
};

export type CreateRiskCalculationInput = {
  companyId: Scalars['String']['input'];
  isHighRiskOverriden?: InputMaybe<Scalars['Boolean']['input']>;
  manualHighRiskOverridenReason?: InputMaybe<Scalars['String']['input']>;
  merchantId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<ScoreType>;
};

export type CreateRiskListMutationInput = {
  name: Scalars['String']['input'];
  type: RiskListType;
};

export type CreateRiskListMutationResponse = {
  __typename?: 'CreateRiskListMutationResponse';
  listId: Scalars['String']['output'];
};

export type CreateRiskRuleMutationInput = {
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  failureCode?: InputMaybe<Scalars['String']['input']>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  logic: Scalars['String']['input'];
  logicClient: Scalars['String']['input'];
  outcomeDetails?: InputMaybe<OutcomeDetailsInput>;
  outcomeDetailsByRange?: InputMaybe<Array<OutcomeDetailsByRangeItemInput>>;
  outcomes: Array<RiskRuleOutcome>;
  postExternalRiskCheck?: InputMaybe<Scalars['Boolean']['input']>;
  rulePriority?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateRoutineTemplateMutationInput = {
  category?: InputMaybe<RoutineTemplateCategory>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  defaultValues?: InputMaybe<Array<TaskFieldInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<TaskFieldsInput>>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  status?: InputMaybe<RoutinesTemplateStatuses>;
  userGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  validationConfigs?: InputMaybe<Array<ValidationConfigInput>>;
  workflowSteps?: InputMaybe<Array<WorkflowStepInput>>;
};

export type CreateSshKeyPairMutationInput = {
  publicKey?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSandboxMerchantInput = {
  currencies?: InputMaybe<Array<CurrencyAlpha3>>;
  name: Scalars['String']['input'];
  pciCompliant?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<ContinentAlpha2>;
  userToInvite?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSandboxMerchantResponse = {
  __typename?: 'CreateSandboxMerchantResponse';
  success: Scalars['Boolean']['output'];
};

export type CreateSnowflakeIdsInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSnowflakeIdsResponse = {
  __typename?: 'CreateSnowflakeIdsResponse';
  ids: Array<Scalars['String']['output']>;
};

export type CreateStructureMutationInput = {
  amlRiskScore?: InputMaybe<Scalars['Int']['input']>;
  countryAlpha2: CountryAlpha2;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  localName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSubscriptionInput = {
  cancelAt?: InputMaybe<Scalars['String']['input']>;
  consumerId: Scalars['String']['input'];
  currentPeriodEndDate?: InputMaybe<Scalars['String']['input']>;
  currentPeriodStartDate?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CustomSettingsInputObject>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SubscriptionStatusEnum>;
};

export type CreateSubscriptionPackageInput = {
  description: Scalars['String']['input'];
  settings: CommonSettingsInputObject;
};

export type CreateTask = {
  assignee?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  creatorNote?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  entityId?: InputMaybe<Scalars['String']['input']>;
  expiresOn?: InputMaybe<Scalars['String']['input']>;
  groupAssignee?: InputMaybe<Scalars['String']['input']>;
  merchantGroupAssignee?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateTaskTemplate = {
  actions: Array<TaskTemplateActionButtonInput>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<FieldInput>>;
  slug: Scalars['String']['input'];
  system?: InputMaybe<TaskSystem>;
  taskCategoryId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: TaskType;
  workflow?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTransactionMutationInput = {
  currency: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  requestedAmount: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreateTransactionMutationResponse = {
  __typename?: 'CreateTransactionMutationResponse';
  jwt?: Maybe<Scalars['String']['output']>;
};

export type CreateUser = {
  countryAlpha2?: InputMaybe<CountryAlpha2>;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
};

export type CreateVerificationCheckObjectInput = {
  applicableTo: VerificationCheckApplicableTo;
  checkProcessingType: VerificationCheckProcessingType;
  checkProviderReference?: InputMaybe<Scalars['String']['input']>;
  checkResults?: InputMaybe<VerificationCheckResultsInput>;
  checkStage?: InputMaybe<VerificationCheckStage>;
  checkStatus?: InputMaybe<Scalars['String']['input']>;
  checkType: VerificationCheckType;
  comments?: InputMaybe<Array<VerificationCheckCommentInput>>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  individualId?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  providerName: VerificationCheckProviderName;
  summary?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWebhookMutationInput = {
  eventTypes: Array<NotificationType>;
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateWebsiteInput = {
  acquiringServices?: InputMaybe<Array<WebsiteAcquiringSetup>>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['String']['input'];
  dba?: InputMaybe<Scalars['String']['input']>;
  domain: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  login?: InputMaybe<Scalars['String']['input']>;
  mccs?: InputMaybe<Array<Scalars['Int']['input']>>;
  msaSignedAt?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  platformRequiresTestUser?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<WebsiteStatus>;
  terminationDescription?: InputMaybe<Scalars['String']['input']>;
  terminationReason?: InputMaybe<WebsiteTerminationReason>;
  underwritingDescription?: InputMaybe<Scalars['String']['input']>;
  underwritingStatus?: InputMaybe<WebsiteUnderwritingStatus>;
};

export type CreateWebsitesBulkInput = {
  websites: Array<CreateWebsiteInput>;
};

export type CrmField = {
  __typename?: 'CrmField';
  description?: Maybe<Scalars['String']['output']>;
  formType?: Maybe<CustomFieldType>;
  id: Scalars['ID']['output'];
  inputType?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<CustomFieldsOption>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  type: CrmFieldType;
  validation?: Maybe<CustomFieldsValidation>;
};

export enum CrmFieldType {
  Boolean = 'boolean',
  Json = 'json',
  List = 'list',
  Number = 'number',
  String = 'string'
}

export type CrmFieldValue = {
  key: Scalars['String']['input'];
  value: MerchantCrmFieldValueInput;
};

export type CrmFields = {
  __typename?: 'CrmFields';
  crmFieldsDefinitions?: Maybe<Array<CrmField>>;
};

export type Currency = {
  __typename?: 'Currency';
  alpha3: CurrencyAlpha3;
  digitsAfterPoint: Scalars['Int']['output'];
  exponent: Scalars['Int']['output'];
  locationsUsing: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numeric: Scalars['Int']['output'];
};

export enum CurrencyAlpha3 {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Azn = 'AZN',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Bov = 'BOV',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Che = 'CHE',
  Chf = 'CHF',
  Chw = 'CHW',
  Clf = 'CLF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Cou = 'COU',
  Crc = 'CRC',
  Cuc = 'CUC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mru = 'MRU',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Mxv = 'MXV',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Stn = 'STN',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Usn = 'USN',
  Uyi = 'UYI',
  Uyu = 'UYU',
  Uyw = 'UYW',
  Uzs = 'UZS',
  Ves = 'VES',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xcd = 'XCD',
  Xof = 'XOF',
  Xpf = 'XPF',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW',
  Zwl = 'ZWL'
}

export enum CustomFieldType {
  Checkbox = 'checkbox',
  Date = 'date',
  Dropdown = 'dropdown',
  Input = 'input',
  Radio = 'radio',
  Select = 'select'
}

export type CustomFieldsOption = {
  __typename?: 'CustomFieldsOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CustomFieldsOptionInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CustomFieldsOptionsTypeObject = {
  __typename?: 'CustomFieldsOptionsTypeObject';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum CustomFieldsTypeEnum {
  Checkbox = 'checkbox',
  Date = 'date',
  Dropdown = 'dropdown',
  Input = 'input',
  Radio = 'radio',
  Select = 'select'
}

export type CustomFieldsTypeObject = {
  __typename?: 'CustomFieldsTypeObject';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  inputType?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<CustomFieldsOptionsTypeObject>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CustomFieldsTypeEnum>;
  validation?: Maybe<CustomFieldsValidationTypeObject>;
};

export type CustomFieldsValidation = {
  __typename?: 'CustomFieldsValidation';
  max?: Maybe<Scalars['Int']['output']>;
  maxLength?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minLength?: Maybe<Scalars['Int']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomFieldsValidationInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  minLength?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomFieldsValidationTypeObject = {
  __typename?: 'CustomFieldsValidationTypeObject';
  max?: Maybe<Scalars['Int']['output']>;
  maxLength?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minLength?: Maybe<Scalars['Int']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomRequestorOriginApiType = {
  __typename?: 'CustomRequestorOriginApiType';
  lastSixDigits?: Maybe<Scalars['String']['output']>;
};

export type CustomSettingsInputObject = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  overwritten?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<CommonSettingsInputObject>;
};

export type CustomSettingsObject = {
  __typename?: 'CustomSettingsObject';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  overwritten?: Maybe<Scalars['Boolean']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<CommonSettingsObject>;
};

export enum CustomerAccessPlatformType {
  App = 'app',
  Both = 'both',
  Website = 'website'
}

export type CustomerMetadata = {
  __typename?: 'CustomerMetadata';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  merchantConsumerId?: Maybe<Scalars['String']['output']>;
};

export type CustomerObject = {
  __typename?: 'CustomerObject';
  billingDetails?: Maybe<Array<Maybe<AddressObject>>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastTransactionDate?: Maybe<Scalars['String']['output']>;
  merchantConsumerId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  shippingDetails?: Maybe<Array<Maybe<AddressObject>>>;
};

export type CustomerSupport = {
  __typename?: 'CustomerSupport';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  statementDescriptor?: Maybe<Scalars['String']['output']>;
};

export type CustomerSupportFilterInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  statementDescriptor?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerSupportInFilterInput = {
  address?: InputMaybe<AddressListInput>;
};

export type CustomerSupportInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  statementDescriptor?: InputMaybe<Scalars['String']['input']>;
};

export type CustomersQueryExactFilterInputValues = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  merchantConsumerId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CustomersQueryFilterInput = {
  and?: InputMaybe<Array<InputMaybe<CustomersQueryFilterInput>>>;
  between?: InputMaybe<CustomersQueryRangeFilterInput>;
  equal?: InputMaybe<CustomersQueryExactFilterInputValues>;
  greater?: InputMaybe<CustomersQueryInputFilterInputValues>;
  greaterOrEquals?: InputMaybe<CustomersQueryInputFilterInputValues>;
  iLike?: InputMaybe<CustomersQueryInputFilterInputValues>;
  in?: InputMaybe<CustomersQueryInFilterInputValues>;
  less?: InputMaybe<CustomersQueryInputFilterInputValues>;
  lessOrEquals?: InputMaybe<CustomersQueryInputFilterInputValues>;
  like?: InputMaybe<CustomersQueryInputFilterInputValues>;
  notBetween?: InputMaybe<CustomersQueryRangeFilterInput>;
  notEqual?: InputMaybe<CustomersQueryInputFilterInputValues>;
  notIn?: InputMaybe<CustomersQueryInFilterInputValues>;
  notLike?: InputMaybe<CustomersQueryInputFilterInputValues>;
  or?: InputMaybe<Array<InputMaybe<CustomersQueryFilterInput>>>;
  textSearchCaseInsensitive?: InputMaybe<CustomersQueryInputFilterInputValues>;
};

export type CustomersQueryInFilterInputValues = {
  email?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CustomersQueryInput = {
  filter?: InputMaybe<CustomersQueryFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomersQueryInputFilterInputValues = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  merchantConsumerId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CustomersQueryRangeFilterInput = {
  lastTransactionDate?: InputMaybe<StringRangeInput>;
};

export type CustomersResponse = {
  __typename?: 'CustomersResponse';
  customers?: Maybe<Array<Maybe<CustomerObject>>>;
  pageInfo: PageInfo;
};

export enum DashboardAllowedResource {
  RiskRule = 'RISK_RULE',
  Subscription = 'SUBSCRIPTION',
  SubscriptionPackage = 'SUBSCRIPTION_PACKAGE'
}

export type DashboardAudit = {
  __typename?: 'DashboardAudit';
  action?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  system?: Maybe<AuditsSystem>;
};

export type DashboardAuditsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  resource: DashboardAllowedResource;
  resourceId: Scalars['String']['input'];
};

export type DashboardAuditsResponse = {
  __typename?: 'DashboardAuditsResponse';
  audits?: Maybe<Array<DashboardAudit>>;
  pageInfo: PageInfo;
};

export type DashboardConfigurationTypeObject = {
  __typename?: 'DashboardConfigurationTypeObject';
  temp?: Maybe<Scalars['String']['output']>;
};

export enum DashboardFeatureFlags {
  Account = 'account',
  AccountNotifications = 'accountNotifications',
  AccountTabs = 'accountTabs',
  ActivationModal = 'activationModal',
  Activity = 'activity',
  ActivityAuthentications = 'activityAuthentications',
  ActivityBulkActions = 'activityBulkActions',
  ActivityCashFlow = 'activityCashFlow',
  AutoIncludeWallets = 'autoIncludeWallets',
  BillingPackages = 'billingPackages',
  BillingSubscriptions = 'billingSubscriptions',
  BulkRefundCsv = 'bulkRefundCsv',
  Collaboration = 'collaboration',
  CollaborationsUnidentifiedAlerts = 'collaborationsUnidentifiedAlerts',
  CountryStateFilter = 'countryStateFilter',
  CreatePaymentCustomerManagement = 'createPaymentCustomerManagement',
  CreatePaymentLink = 'createPaymentLink',
  CreatePayout = 'createPayout',
  CsvExport = 'csvExport',
  CustomIssuerResponseEnabled = 'customIssuerResponseEnabled',
  CustomMerchantDashboards = 'customMerchantDashboards',
  Customers = 'customers',
  CvvWhitelist = 'cvvWhitelist',
  CybersourceRisk = 'cybersourceRisk',
  CybersourceRiskLearnMode = 'cybersourceRiskLearnMode',
  DeclineRecoveryFlexFactor = 'declineRecoveryFlexFactor',
  DefaultExportColumns = 'defaultExportColumns',
  Developers = 'developers',
  DevelopersApiKeys = 'developersApiKeys',
  DevelopersLogs = 'developersLogs',
  DevelopersOverview = 'developersOverview',
  DevelopersRequests = 'developersRequests',
  DevelopersSftp = 'developersSftp',
  DevelopersWebhooks = 'developersWebhooks',
  DisputeAccept = 'disputeAccept',
  DisputeDirectProviderFlow = 'disputeDirectProviderFlow',
  DisputeProvideEvidence = 'disputeProvideEvidence',
  Disputes = 'disputes',
  DisputesOverview = 'disputesOverview',
  DryRunRules = 'dryRunRules',
  EvidenceApiSubmission = 'evidenceApiSubmission',
  Fees = 'fees',
  FinanceBalanceDateTab = 'financeBalanceDateTab',
  FinanceBalancePeriodTab = 'financeBalancePeriodTab',
  FinanceBalanceTab = 'financeBalanceTab',
  FinanceOverviewTab = 'financeOverviewTab',
  FirstTimeDepositorFilter = 'firstTimeDepositorFilter',
  HelpCenter = 'helpCenter',
  Insights = 'insights',
  InsightsCardCategoryFilter = 'insightsCardCategoryFilter',
  InsightsCardFundingFilter = 'insightsCardFundingFilter',
  InsightsPaymentProviderFilters = 'insightsPaymentProviderFilters',
  InsightsSettlementAccountsBreakdown = 'insightsSettlementAccountsBreakdown',
  InsightsThreeDsFilter = 'insightsThreeDsFilter',
  InsightsTotal = 'insightsTotal',
  MerchantApplication = 'merchantApplication',
  MerchantDashboards = 'merchantDashboards',
  MerchantDocuments = 'merchantDocuments',
  PaymentLinks = 'paymentLinks',
  PaymentMethodConfigurationsAdvancedFraudScreening = 'paymentMethodConfigurationsAdvancedFraudScreening',
  PaymentMethodConfigurationsAuthentication = 'paymentMethodConfigurationsAuthentication',
  PaymentMethodConfigurationsDcc = 'paymentMethodConfigurationsDCC',
  PaymentMethodConfigurationsExemption = 'paymentMethodConfigurationsExemption',
  PaymentMethodConfigurationsFunding = 'paymentMethodConfigurationsFunding',
  PaymentMethodConfigurationsInstantRefund = 'paymentMethodConfigurationsInstantRefund',
  PaymentMethodConfigurationsMoto = 'paymentMethodConfigurationsMoto',
  PaymentMethodConfigurationsNameVerification = 'paymentMethodConfigurationsNameVerification',
  PaymentMethodConfigurationsNetworkTokens = 'paymentMethodConfigurationsNetworkTokens',
  PaymentMethodConfigurationsPartialApproval = 'paymentMethodConfigurationsPartialApproval',
  PaymentMethodConfigurationsPayouts = 'paymentMethodConfigurationsPayouts',
  PaymentMethodConfigurationsStatementDescriptorSuffix = 'paymentMethodConfigurationsStatementDescriptorSuffix',
  PaymentMethods = 'paymentMethods',
  PaymentMethodsConfigurations = 'paymentMethodsConfigurations',
  PaymentsCreate = 'paymentsCreate',
  PaymentsExport = 'paymentsExport',
  PciCompliantToggle = 'pciCompliantToggle',
  PendingRefundFlow = 'pendingRefundFlow',
  ResendWebhookEvent = 'resendWebhookEvent',
  Risk = 'risk',
  RiskCardsBlacklist = 'riskCardsBlacklist',
  RiskCustomersBlacklist = 'riskCustomersBlacklist',
  RiskFraudWarnings = 'riskFraudWarnings',
  RiskListCreation = 'riskListCreation',
  RiskListDeletion = 'riskListDeletion',
  RiskLists = 'riskLists',
  RiskReviews = 'riskReviews',
  RiskRuleAuditLog = 'riskRuleAuditLog',
  RiskRuleCustomerExclusion = 'riskRuleCustomerExclusion',
  RiskRulePerformance = 'riskRulePerformance',
  RiskRulesCancel = 'riskRulesCancel',
  RiskRulesConfiguration = 'riskRulesConfiguration',
  RiskRulesPayment = 'riskRulesPayment',
  RiskRulesReview = 'riskRulesReview',
  RiskRulesRouting = 'riskRulesRouting',
  RiskScore = 'riskScore',
  RiskSettings = 'riskSettings',
  RollingReserves = 'rollingReserves',
  RoutingFallback = 'routingFallback',
  RoutingFallbackAdvanced = 'routingFallbackAdvanced',
  Sandbox = 'sandbox',
  SessionsTable = 'sessionsTable',
  SettlementAccountClearFallback = 'settlementAccountClearFallback',
  SettlementAccountName = 'settlementAccountName',
  SettlementAccountNameFinance = 'settlementAccountNameFinance',
  SettlementAccounts = 'settlementAccounts',
  Settlements = 'settlements',
  SettlementsTableSettlementAccountName = 'settlementsTableSettlementAccountName',
  ShowProcessorDetails = 'showProcessorDetails',
  SplitProcessingFees = 'splitProcessingFees',
  Tasks = 'tasks',
  TimeZone = 'timeZone',
  UpcomingSettlementPayout = 'upcomingSettlementPayout',
  UpdateSettlementAccountBank = 'updateSettlementAccountBank',
  UserManagement = 'userManagement',
  UserManagementFrontegg = 'userManagementFrontegg',
  VirtualTerminal = 'virtualTerminal',
  ZendeskSupport = 'zendeskSupport'
}

export type DashboardFeatureFlagsResponse = {
  __typename?: 'DashboardFeatureFlagsResponse';
  defaultValue?: Maybe<Scalars['Boolean']['output']>;
  name: DashboardFeatureFlags;
};

export enum DashboardType {
  CustomEmbeddable = 'custom_embeddable',
  Embeddable = 'embeddable',
  Iframe = 'iframe',
  Superset = 'superset',
  Thoughtspot = 'thoughtspot'
}

export type DashboardWithAllFields = {
  __typename?: 'DashboardWithAllFields';
  dashboardId?: Maybe<Scalars['String']['output']>;
  dashboardUiConfig?: Maybe<Scalars['JSON']['output']>;
  enabled: Scalars['Boolean']['output'];
  groups?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  merchantIds?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  rls?: Maybe<Scalars['JSON']['output']>;
  type: DashboardType;
  url: Scalars['String']['output'];
};

export type DateRange = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type DeactivateUser = {
  id: Scalars['String']['input'];
};

export type DeclineDetailsFilterInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  declineReason?: InputMaybe<Array<InputMaybe<OnboardingDeclineReason>>>;
};

export type DeclineMessage = {
  __typename?: 'DeclineMessage';
  declineCode: Scalars['String']['output'];
  declineMessage: Scalars['String']['output'];
};

export type DeclineMessageInput = {
  declineCode: Scalars['String']['input'];
  declineMessage: Scalars['String']['input'];
};

export type DeclineMessageMutationResponse = {
  __typename?: 'DeclineMessageMutationResponse';
  success: Scalars['Boolean']['output'];
};

export type DeclineMessages = {
  __typename?: 'DeclineMessages';
  declineMessages: Array<DeclineMessage>;
};

export type DeclinesBreakdownByFailureCode = {
  __typename?: 'DeclinesBreakdownByFailureCode';
  declineRate: Scalars['Float']['output'];
  failureCode: Scalars['String']['output'];
};

export type DefaultRiskControl = {
  __typename?: 'DefaultRiskControl';
  end: Scalars['Int']['output'];
  outcome: RiskDecisionsEnum;
  start: Scalars['Int']['output'];
};

export type DefaultRiskControlInput = {
  end: Scalars['Int']['input'];
  outcome: RiskDecisionsEnum;
  start: Scalars['Int']['input'];
};

export type DeleteDashboard = {
  id: Scalars['String']['input'];
};

export type DeleteFeatureFlagMutationInput = {
  name: Scalars['String']['input'];
};

export type DeleteLogicFieldInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteMccMutationInput = {
  mcc: Scalars['Int']['input'];
};

export type DeleteRiskListMutationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteRiskListValueMutationInput = {
  id: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
};

export type DeleteTaskTemplateInput = {
  id: Scalars['ID']['input'];
};

export type DeliveryChannelsObject = {
  __typename?: 'DeliveryChannelsObject';
  email: Scalars['Boolean']['output'];
  sms: Scalars['Boolean']['output'];
};

export type DeliveryConfigInputObject = {
  emailEnabled: Scalars['Boolean']['input'];
  smsEnabled: Scalars['Boolean']['input'];
};

export type DeliveryConfigObject = {
  __typename?: 'DeliveryConfigObject';
  emailEnabled: Scalars['Boolean']['output'];
  smsEnabled: Scalars['Boolean']['output'];
};

export enum DeliveryTimeframe {
  Above21days = 'above21days',
  Below3days = 'below3days',
  Below7days = 'below7days',
  Below15days = 'below15days',
  Below20days = 'below20days',
  Immediate = 'immediate'
}

export type DisableMerchantDashboardInput = {
  id: Scalars['String']['input'];
};

export type DisableMerchantDashboardResponse = {
  __typename?: 'DisableMerchantDashboardResponse';
  success: Scalars['Boolean']['output'];
};

export type DisablingOptionInput = {
  disabledGlobally?: InputMaybe<Scalars['Boolean']['input']>;
  disabledPmTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  disabledRollingReserves?: InputMaybe<Scalars['Boolean']['input']>;
  type: SettlementAccountDisablingOptionsTypeEnum;
};

export type Dispute = {
  __typename?: 'Dispute';
  acceptedReason?: Maybe<Scalars['String']['output']>;
  amount: Scalars['String']['output'];
  arn?: Maybe<Scalars['String']['output']>;
  attempt: Scalars['Int']['output'];
  companyId: Scalars['ID']['output'];
  consumerId: Scalars['ID']['output'];
  currency?: Maybe<CurrencyAlpha3>;
  disputeNetworkReference?: Maybe<Scalars['String']['output']>;
  disputeReasonDetailedInformation?: Maybe<DisputeReasonDetailedInformation>;
  disputedPayment: Scalars['ID']['output'];
  evidence?: Maybe<EvidencesMap>;
  evidenceRequiredBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPartial?: Maybe<Scalars['Boolean']['output']>;
  lastUpdate: Scalars['String']['output'];
  merchantEvidenceRequiredBy?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['ID']['output'];
  merchantLegalName?: Maybe<Scalars['String']['output']>;
  merchantWebsite?: Maybe<Scalars['String']['output']>;
  mid?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  networkDisputeId?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  processor: Scalars['String']['output'];
  processorDisputeId: Scalars['String']['output'];
  reason: DisputeReason;
  reasonCode: Scalars['String']['output'];
  receivedOn: Scalars['String']['output'];
  settlementAccountId?: Maybe<Scalars['String']['output']>;
  settlementAccountName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DisputeStatus>;
};

export type DisputeAcceptMutationInput = {
  id: Scalars['ID']['input'];
};

export type DisputeByMerchant = {
  __typename?: 'DisputeByMerchant';
  count: Scalars['String']['output'];
  merchantId: Scalars['ID']['output'];
  merchantLegalName?: Maybe<Scalars['String']['output']>;
  ratio: Scalars['Float']['output'];
  volume: Scalars['Float']['output'];
};

export type DisputeEvidenceObject = {
  __typename?: 'DisputeEvidenceObject';
  disputeId: Scalars['String']['output'];
  files?: Maybe<Array<Scalars['String']['output']>>;
  filesMetadata?: Maybe<Array<Document>>;
  id: Scalars['String']['output'];
  receivedOn: Scalars['String']['output'];
  text: Scalars['String']['output'];
  type?: Maybe<EvidenceType>;
};

export enum DisputeHandlingEnum {
  CancelEndOfTerm = 'cancel_end_of_term',
  CancelImmediately = 'cancel_immediately',
  DoNothing = 'do_nothing',
  PauseEndOfTerm = 'pause_end_of_term',
  PauseImmediately = 'pause_immediately'
}

export type DisputeQueryInput = {
  id: Scalars['ID']['input'];
};

export enum DisputeReason {
  Authorization = 'AUTHORIZATION',
  ConsumerDisputes = 'CONSUMER_DISPUTES',
  Fraud = 'FRAUD',
  ProcessingErrors = 'PROCESSING_ERRORS'
}

export type DisputeReasonDetailedInformation = {
  __typename?: 'DisputeReasonDetailedInformation';
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  codeUSAorCA?: Maybe<Scalars['String']['output']>;
  reasonDescription?: Maybe<Scalars['String']['output']>;
  reasonTitle?: Maybe<Scalars['String']['output']>;
  requiredDocumentation?: Maybe<Scalars['String']['output']>;
};

export enum DisputeStatus {
  Accepted = 'ACCEPTED',
  ArbitrationLost = 'ARBITRATION_LOST',
  ArbitrationUnderReview = 'ARBITRATION_UNDER_REVIEW',
  ArbitrationWon = 'ARBITRATION_WON',
  Cancelled = 'CANCELLED',
  EvidenceInternalReview = 'EVIDENCE_INTERNAL_REVIEW',
  EvidenceRequired = 'EVIDENCE_REQUIRED',
  EvidenceUnderReview = 'EVIDENCE_UNDER_REVIEW',
  EvidenceUnderReviewAutoDefend = 'EVIDENCE_UNDER_REVIEW_AUTO_DEFEND',
  Expired = 'EXPIRED',
  Lost = 'LOST',
  Open = 'OPEN',
  PreArbitrationEvidenceRequired = 'PRE_ARBITRATION_EVIDENCE_REQUIRED',
  PreArbitrationRequested = 'PRE_ARBITRATION_REQUESTED',
  RequestForInformation = 'REQUEST_FOR_INFORMATION',
  Resolved = 'RESOLVED',
  ResolvedRapidDisputeResolution = 'RESOLVED_RAPID_DISPUTE_RESOLUTION',
  Won = 'WON'
}

export type DisputesByMerchantsQueryExactInputFilter = {
  count?: InputMaybe<Scalars['Float']['input']>;
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  merchantLegalName?: InputMaybe<Scalars['String']['input']>;
  merchantWebsite?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__brand?: InputMaybe<Scalars['String']['input']>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
  volume?: InputMaybe<Scalars['Float']['input']>;
};

export type DisputesByMerchantsQueryInFilterInputValues = {
  merchantId?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantLegalName?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DisputesByMerchantsQueryInput = {
  cardBrand?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CurrencyAlpha3>;
  filter?: InputMaybe<DisputesByMerchantsQueryInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type DisputesByMerchantsQueryInputFilter = {
  and?: InputMaybe<Array<InputMaybe<DisputesByMerchantsQueryInputFilter>>>;
  between?: InputMaybe<DisputesByMerchantsQueryRangeFilterInputValues>;
  equal?: InputMaybe<DisputesByMerchantsQueryExactInputFilter>;
  greater?: InputMaybe<DisputesByMerchantsQueryExactInputFilter>;
  greaterOrEquals?: InputMaybe<DisputesByMerchantsQueryExactInputFilter>;
  iLike?: InputMaybe<DisputesByMerchantsQueryExactInputFilter>;
  in?: InputMaybe<DisputesByMerchantsQueryInFilterInputValues>;
  less?: InputMaybe<DisputesByMerchantsQueryExactInputFilter>;
  lessOrEquals?: InputMaybe<DisputesByMerchantsQueryExactInputFilter>;
  notBetween?: InputMaybe<DisputesByMerchantsQueryRangeFilterInputValues>;
  notEqual?: InputMaybe<DisputesByMerchantsQueryExactInputFilter>;
  notIn?: InputMaybe<DisputesByMerchantsQueryInFilterInputValues>;
  or?: InputMaybe<Array<DisputesByMerchantsQueryInputFilter>>;
  textSearchCaseInsensitive?: InputMaybe<DisputesByMerchantsQueryExactInputFilter>;
};

export type DisputesByMerchantsQueryRangeFilterInputValues = {
  count?: InputMaybe<IntRangeInput>;
  ratio?: InputMaybe<FloatRangeInput>;
  volume?: InputMaybe<FloatRangeInput>;
};

export type DisputesByMerchantsQueryResponse = {
  __typename?: 'DisputesByMerchantsQueryResponse';
  disputesByMerchants: Array<DisputeByMerchant>;
  pageInfo: PageInfo;
};

export type DisputesCsvReportQueryInput = {
  filter?: InputMaybe<DisputesQueryInputFilter>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  reportName: Scalars['String']['input'];
  select: Array<Scalars['String']['input']>;
};

export type DisputesCsvReportResponse = {
  __typename?: 'DisputesCsvReportResponse';
  url: Scalars['String']['output'];
};

export type DisputesFraudOverviewItem = {
  __typename?: 'DisputesFraudOverviewItem';
  amexDisputesRatio: Scalars['Float']['output'];
  amexFraudRatio: Scalars['Float']['output'];
  brand: Scalars['String']['output'];
  disputeCountRatio: Scalars['Float']['output'];
  disputeVolumeRatio: Scalars['Float']['output'];
  ecmRatio: Scalars['Float']['output'];
  efmRatio: Scalars['Float']['output'];
  fraudCountRatio: Scalars['Float']['output'];
  fraudVolumeRatio: Scalars['Float']['output'];
  month: Scalars['String']['output'];
  settlementConfigId: Scalars['String']['output'];
  totalAmexDisputes: Scalars['String']['output'];
  totalAmexFraud: Scalars['String']['output'];
  totalAmexFraudVolume: Scalars['Float']['output'];
  totalCharges: Scalars['String']['output'];
  totalDisputes: Scalars['String']['output'];
  totalEcmDisputes: Scalars['String']['output'];
  totalEfmDisputes: Scalars['String']['output'];
  totalFraud: Scalars['String']['output'];
  totalVampFraudAndDisputes: Scalars['String']['output'];
  vampRatio: Scalars['Float']['output'];
  volumeCharges: Scalars['Float']['output'];
  volumeDisputes: Scalars['Float']['output'];
  volumeFraud: Scalars['Float']['output'];
};

export type DisputesFraudQueryResponse = {
  __typename?: 'DisputesFraudQueryResponse';
  currency: CurrencyAlpha3;
  data: Array<DisputesFraudOverviewItem>;
};

export type DisputesOverviewQueryInput = {
  filter?: InputMaybe<DisputesQueryInputFilter>;
};

export type DisputesOverviewQueryResponse = {
  __typename?: 'DisputesOverviewQueryResponse';
  count: Scalars['Int']['output'];
  disputesPerSchema?: Maybe<Array<DisputesPerSchema>>;
  volume: Scalars['Float']['output'];
};

export type DisputesPerSchema = {
  __typename?: 'DisputesPerSchema';
  cardBrand: Scalars['String']['output'];
  count: Scalars['Float']['output'];
  ratio: Scalars['Float']['output'];
  volume: Scalars['Float']['output'];
};

export type DisputesQueryExactInputFilter = {
  acceptedReason?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  attempt?: InputMaybe<Scalars['Int']['input']>;
  billingDetails__countryAlpha2?: InputMaybe<Scalars['String']['input']>;
  billingDetails__state?: InputMaybe<Scalars['String']['input']>;
  billingDetails__zip?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  consumerEmail?: InputMaybe<Scalars['String']['input']>;
  consumerFirstName?: InputMaybe<Scalars['String']['input']>;
  consumerFullName?: InputMaybe<Scalars['String']['input']>;
  consumerId?: InputMaybe<Scalars['String']['input']>;
  consumerLastName?: InputMaybe<Scalars['String']['input']>;
  consumerMerchantConsumerId?: InputMaybe<Scalars['String']['input']>;
  consumerPhone?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CurrencyAlpha3>;
  disputeNetworkReference?: InputMaybe<Scalars['String']['input']>;
  disputedPayment?: InputMaybe<Scalars['String']['input']>;
  evidenceRequiredBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isPartial?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdate?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  merchantLegalName?: InputMaybe<Scalars['String']['input']>;
  merchantWebsite?: InputMaybe<Scalars['String']['input']>;
  mid?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  networkDisputeId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__addressLine1Check?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__addressPostalCodeCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__bin?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__brand?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__cvcCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__expiryMonth?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__expiryYear?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__fingerprint?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__funding?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__issuerCountry?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__lastFourDigits?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__network?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__walletTokenizedCardLast4?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__addressLine1Check?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__addressPostalCodeCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__bin?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__brand?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__cvcCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__expiryMonth?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__expiryYear?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__fingerprint?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__funding?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__issuerCountry?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__lastFourDigits?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__network?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__wallet?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__generic__type?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__addressLine1Check?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__addressPostalCodeCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__bin?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__brand?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__cvcCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__expiryMonth?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__expiryYear?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__fingerprint?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__funding?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__issuerCountry?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__lastFourDigits?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__network?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__walletTokenizedCardLast4?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__paypal__email?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__paypal__firstName?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__paypal__isBillingAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod__paypal__lastName?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__paypal__payerId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__type?: InputMaybe<Scalars['String']['input']>;
  processor?: InputMaybe<Scalars['String']['input']>;
  processorDisputeId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<DisputeReason>;
  reasonCode?: InputMaybe<Scalars['String']['input']>;
  receivedOn?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DisputeStatus>;
  threeDsResult?: InputMaybe<TransactionThreeDsResult>;
};

export type DisputesQueryInFilterInputValues = {
  currency?: InputMaybe<Array<CurrencyAlpha3>>;
  network?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__addressLine1Check?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__addressPostalCodeCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__brand?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__cardCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__cardType?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__cvcCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__network?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__addressLine1Check?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__addressPostalCodeCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__brand?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__cardCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__cardType?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__cvcCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__network?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__generic__type?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__addressLine1Check?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__addressPostalCodeCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__brand?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__cardCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__cardType?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__cvcCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__network?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__type?: InputMaybe<Array<Scalars['String']['input']>>;
  reason?: InputMaybe<Array<DisputeReason>>;
  settlementAccountId?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<DisputeStatus>>;
  threeDsResult?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DisputesQueryInput = {
  filter?: InputMaybe<DisputesQueryInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type DisputesQueryInputFilter = {
  and?: InputMaybe<Array<InputMaybe<DisputesQueryInputFilter>>>;
  between?: InputMaybe<DisputesQueryRangeFilterInputValues>;
  equal?: InputMaybe<DisputesQueryExactInputFilter>;
  greater?: InputMaybe<DisputesQueryExactInputFilter>;
  greaterOrEquals?: InputMaybe<DisputesQueryExactInputFilter>;
  iLike?: InputMaybe<DisputesQueryExactInputFilter>;
  in?: InputMaybe<DisputesQueryInFilterInputValues>;
  less?: InputMaybe<DisputesQueryExactInputFilter>;
  lessOrEquals?: InputMaybe<DisputesQueryExactInputFilter>;
  notBetween?: InputMaybe<DisputesQueryRangeFilterInputValues>;
  notEqual?: InputMaybe<DisputesQueryExactInputFilter>;
  notIn?: InputMaybe<DisputesQueryInFilterInputValues>;
  notLike?: InputMaybe<DisputesQueryExactInputFilter>;
  or?: InputMaybe<Array<DisputesQueryInputFilter>>;
  textSearchCaseInsensitive?: InputMaybe<DisputesQueryExactInputFilter>;
};

export type DisputesQueryRangeFilterInputValues = {
  amount?: InputMaybe<FloatRangeInput>;
  attempt?: InputMaybe<IntRangeInput>;
  lastUpdate?: InputMaybe<StringRangeInput>;
  receivedOn?: InputMaybe<StringRangeInput>;
};

export type DisputesQueryResponse = {
  __typename?: 'DisputesQueryResponse';
  disputes: Array<Dispute>;
  pageInfo: PageInfo;
};

export type Document = {
  __typename?: 'Document';
  archiveStatus?: Maybe<DocumentArchiveStatus>;
  category?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  contentLength?: Maybe<Scalars['String']['output']>;
  contentType: Scalars['String']['output'];
  expiryDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  issuingDate?: Maybe<Scalars['String']['output']>;
  lastModified?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  originalFilename: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  resourceId?: Maybe<Scalars['String']['output']>;
  reviewStatus?: Maybe<DocumentReviewType>;
  status: DocumentUploadStatus;
  subType?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: DocumentTypeEnum;
  uploadedBy?: Maybe<Scalars['String']['output']>;
  uploadedOn?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum DocumentArchiveStatus {
  Accepted = 'accepted',
  Declined = 'declined',
  Expired = 'expired',
  Irrelevant = 'irrelevant',
  None = 'none',
  Outdated = 'outdated'
}

export enum DocumentEntityType {
  BankAccount = 'bank_account',
  Business = 'business',
  Individual = 'individual',
  RiskAlert = 'risk_alert',
  Screening = 'screening',
  SettlementAccount = 'settlement_account'
}

export type DocumentIdsInput = {
  id: Scalars['String']['input'];
};

export type DocumentMutationResponse = {
  __typename?: 'DocumentMutationResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum DocumentResource {
  BankAccount = 'bank_account',
  Individual = 'individual',
  MerchantApplication = 'merchant_application',
  OnboardingPricing = 'onboarding_pricing',
  RiskAlert = 'risk_alert',
  Screening = 'screening',
  SettlementAccount = 'settlement_account'
}

export enum DocumentReviewType {
  Accepted = 'accepted',
  Internal = 'internal',
  Invalid = 'invalid',
  None = 'none',
  NotRequired = 'not_required',
  Replaced = 'replaced'
}

export enum DocumentSource {
  Hubspot = 'hubspot',
  Paypass = 'paypass'
}

export type DocumentType = {
  __typename?: 'DocumentType';
  archived: Scalars['Boolean']['output'];
  defaultDocumentTags?: Maybe<Array<Scalars['String']['output']>>;
  label: Scalars['String']['output'];
  regions?: Maybe<Array<DocumentTypeRegion>>;
  type: DocumentEntityType;
  value: Scalars['String']['output'];
};

export enum DocumentTypeEnum {
  Evidence = 'EVIDENCE',
  Onboarding = 'ONBOARDING',
  Other = 'OTHER',
  SettlementAccount = 'SETTLEMENT_ACCOUNT',
  Task = 'TASK'
}

export type DocumentTypeMutationResponse = {
  __typename?: 'DocumentTypeMutationResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum DocumentTypeRegion {
  Eu = 'eu',
  Us = 'us'
}

export type DocumentTypesList = {
  __typename?: 'DocumentTypesList';
  defaultTags?: Maybe<Array<Scalars['String']['output']>>;
  documentTypes: Array<DocumentType>;
};

export enum DocumentUploadStatus {
  Accepted = 'ACCEPTED',
  Created = 'CREATED',
  Rejected = 'REJECTED',
  Uploaded = 'UPLOADED'
}

export type DocumentUploadToken = {
  __typename?: 'DocumentUploadToken';
  token: Scalars['String']['output'];
};

export type DocumentUploadTokenQueryInput = {
  companyId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};

export type DocumentUploadUrl = {
  __typename?: 'DocumentUploadUrl';
  url: Scalars['String']['output'];
};

export type DocumentUrlQueryInput = {
  id: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  responseContentDisposition?: InputMaybe<ResponseContentDisposition>;
};

export type Documents = {
  __typename?: 'Documents';
  documents?: Maybe<Array<Document>>;
};

export type DocumentsByIdsInput = {
  documentsIds: Array<DocumentIdsInput>;
};

export type DocumentsFindByParamsExactInputFilter = {
  category?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contentLength?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originalFilename?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  subType?: InputMaybe<Scalars['String']['input']>;
  uploadedBy?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentsFindByParamsInFilterInputValues = {
  archiveStatus?: InputMaybe<Array<DocumentArchiveStatus>>;
  resourceId?: InputMaybe<Array<Scalars['String']['input']>>;
  reviewStatus?: InputMaybe<Array<DocumentReviewType>>;
  status?: InputMaybe<Array<DocumentUploadStatus>>;
  subType?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<DocumentTypeEnum>>;
};

export type DocumentsFindByParamsInputFilter = {
  and?: InputMaybe<Array<InputMaybe<DocumentsFindByParamsInputFilter>>>;
  between?: InputMaybe<DocumentsFindByParamsRangeFilterInputValues>;
  equal?: InputMaybe<DocumentsFindByParamsExactInputFilter>;
  greater?: InputMaybe<DocumentsFindByParamsExactInputFilter>;
  greaterOrEquals?: InputMaybe<DocumentsFindByParamsExactInputFilter>;
  hasAny?: InputMaybe<DocumentsFindByParamsInFilterInputValues>;
  iLike?: InputMaybe<DocumentsFindByParamsExactInputFilter>;
  in?: InputMaybe<DocumentsFindByParamsInFilterInputValues>;
  less?: InputMaybe<DocumentsFindByParamsExactInputFilter>;
  lessOrEquals?: InputMaybe<DocumentsFindByParamsExactInputFilter>;
  notBetween?: InputMaybe<DocumentsFindByParamsRangeFilterInputValues>;
  notEqual?: InputMaybe<DocumentsFindByParamsExactInputFilter>;
  notIn?: InputMaybe<DocumentsFindByParamsInFilterInputValues>;
  or?: InputMaybe<Array<DocumentsFindByParamsInputFilter>>;
  textSearchCaseInsensitive?: InputMaybe<DocumentsFindByParamsExactInputFilter>;
};

export type DocumentsFindByParamsQueryInput = {
  filter?: InputMaybe<DocumentsFindByParamsInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentsFindByParamsQueryResponse = {
  __typename?: 'DocumentsFindByParamsQueryResponse';
  documents: Array<Document>;
  pageInfo: PageInfo;
};

export type DocumentsFindByParamsRangeFilterInputValues = {
  expiryDate?: InputMaybe<StringRangeInput>;
  issuingDate?: InputMaybe<StringRangeInput>;
  lastModified?: InputMaybe<StringRangeInput>;
  uploadedOn?: InputMaybe<StringRangeInput>;
};

export type DocumentsList = {
  merchantId: Scalars['String']['input'];
  path: Scalars['String']['input'];
};

export type DoesPaypassNeedCodeAuthenticationPayload = {
  __typename?: 'DoesPaypassNeedCodeAuthenticationPayload';
  isCodeAuthenticationNeeded?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DownloadAllLegalEntityDocumentsInput = {
  companyId: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
};

export type DownloadAllLegalEntityDocumentsResponse = {
  __typename?: 'DownloadAllLegalEntityDocumentsResponse';
  url?: Maybe<Scalars['String']['output']>;
};

export type DriverLicence = {
  __typename?: 'DriverLicence';
  country?: Maybe<Scalars['String']['output']>;
  countrySubdivision?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type DuplicateRiskRuleMutationInput = {
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type EditRiskRuleMutationInput = {
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  failureCode?: InputMaybe<Scalars['String']['input']>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  logic: Scalars['String']['input'];
  logicClient: Scalars['String']['input'];
  outcome?: InputMaybe<RiskRuleOutcome>;
  outcomeDetails?: InputMaybe<OutcomeDetailsInput>;
  outcomeDetailsByRange?: InputMaybe<Array<OutcomeDetailsByRangeItemInput>>;
  outcomes: Array<RiskRuleOutcome>;
  postExternalRiskCheck?: InputMaybe<Scalars['Boolean']['input']>;
  rulePriority?: InputMaybe<Scalars['Float']['input']>;
};

export type Email = {
  __typename?: 'Email';
  emails?: Maybe<Array<Scalars['String']['output']>>;
  enabled: Scalars['Boolean']['output'];
};

export type EmailInput = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled: Scalars['Boolean']['input'];
};

export type Employee = {
  __typename?: 'Employee';
  email: Scalars['String']['output'];
  riskAlertAutoAssign?: Maybe<Scalars['Boolean']['output']>;
  role: GoogleEmployeeRole;
  status: Scalars['String']['output'];
  type: GoogleEmployeeType;
};

export type EmployeeGroupsInput = {
  userKey: Scalars['String']['input'];
};

export type EmployeesByGroupResponse = {
  __typename?: 'EmployeesByGroupResponse';
  employees: Array<Employee>;
  group: Scalars['String']['output'];
};

export type EmployeesByGroupValueInput = {
  group: Scalars['String']['input'];
};

export type EmployeesByGroupValuesInput = {
  groups: Array<Scalars['String']['input']>;
};

export type EmployeesByGroupsResponse = {
  __typename?: 'EmployeesByGroupsResponse';
  groups?: Maybe<Array<EmployeesByGroupResponse>>;
};

export type EmployeesGroupsResponse = {
  __typename?: 'EmployeesGroupsResponse';
  groups: Array<Scalars['String']['output']>;
  groupsDetails: Array<GroupsDetails>;
};

export type EnabledReportsGraphqlStructure = {
  __typename?: 'EnabledReportsGraphqlStructure';
  disputes?: Maybe<Scalars['Boolean']['output']>;
  fraud?: Maybe<Scalars['Boolean']['output']>;
  fx?: Maybe<Scalars['Boolean']['output']>;
  settlement?: Maybe<Scalars['Boolean']['output']>;
  transaction_reconciliation?: Maybe<Scalars['Boolean']['output']>;
};

export enum EndpointPermission {
  None = 'none',
  Read = 'read',
  Write = 'write'
}

export type EntityShareSetup = {
  __typename?: 'EntityShareSetup';
  actions?: Maybe<Array<Scalars['String']['output']>>;
  basisPoints?: Maybe<Scalars['String']['output']>;
  basisPointsAfterDuration?: Maybe<Scalars['String']['output']>;
  commissionDuration?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type EntityShareSetupInput = {
  actions?: InputMaybe<Array<Scalars['String']['input']>>;
  basisPoints?: InputMaybe<Scalars['String']['input']>;
  basisPointsAfterDuration?: InputMaybe<Scalars['String']['input']>;
  commissionDuration?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type EventType = {
  __typename?: 'EventType';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: NotificationType;
};

export type EvercCheckResult = {
  __typename?: 'EvercCheckResult';
  assignedOwner?: Maybe<Scalars['String']['output']>;
  findings?: Maybe<Array<EvercFindings>>;
  id?: Maybe<Scalars['String']['output']>;
  isMerchantUrl?: Maybe<Scalars['Boolean']['output']>;
  riskQuantifier?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  urlApiLink?: Maybe<Scalars['String']['output']>;
  urlRisk?: Maybe<EvercRisk>;
  verificationCheckId?: Maybe<Scalars['String']['output']>;
};

export type EvercCheckResultInput = {
  assignedOwner?: InputMaybe<Scalars['String']['input']>;
  findings?: InputMaybe<Array<EvercFindingsInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isMerchantUrl?: InputMaybe<Scalars['Boolean']['input']>;
  riskQuantifier?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  urlApiLink?: InputMaybe<Scalars['String']['input']>;
  urlRisk?: InputMaybe<EvercRisk>;
  verificationCheckId?: InputMaybe<Scalars['String']['input']>;
};

export type EvercFindings = {
  __typename?: 'EvercFindings';
  findingCategory?: Maybe<Scalars['String']['output']>;
  findingCategoryName?: Maybe<Scalars['String']['output']>;
  findingName?: Maybe<Scalars['String']['output']>;
  findingRisk?: Maybe<EvercRisk>;
  findingType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type EvercFindingsInput = {
  findingCategory?: InputMaybe<Scalars['String']['input']>;
  findingCategoryName?: InputMaybe<Scalars['String']['input']>;
  findingName?: InputMaybe<Scalars['String']['input']>;
  findingRisk?: InputMaybe<EvercRisk>;
  findingType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export enum EvercRisk {
  Critical = 'critical',
  High = 'high',
  Low = 'low',
  Medium = 'medium',
  NoRisk = 'no_risk',
  Unknown = 'unknown'
}

export enum EvidenceType {
  AdditionalEvidence = 'ADDITIONAL_EVIDENCE',
  CardholderEvidence = 'CARDHOLDER_EVIDENCE',
  CustomerCommunication = 'CUSTOMER_COMMUNICATION',
  InvoiceOrReceipt = 'INVOICE_OR_RECEIPT',
  InvoiceShowingDistinctTransactions = 'INVOICE_SHOWING_DISTINCT_TRANSACTIONS',
  IssuerWinningEvidence = 'ISSUER_WINNING_EVIDENCE',
  ProofOfDeliveryOrService = 'PROOF_OF_DELIVERY_OR_SERVICE',
  ProofOfDeliveryOrServiceDate = 'PROOF_OF_DELIVERY_OR_SERVICE_DATE',
  RecurringTransactionAgreement = 'RECURRING_TRANSACTION_AGREEMENT',
  RefundOrCancellationPolicy = 'REFUND_OR_CANCELLATION_POLICY'
}

export type EvidencesMap = {
  __typename?: 'EvidencesMap';
  additionalEvidence?: Maybe<DisputeEvidenceObject>;
  customerCommunication?: Maybe<DisputeEvidenceObject>;
  invoiceOrReceipt?: Maybe<DisputeEvidenceObject>;
  invoiceShowingDistinctTransactions?: Maybe<DisputeEvidenceObject>;
  proofOfDeliveryOrService?: Maybe<DisputeEvidenceObject>;
  proofOfDeliveryOrServiceDate?: Maybe<DisputeEvidenceObject>;
  recurringTransactionAgreement?: Maybe<DisputeEvidenceObject>;
  refundOrCancellationPolicy?: Maybe<DisputeEvidenceObject>;
};

export enum ExemptionTypeEnum {
  Lv = 'LV',
  Tra = 'TRA'
}

export type ExportField = {
  __typename?: 'ExportField';
  category?: Maybe<Scalars['String']['output']>;
  fieldDescription?: Maybe<Scalars['String']['output']>;
  fieldKey: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  tableName: Scalars['String']['output'];
};

export type ExportFieldInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  fieldDescription?: InputMaybe<Scalars['String']['input']>;
  fieldKey: Scalars['String']['input'];
  fieldName: Scalars['String']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  tableName: Scalars['String']['input'];
};

export type ExportFieldKeyInput = {
  fieldKey: Scalars['String']['input'];
  tableName: Scalars['String']['input'];
};

export type ExportFieldMutationResponse = {
  __typename?: 'ExportFieldMutationResponse';
  success: Scalars['Boolean']['output'];
};

export type ExportFields = {
  __typename?: 'ExportFields';
  exportFields: Array<ExportField>;
};

export type ExportTableFields = {
  __typename?: 'ExportTableFields';
  fieldDescription?: Maybe<Scalars['String']['output']>;
  fieldKey: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  tableName: Scalars['String']['output'];
};

export type ExportTableFieldsQueryInput = {
  tableName: ExportTableName;
};

export type ExportTableFieldsQueryResponse = {
  __typename?: 'ExportTableFieldsQueryResponse';
  exportFields?: Maybe<Array<Maybe<ExportTableFields>>>;
};

export enum ExportTableName {
  Authentications = 'authentications',
  CashFlowTransactions = 'cash_flow_transactions',
  Collaborations = 'collaborations',
  ConsumersRulesExclusions = 'consumers_rules_exclusions',
  Disputes = 'disputes',
  FraudWarningsTransactions = 'fraud_warnings_transactions',
  SessionTransactions = 'session_transactions',
  Transactions = 'transactions'
}

export type ExposureRisk = {
  __typename?: 'ExposureRisk';
  calculatedExposure?: Maybe<Scalars['String']['output']>;
  percentHeldBack?: Maybe<Scalars['String']['output']>;
  rollingReserveDays?: Maybe<Scalars['Int']['output']>;
};

export enum ExposureRiskCategory {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  VeryHigh = 'VERY_HIGH'
}

export type ExposureRiskFilterInput = {
  calculatedExposure?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
};

export type ExposureRiskInput = {
  calculatedExposure?: InputMaybe<Scalars['String']['input']>;
  percentHeldBack?: InputMaybe<Scalars['String']['input']>;
  rollingReserveDays?: InputMaybe<Scalars['Int']['input']>;
};

export type ExposureRiskPreview = {
  __typename?: 'ExposureRiskPreview';
  calculatedExposure?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
};

export type FailureCodeMessageObject = {
  __typename?: 'FailureCodeMessageObject';
  dashboardMessage?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endUserMessage?: Maybe<Scalars['String']['output']>;
  errorCode: Scalars['String']['output'];
  fallbackable?: Maybe<Scalars['Boolean']['output']>;
  internal?: Maybe<Scalars['Boolean']['output']>;
};

export type FailureCodeMessageQueryResponse = {
  __typename?: 'FailureCodeMessageQueryResponse';
  errorCode: Scalars['String']['output'];
};

export enum FailureEnum {
  Cancel = 'cancel',
  Pause = 'pause'
}

export type FallbackConfigItem = {
  __typename?: 'FallbackConfigItem';
  defaultConfig: Scalars['Boolean']['output'];
  failureCodes?: Maybe<Array<Scalars['String']['output']>>;
  settlementAccountId?: Maybe<Scalars['String']['output']>;
};

export type FallbackConfigItemInput = {
  defaultConfig: Scalars['Boolean']['input'];
  failureCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  settlementAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type FallbackRoute = {
  __typename?: 'FallbackRoute';
  failureCodes?: Maybe<Array<Scalars['String']['output']>>;
  targets?: Maybe<Array<FallbackRoutingTarget>>;
};

export type FallbackRouteInput = {
  failureCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  targets?: InputMaybe<Array<FallbackRoutingTargetInput>>;
};

export type FallbackRouting = {
  __typename?: 'FallbackRouting';
  routes?: Maybe<Array<FallbackRoute>>;
};

export type FallbackRoutingInput = {
  routes?: InputMaybe<Array<FallbackRouteInput>>;
};

export type FallbackRoutingTarget = {
  __typename?: 'FallbackRoutingTarget';
  end: Scalars['Int']['output'];
  paymentMethodConfigId?: Maybe<Scalars['String']['output']>;
  routes?: Maybe<Array<Scalars['JSON']['output']>>;
  settlementAccountId: Scalars['String']['output'];
  start: Scalars['Int']['output'];
};

export type FallbackRoutingTargetInput = {
  end: Scalars['Int']['input'];
  paymentMethodConfigId?: InputMaybe<Scalars['String']['input']>;
  routes?: InputMaybe<Array<FallbackRouteInput>>;
  settlementAccountId: Scalars['String']['input'];
  start: Scalars['Int']['input'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type FeatureFlagQueryInput = {
  name: Scalars['String']['input'];
};

export enum FeeType {
  Commission = 'COMMISSION',
  Interchange = 'INTERCHANGE',
  Merchant = 'MERCHANT',
  Network = 'NETWORK',
  Provider = 'PROVIDER',
  ProviderRevShare = 'PROVIDER_REV_SHARE',
  Referral = 'REFERRAL',
  Reseller = 'RESELLER',
  Vat = 'VAT'
}

export type FieldInput = {
  externalId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  options?: InputMaybe<Array<TaskFieldsOptionInput>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  tooltipText?: InputMaybe<Scalars['String']['input']>;
  type: TaskFieldType;
};

export type Finalize = {
  __typename?: 'Finalize';
  authCode?: Maybe<Scalars['String']['output']>;
  eci?: Maybe<Scalars['String']['output']>;
  issuerResponseCode?: Maybe<Scalars['String']['output']>;
  issuerResponseText?: Maybe<Scalars['String']['output']>;
  networkCode?: Maybe<Scalars['String']['output']>;
  networkSpecificFields?: Maybe<Array<Maybe<NetworkSpecificFields>>>;
  resultSource?: Maybe<Scalars['String']['output']>;
  systemTraceAuditNumber?: Maybe<Scalars['String']['output']>;
  transactionResult?: Maybe<Scalars['String']['output']>;
  transactionRrn?: Maybe<Scalars['String']['output']>;
  transactionTimestamp?: Maybe<Scalars['String']['output']>;
};

export type FinalizeInput = {
  authCode?: InputMaybe<Scalars['String']['input']>;
  eci?: InputMaybe<Scalars['String']['input']>;
  issuerResponseCode?: InputMaybe<Scalars['String']['input']>;
  issuerResponseText?: InputMaybe<Scalars['String']['input']>;
  networkCode?: InputMaybe<Scalars['String']['input']>;
  resultSource?: InputMaybe<Scalars['String']['input']>;
  rrn?: InputMaybe<Scalars['String']['input']>;
  systemTraceAuditNumber?: InputMaybe<Scalars['String']['input']>;
  transactionResult?: InputMaybe<Scalars['String']['input']>;
  transactionRrn?: InputMaybe<Scalars['String']['input']>;
  transactionTimestamp?: InputMaybe<Scalars['String']['input']>;
};

export type FinalizeNetworkSpecificFields = {
  __typename?: 'FinalizeNetworkSpecificFields';
  /** MasterCard */
  banknetReference?: Maybe<Scalars['String']['output']>;
  processor?: Maybe<Scalars['String']['output']>;
  /** MasterCard */
  traceId?: Maybe<Scalars['String']['output']>;
  /** Visa */
  transactionIdentifier?: Maybe<Scalars['String']['output']>;
};

export type FinalizeReadOnly = {
  __typename?: 'FinalizeReadOnly';
  authCode?: Maybe<Scalars['String']['output']>;
  eci?: Maybe<Scalars['String']['output']>;
  issuerResponseCode?: Maybe<Scalars['String']['output']>;
  issuerResponseText?: Maybe<Scalars['String']['output']>;
  networkCode?: Maybe<Scalars['String']['output']>;
  networkSpecificFields?: Maybe<Array<NetworkSpecificFields>>;
  resultSource?: Maybe<Scalars['String']['output']>;
  rrn?: Maybe<Scalars['String']['output']>;
  systemTraceAuditNumber?: Maybe<Scalars['String']['output']>;
  transactionResult?: Maybe<Scalars['String']['output']>;
  transactionRrn?: Maybe<Scalars['String']['output']>;
  transactionTimestamp?: Maybe<Scalars['String']['output']>;
};

export type FinalizeSignUpMerchantMutationInput = {
  companyId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};

export type FinanceObject = {
  __typename?: 'FinanceObject';
  commissionSetup?: Maybe<Array<EntityShareSetup>>;
  companyId: Scalars['String']['output'];
  merchantId: Scalars['String']['output'];
  referralId?: Maybe<Scalars['String']['output']>;
  revShareTiers?: Maybe<Array<RevShareTiers>>;
};

export type FlattenedIndividual = {
  __typename?: 'FlattenedIndividual';
  annualIncome?: Maybe<Scalars['String']['output']>;
  annualIncomeCurrency?: Maybe<CurrencyAlpha3>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  companyDateOfIncorporation?: Maybe<Scalars['String']['output']>;
  companyLegalName?: Maybe<Scalars['String']['output']>;
  companyPhysicalAddress?: Maybe<Address>;
  companyRegisteredAddress?: Maybe<Address>;
  companyRegistrationNumber?: Maybe<Scalars['String']['output']>;
  contactTypes?: Maybe<Array<IndividualContactType>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  documentCountryOfIssue?: Maybe<CountryAlpha2>;
  documentExpirationDate?: Maybe<Scalars['String']['output']>;
  documentIssueDate?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Document>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idNumber?: Maybe<Scalars['String']['output']>;
  identificationDocumentType?: Maybe<Scalars['String']['output']>;
  isContact?: Maybe<Scalars['Boolean']['output']>;
  isDirector?: Maybe<Scalars['Boolean']['output']>;
  isNomineeShareholder?: Maybe<Scalars['Boolean']['output']>;
  isPrimaryContact?: Maybe<Scalars['Boolean']['output']>;
  isRepresented?: Maybe<Scalars['Boolean']['output']>;
  isShareholder?: Maybe<Scalars['Boolean']['output']>;
  isUbo?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  nationalities?: Maybe<Array<CountryAlpha2>>;
  otherActivitiesDetails?: Maybe<Scalars['String']['output']>;
  pep?: Maybe<Scalars['Boolean']['output']>;
  percentageOfShares?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  proofOfResidenceDocumentType?: Maybe<ProofOfResidenceDocumentType>;
  residentialAddress?: Maybe<Address>;
  significantResponsibility?: Maybe<Scalars['Boolean']['output']>;
  signsTaxDocuments?: Maybe<Scalars['Boolean']['output']>;
  sizeOfWealth?: Maybe<Scalars['String']['output']>;
  sizeOfWealthCurrency?: Maybe<CurrencyAlpha3>;
  socialMedia?: Maybe<Array<SocialMedia>>;
  sourceOfIncomeOther?: Maybe<Scalars['String']['output']>;
  sourceOfWealthOther?: Maybe<Scalars['String']['output']>;
  sourcesOfIncome?: Maybe<Array<SourceOfIncome>>;
  sourcesOfWealth?: Maybe<Array<SourceOfWealth>>;
  ssn?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: IndividualType;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type FlattenedIndividualInput = {
  annualIncome?: InputMaybe<Scalars['String']['input']>;
  annualIncomeCurrency?: InputMaybe<CurrencyAlpha3>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyDateOfIncorporation?: InputMaybe<Scalars['String']['input']>;
  companyLegalName?: InputMaybe<Scalars['String']['input']>;
  companyPhysicalAddress?: InputMaybe<AddressInput>;
  companyRegisteredAddress?: InputMaybe<AddressInput>;
  companyRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  contactTypes?: InputMaybe<Array<IndividualContactType>>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  documentCountryOfIssue?: InputMaybe<CountryAlpha2>;
  documentExpirationDate?: InputMaybe<Scalars['String']['input']>;
  documentIssueDate?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  idNumber?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentType?: InputMaybe<Scalars['String']['input']>;
  isContact?: InputMaybe<Scalars['Boolean']['input']>;
  isDirector?: InputMaybe<Scalars['Boolean']['input']>;
  isNomineeShareholder?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimaryContact?: InputMaybe<Scalars['Boolean']['input']>;
  isRepresented?: InputMaybe<Scalars['Boolean']['input']>;
  isShareholder?: InputMaybe<Scalars['Boolean']['input']>;
  isUbo?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  nationalities?: InputMaybe<Array<CountryAlpha2>>;
  otherActivitiesDetails?: InputMaybe<Scalars['String']['input']>;
  pep?: InputMaybe<Scalars['Boolean']['input']>;
  percentageOfShares?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  proofOfResidenceDocumentType?: InputMaybe<ProofOfResidenceDocumentType>;
  residentialAddress?: InputMaybe<AddressInput>;
  significantResponsibility?: InputMaybe<Scalars['Boolean']['input']>;
  signsTaxDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  sizeOfWealth?: InputMaybe<Scalars['String']['input']>;
  sizeOfWealthCurrency?: InputMaybe<CurrencyAlpha3>;
  socialMedia?: InputMaybe<Array<IndividualSocialMediaInput>>;
  sourceOfIncomeOther?: InputMaybe<Scalars['String']['input']>;
  sourceOfWealthOther?: InputMaybe<Scalars['String']['input']>;
  sourcesOfIncome?: InputMaybe<Array<SourceOfIncome>>;
  sourcesOfWealth?: InputMaybe<Array<SourceOfWealth>>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IndividualType>;
};

export type FloatRangeInput = {
  from: Scalars['Float']['input'];
  to: Scalars['Float']['input'];
};

export enum FraudInputMethod {
  NotAvailable = 'not_available',
  PanKeyEntered = 'pan_key_entered',
  Swiped = 'swiped'
}

export enum FraudType {
  AccountTakeover = 'account_takeover',
  BustOutCollusiveMerchant = 'bust_out_collusive_merchant',
  CardNeverReceived = 'card_never_received',
  FirstPartyFraud = 'first_party_fraud',
  FraudulentCardApplication = 'fraudulent_card_application',
  IncorrectProcessing = 'incorrect_processing',
  MadeWithCounterfeitCard = 'made_with_counterfeit_card',
  MadeWithLostCard = 'made_with_lost_card',
  MadeWithStolenCard = 'made_with_stolen_card',
  ManipulationOfAccountholder = 'manipulation_of_accountholder',
  ManipulationOfCardholder = 'manipulation_of_cardholder',
  MerchantMisrepresentation = 'merchant_misrepresentation',
  Misc = 'misc',
  ModificationOfPaymentOrder = 'modification_of_payment_order',
  MultipleImprintFraud = 'multiple_imprint_fraud',
  UnauthorizedUseOfCard = 'unauthorized_use_of_card'
}

export type FrontendContentTypeObject = {
  __typename?: 'FrontendContentTypeObject';
  content: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FulfillmentDetails = {
  __typename?: 'FulfillmentDetails';
  deliveryTimeframe?: Maybe<Scalars['String']['output']>;
  fulfillmentMethod?: Maybe<FulfillmentMethod>;
  fulfillmentMethodDescription?: Maybe<Scalars['String']['output']>;
  physicalGoods?: Maybe<Scalars['Boolean']['output']>;
};

export type FulfillmentDetailsFilterInput = {
  deliveryTimeframe?: InputMaybe<Array<InputMaybe<DeliveryTimeframe>>>;
  fulfillmentMethod?: InputMaybe<Array<InputMaybe<FulfillmentMethod>>>;
  fulfillmentMethodDescription?: InputMaybe<Scalars['String']['input']>;
  physicalGoods?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FulfillmentDetailsInput = {
  deliveryTimeframe?: InputMaybe<Scalars['String']['input']>;
  fulfillmentMethod?: InputMaybe<FulfillmentMethod>;
  fulfillmentMethodDescription?: InputMaybe<Scalars['String']['input']>;
  physicalGoods?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FulfillmentDetailsPreview = {
  __typename?: 'FulfillmentDetailsPreview';
  deliveryTimeframe?: Maybe<Scalars['String']['output']>;
  fulfillmentMethod?: Maybe<FulfillmentMethod>;
  fulfillmentMethodDescription?: Maybe<Scalars['String']['output']>;
  physicalGoods?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerateCsrCertificate = {
  __typename?: 'GenerateCsrCertificate';
  base64csr: Scalars['String']['output'];
};

export type GenerateOnboardingPricingSigningUrlInput = {
  id: Scalars['ID']['input'];
};

export type GenerateOnboardingPricingSigningUrlMutationResponse = {
  __typename?: 'GenerateOnboardingPricingSigningUrlMutationResponse';
  url: Scalars['String']['output'];
};

export type GetAllDashboardsResponse = {
  __typename?: 'GetAllDashboardsResponse';
  dashboards?: Maybe<Array<DashboardWithAllFields>>;
};

export type GetAllFailureCodeMessagesQueryResponse = {
  __typename?: 'GetAllFailureCodeMessagesQueryResponse';
  failureCodeMessages: Array<FailureCodeMessageObject>;
};

export type GetCrmFieldRequest = {
  id: Scalars['ID']['input'];
};

export type GetCustomerSupportLinkResponse = {
  __typename?: 'GetCustomerSupportLinkResponse';
  url: Scalars['String']['output'];
};

export type GetDocumentTypeInput = {
  type: DocumentEntityType;
  value: Scalars['String']['input'];
};

export type GetDocumentTypesByTypeAndRegionInput = {
  region?: InputMaybe<DocumentTypeRegion>;
  type: DocumentEntityType;
};

export type GetEntityMccsInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetEntityMccsResponse = {
  __typename?: 'GetEntityMccsResponse';
  mccs?: Maybe<Array<MccEntry>>;
};

export type GetEntityOnboardingPricingListResponse = {
  __typename?: 'GetEntityOnboardingPricingListResponse';
  onboardingPricingList?: Maybe<Array<OnboardingPricing>>;
};

export type GetEntityPrimaryContactInput = {
  companyId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
};

export type GetEntityWebsitesInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  entityId: Scalars['String']['input'];
};

export type GetEntityWebsitesResponse = {
  __typename?: 'GetEntityWebsitesResponse';
  websites?: Maybe<Array<WebsiteEntry>>;
};

export type GetFinanceInput = {
  companyId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};

export type GetIndividualInput = {
  id: Scalars['ID']['input'];
};

export type GetIndividualRelationsInput = {
  individualId?: InputMaybe<Scalars['ID']['input']>;
  relatedCompanyId?: InputMaybe<Scalars['ID']['input']>;
  relatedEntityId?: InputMaybe<Scalars['ID']['input']>;
  relatedIndividualId?: InputMaybe<Scalars['ID']['input']>;
  relatedPartnerId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetIndividualsQueryInput = {
  filter?: InputMaybe<IndividualsQueryInputFilter>;
  getTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type GetMerchantDashboardTokenInput = {
  id: Scalars['String']['input'];
};

export type GetMerchantDashboardTokenResponse = {
  __typename?: 'GetMerchantDashboardTokenResponse';
  token: Scalars['String']['output'];
};

export type GetMerchantDashboardsResponse = {
  __typename?: 'GetMerchantDashboardsResponse';
  categories: Array<MerchantDashboardCategory>;
  dashboards: Array<MerchantDashboard>;
};

export type GetOnboardingPricingFieldsInput = {
  contractType?: InputMaybe<OnboardingPricingContractType>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<OnboardingPricingRegion>;
};

export type GetOnboardingPricingFieldsResponse = {
  __typename?: 'GetOnboardingPricingFieldsResponse';
  onboardingPricingFields?: Maybe<Array<OnboardingPricingField>>;
};

export type GetOnboardingPricingInput = {
  id: Scalars['ID']['input'];
};

export type GetPotentialDuplicateIndividualsInput = {
  individualIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type GetPricingActionInput = {
  action: Scalars['ID']['input'];
};

export type GetProvisioningTemplateQueryInput = {
  id: Scalars['ID']['input'];
};

export type GetReferralInput = {
  id: Scalars['ID']['input'];
};

export type GetReportsConfigQueryInput = {
  companyId: Scalars['String']['input'];
  merchantId?: InputMaybe<Scalars['String']['input']>;
};

export type GetReportsConfigQueryResponse = {
  __typename?: 'GetReportsConfigQueryResponse';
  companyId: Scalars['String']['output'];
  merchantId?: Maybe<Scalars['String']['output']>;
};

export type GitHubBranch = {
  __typename?: 'GitHubBranch';
  label?: Maybe<Scalars['String']['output']>;
  ref?: Maybe<Scalars['String']['output']>;
  repo?: Maybe<GitHubRepository>;
  sha?: Maybe<Scalars['String']['output']>;
  user?: Maybe<GitHubUser>;
};

export type GitHubLabel = {
  __typename?: 'GitHubLabel';
  color?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  node_id?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GitHubLink = {
  __typename?: 'GitHubLink';
  href?: Maybe<Scalars['String']['output']>;
};

export type GitHubLinks = {
  __typename?: 'GitHubLinks';
  _self?: Maybe<GitHubLink>;
  comments?: Maybe<GitHubLink>;
  commits?: Maybe<GitHubLink>;
  html?: Maybe<GitHubLink>;
  issue?: Maybe<GitHubLink>;
  review_comment?: Maybe<GitHubLink>;
  review_comments?: Maybe<GitHubLink>;
  statuses?: Maybe<GitHubLink>;
};

export type GitHubPullRequest = {
  __typename?: 'GitHubPullRequest';
  _links?: Maybe<GitHubLinks>;
  active_lock_reason?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<GitHubUser>;
  assignees?: Maybe<Array<Maybe<GitHubUser>>>;
  author_association?: Maybe<Scalars['String']['output']>;
  auto_merge?: Maybe<Scalars['String']['output']>;
  base?: Maybe<GitHubBranch>;
  body?: Maybe<Scalars['String']['output']>;
  closed_at?: Maybe<Scalars['String']['output']>;
  comments_url?: Maybe<Scalars['String']['output']>;
  commits_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  diff_url?: Maybe<Scalars['String']['output']>;
  draft?: Maybe<Scalars['Boolean']['output']>;
  head?: Maybe<GitHubBranch>;
  html_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  issue_url?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<GitHubLabel>>>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  merge_commit_sha?: Maybe<Scalars['String']['output']>;
  merged_at?: Maybe<Scalars['String']['output']>;
  milestone?: Maybe<Scalars['String']['output']>;
  node_id?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  patch_url?: Maybe<Scalars['String']['output']>;
  requested_reviewers?: Maybe<Array<Maybe<GitHubUser>>>;
  requested_teams?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  review_comment_url?: Maybe<Scalars['String']['output']>;
  review_comments_url?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  statuses_url?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<GitHubUser>;
};

export type GitHubPullRequestResponse = {
  __typename?: 'GitHubPullRequestResponse';
  prs?: Maybe<Array<GitHubPullRequest>>;
};

export type GitHubRepository = {
  __typename?: 'GitHubRepository';
  archive_url?: Maybe<Scalars['String']['output']>;
  assignees_url?: Maybe<Scalars['String']['output']>;
  blobs_url?: Maybe<Scalars['String']['output']>;
  branches_url?: Maybe<Scalars['String']['output']>;
  collaborators_url?: Maybe<Scalars['String']['output']>;
  comments_url?: Maybe<Scalars['String']['output']>;
  commits_url?: Maybe<Scalars['String']['output']>;
  compare_url?: Maybe<Scalars['String']['output']>;
  contents_url?: Maybe<Scalars['String']['output']>;
  contributors_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  deployments_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  downloads_url?: Maybe<Scalars['String']['output']>;
  events_url?: Maybe<Scalars['String']['output']>;
  fork?: Maybe<Scalars['Boolean']['output']>;
  forks_url?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  git_commits_url?: Maybe<Scalars['String']['output']>;
  git_refs_url?: Maybe<Scalars['String']['output']>;
  git_tags_url?: Maybe<Scalars['String']['output']>;
  hooks_url?: Maybe<Scalars['String']['output']>;
  html_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  issue_comment_url?: Maybe<Scalars['String']['output']>;
  issue_events_url?: Maybe<Scalars['String']['output']>;
  issues_url?: Maybe<Scalars['String']['output']>;
  keys_url?: Maybe<Scalars['String']['output']>;
  labels_url?: Maybe<Scalars['String']['output']>;
  languages_url?: Maybe<Scalars['String']['output']>;
  merges_url?: Maybe<Scalars['String']['output']>;
  milestones_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  node_id?: Maybe<Scalars['String']['output']>;
  notifications_url?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<GitHubUser>;
  private?: Maybe<Scalars['Boolean']['output']>;
  pulls_url?: Maybe<Scalars['String']['output']>;
  pushed_at?: Maybe<Scalars['String']['output']>;
  releases_url?: Maybe<Scalars['String']['output']>;
  stargazers_url?: Maybe<Scalars['String']['output']>;
  statuses_url?: Maybe<Scalars['String']['output']>;
  subscribers_url?: Maybe<Scalars['String']['output']>;
  subscription_url?: Maybe<Scalars['String']['output']>;
  tags_url?: Maybe<Scalars['String']['output']>;
  teams_url?: Maybe<Scalars['String']['output']>;
  trees_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GitHubUser = {
  __typename?: 'GitHubUser';
  avatar_url?: Maybe<Scalars['String']['output']>;
  events_url?: Maybe<Scalars['String']['output']>;
  followers_url?: Maybe<Scalars['String']['output']>;
  following_url?: Maybe<Scalars['String']['output']>;
  gists_url?: Maybe<Scalars['String']['output']>;
  gravatar_id?: Maybe<Scalars['String']['output']>;
  html_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  node_id?: Maybe<Scalars['String']['output']>;
  organizations_url?: Maybe<Scalars['String']['output']>;
  received_events_url?: Maybe<Scalars['String']['output']>;
  repos_url?: Maybe<Scalars['String']['output']>;
  site_admin?: Maybe<Scalars['Boolean']['output']>;
  starred_url?: Maybe<Scalars['String']['output']>;
  subscriptions_url?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum GoogleEmployeeRole {
  Manager = 'MANAGER',
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export enum GoogleEmployeeType {
  Customer = 'CUSTOMER',
  External = 'EXTERNAL',
  Group = 'GROUP',
  User = 'USER'
}

export type GooglepayCollectionShippingAddress = {
  __typename?: 'GooglepayCollectionShippingAddress';
  allowedCountries?: Maybe<Array<Scalars['String']['output']>>;
  enabled: Scalars['Boolean']['output'];
  includePhoneNumber: Scalars['Boolean']['output'];
};

export type GooglepayConfigQueryResponse = {
  __typename?: 'GooglepayConfigQueryResponse';
  googlepayMerchantId?: Maybe<Scalars['String']['output']>;
};

export type GooglepayPaymentMethodOptions = {
  __typename?: 'GooglepayPaymentMethodOptions';
  shippingAddress?: Maybe<GooglepayCollectionShippingAddress>;
};

export type GroupsDetails = {
  __typename?: 'GroupsDetails';
  adminCreated?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directMembersCount?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nonEditableAliases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type IdsInput = {
  id: Scalars['String']['input'];
};

export type IdsMutationResponse = {
  __typename?: 'IdsMutationResponse';
  payload: MerchantCompanyIdsPayload;
  success: Scalars['Boolean']['output'];
};

export type IdsVersion = {
  __typename?: 'IdsVersion';
  companyId: Scalars['String']['output'];
  merchantId: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type IdsVersionMutationResponse = {
  __typename?: 'IdsVersionMutationResponse';
  payload: IdsVersion;
  success: Scalars['Boolean']['output'];
};

export type Implementation = {
  __typename?: 'Implementation';
  customType?: Maybe<Scalars['String']['output']>;
  predefinedTypes?: Maybe<Array<ImplementationType>>;
};

export type ImplementationInput = {
  customType?: InputMaybe<Scalars['String']['input']>;
  predefinedTypes?: InputMaybe<Array<ImplementationType>>;
};

export enum ImplementationType {
  CodingRequired = 'CODING_REQUIRED',
  Hosted = 'HOSTED',
  LowCode = 'LOW_CODE',
  NoCode = 'NO_CODE',
  Other = 'OTHER',
  PaymentTerminal = 'PAYMENT_TERMINAL',
  PayrollServices = 'PAYROLL_SERVICES',
  PayByLink = 'PAY_BY_LINK',
  ServerToServer = 'SERVER_TO_SERVER',
  SubscriptionServices = 'SUBSCRIPTION_SERVICES'
}

export enum IndividualContactType {
  Amlco = 'amlco',
  Chargeback = 'chargeback',
  Fraud = 'fraud',
  PaymentSupport = 'payment_support',
  TechnicalSupport = 'technical_support'
}

export type IndividualObject = {
  __typename?: 'IndividualObject';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idNumber?: Maybe<Scalars['String']['output']>;
  identificationDocumentType?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  nationalities?: Maybe<Array<CountryAlpha2>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  residentialAddress?: Maybe<Address>;
  ssn?: Maybe<Scalars['String']['output']>;
  type: IndividualType;
};

export type IndividualRelationInput = {
  contactTypes?: InputMaybe<Array<IndividualContactType>>;
  individualId: Scalars['ID']['input'];
  isContact?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimaryContact?: InputMaybe<Scalars['Boolean']['input']>;
  isShareholder?: InputMaybe<Scalars['Boolean']['input']>;
  isUbo?: InputMaybe<Scalars['Boolean']['input']>;
  percentageOfShares?: InputMaybe<Scalars['String']['input']>;
  relatedCompanyId?: InputMaybe<Scalars['ID']['input']>;
  relatedEntityId?: InputMaybe<Scalars['ID']['input']>;
  relatedIndividualId?: InputMaybe<Scalars['ID']['input']>;
  relatedPartnerId?: InputMaybe<Scalars['ID']['input']>;
  signsTaxDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IndividualRelationObject = {
  __typename?: 'IndividualRelationObject';
  contactTypes?: Maybe<Array<IndividualContactType>>;
  individualId: Scalars['ID']['output'];
  isContact?: Maybe<Scalars['Boolean']['output']>;
  isPrimaryContact?: Maybe<Scalars['Boolean']['output']>;
  isUbo?: Maybe<Scalars['Boolean']['output']>;
  percentageOfShares?: Maybe<Scalars['String']['output']>;
  relatedCompanyId?: Maybe<Scalars['ID']['output']>;
  relatedEntityId?: Maybe<Scalars['ID']['output']>;
  relatedIndividualId?: Maybe<Scalars['ID']['output']>;
  relatedPartnerId?: Maybe<Scalars['ID']['output']>;
  signsTaxDocuments?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type IndividualRelationsResponse = {
  __typename?: 'IndividualRelationsResponse';
  relations?: Maybe<Array<IndividualRelationObject>>;
};

export type IndividualSocialMediaInput = {
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum IndividualSpecialAttribute {
  CyprusPermanentResidency = 'cyprus_permanent_residency',
  InvestmentFundOrFinancialService = 'investment_fund_or_financial_service'
}

export enum IndividualType {
  Corporate = 'corporate',
  Individual = 'individual'
}

export type IndividualWithRelations = {
  __typename?: 'IndividualWithRelations';
  childRelations?: Maybe<Array<IndividualRelationObject>>;
  individual: IndividualObject;
  parentRelations?: Maybe<Array<IndividualRelationObject>>;
};

export type IndividualsMutationResponse = {
  __typename?: 'IndividualsMutationResponse';
  success: Scalars['Boolean']['output'];
};

export type IndividualsPair = {
  __typename?: 'IndividualsPair';
  primaryIndividual: IndividualObject;
  secondaryIndividual: IndividualObject;
};

export type IndividualsQueryExactFilterInputValues = {
  annualIncome?: InputMaybe<Scalars['String']['input']>;
  annualIncomeCurrency?: InputMaybe<CurrencyAlpha3>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyDateOfIncorporation?: InputMaybe<Scalars['String']['input']>;
  companyLegalName?: InputMaybe<Scalars['String']['input']>;
  companyPhysicalAddress?: InputMaybe<AddressInput>;
  companyRegisteredAddress?: InputMaybe<AddressInput>;
  companyRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  documentCountryOfIssue?: InputMaybe<CountryAlpha2>;
  documentExpirationDate?: InputMaybe<Scalars['String']['input']>;
  documentIssueDate?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentType?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  otherActivitiesDetails?: InputMaybe<Scalars['String']['input']>;
  pep?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  proofOfResidenceDocumentType?: InputMaybe<ProofOfResidenceDocumentType>;
  residentialAddress?: InputMaybe<AddressInput>;
  searchLabel?: InputMaybe<Scalars['String']['input']>;
  sizeOfWealth?: InputMaybe<Scalars['String']['input']>;
  sizeOfWealthCurrency?: InputMaybe<CurrencyAlpha3>;
  sourceOfIncomeOther?: InputMaybe<Scalars['String']['input']>;
  sourceOfWealthOther?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IndividualType>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type IndividualsQueryInFilterInputValues = {
  annualIncome?: InputMaybe<Array<Scalars['String']['input']>>;
  annualIncomeCurrency?: InputMaybe<Array<CurrencyAlpha3>>;
  archived?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  companyDateOfIncorporation?: InputMaybe<Array<Scalars['String']['input']>>;
  companyLegalName?: InputMaybe<Array<Scalars['String']['input']>>;
  companyPhysicalAddress?: InputMaybe<AddressListInput>;
  companyRegisteredAddress?: InputMaybe<AddressListInput>;
  companyRegistrationNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Array<Scalars['String']['input']>>;
  createdBy?: InputMaybe<Array<Scalars['String']['input']>>;
  dateOfBirth?: InputMaybe<Array<Scalars['String']['input']>>;
  documentCountryOfIssue?: InputMaybe<Array<CountryAlpha2>>;
  documentExpirationDate?: InputMaybe<Array<Scalars['String']['input']>>;
  documentIssueDate?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  identificationDocumentType?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Array<Scalars['String']['input']>>;
  middleName?: InputMaybe<Array<Scalars['String']['input']>>;
  nationalities?: InputMaybe<Array<CountryAlpha2>>;
  otherActivitiesDetails?: InputMaybe<Array<Scalars['String']['input']>>;
  pep?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  phoneNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  placeOfBirth?: InputMaybe<Array<Scalars['String']['input']>>;
  proofOfResidenceDocumentType?: InputMaybe<Array<ProofOfResidenceDocumentType>>;
  residentialAddress?: InputMaybe<AddressListInput>;
  sizeOfWealth?: InputMaybe<Array<Scalars['String']['input']>>;
  sizeOfWealthCurrency?: InputMaybe<Array<CurrencyAlpha3>>;
  sourceOfIncomeOther?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceOfWealthOther?: InputMaybe<Array<Scalars['String']['input']>>;
  sourcesOfIncome?: InputMaybe<Array<SourceOfIncome>>;
  sourcesOfWealth?: InputMaybe<Array<SourceOfWealth>>;
  specialAttributes?: InputMaybe<Array<IndividualSpecialAttribute>>;
  ssn?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<IndividualType>>;
  updatedAt?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedBy?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IndividualsQueryInputFilter = {
  and?: InputMaybe<Array<IndividualsQueryInputFilter>>;
  equal?: InputMaybe<IndividualsQueryExactFilterInputValues>;
  greater?: InputMaybe<IndividualsQueryExactFilterInputValues>;
  greaterOrEquals?: InputMaybe<IndividualsQueryExactFilterInputValues>;
  hasAny?: InputMaybe<IndividualsQueryInFilterInputValues>;
  iLike?: InputMaybe<IndividualsQueryExactFilterInputValues>;
  in?: InputMaybe<IndividualsQueryInFilterInputValues>;
  less?: InputMaybe<IndividualsQueryExactFilterInputValues>;
  lessOrEquals?: InputMaybe<IndividualsQueryExactFilterInputValues>;
  like?: InputMaybe<IndividualsQueryExactFilterInputValues>;
  notEqual?: InputMaybe<IndividualsQueryExactFilterInputValues>;
  notIn?: InputMaybe<IndividualsQueryInFilterInputValues>;
  notLike?: InputMaybe<IndividualsQueryExactFilterInputValues>;
  or?: InputMaybe<Array<IndividualsQueryInputFilter>>;
  textSearchCaseInsensitive?: InputMaybe<IndividualsQueryExactFilterInputValues>;
};

export type IndividualsResponse = {
  __typename?: 'IndividualsResponse';
  individuals?: Maybe<Array<IndividualObject>>;
  pageInfo: PageInfo;
  queryParams?: Maybe<Scalars['JSON']['output']>;
};

export type IndividualsVerificationChecksInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  individualIds?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
};

export type InfiniceptCategory = {
  __typename?: 'InfiniceptCategory';
  status?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InfiniceptCategoryInput = {
  status?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InputTaskFieldGenericValue = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  jsonValue?: InputMaybe<Scalars['JSON']['input']>;
  kind: Scalars['String']['input'];
  listValue?: InputMaybe<Array<InputTaskFieldGenericValue>>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

export type IntRangeInput = {
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
};

export enum IntervalEnum {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

export type IsPaypassStandaloneSetupCompletedPayload = {
  __typename?: 'IsPaypassStandaloneSetupCompletedPayload';
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  shouldPromptForPassword?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

export type IssuerResponseCodeObject = {
  __typename?: 'IssuerResponseCodeObject';
  code: Scalars['String']['output'];
  failureCode: Scalars['String']['output'];
  failureDescription?: Maybe<Scalars['String']['output']>;
  networkCode?: Maybe<Scalars['String']['output']>;
  subType: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type IssuerResponseCodeQueryResponse = {
  __typename?: 'IssuerResponseCodeQueryResponse';
  code: Scalars['String']['output'];
  subType: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum ListAlias {
  CustomerBlacklist = 'customer_blacklist',
  PaymentRulesCustomerWhitelist = 'payment_rules_customer_whitelist',
  PmCardBlacklist = 'pm_card_blacklist'
}

export enum ListTypes {
  BillingAddress = 'billing_address',
  Bin = 'bin',
  Card = 'card',
  CardName = 'card_name',
  Custom = 'custom',
  CustomerId = 'customer_id',
  Email = 'email',
  EmailDomain = 'email_domain',
  IpAddress = 'ip_address',
  IssuerCountry = 'issuer_country',
  PhoneNumber = 'phone_number'
}

export type ListValueMetadata = {
  __typename?: 'ListValueMetadata';
  bin?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<CustomerMetadata>;
  issuerCountry?: Maybe<Scalars['String']['output']>;
  issuerName?: Maybe<Scalars['String']['output']>;
  lastFourDigits?: Maybe<Scalars['String']['output']>;
};

export type LogEntry = {
  __typename?: 'LogEntry';
  apiKeyId?: Maybe<Scalars['String']['output']>;
  apiVersion?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  direction?: Maybe<RequestDirection>;
  eventId?: Maybe<Scalars['String']['output']>;
  firstRequestTime: Scalars['String']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  logType?: Maybe<LogType>;
  merchantId: Scalars['String']['output'];
  method?: Maybe<Scalars['String']['output']>;
  /** COMPUTED_FIELD: created At time unix timestamp with ms */
  nextRetry: Scalars['String']['output'];
  origin?: Maybe<OriginType>;
  originalUri?: Maybe<Scalars['String']['output']>;
  requestAttempt?: Maybe<Scalars['Int']['output']>;
  requestData?: Maybe<Scalars['String']['output']>;
  requestHeaders?: Maybe<Scalars['String']['output']>;
  requestId: Scalars['String']['output'];
  responseData?: Maybe<Scalars['String']['output']>;
  responseHeaders?: Maybe<Scalars['String']['output']>;
  responseStatusCode?: Maybe<Scalars['Int']['output']>;
  responseTime?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time: Scalars['String']['output'];
  traceId: Scalars['String']['output'];
  transactionAttemptId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  webhookEventType?: Maybe<Scalars['String']['output']>;
  webhookId?: Maybe<Scalars['ID']['output']>;
};

export enum LogType {
  Provider = 'PROVIDER',
  Request = 'REQUEST',
  Webhook = 'WEBHOOK'
}

export type LogicField = {
  __typename?: 'LogicField';
  additionalSettings?: Maybe<LogicFieldAdditionalSettings>;
  categoryName?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  internal?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  listTypes?: Maybe<Array<ListTypes>>;
  merchantId?: Maybe<Scalars['ID']['output']>;
  onlyForOutcomesCategories?: Maybe<Array<LogicFieldOutcomesCategories>>;
  options?: Maybe<Array<LogicFieldOption>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  regex?: Maybe<Scalars['String']['output']>;
  subKey?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<LogicType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  valueFieldType: LogicFieldsValueFieldType;
};

export type LogicFieldAdditionalSettings = {
  __typename?: 'LogicFieldAdditionalSettings';
  dependsOnExternalRiskEngine?: Maybe<Scalars['Boolean']['output']>;
};

export type LogicFieldMutationResponse = {
  __typename?: 'LogicFieldMutationResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LogicFieldOption = {
  __typename?: 'LogicFieldOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LogicFieldOptionInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum LogicFieldOutcomesCategories {
  Alert = 'alert',
  Cancel = 'cancel',
  Configuration = 'configuration',
  Payment = 'payment',
  Review = 'review',
  Routing = 'routing'
}

export type LogicFields = {
  __typename?: 'LogicFields';
  logicFields: Array<LogicField>;
};

export enum LogicFieldsValueFieldType {
  Array = 'array',
  Boolean = 'boolean',
  Country = 'country',
  Currency = 'currency',
  Number = 'number',
  Select = 'select',
  SettlementAccount = 'settlement_account',
  Text = 'text',
  Unknown = 'unknown'
}

export enum LogicType {
  Aggregation = 'aggregation',
  Field = 'field',
  Metadata = 'metadata'
}

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  success: Scalars['Boolean']['output'];
};

export type LogsByTransactionIdQueryInput = {
  direction?: InputMaybe<RequestDirection>;
  transactionId: Scalars['ID']['input'];
};

export type LogsByTransactionIdResponse = {
  __typename?: 'LogsByTransactionIdResponse';
  logs: Array<LogEntry>;
};

export type LogsQueryExactInputFilter = {
  apiKeyId?: InputMaybe<Scalars['ID']['input']>;
  apiVersion?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<RequestDirection>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  logType?: InputMaybe<LogType>;
  method?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<OriginType>;
  originalUri?: InputMaybe<Scalars['String']['input']>;
  requestAttempt?: InputMaybe<Scalars['Int']['input']>;
  requestData?: InputMaybe<Scalars['String']['input']>;
  requestHeaders?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['ID']['input']>;
  responseData?: InputMaybe<Scalars['String']['input']>;
  responseHeaders?: InputMaybe<Scalars['String']['input']>;
  responseStatusCode?: InputMaybe<Scalars['Int']['input']>;
  responseTime?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  traceId?: InputMaybe<Scalars['ID']['input']>;
  transactionAttemptId?: InputMaybe<Scalars['ID']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  webhookEventType?: InputMaybe<Scalars['String']['input']>;
  webhookId?: InputMaybe<Scalars['ID']['input']>;
};

export type LogsQueryInFilterInputValues = {
  direction?: InputMaybe<Array<RequestDirection>>;
  logType?: InputMaybe<Array<LogType>>;
  origin?: InputMaybe<Array<OriginType>>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LogsQueryInput = {
  aggregate?: InputMaybe<LogsQueryInputAggregate>;
  filter?: InputMaybe<LogsQueryInputFilter>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type LogsQueryInputAggregate = {
  aggregateFunctions?: InputMaybe<LogsQueryInputAggregateFunctions>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LogsQueryInputAggregateFunctions = {
  anyLast?: InputMaybe<Array<Scalars['String']['input']>>;
  max?: InputMaybe<Array<Scalars['String']['input']>>;
  min?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LogsQueryInputFilter = {
  between?: InputMaybe<LogsQueryRangeFilterInputValues>;
  equal?: InputMaybe<LogsQueryExactInputFilter>;
  greaterOrEquals?: InputMaybe<LogsQueryExactInputFilter>;
  iLike?: InputMaybe<LogsQueryExactInputFilter>;
  in?: InputMaybe<LogsQueryInFilterInputValues>;
  lessOrEquals?: InputMaybe<LogsQueryExactInputFilter>;
  notEqual?: InputMaybe<LogsQueryExactInputFilter>;
  notIn?: InputMaybe<LogsQueryInFilterInputValues>;
  notLike?: InputMaybe<LogsQueryExactInputFilter>;
};

export type LogsQueryRangeFilterInputValues = {
  responseStatusCode?: InputMaybe<IntRangeInput>;
  time?: InputMaybe<StringRangeInput>;
};

export type LogsQueryResponse = {
  __typename?: 'LogsQueryResponse';
  logs: Array<LogEntry>;
  pageInfo: PageInfo;
};

export type ManualSettlementBalanceResponse = {
  __typename?: 'ManualSettlementBalanceResponse';
  balance: Scalars['Float']['output'];
  completed: Scalars['Boolean']['output'];
  isAlreadyApproved?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<ManualSettlementWorkflowStatus>;
};

export type ManualSettlementInput = {
  settlementAccountId: Scalars['String']['input'];
};

export type ManualSettlementReponse = {
  __typename?: 'ManualSettlementReponse';
  success: Scalars['Boolean']['output'];
};

export enum ManualSettlementWorkflowStatus {
  AssigningTransactions = 'assigning_transactions',
  CalculatedWaitingForSignal = 'calculated_waiting_for_signal',
  Calculating = 'calculating',
  CalculatingServiceFees = 'calculating_service_fees',
  CheckingReserve = 'checking_reserve',
  CreatingRecord = 'creating_record',
  FindingBankAccount = 'finding_bank_account',
  Rejected = 'rejected',
  SignalReceived = 'signal_received'
}

export type MasterAccountDetailsInput = {
  accountIdentifier?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  swiftBic?: InputMaybe<Scalars['String']['input']>;
};

export type MatchRequestPrincipals = {
  __typename?: 'MatchRequestPrincipals';
  address?: Maybe<AddressMatchFormat>;
  altPhoneNumber?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  driversLicense?: Maybe<DriverLicence>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleInitial?: Maybe<Scalars['String']['output']>;
  nationalId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export enum MatchType {
  Exact = 'exact',
  None = 'none',
  Partial = 'partial',
  Phonetic = 'phonetic',
  Unknown = 'unknown'
}

export type Mcc = {
  __typename?: 'Mcc';
  amlRank?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  exposureFactor?: Maybe<Scalars['Float']['output']>;
  exposureRiskCategory?: Maybe<ExposureRiskCategory>;
  mcc: Scalars['Int']['output'];
  primaryCategory?: Maybe<Scalars['String']['output']>;
  riskTier?: Maybe<Scalars['Int']['output']>;
};

export enum MccBai {
  Aa = 'AA',
  Bb = 'BB',
  Bi = 'BI',
  Bp = 'BP',
  Cd = 'CD',
  Cp = 'CP',
  Fd = 'FD',
  Ft = 'FT',
  Gd = 'GD',
  Gp = 'GP',
  La = 'LA',
  Lo = 'LO',
  Md = 'MD',
  Mi = 'MI',
  Og = 'OG',
  Pd = 'PD',
  Pp = 'PP',
  Rp = 'RP',
  Tu = 'TU',
  Wt = 'WT'
}

export enum MccCardScheme {
  Amex = 'amex',
  Discover = 'discover',
  Mastercard = 'mastercard',
  Visa = 'visa'
}

export type MccEntry = {
  __typename?: 'MccEntry';
  archived: Scalars['Boolean']['output'];
  cardSchemas: Array<MccCardScheme>;
  code: Scalars['Int']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  transactionTypeCodes?: Maybe<Array<TransactionTypeCodes>>;
  type: MccType;
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MccEntryMutationResponse = {
  __typename?: 'MccEntryMutationResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MccMutationResponse = {
  __typename?: 'MccMutationResponse';
  payload: MccPayload;
  success: Scalars['Boolean']['output'];
};

export type MccPayload = {
  __typename?: 'MccPayload';
  mcc: Scalars['Int']['output'];
};

export type MccQueryInput = {
  mcc: Scalars['Int']['input'];
};

export enum MccTti {
  C04 = 'C04',
  C07 = 'C07',
  C52 = 'C52',
  C54 = 'C54',
  C55 = 'C55',
  C56 = 'C56',
  C57 = 'C57',
  C58 = 'C58',
  C59 = 'C59',
  C60 = 'C60',
  C65 = 'C65',
  F07 = 'F07',
  F08 = 'F08',
  F52 = 'F52',
  F54 = 'F54',
  F55 = 'F55',
  F56 = 'F56',
  F61 = 'F61',
  F64 = 'F64',
  F65 = 'F65'
}

export enum MccType {
  Acquiring = 'acquiring',
  Funding = 'funding',
  Payout = 'payout'
}

export type MccsQueryResponse = {
  __typename?: 'MccsQueryResponse';
  mccs: Array<Mcc>;
};

export type Merchant = {
  __typename?: 'Merchant';
  acquirer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  activationDate?: Maybe<Scalars['String']['output']>;
  applicationStatus?: Maybe<MerchantApplicationStatuses>;
  assignee?: Maybe<Scalars['String']['output']>;
  automaticReview?: Maybe<Scalars['Boolean']['output']>;
  billingDetails?: Maybe<Address>;
  branding?: Maybe<Branding>;
  businessDetails?: Maybe<BusinessDetails>;
  companyId?: Maybe<Scalars['String']['output']>;
  consumerPayoutsEnabled?: Maybe<Scalars['Boolean']['output']>;
  contactInfo?: Maybe<ContactInfo>;
  continent?: Maybe<ContinentAlpha2>;
  costsProviderOverride?: Maybe<Scalars['JSON']['output']>;
  country?: Maybe<Country>;
  crmFields?: Maybe<MerchantCrmFields>;
  currencyCode?: Maybe<CurrencyAlpha3>;
  default3DsProcessor?: Maybe<Scalars['String']['output']>;
  defaultProcessor?: Maybe<Scalars['String']['output']>;
  defaultProcessorAmex?: Maybe<Scalars['String']['output']>;
  defaultProcessorDiscover?: Maybe<Scalars['String']['output']>;
  defaultProcessorMastercard?: Maybe<Scalars['String']['output']>;
  defaultProcessorVisa?: Maybe<Scalars['String']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  doingBusinessAs?: Maybe<Scalars['String']['output']>;
  featureFlags: Array<Maybe<FeatureFlag>>;
  fronteggTenantId?: Maybe<Scalars['String']['output']>;
  gateway?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['String']['output']>;
  limits?: Maybe<MerchantLimits>;
  metadataQuickSearchKeys?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  overrideOnboardingMerchantId?: Maybe<Scalars['String']['output']>;
  payfac?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  processingCurrencyCodes?: Maybe<Array<Scalars['String']['output']>>;
  processingRiskScore?: Maybe<MerchantApplicationRiskScores>;
  processingToSettlementsCurrencyCodes?: Maybe<Scalars['JSON']['output']>;
  settlementCurrencyCodes?: Maybe<Array<Scalars['String']['output']>>;
  stage?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<MerchantStatus>;
  testMerchant?: Maybe<Scalars['Boolean']['output']>;
};

export type MerchantAndCompany = {
  __typename?: 'MerchantAndCompany';
  companyId: Scalars['ID']['output'];
  merchantId?: Maybe<Scalars['ID']['output']>;
};

export type MerchantAndCompanyInput = {
  companyId: Scalars['ID']['input'];
};

export type MerchantApplication = {
  __typename?: 'MerchantApplication';
  acquiringProviders?: Maybe<Array<AcquiringProvider>>;
  acquiringServices?: Maybe<Array<AcquiringService>>;
  approvalDate?: Maybe<Scalars['String']['output']>;
  automaticReview?: Maybe<Scalars['Boolean']['output']>;
  bankDetails?: Maybe<OnboardingBankDetails>;
  businessActivity?: Maybe<OnboardingBusinessActivity>;
  businessDetails?: Maybe<OnboardingBusinessDetails>;
  businessProcessingInfo?: Maybe<OnboardingBusinessProcessingInfo>;
  businessReview?: Maybe<ReviewStatuses>;
  businessStructureDetails?: Maybe<BusinessStructureDetails>;
  channel?: Maybe<OnboardingChannel>;
  companyId: Scalars['String']['output'];
  contractAgreementDate?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdBySystem?: Maybe<OnboardingSystem>;
  customerSupport?: Maybe<CustomerSupport>;
  declineDetails?: Maybe<OnboardingDeclineDetails>;
  documents?: Maybe<Array<Document>>;
  enrollmentDate?: Maybe<Scalars['String']['output']>;
  fulfillmentDetails?: Maybe<FulfillmentDetails>;
  heardOfPayFrom?: Maybe<Scalars['String']['output']>;
  individuals?: Maybe<Array<FlattenedIndividual>>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  latestVersion?: Maybe<Scalars['Int']['output']>;
  merchantId: Scalars['String']['output'];
  onboardingChannel?: Maybe<ChannelOnboarding>;
  otherCommunications?: Maybe<Scalars['Boolean']['output']>;
  payLegalEntity?: Maybe<Array<PayLegalEntityType>>;
  paymentRequirements?: Maybe<Scalars['String']['output']>;
  paypassLinkCreatedAt?: Maybe<Scalars['String']['output']>;
  paypassLinkCreatedBy?: Maybe<Scalars['String']['output']>;
  paypassLinkCreatedBySystem?: Maybe<OnboardingSystem>;
  paypassSubmittedAt?: Maybe<Scalars['String']['output']>;
  primaryContact?: Maybe<FlattenedIndividual>;
  priority?: Maybe<Scalars['Int']['output']>;
  privacyPolicyAgreement?: Maybe<Scalars['Boolean']['output']>;
  providerData?: Maybe<ProviderData>;
  risk?: Maybe<Risk>;
  riskScore?: Maybe<MerchantApplicationRiskScores>;
  salesAssignee?: Maybe<Scalars['String']['output']>;
  settlementTerms?: Maybe<SettlementTerms>;
  shadowPurchase?: Maybe<ReviewStatuses>;
  shortDescriptor?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<MerchantApplicationStatuses>;
  taxInfo?: Maybe<TaxInfo>;
  test?: Maybe<Scalars['Boolean']['output']>;
  underwritingAssignee?: Maybe<Scalars['String']['output']>;
  underwritingInfo?: Maybe<UnderwritingInfo>;
  version?: Maybe<Scalars['Int']['output']>;
  websites?: Maybe<Array<WebsiteEntry>>;
};

export type MerchantApplicationIdsInput = {
  companyId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};

export type MerchantApplicationInputFilter = {
  and?: InputMaybe<Array<MerchantApplicationInputFilter>>;
  between?: InputMaybe<MerchantApplicationQueryRangeFilterInputValues>;
  equal?: InputMaybe<MerchantApplicationQueryExactFilterInputValues>;
  greater?: InputMaybe<MerchantApplicationQueryExactFilterInputValues>;
  greaterOrEquals?: InputMaybe<MerchantApplicationQueryExactFilterInputValues>;
  hasAny?: InputMaybe<MerchantApplicationQueryHasAnyFilterInputValues>;
  iLike?: InputMaybe<MerchantApplicationQueryExactFilterInputValues>;
  in?: InputMaybe<MerchantApplicationQueryInFilterInputValues>;
  less?: InputMaybe<MerchantApplicationQueryExactFilterInputValues>;
  lessOrEquals?: InputMaybe<MerchantApplicationQueryExactFilterInputValues>;
  like?: InputMaybe<MerchantApplicationQueryExactFilterInputValues>;
  notBetween?: InputMaybe<MerchantApplicationQueryRangeFilterInputValues>;
  notEqual?: InputMaybe<MerchantApplicationQueryExactFilterInputValues>;
  notIn?: InputMaybe<MerchantApplicationQueryInFilterInputValues>;
  notLike?: InputMaybe<MerchantApplicationQueryExactFilterInputValues>;
  or?: InputMaybe<Array<MerchantApplicationInputFilter>>;
};

export type MerchantApplicationPreview = {
  __typename?: 'MerchantApplicationPreview';
  acquiringProviders?: Maybe<Array<AcquiringProvider>>;
  acquiringServices?: Maybe<Array<AcquiringService>>;
  approvalDate?: Maybe<Scalars['String']['output']>;
  automaticReview?: Maybe<Scalars['Boolean']['output']>;
  businessActivity?: Maybe<OnboardingBusinessActivityPreview>;
  businessDetails?: Maybe<OnboardingBusinessDetailsPreview>;
  businessProcessingInfo?: Maybe<OnboardingBusinessProcessingInfo>;
  businessReview?: Maybe<ReviewStatuses>;
  businessStructureDetails?: Maybe<BusinessStructureDetailsPreview>;
  channel?: Maybe<OnboardingChannel>;
  companyId: Scalars['String']['output'];
  contractAgreementDate?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBySystem?: Maybe<OnboardingSystem>;
  customerSupport?: Maybe<CustomerSupport>;
  declineDetails?: Maybe<OnboardingDeclineDetails>;
  enrollmentDate?: Maybe<Scalars['String']['output']>;
  fulfillmentDetails?: Maybe<FulfillmentDetailsPreview>;
  heardOfPayFrom?: Maybe<Scalars['String']['output']>;
  isAnyMerchantActive?: Maybe<Scalars['Boolean']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  mccCodes?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  merchantId: Scalars['String']['output'];
  merchantIds?: Maybe<Array<Scalars['String']['output']>>;
  onboardingChannel?: Maybe<ChannelOnboarding>;
  otherCommunications?: Maybe<Scalars['Boolean']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  payLegalEntity?: Maybe<Array<PayLegalEntityType>>;
  paymentRequirements?: Maybe<Scalars['String']['output']>;
  paypassLinkCreatedAt?: Maybe<Scalars['String']['output']>;
  paypassLinkCreatedBy?: Maybe<Scalars['String']['output']>;
  paypassLinkCreatedBySystem?: Maybe<OnboardingSystem>;
  paypassSubmittedAt?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  privacyPolicyAgreement?: Maybe<Scalars['Boolean']['output']>;
  risk?: Maybe<RiskPreview>;
  riskScore?: Maybe<MerchantApplicationRiskScores>;
  salesAssignee?: Maybe<Scalars['String']['output']>;
  salesInfo?: Maybe<SalesInfo>;
  settlementTerms?: Maybe<SettlementTermsPreview>;
  shadowPurchase?: Maybe<ReviewStatuses>;
  shortDescriptor?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<MerchantApplicationStatuses>;
  taxInfo?: Maybe<TaxInfo>;
  test?: Maybe<Scalars['Boolean']['output']>;
  underwritingAssignee?: Maybe<Scalars['String']['output']>;
  underwritingInfo?: Maybe<UnderwritingInfoPreview>;
  version?: Maybe<Scalars['Int']['output']>;
  websiteDomains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MerchantApplicationQueryExactFilterInputValues = {
  automaticReview?: InputMaybe<Scalars['Boolean']['input']>;
  businessActivity?: InputMaybe<BusinessActivityFilterInput>;
  businessDetails?: InputMaybe<BusinessDetailsFilterInput>;
  businessProcessingInfo?: InputMaybe<BusinessProcessingInfoFilterInput>;
  businessStructureDetails?: InputMaybe<BusinessStructureDetailsFilterInput>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  customerSupport?: InputMaybe<CustomerSupportFilterInput>;
  declineDetails?: InputMaybe<DeclineDetailsFilterInput>;
  fulfillmentDetails?: InputMaybe<FulfillmentDetailsFilterInput>;
  heardOfPayFrom?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  onboardingChannel?: InputMaybe<ChannelOnboardingFilterInput>;
  otherCommunications?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  paymentRequirements?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  privacyPolicyAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  risk?: InputMaybe<RiskFilterInput>;
  salesAssignee?: InputMaybe<Scalars['String']['input']>;
  salesInfo?: InputMaybe<SalesInfoFilterInput>;
  settlementTerms?: InputMaybe<SettlementTermsFilterInput>;
  shadowPurchase?: InputMaybe<Scalars['String']['input']>;
  shortDescriptor?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  taxInfo?: InputMaybe<TaxInfoFilterInput>;
  test?: InputMaybe<Scalars['Boolean']['input']>;
  underwritingAssignee?: InputMaybe<Scalars['String']['input']>;
  underwritingInfo?: InputMaybe<UnderwritingInfoFilterInput>;
  version?: InputMaybe<Scalars['Int']['input']>;
  websiteDomains?: InputMaybe<Scalars['String']['input']>;
};

export type MerchantApplicationQueryHasAnyFilterInputValues = {
  acquiringProviders?: InputMaybe<Array<InputMaybe<AcquiringProvider>>>;
  acquiringServices?: InputMaybe<Array<InputMaybe<AcquiringService>>>;
  businessActivity?: InputMaybe<BusinessActivityFilterInput>;
  businessDetails?: InputMaybe<BusinessDetailsFilterInput>;
  mccCodes?: InputMaybe<Array<Scalars['Int']['input']>>;
  merchantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  payLegalEntity?: InputMaybe<Array<PayLegalEntityType>>;
  websiteDomains?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MerchantApplicationQueryInFilterInputValues = {
  businessActivity?: InputMaybe<BusinessActivityFilterInput>;
  businessDetails?: InputMaybe<BusinessDetailsFilterInput>;
  businessProcessingInfo?: InputMaybe<BusinessProcessingInfoFilterInput>;
  businessReview?: InputMaybe<Array<InputMaybe<ReviewStatuses>>>;
  businessStructureDetails?: InputMaybe<BusinessStructureDetailsInFilterInput>;
  channel?: InputMaybe<Array<InputMaybe<OnboardingChannel>>>;
  createdBySystem?: InputMaybe<Array<InputMaybe<OnboardingSystem>>>;
  customerSupport?: InputMaybe<CustomerSupportInFilterInput>;
  declineDetails?: InputMaybe<DeclineDetailsFilterInput>;
  fulfillmentDetails?: InputMaybe<FulfillmentDetailsFilterInput>;
  onboardingChannel?: InputMaybe<ChannelOnboardingFilterInput>;
  paypassLinkCreatedBySystem?: InputMaybe<Array<InputMaybe<OnboardingSystem>>>;
  risk?: InputMaybe<RiskFilterInput>;
  riskScore?: InputMaybe<Array<InputMaybe<MerchantApplicationRiskScores>>>;
  settlementTerms?: InputMaybe<SettlementTermsFilterInput>;
  shadowPurchase?: InputMaybe<Array<InputMaybe<ReviewStatuses>>>;
  status?: InputMaybe<Array<InputMaybe<MerchantApplicationStatuses>>>;
  taxInfo?: InputMaybe<TaxInfoInFilterInput>;
};

export type MerchantApplicationQueryInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type MerchantApplicationQueryRangeFilterInputValues = {
  approvalDate?: InputMaybe<StringRangeInput>;
  businessStructureDetails?: InputMaybe<BusinessStructureDetailsFilterInput>;
  contractAgreementDate?: InputMaybe<StringRangeInput>;
  createdAt?: InputMaybe<StringRangeInput>;
  enrollmentDate?: InputMaybe<StringRangeInput>;
  lastUpdated?: InputMaybe<StringRangeInput>;
  paypassLinkCreatedAt?: InputMaybe<StringRangeInput>;
  paypassSubmittedAt?: InputMaybe<StringRangeInput>;
  risk?: InputMaybe<RiskFilterInput>;
};

export type MerchantApplicationResponse = {
  __typename?: 'MerchantApplicationResponse';
  merchantApplications?: Maybe<Array<MerchantApplicationPreview>>;
  pageInfo: PageInfo;
};

export enum MerchantApplicationRiskScores {
  HighRisk = 'high_risk',
  LowRisk = 'low_risk',
  MediumRisk = 'medium_risk',
  Unacceptable = 'unacceptable'
}

export enum MerchantApplicationStatuses {
  Approved = 'APPROVED',
  ClientInfoUpdated = 'CLIENT_INFO_UPDATED',
  Declined = 'DECLINED',
  Enrolled = 'ENROLLED',
  ExternalChecksDone = 'EXTERNAL_CHECKS_DONE',
  ExternalChecksFailed = 'EXTERNAL_CHECKS_FAILED',
  InReview = 'IN_REVIEW',
  ManuallyApproved = 'MANUALLY_APPROVED',
  ManuallyDeclined = 'MANUALLY_DECLINED',
  New = 'NEW',
  PendingApprovals = 'PENDING_APPROVALS',
  PendingCompliance = 'PENDING_COMPLIANCE',
  PendingExternalChecks = 'PENDING_EXTERNAL_CHECKS',
  PendingHeadOfUw = 'PENDING_HEAD_OF_UW',
  PendingInformation = 'PENDING_INFORMATION',
  PendingManagement = 'PENDING_MANAGEMENT',
  PendingRisk = 'PENDING_RISK',
  PreChecksDone = 'PRE_CHECKS_DONE',
  Submitted = 'SUBMITTED',
  Withdrawn = 'WITHDRAWN'
}

export type MerchantApplicationsQueryInput = {
  filter?: InputMaybe<MerchantApplicationInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type MerchantApproval = {
  __typename?: 'MerchantApproval';
  amlRiskCategory?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  conditions?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  groupAssigned: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  merchantId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  recordType: OnboardingApprovalRecordType;
  requestedByTask?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status: OnboardingApprovalStatus;
  submittedBy?: Maybe<Scalars['String']['output']>;
  submittedDate?: Maybe<Scalars['String']['output']>;
};

export type MerchantApprovalsQueryInput = {
  companyId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};

export type MerchantApprovalsQueryResponse = {
  __typename?: 'MerchantApprovalsQueryResponse';
  approvals: Array<MerchantApproval>;
};

export type MerchantCompanyIdsPayload = {
  __typename?: 'MerchantCompanyIdsPayload';
  companyId: Scalars['String']['output'];
  merchantId: Scalars['String']['output'];
};

export type MerchantConnections = {
  __typename?: 'MerchantConnections';
  completed: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  enabledAt: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  partnerAccountIdentifier?: Maybe<Scalars['String']['output']>;
  partnerKey: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  routingKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type MerchantConnectionsQueryInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MerchantConnectionsQueryResponse = {
  __typename?: 'MerchantConnectionsQueryResponse';
  connections: Array<MerchantConnections>;
};

export type MerchantCrmFieldGenericValue = {
  __typename?: 'MerchantCrmFieldGenericValue';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  json?: Maybe<Scalars['JSON']['output']>;
  list?: Maybe<Array<MerchantCrmFieldGenericValue>>;
  number?: Maybe<Scalars['Float']['output']>;
  string?: Maybe<Scalars['String']['output']>;
};

export type MerchantCrmFieldValue = {
  __typename?: 'MerchantCrmFieldValue';
  companyId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  key: Scalars['String']['output'];
  merchantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  value: MerchantCrmFieldGenericValue;
};

export type MerchantCrmFieldValueInput = {
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  json?: InputMaybe<Scalars['JSON']['input']>;
  list?: InputMaybe<Array<MerchantCrmFieldValueInput>>;
  number?: InputMaybe<Scalars['Float']['input']>;
  string?: InputMaybe<Scalars['String']['input']>;
};

export type MerchantCrmFields = {
  __typename?: 'MerchantCrmFields';
  closingOrTerminationDate?: Maybe<Scalars['String']['output']>;
  closingOrTerminationReason?: Maybe<Scalars['String']['output']>;
  terminationReasonOptions?: Maybe<Array<MerchantTerminationReason>>;
};

export type MerchantCrmFieldsValues = {
  __typename?: 'MerchantCrmFieldsValues';
  fieldsValue?: Maybe<Array<MerchantCrmFieldValue>>;
};

export type MerchantDashboard = {
  __typename?: 'MerchantDashboard';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: DashboardType;
};

export type MerchantDashboardCategory = {
  __typename?: 'MerchantDashboardCategory';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MerchantDefaultExportFieldsPayload = {
  tableName: Scalars['String']['input'];
};

export type MerchantFieldValueInput = {
  companyId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};

export type MerchantFieldsValuesInput = {
  companyId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};

export type MerchantFilteredRulesInput = {
  ruleType: Scalars['String']['input'];
};

export type MerchantFilteredRulesResponse = {
  __typename?: 'MerchantFilteredRulesResponse';
  rules: Array<RuleObject>;
};

export type MerchantInsightsInput = {
  cardBrand?: InputMaybe<Scalars['String']['input']>;
  cardCategory?: InputMaybe<Scalars['String']['input']>;
  cardFunding?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryAlpha2>;
  countryState?: InputMaybe<Scalars['String']['input']>;
  currency: CurrencyAlpha3;
  dateRange?: InputMaybe<StringRangeInput>;
  firstTimeDepositor?: InputMaybe<Scalars['Boolean']['input']>;
  googlePayPanOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeWallets?: InputMaybe<Scalars['Boolean']['input']>;
  isTotal?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  retry?: InputMaybe<Scalars['String']['input']>;
  settlementAccountId?: InputMaybe<Scalars['String']['input']>;
  threeDs?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MerchantInsightsObject = {
  __typename?: 'MerchantInsightsObject';
  abandonBreakdownByLastVisitedStep: Array<AbandonBreakdownByLastVisitedStep>;
  abandonedCount: Scalars['Float']['output'];
  abandonedRate: Scalars['Float']['output'];
  approvalRate: Scalars['Float']['output'];
  averagePayment: Scalars['Float']['output'];
  averagePayout: Scalars['Float']['output'];
  breakdownByPaymentMethod: Array<BreakdownByPaymentMethod>;
  breakdownBySettlementAccount: Array<BreakdownBySettlementAccount>;
  cardBrands: Array<Scalars['String']['output']>;
  countryOptions: Array<CountryAlpha2>;
  countryStateOptions: Array<Scalars['String']['output']>;
  declineRate: Scalars['Float']['output'];
  declinedPayments: Scalars['Float']['output'];
  declinesBreakdownByFailureCode: Array<DeclinesBreakdownByFailureCode>;
  disputeRate: Scalars['Float']['output'];
  fraudPaymentsVolume: Scalars['Float']['output'];
  fraudRate: Scalars['Float']['output'];
  isApprovalRateTransactionsBased: Scalars['Boolean']['output'];
  openDisputesCount: Scalars['Float']['output'];
  openDisputesVolume: Scalars['Float']['output'];
  paymentMethods: Array<Scalars['String']['output']>;
  paymentsBreakdownByDate: Array<PaymentsBreakdownByDate>;
  paymentsCount: Scalars['Float']['output'];
  paymentsVolume: Scalars['Float']['output'];
  payoutCount: Scalars['Float']['output'];
  payoutRatio: Scalars['Float']['output'];
  payoutVolume: Scalars['Float']['output'];
  refundCount: Scalars['Float']['output'];
  refundOutOfPayments: Scalars['Float']['output'];
  refundVolume: Scalars['Float']['output'];
  sessionsCount: Scalars['Float']['output'];
  settlementAccountIds: Array<Scalars['String']['output']>;
  successfulPayments: Scalars['Float']['output'];
  totalDeclines: Scalars['Float']['output'];
  totalFraudPayments: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
};

export enum MerchantLeadSource {
  Advertisement = 'ADVERTISEMENT',
  AffiliatedCompany = 'AFFILIATED_COMPANY',
  ComparisonSite = 'COMPARISON_SITE',
  ContactSales = 'CONTACT_SALES',
  CustomerEvent = 'CUSTOMER_EVENT',
  EmployeeReferral = 'EMPLOYEE_REFERRAL',
  ExternalReferral = 'EXTERNAL_REFERRAL',
  GoogleAdwords = 'GOOGLE_ADWORDS',
  Other = 'OTHER',
  Outbound = 'OUTBOUND',
  Partner = 'PARTNER',
  Paypass = 'PAYPASS',
  PaypassEea = 'PAYPASS_EEA',
  PurchasedList = 'PURCHASED_LIST',
  SelfSourced = 'SELF_SOURCED',
  TradeShow = 'TRADE_SHOW',
  Webinar = 'WEBINAR',
  Website = 'WEBSITE'
}

export type MerchantLimits = {
  __typename?: 'MerchantLimits';
  maximumPaymentAmount?: Maybe<Scalars['String']['output']>;
  minimumPaymentAmount?: Maybe<Scalars['String']['output']>;
};

export type MerchantLogicFieldsInput = {
  merchantId: Scalars['ID']['input'];
};

export type MerchantPaymentMethodConfig = {
  __typename?: 'MerchantPaymentMethodConfig';
  companyId: Scalars['String']['output'];
  configName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  defaultConfig?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  merchantId: Scalars['String']['output'];
  paymentMethodOptions?: Maybe<SettingsPaymentMethodOptions>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type MerchantSettings = {
  __typename?: 'MerchantSettings';
  defaultRiskControl?: Maybe<Array<DefaultRiskControl>>;
};

export type MerchantSettingsQueryInput = {
  companyId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};

export enum MerchantStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Closed = 'CLOSED',
  Dormant = 'DORMANT',
  Inactive = 'INACTIVE',
  Lead = 'LEAD',
  Opportunity = 'OPPORTUNITY',
  PendingConfigurations = 'PENDING_CONFIGURATIONS',
  SalesBlocked = 'SALES_BLOCKED',
  SalesFrozen = 'SALES_FROZEN',
  Terminated = 'TERMINATED'
}

export enum MerchantTerminationReason {
  AdverseMedia = 'ADVERSE_MEDIA',
  AgreementBreach = 'AGREEMENT_BREACH',
  ComplianceConsiderations = 'COMPLIANCE_CONSIDERATIONS',
  DidNotSubmitEvidenceDuringInvestigation = 'DID_NOT_SUBMIT_EVIDENCE_DURING_INVESTIGATION',
  DidNotSubmitRenewalDocs = 'DID_NOT_SUBMIT_RENEWAL_DOCS',
  ExcessiveCreditExposure = 'EXCESSIVE_CREDIT_EXPOSURE',
  ExcessiveDisputesRate = 'EXCESSIVE_DISPUTES_RATE',
  ExcessiveFraudRate = 'EXCESSIVE_FRAUD_RATE',
  ExcessiveRefundsRate = 'EXCESSIVE_REFUNDS_RATE',
  FraudulentActivity = 'FRAUDULENT_ACTIVITY',
  Miscoding = 'MISCODING',
  Other = 'OTHER',
  OutsideOfRiskAppetite = 'OUTSIDE_OF_RISK_APPETITE',
  ProhibitedActivity = 'PROHIBITED_ACTIVITY',
  SanctionsOngoingMatch = 'SANCTIONS_ONGOING_MATCH',
  SuspiciousActivity = 'SUSPICIOUS_ACTIVITY',
  TransactionLaundering = 'TRANSACTION_LAUNDERING'
}

export type MerchantsQueryInput = {
  filter?: InputMaybe<MerchantsQueryInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type MerchantsResponse = {
  __typename?: 'MerchantsResponse';
  merchants?: Maybe<Array<Merchant>>;
  pageInfo: PageInfo;
};

export type MerchantsUnderRuleInput = {
  companyId: Scalars['ID']['input'];
  filter?: InputMaybe<MerchantsQueryInputFilter>;
  includedInRule: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  merchantId: Scalars['ID']['input'];
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  ruleId: Scalars['ID']['input'];
};

export type MerchantsUnderRuleResponse = {
  __typename?: 'MerchantsUnderRuleResponse';
  amountOfMerchantsExcludedFromRule: Scalars['Int']['output'];
  amountOfMerchantsIncludedInRule: Scalars['Int']['output'];
  hits: Scalars['Int']['output'];
  totalTransactions: Scalars['Int']['output'];
};

export enum MitReason {
  First = 'FIRST',
  Subsequent = 'SUBSEQUENT',
  Unscheduled = 'UNSCHEDULED'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptDispute: AcceptDisputeResponse;
  addCommentToVerificationCheck: VerificationCheckResponse;
  addDisputeEvidence: AddEvidenceMutationResponse;
  addMerchantCrmFieldValues: AddCrmFieldValuesResponse;
  addRiskListValues: RiskListMutationResponse;
  addTaskNote: TaskMutationResponse;
  addToList: UpdateListMutationResponse;
  archiveRule: UpdateRiskRuleMutationResponse;
  assignTask: TaskMutationResponse;
  authenticatePaypassWithVerificationCode?: Maybe<AuthenticateWithVerificationCodePayload>;
  bulkAddToBlacklist: BulkAddToBlacklistMutationResponse;
  cancelSubscription: CommonSubscriptionMutationResponse;
  cancelTask: TaskMutationResponse;
  collaborationsRefund: CollaborationsRefundResponse;
  createApiKey: ApiKeyResponse;
  createAutomaticVerificationCheck: VerificationCheckResponse;
  createBankAccount: BankAccountMutationResponse;
  createCardPayment: CreateCardPaymentMutationResponse;
  createChargebackReason: ChargebackReasonMutationResponse;
  createCommission: Commission;
  createConsumer: CreateConsumerMutationResponse;
  createCost: CostMutationResponse;
  createCountry: CountryMutationResponse;
  createCrmField: CreateCrmFieldMutationResponse;
  createDashboard: SupersetMutationResponse;
  createDeclineMessage: DeclineMessageMutationResponse;
  createDocumentType: DocumentTypeMutationResponse;
  createEntityMcc?: Maybe<MccEntryMutationResponse>;
  createEntityTasksFromGroupTemplates: TaskGroupTemplateMutationResponse;
  createExportField: ExportFieldMutationResponse;
  createFailureCodeMessage: FailureCodeMessageQueryResponse;
  createFeatureFlag: FeatureFlag;
  createFinance: FinanceObject;
  createIndividualRelation: IndividualsMutationResponse;
  createIndividualWithRelation: CreateIndividualWithRelationResponse;
  createIssuerResponseCode: IssuerResponseCodeQueryResponse;
  createLogicField: LogicFieldMutationResponse;
  createMcc: MccMutationResponse;
  createMerchantDashboard: CreateMerchantDashboardResponse;
  createMerchantSettings?: Maybe<CreateMerchantSettingsResponse>;
  createNote: CreateNoteMutationResponse;
  createOnboardingJWT: CreateOnboardingJwtMutationResponse;
  createOnboardingPricing?: Maybe<CreateOnboardingPricingMutationResponse>;
  createOnboardingPricingField?: Maybe<OnboardingPricingFieldMutationResponse>;
  createOnboardingRiskRule?: Maybe<OnboardingRiskRulesMutationResponse>;
  createPaymentLink: CreatePaymentLinkMutationResponse;
  createPayout?: Maybe<CreatePayoutResponse>;
  createPricing: MerchantAndCompany;
  createPricingAction: PricingAction;
  createProviderFeatures?: Maybe<ProviderFeaturesMutationResponse>;
  createProvisioningTemplate?: Maybe<CreateProvisioningTemplateMutationResponse>;
  createReconciliationConfig?: Maybe<ReconciliationConfigMutationResponse>;
  createReferral: ReferralObject;
  createReportsConfig: GetReportsConfigQueryResponse;
  createRiskCalculation: RiskCalculation;
  createRiskList: CreateRiskListMutationResponse;
  createRiskRule: UpdateRiskRuleMutationResponse;
  createRole: SaveRoleMutationResponse;
  createRoutineTemplate?: Maybe<RoutineIdResponse>;
  createSSHKeyPair?: Maybe<Scalars['String']['output']>;
  createSandboxMerchant: CreateSandboxMerchantResponse;
  createSnowflakeId: Scalars['String']['output'];
  createSnowflakeIds: CreateSnowflakeIdsResponse;
  createStructure: StructureMutationResponse;
  createSubscription: CommonSubscriptionMutationResponse;
  createSubscriptionPackage: CommonSubscriptionMutationResponse;
  createTask: TaskMutationResponse;
  createTaskTemplate: TaskTemplateResponse;
  createTransaction: CreateTransactionMutationResponse;
  createUser: SaveMutationResponse;
  createVerificationCheck: VerificationCheckResponse;
  createWebhook: Webhook;
  createWebsite?: Maybe<WebsiteMutationResponse>;
  createWebsitesBulk?: Maybe<WebsiteMutationResponse>;
  deactivateUser: SaveMutationResponse;
  deleteDashboard: SupersetMutationResponse;
  deleteFeatureFlag: FeatureFlag;
  deleteLogicField: LogicFieldMutationResponse;
  deleteMcc: MccMutationResponse;
  deleteRiskList: RiskListMutationResponse;
  deleteRiskListValue: RiskListMutationResponse;
  deleteTaskTemplate: TaskTemplateResponse;
  deleteWebhook: Webhook;
  disableMerchantDashboard: DisableMerchantDashboardResponse;
  duplicateRiskRule: UpdateRiskRuleMutationResponse;
  editRiskRule: UpdateRiskRuleMutationResponse;
  finalizeSignUpMerchant: SignupMerchantMutationResponse;
  generateAssessmentForm: AssessmentFormResponse;
  generateCsrCertificate?: Maybe<GenerateCsrCertificate>;
  generateOnboardingMpa: OnboardingMpaResponse;
  generateOnboardingPricingSigningUrl?: Maybe<GenerateOnboardingPricingSigningUrlMutationResponse>;
  initManualSettlement: ManualSettlementReponse;
  logout: LogoutResponse;
  paymentCancellation: PaymentCancellationMutationResponse;
  paymentCapture: PaymentMutationResponse;
  paymentRefund: PaymentMutationResponse;
  registerApplePayDomain: RegisterApplePayDomainResponse;
  removeApiKey: RemoveApiKeyMutationResponse;
  removeApplePayCertificate?: Maybe<RemoveApplePayCertificate>;
  removeChargebackReason: ChargebackReasonMutationResponse;
  removeConsumerRuleExclusion: ConsumerRuleExclusionMutationResponse;
  removeCost: CostMutationResponse;
  removeCountry: CountryMutationResponse;
  removeDeclineMessage: DeclineMessageMutationResponse;
  removeExportField: ExportFieldMutationResponse;
  removeFailureCodeMessage: FailureCodeMessageQueryResponse;
  removeFromList: UpdateListMutationResponse;
  removeIndividual: IndividualsMutationResponse;
  removeIndividualRelation: IndividualsMutationResponse;
  removeIssuerResponseCode: IssuerResponseCodeQueryResponse;
  removeMerchantDefaultExportFields: ExportFieldMutationResponse;
  removeNote: RemoveNoteMutationResponse;
  removePricing: MerchantAndCompany;
  removeReconciliationConfig?: Maybe<ReconciliationConfigMutationResponse>;
  removeRoutineTemplate?: Maybe<RoutineIdResponse>;
  removeSource: RemoveSourceResponse;
  removeStructure: StructureMutationResponse;
  removeVerificationCheck: VerificationCheckResponse;
  requestBlocking: RequestBlockingMutationResponse;
  requestInformation: RequestInformationResponse;
  rerollApiKey: RerollApiKeyResponse;
  resendWebhookEvent: ResendWebhookEventMutationResponse;
  resetRulesPriorities: UpdateRiskRuleMutationResponse;
  retrySubscription: CommonSubscriptionMutationResponse;
  rollWebhookSecret: Webhook;
  sendCustomerSupportEmail: SendCustomerSupportEmailResponse;
  sendPaypassUrl: IdsMutationResponse;
  sendPaypassVerificationCode?: Maybe<SendVerificationCodePayload>;
  setDefaultSettlementAccount?: Maybe<SetDefaultSettlementAccountMutationResponse>;
  setupPasswordPaypassStandaloneCompletion?: Maybe<SetupPasswordPayload>;
  standaloneMerchantSignup: SignupMerchantMutationResponse;
  startProvisioning?: Maybe<StartProvisioningResponse>;
  startRoutine?: Maybe<StartRoutineResponse>;
  submitDisputeEvidence: SubmitEvidenceMutationResponse;
  submitMerchantApplication: IdsMutationResponse;
  submitMerchantApproval: UpdateOnboardingApprovalMutationResponse;
  submitTask: TaskMutationResponse;
  syncOnboardingPricing?: Maybe<SyncOnboardingPricingMutationResponse>;
  testWebhook: TestWebhookMutationResponse;
  toggleArchiveBankAccount: BankAccount;
  toggleRuleEnabled: UpdateRiskRuleMutationResponse;
  toggleSandbox: ToggleSandboxMutationResponse;
  transactionsRefund: TransactionsRefundMutationResponse;
  unregisterApplePayDomain: ApplePayDomainSuccess;
  updateAccountNotification: UpdateAccountNotificationResponse;
  updateApiKey: UpdateApiKeyResponse;
  updateBankAccount: BankAccount;
  updateChargebackReason: ChargebackReasonMutationResponse;
  updateCommission: Commission;
  updateConsumer: UpdateConsumerMutationResponse;
  updateConsumerRuleExclusionStatus: ConsumerRuleExclusionMutationResponse;
  updateCost: CostMutationResponse;
  updateCountry: CountryMutationResponse;
  updateCrmField: CreateCrmFieldMutationResponse;
  updateDashboard: SupersetMutationResponse;
  updateDeclineMessage: DeclineMessageMutationResponse;
  updateDispute: UpdateDisputeMutationResponse;
  updateDocument: DocumentMutationResponse;
  updateDocumentType: DocumentTypeMutationResponse;
  updateEntityArchiveMcc?: Maybe<MccEntryMutationResponse>;
  updateEntityMcc?: Maybe<MccEntryMutationResponse>;
  updateExportField: ExportFieldMutationResponse;
  updateFailureCodeMessage: FailureCodeMessageQueryResponse;
  updateFeatureFlag: FeatureFlag;
  updateFinance: FinanceObject;
  updateGooglepayConfig: UpdateGooglepayConfigMutationResponse;
  updateIndividual: IndividualsMutationResponse;
  updateIndividualRelation: IndividualsMutationResponse;
  updateIssuerResponseCode: IssuerResponseCodeQueryResponse;
  updateLogicField: LogicFieldMutationResponse;
  updateManualSettlementStatus: ManualSettlementReponse;
  updateMcc: MccMutationResponse;
  updateMerchant: UpdateMerchantMutationResponse;
  updateMerchantApplication: IdsVersionMutationResponse;
  updateMerchantConnection: UpdateMerchantConnectionMutationResponse;
  updateMerchantCrmFieldValues: UpdateMerchantCrmFieldResponse;
  updateMerchantDashboard: UpdateMerchantDashboardResponse;
  updateMerchantDefaultExportFields: ExportFieldMutationResponse;
  updateMerchantSettings?: Maybe<UpdateMerchantSettingsResponse>;
  updateNote: UpdateNoteMutationResponse;
  updateOnboardingPricing?: Maybe<OnboardingPricingMutationResponse>;
  updateOnboardingPricingField?: Maybe<OnboardingPricingFieldMutationResponse>;
  updateOnboardingRiskRule?: Maybe<OnboardingRiskRulesMutationResponse>;
  updatePaymentLinkStatus: PaymentLinkStatusMutationResponse;
  updatePricing: MerchantAndCompany;
  updatePricingAction: PricingAction;
  updateProviderFeatures?: Maybe<ProviderFeaturesMutationResponse>;
  updateProvisioningTemplate?: Maybe<UpdateProvisioningTemplateMutationResponse>;
  updateReconciliationConfig?: Maybe<ReconciliationConfigMutationResponse>;
  updateReferral: ReferralObject;
  updateReportsConfig: GetReportsConfigQueryResponse;
  updateRiskAlert: RiskAlertUpdateMutationResponse;
  updateRiskAlerts: RiskAlertsUpdateMutationResponse;
  updateRiskCalculatorConfig: UpdateRiskCalculatorMutationResponse;
  updateRiskList: UpdateRiskListMutationResponse;
  updateRiskReview: UpdateRiskReviewMutationResponse;
  updateRiskRule: UpdateRiskRuleMutationResponse;
  updateRole: SaveRoleMutationResponse;
  updateRoutineTemplate?: Maybe<RoutineIdResponse>;
  updateRulePriority: UpdateRiskRuleMutationResponse;
  updateSettlementAccount?: Maybe<UpdateSettlementAccountMutationResponse>;
  updateSettlementAccountBankTask?: Maybe<UpdateSettlementAccountMutationResponse>;
  updateStructure: StructureMutationResponse;
  updateSubscription: CommonSubscriptionMutationResponse;
  updateSubscriptionPackage: CommonSubscriptionMutationResponse;
  updateSubscriptionPackageStatus: CommonSubscriptionMutationResponse;
  updateTaskTemplate: TaskTemplateResponse;
  updateTransactionReviewStatus: TransactionReviewStatusSuccessMutationResponse;
  updateUser: SaveMutationResponse;
  updateVerificationCheck: VerificationCheckResponse;
  updateWebhook: Webhook;
  updateWebsite?: Maybe<WebsiteMutationResponse>;
  updateWebsitesBulk?: Maybe<WebsiteMutationResponse>;
  uploadApplePayCertificate?: Maybe<UploadApplePayCertificate>;
};


export type MutationAcceptDisputeArgs = {
  input: DisputeAcceptMutationInput;
};


export type MutationAddCommentToVerificationCheckArgs = {
  input: AddVerificationCheckCommentInput;
};


export type MutationAddDisputeEvidenceArgs = {
  input: AddEvidenceMutationInput;
};


export type MutationAddMerchantCrmFieldValuesArgs = {
  input: AddCrmFieldValues;
};


export type MutationAddRiskListValuesArgs = {
  input: AddRiskListValuesMutationInput;
};


export type MutationAddTaskNoteArgs = {
  input: AddTaskNote;
};


export type MutationAddToListArgs = {
  input: AddToListMutationInput;
};


export type MutationArchiveRuleArgs = {
  input: UpdateRiskRuleMutationInput;
};


export type MutationAssignTaskArgs = {
  input: AssignTask;
};


export type MutationAuthenticatePaypassWithVerificationCodeArgs = {
  input: AuthenticateWithVerificationCodeInput;
};


export type MutationBulkAddToBlacklistArgs = {
  input: BulkAddCardToBlacklistMutationInput;
};


export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationCancelTaskArgs = {
  input: CancelTask;
};


export type MutationCollaborationsRefundArgs = {
  input: CollaborationsRefundMutationInput;
};


export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyMutationInput;
};


export type MutationCreateAutomaticVerificationCheckArgs = {
  input: CreateAutomaticVerificationCheckObjectInput;
};


export type MutationCreateBankAccountArgs = {
  input: CreateBankAccountInput;
};


export type MutationCreateCardPaymentArgs = {
  input: CreateCardPaymentMutationInput;
};


export type MutationCreateChargebackReasonArgs = {
  input: CreateChargebackReasonMutationInput;
};


export type MutationCreateCommissionArgs = {
  input: CreateCommissionInput;
};


export type MutationCreateConsumerArgs = {
  input: CreateConsumerMutationInput;
};


export type MutationCreateCostArgs = {
  input: CreateCostMutationInput;
};


export type MutationCreateCountryArgs = {
  input?: InputMaybe<CreateCountryInput>;
};


export type MutationCreateCrmFieldArgs = {
  input: CreateCrmFieldInput;
};


export type MutationCreateDashboardArgs = {
  input: CreateDashboard;
};


export type MutationCreateDeclineMessageArgs = {
  input: DeclineMessageInput;
};


export type MutationCreateDocumentTypeArgs = {
  input: CreateDocumentTypeInput;
};


export type MutationCreateEntityMccArgs = {
  input: CreateMccInput;
};


export type MutationCreateEntityTasksFromGroupTemplatesArgs = {
  input: CreateEntityTasksFromGroupTemplates;
};


export type MutationCreateExportFieldArgs = {
  input: ExportFieldInput;
};


export type MutationCreateFailureCodeMessageArgs = {
  input: CreateOrUpdateFailureCodeMessageQueryInput;
};


export type MutationCreateFeatureFlagArgs = {
  input: CreateFeatureFlagMutationInput;
};


export type MutationCreateFinanceArgs = {
  input: CreateFinanceInput;
};


export type MutationCreateIndividualRelationArgs = {
  input: IndividualRelationInput;
};


export type MutationCreateIndividualWithRelationArgs = {
  input: CreateIndividualWithRelationInput;
};


export type MutationCreateIssuerResponseCodeArgs = {
  input: CreateOrUpdateIssuerResponseCodeQueryInput;
};


export type MutationCreateLogicFieldArgs = {
  input: CreateLogicFieldInput;
};


export type MutationCreateMccArgs = {
  input: CreateMccMutationInput;
};


export type MutationCreateMerchantDashboardArgs = {
  input: CreateMerchantDashboardInput;
};


export type MutationCreateMerchantSettingsArgs = {
  input: UpdateMerchantSettingsInput;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteMutationInput;
};


export type MutationCreateOnboardingPricingArgs = {
  input: CreateOnboardingPricingInput;
};


export type MutationCreateOnboardingPricingFieldArgs = {
  input: CreateOnboardingPricingFieldInput;
};


export type MutationCreateOnboardingRiskRuleArgs = {
  input: OnboardingRiskRuleCreateInput;
};


export type MutationCreatePaymentLinkArgs = {
  input: CreatePaymentLinkMutationInput;
};


export type MutationCreatePayoutArgs = {
  input: CreatePayoutInput;
};


export type MutationCreatePricingArgs = {
  input: PricingInput;
};


export type MutationCreatePricingActionArgs = {
  input: PricingActionInput;
};


export type MutationCreateProviderFeaturesArgs = {
  input: CreateProviderFeaturesMutationInput;
};


export type MutationCreateProvisioningTemplateArgs = {
  input: CreateProvisioningTemplateMutationInput;
};


export type MutationCreateReconciliationConfigArgs = {
  input: CreateReconciliationConfigInput;
};


export type MutationCreateReferralArgs = {
  input: CreateReferralInput;
};


export type MutationCreateReportsConfigArgs = {
  input: ReportsConfigInput;
};


export type MutationCreateRiskCalculationArgs = {
  input: CreateRiskCalculationInput;
};


export type MutationCreateRiskListArgs = {
  input: CreateRiskListMutationInput;
};


export type MutationCreateRiskRuleArgs = {
  input: CreateRiskRuleMutationInput;
};


export type MutationCreateRoleArgs = {
  input: SaveRole;
};


export type MutationCreateRoutineTemplateArgs = {
  input: CreateRoutineTemplateMutationInput;
};


export type MutationCreateSshKeyPairArgs = {
  input?: InputMaybe<CreateSshKeyPairMutationInput>;
};


export type MutationCreateSandboxMerchantArgs = {
  input: CreateSandboxMerchantInput;
};


export type MutationCreateSnowflakeIdsArgs = {
  input: CreateSnowflakeIdsInput;
};


export type MutationCreateStructureArgs = {
  input: CreateStructureMutationInput;
};


export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationCreateSubscriptionPackageArgs = {
  input: CreateSubscriptionPackageInput;
};


export type MutationCreateTaskArgs = {
  input: CreateTask;
};


export type MutationCreateTaskTemplateArgs = {
  input: CreateTaskTemplate;
};


export type MutationCreateTransactionArgs = {
  input?: InputMaybe<CreateTransactionMutationInput>;
};


export type MutationCreateUserArgs = {
  input: CreateUser;
};


export type MutationCreateVerificationCheckArgs = {
  input: CreateVerificationCheckObjectInput;
};


export type MutationCreateWebhookArgs = {
  input: CreateWebhookMutationInput;
};


export type MutationCreateWebsiteArgs = {
  input: CreateWebsiteInput;
};


export type MutationCreateWebsitesBulkArgs = {
  input: CreateWebsitesBulkInput;
};


export type MutationDeactivateUserArgs = {
  input: DeactivateUser;
};


export type MutationDeleteDashboardArgs = {
  input: DeleteDashboard;
};


export type MutationDeleteFeatureFlagArgs = {
  input: DeleteFeatureFlagMutationInput;
};


export type MutationDeleteLogicFieldArgs = {
  input: DeleteLogicFieldInput;
};


export type MutationDeleteMccArgs = {
  input: DeleteMccMutationInput;
};


export type MutationDeleteRiskListArgs = {
  input: DeleteRiskListMutationInput;
};


export type MutationDeleteRiskListValueArgs = {
  input: DeleteRiskListValueMutationInput;
};


export type MutationDeleteTaskTemplateArgs = {
  input: DeleteTaskTemplateInput;
};


export type MutationDeleteWebhookArgs = {
  input: WebhookIdInput;
};


export type MutationDisableMerchantDashboardArgs = {
  input: DisableMerchantDashboardInput;
};


export type MutationDuplicateRiskRuleArgs = {
  input: DuplicateRiskRuleMutationInput;
};


export type MutationEditRiskRuleArgs = {
  input: EditRiskRuleMutationInput;
};


export type MutationFinalizeSignUpMerchantArgs = {
  input: FinalizeSignUpMerchantMutationInput;
};


export type MutationGenerateAssessmentFormArgs = {
  input: AssessmentFormInputObject;
};


export type MutationGenerateOnboardingMpaArgs = {
  input: OnboardingMpaInputObject;
};


export type MutationGenerateOnboardingPricingSigningUrlArgs = {
  input: GenerateOnboardingPricingSigningUrlInput;
};


export type MutationInitManualSettlementArgs = {
  input: ManualSettlementInput;
};


export type MutationPaymentCancellationArgs = {
  input: PaymentCancellationMutationInput;
};


export type MutationPaymentCaptureArgs = {
  input: PaymentCaptureMutationInput;
};


export type MutationPaymentRefundArgs = {
  input: PaymentRefundMutationInput;
};


export type MutationRegisterApplePayDomainArgs = {
  input: RegisterApplePayDomainInput;
};


export type MutationRemoveApiKeyArgs = {
  input: PasswordProtectedApiKeyIdInput;
};


export type MutationRemoveApplePayCertificateArgs = {
  input: RemoveApplePayCertificateInput;
};


export type MutationRemoveChargebackReasonArgs = {
  input: RemoveChargebackReasonMutationInput;
};


export type MutationRemoveConsumerRuleExclusionArgs = {
  input: RemoveConsumerRuleExclusionInput;
};


export type MutationRemoveCostArgs = {
  input: RemoveCostMutationInput;
};


export type MutationRemoveCountryArgs = {
  input: CountryQueryInput;
};


export type MutationRemoveDeclineMessageArgs = {
  input: RemoveDeclineMessageInput;
};


export type MutationRemoveExportFieldArgs = {
  input: ExportFieldKeyInput;
};


export type MutationRemoveFailureCodeMessageArgs = {
  input: RemoveFailureCodeMessageQueryInput;
};


export type MutationRemoveFromListArgs = {
  input: RemoveFromListMutationInput;
};


export type MutationRemoveIndividualArgs = {
  input: GetIndividualInput;
};


export type MutationRemoveIndividualRelationArgs = {
  input: GetIndividualRelationsInput;
};


export type MutationRemoveIssuerResponseCodeArgs = {
  input: RemoveIssuerResponseCodeQueryInput;
};


export type MutationRemoveMerchantDefaultExportFieldsArgs = {
  input: MerchantDefaultExportFieldsPayload;
};


export type MutationRemoveNoteArgs = {
  input: RemoveNoteMutationInput;
};


export type MutationRemovePricingArgs = {
  input: RemovePricingInput;
};


export type MutationRemoveReconciliationConfigArgs = {
  input: RemoveReconciliationConfigInput;
};


export type MutationRemoveRoutineTemplateArgs = {
  input: RemoveRoutineTemplateMutationInput;
};


export type MutationRemoveSourceArgs = {
  input: RemoveSourceInput;
};


export type MutationRemoveStructureArgs = {
  input: RemoveStructureMutationInput;
};


export type MutationRemoveVerificationCheckArgs = {
  input: IdsInput;
};


export type MutationRequestBlockingArgs = {
  input: RequestBlockingMutationInput;
};


export type MutationRequestInformationArgs = {
  input: RequestInformationInput;
};


export type MutationRerollApiKeyArgs = {
  input: PasswordProtectedApiKeyIdInput;
};


export type MutationResendWebhookEventArgs = {
  input: ResendWebhookEventMutationInput;
};


export type MutationResetRulesPrioritiesArgs = {
  input: ResetRulePrioritiesMutationInput;
};


export type MutationRetrySubscriptionArgs = {
  input: RetrySubscriptionInput;
};


export type MutationRollWebhookSecretArgs = {
  input: WebhookIdInput;
};


export type MutationSendCustomerSupportEmailArgs = {
  input: SendCustomerSupportEmailInput;
};


export type MutationSendPaypassUrlArgs = {
  input: MerchantApplicationIdsInput;
};


export type MutationSetDefaultSettlementAccountArgs = {
  input: SetDefaultSettlementAccountMutationInput;
};


export type MutationSetupPasswordPaypassStandaloneCompletionArgs = {
  input: SetupPasswordInput;
};


export type MutationStandaloneMerchantSignupArgs = {
  input?: InputMaybe<StandaloneMerchantSignupMutationInput>;
};


export type MutationStartProvisioningArgs = {
  input: StartProvisioningMutationInput;
};


export type MutationStartRoutineArgs = {
  input: StartRoutineMutationInput;
};


export type MutationSubmitDisputeEvidenceArgs = {
  input: SubmitEvidenceMutationInput;
};


export type MutationSubmitMerchantApprovalArgs = {
  input: SubmitMerchantApprovalMutationInput;
};


export type MutationSubmitTaskArgs = {
  input: SubmitTask;
};


export type MutationSyncOnboardingPricingArgs = {
  input: SyncOnboardingPricingInput;
};


export type MutationTestWebhookArgs = {
  input: TestWebhookMutationInput;
};


export type MutationToggleArchiveBankAccountArgs = {
  input: ToggleArchiveBankAccountInput;
};


export type MutationToggleRuleEnabledArgs = {
  input: ToggleRuleEnabledMutationInput;
};


export type MutationTransactionsRefundArgs = {
  input: TransactionsRefundMutationInput;
};


export type MutationUnregisterApplePayDomainArgs = {
  input: UnregisterApplePayDomainInput;
};


export type MutationUpdateAccountNotificationArgs = {
  input: UpdateAccountNotificationInput;
};


export type MutationUpdateApiKeyArgs = {
  input: UpdateApiKeyMutationInput;
};


export type MutationUpdateBankAccountArgs = {
  input: UpdateBankAccountInput;
};


export type MutationUpdateChargebackReasonArgs = {
  input: UpdateChargebackReasonMutationInput;
};


export type MutationUpdateCommissionArgs = {
  input: UpdateCommissionInput;
};


export type MutationUpdateConsumerArgs = {
  input: UpdateConsumerMutationInput;
};


export type MutationUpdateConsumerRuleExclusionStatusArgs = {
  input: UpdateConsumerRuleExclusionStatusInput;
};


export type MutationUpdateCostArgs = {
  input: UpdateCostMutationInput;
};


export type MutationUpdateCountryArgs = {
  input: UpdateCountryInput;
};


export type MutationUpdateCrmFieldArgs = {
  input: CreateCrmFieldInput;
};


export type MutationUpdateDashboardArgs = {
  input: UpdateDashboard;
};


export type MutationUpdateDeclineMessageArgs = {
  input: DeclineMessageInput;
};


export type MutationUpdateDisputeArgs = {
  input: UpdateDisputeMutationInput;
};


export type MutationUpdateDocumentArgs = {
  input: UpdateDocumentMutationInput;
};


export type MutationUpdateDocumentTypeArgs = {
  input: UpdateDocumentTypeInput;
};


export type MutationUpdateEntityArchiveMccArgs = {
  input: UpdateArchiveMccInput;
};


export type MutationUpdateEntityMccArgs = {
  input: UpdateMccInput;
};


export type MutationUpdateExportFieldArgs = {
  input: ExportFieldInput;
};


export type MutationUpdateFailureCodeMessageArgs = {
  input: CreateOrUpdateFailureCodeMessageQueryInput;
};


export type MutationUpdateFeatureFlagArgs = {
  input: UpdateFeatureFlagMutationInput;
};


export type MutationUpdateFinanceArgs = {
  input: UpdateFinanceInput;
};


export type MutationUpdateGooglepayConfigArgs = {
  input: UpdateGooglepayConfigMutationInput;
};


export type MutationUpdateIndividualArgs = {
  input: UpdateIndividualInput;
};


export type MutationUpdateIndividualRelationArgs = {
  input: IndividualRelationInput;
};


export type MutationUpdateIssuerResponseCodeArgs = {
  input: CreateOrUpdateIssuerResponseCodeQueryInput;
};


export type MutationUpdateLogicFieldArgs = {
  input: UpdateLogicFieldInput;
};


export type MutationUpdateManualSettlementStatusArgs = {
  input: UpdateManualSettlementStatusInput;
};


export type MutationUpdateMccArgs = {
  input: UpdateMccMutationInput;
};


export type MutationUpdateMerchantArgs = {
  input: UpdateMerchantMutationInput;
};


export type MutationUpdateMerchantApplicationArgs = {
  input: UpdateMerchantApplicationMutationInput;
};


export type MutationUpdateMerchantConnectionArgs = {
  input: UpdateMerchantConnectionMutationInput;
};


export type MutationUpdateMerchantCrmFieldValuesArgs = {
  input: UpdateMerchantCrmFieldMutationInput;
};


export type MutationUpdateMerchantDashboardArgs = {
  input: UpdateMerchantDashboardInput;
};


export type MutationUpdateMerchantDefaultExportFieldsArgs = {
  input: UpdateMerchantDefaultExportFieldsPayload;
};


export type MutationUpdateMerchantSettingsArgs = {
  input: UpdateMerchantSettingsInput;
};


export type MutationUpdateNoteArgs = {
  input: UpdateNoteMutationInput;
};


export type MutationUpdateOnboardingPricingArgs = {
  input: UpdateOnboardingPricingInput;
};


export type MutationUpdateOnboardingPricingFieldArgs = {
  input: UpdateOnboardingPricingFieldInput;
};


export type MutationUpdateOnboardingRiskRuleArgs = {
  input: OnboardingRiskRuleUpdateInput;
};


export type MutationUpdatePaymentLinkStatusArgs = {
  input: PaymentLinkStatusMutationInput;
};


export type MutationUpdatePricingArgs = {
  input: PricingInput;
};


export type MutationUpdatePricingActionArgs = {
  input: PricingActionInput;
};


export type MutationUpdateProviderFeaturesArgs = {
  input: UpdateProviderFeaturesMutationInput;
};


export type MutationUpdateProvisioningTemplateArgs = {
  input: UpdateProvisioningTemplateMutationInput;
};


export type MutationUpdateReconciliationConfigArgs = {
  input: UpdateReconciliationConfigInput;
};


export type MutationUpdateReferralArgs = {
  input: UpdateReferralInput;
};


export type MutationUpdateReportsConfigArgs = {
  input: ReportsConfigInput;
};


export type MutationUpdateRiskAlertArgs = {
  input: UpdateRiskAlertInput;
};


export type MutationUpdateRiskAlertsArgs = {
  input: UpdateRiskAlertsInput;
};


export type MutationUpdateRiskCalculatorConfigArgs = {
  input: UpdateRiskCalculatorConfigInput;
};


export type MutationUpdateRiskListArgs = {
  input: UpdateRiskListMutationInput;
};


export type MutationUpdateRiskReviewArgs = {
  input: UpdateRiskReviewMutationInput;
};


export type MutationUpdateRiskRuleArgs = {
  input: UpdateRiskRuleMutationInput;
};


export type MutationUpdateRoleArgs = {
  input: SaveRole;
};


export type MutationUpdateRoutineTemplateArgs = {
  input: UpdateRoutineTemplateMutationInput;
};


export type MutationUpdateRulePriorityArgs = {
  input: UpdateRulePriorityMutationInput;
};


export type MutationUpdateSettlementAccountArgs = {
  input: UpdateSettlementAccountMutationInput;
};


export type MutationUpdateSettlementAccountBankTaskArgs = {
  input: UpdateSettlementAccountBankTaskMutationInput;
};


export type MutationUpdateStructureArgs = {
  input: UpdatedStructureMutationInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationUpdateSubscriptionPackageArgs = {
  input: UpdateSubscriptionPackageInput;
};


export type MutationUpdateSubscriptionPackageStatusArgs = {
  input: UpdateSubscriptionPackageStatusInput;
};


export type MutationUpdateTaskTemplateArgs = {
  input: UpdateTaskTemplateInput;
};


export type MutationUpdateTransactionReviewStatusArgs = {
  input: UpdateTransactionReviewStatusMutationInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUser;
};


export type MutationUpdateVerificationCheckArgs = {
  input: UpdateVerificationCheckObjectInput;
};


export type MutationUpdateWebhookArgs = {
  input: UpdateWebhookMutationInput;
};


export type MutationUpdateWebsiteArgs = {
  input: UpdateWebsiteInput;
};


export type MutationUpdateWebsitesBulkArgs = {
  input: UpdateWebsitesBulkInput;
};


export type MutationUploadApplePayCertificateArgs = {
  input: UploadApplePayCertificateInput;
};

export type NestedIndividualsResponse = {
  __typename?: 'NestedIndividualsResponse';
  individuals?: Maybe<Array<IndividualWithRelations>>;
};

export type NetworkSpecificFields = {
  __typename?: 'NetworkSpecificFields';
  /** MasterCard */
  banknetReference?: Maybe<Scalars['String']['output']>;
  processor?: Maybe<Scalars['String']['output']>;
  /** MasterCard */
  traceId?: Maybe<Scalars['String']['output']>;
  /** Visa */
  transactionIdentifier?: Maybe<Scalars['String']['output']>;
};

export type NextSettlementQueryInput = {
  currency: CurrencyAlpha3;
};

export type NextSettlementQueryResponse = {
  __typename?: 'NextSettlementQueryResponse';
  amount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
};

export type Note = {
  __typename?: 'Note';
  addedAt?: Maybe<Scalars['String']['output']>;
  addedBy?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  section?: Maybe<Scalars['String']['output']>;
};

export type NoteInput = {
  addedAt?: InputMaybe<Scalars['String']['input']>;
  addedBy?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
};

export type NoteObject = {
  __typename?: 'NoteObject';
  content: Scalars['String']['output'];
  context?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pinned?: Maybe<Scalars['Boolean']['output']>;
  resource: NoteResource;
  resourceId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export enum NoteResource {
  RiskReview = 'risk_review',
  Transaction = 'transaction'
}

export type NotesQueryInput = {
  resource: NoteResource;
  resourceId: Scalars['ID']['input'];
};

export type NotificationGroupObject = {
  __typename?: 'NotificationGroupObject';
  groupId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notifications: Array<NotificationObject>;
};

export type NotificationObject = {
  __typename?: 'NotificationObject';
  availableDeliveryChannels: DeliveryChannelsObject;
  deliveryConfig: DeliveryConfigObject;
  description: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notificationType: NotificationType;
};

/** REFERENCE: https://github.com/pay-com/libs-types/commit/6f8134fd37b5bb1bb665fb4f1fd23b0ee00e2470 */
export enum NotificationType {
  AuthenticationSessionAuthenticated = 'AUTHENTICATION_SESSION__AUTHENTICATED',
  AuthenticationSessionFailed = 'AUTHENTICATION_SESSION__FAILED',
  AuthenticationSessionOpen = 'AUTHENTICATION_SESSION__OPEN',
  BatchCompleted = 'BATCH__COMPLETED',
  BatchCreated = 'BATCH__CREATED',
  BatchProgressUpdate = 'BATCH__PROGRESS_UPDATE',
  CardVerificationDeclined = 'CARD_VERIFICATION_DECLINED',
  CardVerified = 'CARD_VERIFIED',
  CashflowTransactionCreated = 'CASHFLOW_TRANSACTION__CREATED',
  ChargeAccepted = 'CHARGE__ACCEPTED',
  ChargeFailed = 'CHARGE__FAILED',
  ChargePending = 'CHARGE__PENDING',
  ChargeRefunded = 'CHARGE__REFUNDED',
  ChargeRequiresAction = 'CHARGE__REQUIRES_ACTION',
  ChargeRequiresAuthentication = 'CHARGE__REQUIRES_AUTHENTICATION',
  ChargeRequiresConfirmation = 'CHARGE__REQUIRES_CONFIRMATION',
  ChargeSucceeded = 'CHARGE__SUCCEEDED',
  ChargeUpdated = 'CHARGE__UPDATED',
  CheckoutSessionCompleted = 'CHECKOUT_SESSION__COMPLETED',
  CheckoutSessionExpired = 'CHECKOUT_SESSION__EXPIRED',
  CheckoutSessionFailed = 'CHECKOUT_SESSION__FAILED',
  CheckoutSessionOpen = 'CHECKOUT_SESSION__OPEN',
  CollaborationEscalated = 'COLLABORATION__ESCALATED',
  CollaborationOpen = 'COLLABORATION__OPEN',
  CollaborationResolved = 'COLLABORATION__RESOLVED',
  CustomerBlockReviewCreated = 'CUSTOMER_BLOCK_REVIEW__CREATED',
  CustomerCreated = 'CUSTOMER__CREATED',
  CustomerDefaultSourceChanged = 'CUSTOMER__DEFAULT_SOURCE__CHANGED',
  CustomerDeleted = 'CUSTOMER__DELETED',
  CustomerUpdated = 'CUSTOMER__UPDATED',
  DisputeArbitrationLost = 'DISPUTE__ARBITRATION_LOST',
  DisputeArbitrationUnderReview = 'DISPUTE__ARBITRATION_UNDER_REVIEW',
  DisputeArbitrationWon = 'DISPUTE__ARBITRATION_WON',
  DisputeCanceled = 'DISPUTE__CANCELED',
  DisputeChargebackAccepted = 'DISPUTE__CHARGEBACK_ACCEPTED',
  DisputeChargebackCanceled = 'DISPUTE__CHARGEBACK_CANCELED',
  DisputeEvidenceRejected = 'DISPUTE__EVIDENCE_REJECTED',
  DisputeEvidenceRequired = 'DISPUTE__EVIDENCE_REQUIRED',
  DisputeEvidenceUnderReview = 'DISPUTE__EVIDENCE_UNDER_REVIEW',
  DisputeEvidenceUnderReviewAutoDefend = 'DISPUTE__EVIDENCE_UNDER_REVIEW_AUTO_DEFEND',
  DisputeExpired = 'DISPUTE__EXPIRED',
  DisputeLost = 'DISPUTE__LOST',
  DisputeOpen = 'DISPUTE__OPEN',
  DisputePreArbitration = 'DISPUTE__PRE_ARBITRATION',
  DisputeResolved = 'DISPUTE__RESOLVED',
  DisputeResolvedRapidDisputeResolution = 'DISPUTE__RESOLVED_RAPID_DISPUTE_RESOLUTION',
  DisputeWon = 'DISPUTE__WON',
  DocumentActive = 'DOCUMENT__ACTIVE',
  DocumentCreated = 'DOCUMENT__CREATED',
  DocumentPending = 'DOCUMENT__PENDING',
  DocumentRejected = 'DOCUMENT__REJECTED',
  ExchangeRatesUpdate = 'EXCHANGE_RATES__UPDATE',
  FraudWarningCreated = 'FRAUD_WARNING__CREATED',
  HoldCanceled = 'HOLD__CANCELED',
  HoldCaptured = 'HOLD__CAPTURED',
  HoldFailed = 'HOLD__FAILED',
  HoldFundsAboutToExpire = 'HOLD__FUNDS_ABOUT_TO_EXPIRE',
  HoldRequiresAction = 'HOLD__REQUIRES_ACTION',
  HoldRequiresAuthentication = 'HOLD__REQUIRES_AUTHENTICATION',
  HoldRequiresCapture = 'HOLD__REQUIRES_CAPTURE',
  HoldRequiresConfirmation = 'HOLD__REQUIRES_CONFIRMATION',
  HoldSucceeded = 'HOLD__SUCCEEDED',
  PaymentApproved = 'PAYMENT_APPROVED',
  PaymentAttemptFailed = 'PAYMENT_ATTEMPT__FAILED',
  PaymentAttemptSucceeded = 'PAYMENT_ATTEMPT__SUCCEEDED',
  PaymentCancelled = 'PAYMENT_CANCELLED',
  PaymentCaptured = 'PAYMENT_CAPTURED',
  PaymentChargeback = 'PAYMENT_CHARGEBACK',
  PaymentDeclined = 'PAYMENT_DECLINED',
  PaymentError = 'PAYMENT_ERROR',
  PaymentExpired = 'PAYMENT_EXPIRED',
  PaymentMethodCreated = 'PAYMENT_METHOD__CREATED',
  PaymentMethodDeleted = 'PAYMENT_METHOD__DELETED',
  PaymentMethodFailedAuthentication = 'PAYMENT_METHOD__FAILED_AUTHENTICATION',
  PaymentMethodNetworkTokenDeleted = 'PAYMENT_METHOD__NETWORK_TOKEN__DELETED',
  PaymentMethodNetworkTokenProvisioned = 'PAYMENT_METHOD__NETWORK_TOKEN__PROVISIONED',
  PaymentMethodRequiresConfirmation = 'PAYMENT_METHOD__REQUIRES_CONFIRMATION',
  PaymentMethodThirdPartyTokenCreated = 'PAYMENT_METHOD__THIRD_PARTY_TOKEN__CREATED',
  PaymentMethodUpdated = 'PAYMENT_METHOD__UPDATED',
  PaymentPending = 'PAYMENT_PENDING',
  PaymentRefunded = 'PAYMENT_REFUNDED',
  PaymentRetrieval = 'PAYMENT_RETRIEVAL',
  PaymentSessionCompleted = 'PAYMENT_SESSION__COMPLETED',
  PaymentSessionDisplayed = 'PAYMENT_SESSION__DISPLAYED',
  PaymentSessionExpired = 'PAYMENT_SESSION__EXPIRED',
  PaymentSessionFailed = 'PAYMENT_SESSION__FAILED',
  PaymentSessionOpen = 'PAYMENT_SESSION__OPEN',
  PayoutFailed = 'PAYOUT__FAILED',
  PayoutPending = 'PAYOUT__PENDING',
  PayoutRequiresConfirmation = 'PAYOUT__REQUIRES_CONFIRMATION',
  PayoutSucceeded = 'PAYOUT__SUCCEEDED',
  ReconciliationUpdate = 'RECONCILIATION__UPDATE',
  RefundFailed = 'REFUND__FAILED',
  RefundPending = 'REFUND__PENDING',
  RefundSucceeded = 'REFUND__SUCCEEDED',
  RefundUpdated = 'REFUND__UPDATED',
  ReportUploaded = 'REPORT__UPLOADED',
  RetriedAttemptCreated = 'RETRIED_ATTEMPT__CREATED',
  ReviewCustomerCreated = 'REVIEW__CUSTOMER__CREATED',
  ReviewCustomerExpired = 'REVIEW__CUSTOMER__EXPIRED',
  ReviewCustomerReviewed = 'REVIEW__CUSTOMER__REVIEWED',
  ReviewTransactionCreated = 'REVIEW__TRANSACTION__CREATED',
  ReviewTransactionExpired = 'REVIEW__TRANSACTION__EXPIRED',
  ReviewTransactionReviewed = 'REVIEW__TRANSACTION__REVIEWED',
  RuleCreated = 'RULE__CREATED',
  RuleDeleted = 'RULE__DELETED',
  RuleUpdated = 'RULE__UPDATED',
  SettlementCreated = 'SETTLEMENT__CREATED',
  SettlementHeld = 'SETTLEMENT__HELD',
  SettlementPaid = 'SETTLEMENT__PAID',
  SetupAttemptFailed = 'SETUP_ATTEMPT__FAILED',
  SetupAttemptSucceeded = 'SETUP_ATTEMPT__SUCCEEDED',
  SetupSessionCompleted = 'SETUP_SESSION__COMPLETED',
  SetupSessionFailed = 'SETUP_SESSION__FAILED',
  SetupSessionOpen = 'SETUP_SESSION__OPEN',
  SubscriptionActive = 'SUBSCRIPTION__ACTIVE',
  SubscriptionAttempted = 'SUBSCRIPTION__ATTEMPTED',
  SubscriptionCanceled = 'SUBSCRIPTION__CANCELED',
  SubscriptionCharged = 'SUBSCRIPTION__CHARGED',
  SubscriptionFailed = 'SUBSCRIPTION__FAILED',
  SubscriptionPaymentMethodUpcomingExpiry = 'SUBSCRIPTION__PAYMENT_METHOD__UPCOMING_EXPIRY',
  SubscriptionUnpaid = 'SUBSCRIPTION__UNPAID',
  SubscriptionUpcomingRenewal = 'SUBSCRIPTION__UPCOMING_RENEWAL'
}

export type NumberMerchantsUnderRuleInput = {
  companyId: Scalars['ID']['input'];
  merchantId: Scalars['ID']['input'];
  ruleId: Scalars['ID']['input'];
};

export enum OnboardingApprovalRecordType {
  Approval = 'approval',
  ProvideInfo = 'provide_info',
  ReceiveInfo = 'receive_info'
}

export enum OnboardingApprovalStatus {
  ApprovalNotRecommended = 'approval_not_recommended',
  Approved = 'approved',
  Created = 'created',
  Escalated = 'escalated',
  InfoReceived = 'info_received',
  PendingInfo = 'pending_info',
  ProvidedInfo = 'provided_info',
  Rejected = 'rejected',
  RequestedInfo = 'requested_info'
}

export type OnboardingBankDetails = {
  __typename?: 'OnboardingBankDetails';
  bankAccounts?: Maybe<Array<BankAccount>>;
};

export type OnboardingBankDetailsInput = {
  bankAccounts?: InputMaybe<Array<UpdateBankAccountInput>>;
};

export type OnboardingBusinessActivity = {
  __typename?: 'OnboardingBusinessActivity';
  annualAmexVolumeExceeds?: Maybe<Scalars['Boolean']['output']>;
  applyingReason?: Maybe<Scalars['String']['output']>;
  averageTransactionAmount?: Maybe<Scalars['String']['output']>;
  averageTransactionCurrency?: Maybe<Scalars['String']['output']>;
  blacklistedCountries?: Maybe<Array<CountryAlpha2>>;
  businessToBusinessBasisPoints?: Maybe<Scalars['String']['output']>;
  cardPresentBasisPoints?: Maybe<Scalars['String']['output']>;
  currentPaymentProcessor?: Maybe<Scalars['String']['output']>;
  customersAbroad?: Maybe<Scalars['Boolean']['output']>;
  customersAbroadCountries?: Maybe<Array<CountryAlpha2>>;
  ecommerceBasisPoints?: Maybe<Scalars['String']['output']>;
  esaNumber?: Maybe<Scalars['String']['output']>;
  highRiskCountries?: Maybe<Array<Scalars['String']['output']>>;
  licenseJurisdictionCountry?: Maybe<CountryAlpha2>;
  licenseType?: Maybe<Scalars['String']['output']>;
  manuallyKeyedCnpMotoBasisPoints?: Maybe<Scalars['String']['output']>;
  manuallyKeyedCpImprintBasisPoints?: Maybe<Scalars['String']['output']>;
  maximumMonthlyCardVolumeAmount?: Maybe<Scalars['String']['output']>;
  maximumMonthlyCardVolumeCurrency?: Maybe<CurrencyAlpha3>;
  maximumTransactionAmount?: Maybe<Scalars['String']['output']>;
  maximumTransactionCurrency?: Maybe<Scalars['String']['output']>;
  minimumTransactionAmount?: Maybe<Scalars['String']['output']>;
  minimumTransactionCurrency?: Maybe<Scalars['String']['output']>;
  monthlyAverageVolumeAmount?: Maybe<Scalars['String']['output']>;
  monthlyAverageVolumeCurrency?: Maybe<CurrencyAlpha3>;
  monthlyCardVolumeAmount?: Maybe<Scalars['String']['output']>;
  monthlyCardVolumeCurrency?: Maybe<CurrencyAlpha3>;
  motoOptions?: Maybe<Scalars['Boolean']['output']>;
  originsOfFunds?: Maybe<Array<Scalars['String']['output']>>;
  paymentChannels?: Maybe<Array<PaymentChannel>>;
  physicalProductsOrigins?: Maybe<Array<Scalars['String']['output']>>;
  processingCurrencies?: Maybe<Array<CurrencyAlpha3>>;
  productCompany?: Maybe<Scalars['Boolean']['output']>;
  productDescription?: Maybe<Scalars['String']['output']>;
  productSupplyTimeRange?: Maybe<ProductSupplyTimeRange>;
  projectedCardTurnover?: Maybe<Scalars['String']['output']>;
  projectedCardVolume?: Maybe<Scalars['String']['output']>;
  projectedCardVolumeCurrency?: Maybe<CurrencyAlpha3>;
  reason?: Maybe<Scalars['String']['output']>;
  requestingPayoutsToCustomers?: Maybe<Scalars['Boolean']['output']>;
  requiresAuthorizationFromAuthority?: Maybe<Scalars['Boolean']['output']>;
  requiresAuthorizationFromAuthorityDescription?: Maybe<Scalars['String']['output']>;
  seasonalBusiness?: Maybe<Scalars['Boolean']['output']>;
  seasonalBusinessMonths?: Maybe<Array<Scalars['String']['output']>>;
  settlementCurrencies?: Maybe<Array<CurrencyAlpha3>>;
  sourcesOfFunds?: Maybe<Array<Scalars['String']['output']>>;
  subscriptionBasedService?: Maybe<Scalars['Boolean']['output']>;
  targetMarketsCountriesOnly?: Maybe<Scalars['Boolean']['output']>;
  volumeShareCountries?: Maybe<Array<CountryVolumeShare>>;
  yearlyVolume?: Maybe<Scalars['String']['output']>;
  yearlyVolumeCurrency?: Maybe<Scalars['String']['output']>;
};

export type OnboardingBusinessActivityInput = {
  annualAmexVolumeExceeds?: InputMaybe<Scalars['Boolean']['input']>;
  applyingReason?: InputMaybe<Scalars['String']['input']>;
  averageTransactionAmount?: InputMaybe<Scalars['String']['input']>;
  averageTransactionCurrency?: InputMaybe<Scalars['String']['input']>;
  blacklistedCountries?: InputMaybe<Array<CountryAlpha2>>;
  businessToBusinessBasisPoints?: InputMaybe<Scalars['String']['input']>;
  cardPresentBasisPoints?: InputMaybe<Scalars['String']['input']>;
  currentPaymentProcessor?: InputMaybe<Scalars['String']['input']>;
  customersAbroad?: InputMaybe<Scalars['Boolean']['input']>;
  customersAbroadCountries?: InputMaybe<Array<CountryAlpha2>>;
  ecommerceBasisPoints?: InputMaybe<Scalars['String']['input']>;
  esaNumber?: InputMaybe<Scalars['String']['input']>;
  highRiskCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  licenseJurisdictionCountry?: InputMaybe<CountryAlpha2>;
  licenseType?: InputMaybe<Scalars['String']['input']>;
  manuallyKeyedCnpMotoBasisPoints?: InputMaybe<Scalars['String']['input']>;
  manuallyKeyedCpImprintBasisPoints?: InputMaybe<Scalars['String']['input']>;
  maximumMonthlyCardVolumeAmount?: InputMaybe<Scalars['String']['input']>;
  maximumMonthlyCardVolumeCurrency?: InputMaybe<CurrencyAlpha3>;
  maximumTransactionAmount?: InputMaybe<Scalars['String']['input']>;
  maximumTransactionCurrency?: InputMaybe<Scalars['String']['input']>;
  minimumTransactionAmount?: InputMaybe<Scalars['String']['input']>;
  minimumTransactionCurrency?: InputMaybe<Scalars['String']['input']>;
  monthlyAverageVolumeAmount?: InputMaybe<Scalars['String']['input']>;
  monthlyAverageVolumeCurrency?: InputMaybe<CurrencyAlpha3>;
  monthlyCardVolumeAmount?: InputMaybe<Scalars['String']['input']>;
  monthlyCardVolumeCurrency?: InputMaybe<CurrencyAlpha3>;
  motoOptions?: InputMaybe<Scalars['Boolean']['input']>;
  originsOfFunds?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentChannels?: InputMaybe<Array<PaymentChannel>>;
  physicalProductsOrigins?: InputMaybe<Array<Scalars['String']['input']>>;
  processingCurrencies?: InputMaybe<Array<CurrencyAlpha3>>;
  productCompany?: InputMaybe<Scalars['Boolean']['input']>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  productSupplyTimeRange?: InputMaybe<ProductSupplyTimeRange>;
  projectedCardTurnover?: InputMaybe<Scalars['String']['input']>;
  projectedCardVolume?: InputMaybe<Scalars['String']['input']>;
  projectedCardVolumeCurrency?: InputMaybe<CurrencyAlpha3>;
  reason?: InputMaybe<Scalars['String']['input']>;
  requestingPayoutsToCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  requiresAuthorizationFromAuthority?: InputMaybe<Scalars['Boolean']['input']>;
  requiresAuthorizationFromAuthorityDescription?: InputMaybe<Scalars['String']['input']>;
  seasonalBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  seasonalBusinessMonths?: InputMaybe<Array<Scalars['String']['input']>>;
  settlementCurrencies?: InputMaybe<Array<CurrencyAlpha3>>;
  sourcesOfFunds?: InputMaybe<Array<Scalars['String']['input']>>;
  subscriptionBasedService?: InputMaybe<Scalars['Boolean']['input']>;
  targetMarketsCountriesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  volumeShareCountries?: InputMaybe<Array<CountryVolumeShareInput>>;
  yearlyVolume?: InputMaybe<Scalars['String']['input']>;
  yearlyVolumeCurrency?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingBusinessActivityPreview = {
  __typename?: 'OnboardingBusinessActivityPreview';
  annualAmexVolumeExceeds?: Maybe<Scalars['Boolean']['output']>;
  applyingReason?: Maybe<Scalars['String']['output']>;
  averageTransactionAmount?: Maybe<Scalars['String']['output']>;
  averageTransactionCurrency?: Maybe<Scalars['String']['output']>;
  blacklistedCountries?: Maybe<Array<CountryAlpha2>>;
  businessToBusinessBasisPoints?: Maybe<Scalars['String']['output']>;
  cardPresentBasisPoints?: Maybe<Scalars['String']['output']>;
  currentPaymentProcessor?: Maybe<Scalars['String']['output']>;
  customersAbroad?: Maybe<Scalars['Boolean']['output']>;
  customersAbroadCountries?: Maybe<Array<CountryAlpha2>>;
  ecommerceBasisPoints?: Maybe<Scalars['String']['output']>;
  esaNumber?: Maybe<Scalars['String']['output']>;
  highRiskCountries?: Maybe<Array<Scalars['String']['output']>>;
  licenseJurisdictionCountry?: Maybe<CountryAlpha2>;
  licenseType?: Maybe<Scalars['String']['output']>;
  manuallyKeyedCnpMotoBasisPoints?: Maybe<Scalars['String']['output']>;
  manuallyKeyedCpImprintBasisPoints?: Maybe<Scalars['String']['output']>;
  maximumMonthlyCardVolumeAmount?: Maybe<Scalars['String']['output']>;
  maximumMonthlyCardVolumeCurrency?: Maybe<Scalars['String']['output']>;
  maximumTransactionAmount?: Maybe<Scalars['String']['output']>;
  maximumTransactionCurrency?: Maybe<Scalars['String']['output']>;
  minimumTransactionAmount?: Maybe<Scalars['String']['output']>;
  minimumTransactionCurrency?: Maybe<Scalars['String']['output']>;
  monthlyAverageVolumeAmount?: Maybe<Scalars['String']['output']>;
  monthlyAverageVolumeCurrency?: Maybe<CurrencyAlpha3>;
  monthlyCardVolumeAmount?: Maybe<Scalars['String']['output']>;
  monthlyCardVolumeCurrency?: Maybe<CurrencyAlpha3>;
  motoOptions?: Maybe<Scalars['Boolean']['output']>;
  originsOfFunds?: Maybe<Array<Scalars['String']['output']>>;
  paymentChannels?: Maybe<Array<PaymentChannel>>;
  physicalProductsOrigins?: Maybe<Array<Scalars['String']['output']>>;
  processingCurrencies?: Maybe<Array<CurrencyAlpha3>>;
  productCompany?: Maybe<Scalars['Boolean']['output']>;
  productDescription?: Maybe<Scalars['String']['output']>;
  productSupplyTimeRange?: Maybe<ProductSupplyTimeRange>;
  projectedCardTurnover?: Maybe<Scalars['String']['output']>;
  projectedCardVolume?: Maybe<Scalars['String']['output']>;
  projectedCardVolumeCurrency?: Maybe<CurrencyAlpha3>;
  reason?: Maybe<Scalars['String']['output']>;
  requestingPayoutsToCustomers?: Maybe<Scalars['Boolean']['output']>;
  requiresAuthorizationFromAuthority?: Maybe<Scalars['Boolean']['output']>;
  requiresAuthorizationFromAuthorityDesc?: Maybe<Scalars['String']['output']>;
  seasonalBusiness?: Maybe<Scalars['Boolean']['output']>;
  seasonalBusinessMonths?: Maybe<Array<Scalars['String']['output']>>;
  settlementCurrencies?: Maybe<Array<CurrencyAlpha3>>;
  sourcesOfFunds?: Maybe<Array<Scalars['String']['output']>>;
  subscriptionBasedService?: Maybe<Scalars['Boolean']['output']>;
  targetMarketsCountriesOnly?: Maybe<Scalars['Boolean']['output']>;
  yearlyVolume?: Maybe<Scalars['String']['output']>;
  yearlyVolumeCurrency?: Maybe<Scalars['String']['output']>;
};

export type OnboardingBusinessDetails = {
  __typename?: 'OnboardingBusinessDetails';
  businessLicenseNumber?: Maybe<Scalars['String']['output']>;
  companyRegistrationNumber?: Maybe<Scalars['String']['output']>;
  doingBusinessAs?: Maybe<Scalars['String']['output']>;
  employerIdNumber?: Maybe<Scalars['String']['output']>;
  implementation?: Maybe<Implementation>;
  industry?: Maybe<Mcc>;
  industryDescription?: Maybe<Scalars['String']['output']>;
  issuingAuthority?: Maybe<Scalars['String']['output']>;
  legalBusinessName?: Maybe<Scalars['String']['output']>;
  monthlyProcessingVolume?: Maybe<Scalars['String']['output']>;
  monthlyProcessingVolumeCurrency?: Maybe<Scalars['String']['output']>;
  noOnlinePresence?: Maybe<Scalars['Boolean']['output']>;
  noVatNumber?: Maybe<Scalars['Boolean']['output']>;
  noWebsite?: Maybe<Scalars['Boolean']['output']>;
  productDescription?: Maybe<Scalars['String']['output']>;
  socialMedia?: Maybe<Array<SocialMediaObject>>;
  specialProducts?: Maybe<Array<SpecialProducts>>;
  specialProductsDescription?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  websiteUnderConstruction?: Maybe<Scalars['Boolean']['output']>;
};

export type OnboardingBusinessDetailsInput = {
  businessLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  companyRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  doingBusinessAs?: InputMaybe<Scalars['String']['input']>;
  employerIdNumber?: InputMaybe<Scalars['String']['input']>;
  implementation?: InputMaybe<ImplementationInput>;
  industry?: InputMaybe<Scalars['String']['input']>;
  industryDescription?: InputMaybe<Scalars['String']['input']>;
  issuingAuthority?: InputMaybe<Scalars['String']['input']>;
  legalBusinessName?: InputMaybe<Scalars['String']['input']>;
  monthlyProcessingVolume?: InputMaybe<Scalars['String']['input']>;
  monthlyProcessingVolumeCurrency?: InputMaybe<Scalars['String']['input']>;
  noOnlinePresence?: InputMaybe<Scalars['Boolean']['input']>;
  noVatNumber?: InputMaybe<Scalars['Boolean']['input']>;
  noWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  socialMedia?: InputMaybe<Array<SocialMediaInput>>;
  specialProducts?: InputMaybe<Array<SpecialProducts>>;
  specialProductsDescription?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  websiteUnderConstruction?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnboardingBusinessDetailsPreview = {
  __typename?: 'OnboardingBusinessDetailsPreview';
  businessLicenseNumber?: Maybe<Scalars['String']['output']>;
  companyRegistrationNumber?: Maybe<Scalars['String']['output']>;
  doingBusinessAs?: Maybe<Scalars['String']['output']>;
  employerIdNumber?: Maybe<Scalars['String']['output']>;
  implementation?: Maybe<Implementation>;
  industryDescription?: Maybe<Scalars['String']['output']>;
  issuingAuthority?: Maybe<Scalars['String']['output']>;
  legalBusinessName?: Maybe<Scalars['String']['output']>;
  monthlyProcessingVolume?: Maybe<Scalars['String']['output']>;
  monthlyProcessingVolumeCurrency?: Maybe<Scalars['String']['output']>;
  noOnlinePresence?: Maybe<Scalars['Boolean']['output']>;
  noVatNumber?: Maybe<Scalars['Boolean']['output']>;
  noWebsite?: Maybe<Scalars['Boolean']['output']>;
  productDescription?: Maybe<Scalars['String']['output']>;
  specialProducts?: Maybe<Array<SpecialProducts>>;
  specialProductsDescription?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  websiteUnderConstruction?: Maybe<Scalars['Boolean']['output']>;
};

export type OnboardingBusinessProcessingInfo = {
  __typename?: 'OnboardingBusinessProcessingInfo';
  applyingForAdditionalLocations?: Maybe<Scalars['Boolean']['output']>;
  chargebackProcedureDescription?: Maybe<Scalars['String']['output']>;
  customerAccessType?: Maybe<CustomerAccessPlatformType>;
  emailReceipts?: Maybe<Scalars['Boolean']['output']>;
  existingPaycomMerchantId?: Maybe<Scalars['String']['output']>;
  fraudPreventionServiceDescription?: Maybe<Scalars['String']['output']>;
  fraudPreventionServiceUsed?: Maybe<Scalars['Boolean']['output']>;
  hasAcceptedCcBeforeDescription?: Maybe<Scalars['String']['output']>;
  hasAcceptedCreditCardsBefore?: Maybe<Scalars['Boolean']['output']>;
  hasExistingPaycomMerchant?: Maybe<Scalars['Boolean']['output']>;
  isWebsitePciCompliant?: Maybe<Scalars['Boolean']['output']>;
  numberOfPhysicalLocations?: Maybe<Scalars['Int']['output']>;
  ordersFulfilledDirectly?: Maybe<Scalars['Boolean']['output']>;
  platformRequiresTestUser?: Maybe<Scalars['Boolean']['output']>;
  returnAndRefundPolicy?: Maybe<Scalars['String']['output']>;
  saqType?: Maybe<SaqType>;
  terminatedByPreviousProcessor?: Maybe<Scalars['Boolean']['output']>;
  testPassword?: Maybe<Scalars['String']['output']>;
  testUsername?: Maybe<Scalars['String']['output']>;
  thirdPartyIntegration?: Maybe<Scalars['Boolean']['output']>;
  thirdPartyIntegrationDescription?: Maybe<Scalars['String']['output']>;
  wantsAmexMarketingMaterials?: Maybe<Scalars['Boolean']['output']>;
};

export type OnboardingBusinessProcessingInput = {
  applyingForAdditionalLocations?: InputMaybe<Scalars['Boolean']['input']>;
  chargebackProcedureDescription?: InputMaybe<Scalars['String']['input']>;
  customerAccessType?: InputMaybe<CustomerAccessPlatformType>;
  emailReceipts?: InputMaybe<Scalars['Boolean']['input']>;
  existingPaycomMerchantId?: InputMaybe<Scalars['String']['input']>;
  fraudPreventionServiceDescription?: InputMaybe<Scalars['String']['input']>;
  fraudPreventionServiceUsed?: InputMaybe<Scalars['Boolean']['input']>;
  hasAcceptedCcBeforeDescription?: InputMaybe<Scalars['String']['input']>;
  hasAcceptedCreditCardsBefore?: InputMaybe<Scalars['Boolean']['input']>;
  hasExistingPaycomMerchant?: InputMaybe<Scalars['Boolean']['input']>;
  isWebsitePciCompliant?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfPhysicalLocations?: InputMaybe<Scalars['Int']['input']>;
  ordersFulfilledDirectly?: InputMaybe<Scalars['Boolean']['input']>;
  platformRequiresTestUser?: InputMaybe<Scalars['Boolean']['input']>;
  returnAndRefundPolicy?: InputMaybe<Scalars['String']['input']>;
  saqType?: InputMaybe<SaqType>;
  terminatedByPreviousProcessor?: InputMaybe<Scalars['Boolean']['input']>;
  testPassword?: InputMaybe<Scalars['String']['input']>;
  testUsername?: InputMaybe<Scalars['String']['input']>;
  thirdPartyIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  thirdPartyIntegrationDescription?: InputMaybe<Scalars['String']['input']>;
  wantsAmexMarketingMaterials?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OnboardingChannel {
  Solicited = 'solicited',
  Unsolicited = 'unsolicited'
}

export enum OnboardingCountryRegion {
  Af = 'af',
  As = 'as',
  Eu = 'eu',
  Me = 'me',
  Na = 'na',
  Oc = 'oc',
  Sa = 'sa'
}

export type OnboardingDeclineDetails = {
  __typename?: 'OnboardingDeclineDetails';
  comment?: Maybe<Scalars['String']['output']>;
  declineReason?: Maybe<OnboardingDeclineReason>;
};

export type OnboardingDeclineDetailsInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  declineReason: OnboardingDeclineReason;
};

export enum OnboardingDeclineReason {
  InsufficientWebsite = 'insufficient_website',
  NonCorresponding = 'non_corresponding',
  NotMeetingMinimumProcessingVolume = 'not_meeting_minimum_processing_volume',
  Other = 'other',
  Prohibited = 'prohibited',
  SuspectedRisk = 'suspected_risk'
}

export type OnboardingEvent = {
  __typename?: 'OnboardingEvent';
  browser?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  eventData?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  occurredAt?: Maybe<Scalars['String']['output']>;
  operatingSystem?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  resourceId?: Maybe<Scalars['String']['output']>;
  system?: Maybe<AuditsSystem>;
  traceId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OnboardingEventType>;
  userAgent?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum OnboardingEventType {
  PaypassEmailSent = 'paypass_email_sent',
  PaypassReviewSectionOpened = 'paypass_review_section_opened',
  PaypassStepChanged = 'paypass_step_changed',
  PaypassSubmitted = 'paypass_submitted',
  PaypassTaskSubmitted = 'paypass_task_submitted',
  PaypassTasksEmailSent = 'paypass_tasks_email_sent',
  PaypassUrlOpened = 'paypass_url_opened',
  PaypassUserLoggedIn = 'paypass_user_logged_in',
  SignAuthenticationPassed = 'sign_authentication_passed',
  SignCompleted = 'sign_completed',
  SignDocumentOpened = 'sign_document_opened',
  SignDocumentSigned = 'sign_document_signed',
  SignNotificationSent = 'sign_notification_sent',
  SignRequestCreated = 'sign_request_created',
  SignTermsAccepted = 'sign_terms_accepted'
}

export type OnboardingEventsQueryInput = {
  filter?: InputMaybe<OnboardingEventsInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type OnboardingEventsResponse = {
  __typename?: 'OnboardingEventsResponse';
  events?: Maybe<Array<OnboardingEvent>>;
  pageInfo: PageInfo;
};

export type OnboardingMpaInputObject = {
  companyId: Scalars['ID']['input'];
  merchantId: Scalars['ID']['input'];
  saveAsDraft: Scalars['Boolean']['input'];
};

export type OnboardingMpaResponse = {
  __typename?: 'OnboardingMpaResponse';
  documentFilename: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  documentUrl: Scalars['String']['output'];
};

export type OnboardingPricing = {
  __typename?: 'OnboardingPricing';
  archived: Scalars['Boolean']['output'];
  categories?: Maybe<Array<OnboardingPricingCategory>>;
  companyId?: Maybe<Scalars['ID']['output']>;
  contractType: OnboardingPricingContractType;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  currency: CurrencyAlpha3;
  entityId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pricingType: OnboardingPricingType;
  primaryContact?: Maybe<OnboardingPricingPrimaryContact>;
  region: OnboardingPricingRegion;
  salesAssignee?: Maybe<Scalars['String']['output']>;
  settlementTerms?: Maybe<OnboardingPricingSettlementTerms>;
  status: OnboardingPricingStatus;
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type OnboardingPricingCategory = {
  __typename?: 'OnboardingPricingCategory';
  fields?: Maybe<Array<OnboardingPricingFieldData>>;
  name: Scalars['String']['output'];
  subcategories?: Maybe<Array<OnboardingPricingSubcategory>>;
  type: OnboardingPricingFieldType;
};

export type OnboardingPricingCategoryInput = {
  fields?: InputMaybe<Array<OnboardingPricingFieldDataInput>>;
  name: Scalars['String']['input'];
  subcategories?: InputMaybe<Array<OnboardingPricingSubcategoryInput>>;
  type: OnboardingPricingFieldType;
};

export enum OnboardingPricingContractType {
  Gateway = 'gateway',
  Msa = 'msa'
}

export type OnboardingPricingExactFilterInputValues = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primaryContact?: InputMaybe<OnboardingPricingPrimaryContactInput>;
  salesAssignee?: InputMaybe<Scalars['String']['input']>;
  settlementTerms?: InputMaybe<OnboardingPricingSettlementTermsFilterInput>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingPricingField = {
  __typename?: 'OnboardingPricingField';
  archived: Scalars['Boolean']['output'];
  categories?: Maybe<Array<OnboardingPricingFieldCategory>>;
  contractTypes?: Maybe<Array<OnboardingPricingContractType>>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  fieldTypes?: Maybe<Array<OnboardingPricingFieldFieldType>>;
  frequency?: Maybe<Array<OnboardingPricingFieldFrequency>>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  regions?: Maybe<Array<OnboardingPricingRegion>>;
  tieredTypeConfig?: Maybe<OnboardingPricingFieldTieredTypeConfig>;
  type: OnboardingPricingFieldType;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum OnboardingPricingFieldCategory {
  AcquiringFees = 'acquiring_fees',
  ApplePay = 'apple_pay',
  CardFees = 'card_fees',
  GatewayFees = 'gateway_fees',
  GeneralFees = 'general_fees',
  GooglePay = 'google_pay',
  Paypal = 'paypal'
}

export type OnboardingPricingFieldData = {
  __typename?: 'OnboardingPricingFieldData';
  amount?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<CurrencyAlpha3>;
  frequency?: Maybe<OnboardingPricingFieldFrequency>;
  key: Scalars['String']['output'];
  percentage?: Maybe<Scalars['String']['output']>;
  tiered?: Maybe<Array<OnboardingPricingTieredValue>>;
  type?: Maybe<OnboardingPricingFieldFieldType>;
};

export type OnboardingPricingFieldDataInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<OnboardingPricingFieldFrequency>;
  key: Scalars['String']['input'];
  percentage?: InputMaybe<Scalars['String']['input']>;
  tiered?: InputMaybe<Array<OnboardingPricingTieredValueInput>>;
  type?: InputMaybe<OnboardingPricingFieldFieldType>;
};

export enum OnboardingPricingFieldFieldType {
  Amount = 'amount',
  BasicPoints = 'basic_points',
  Hybrid = 'hybrid',
  Tiered = 'tiered'
}

export enum OnboardingPricingFieldFrequency {
  Annual = 'annual',
  Daily = 'daily',
  Monthly = 'monthly',
  OneOff = 'one_off',
  PerSettlement = 'per_settlement',
  PerTransaction = 'per_transaction',
  Weekly = 'weekly'
}

export type OnboardingPricingFieldMutationResponse = {
  __typename?: 'OnboardingPricingFieldMutationResponse';
  success: Scalars['Boolean']['output'];
};

export type OnboardingPricingFieldTieredTypeConfig = {
  __typename?: 'OnboardingPricingFieldTieredTypeConfig';
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  rangeType?: Maybe<OnboardingPricingFieldTieredTypeConfigRangeType>;
  valueType?: Maybe<OnboardingPricingFieldFieldType>;
};

export type OnboardingPricingFieldTieredTypeConfigInput = {
  max?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
  rangeType?: InputMaybe<OnboardingPricingFieldTieredTypeConfigRangeType>;
  valueType?: InputMaybe<OnboardingPricingFieldFieldType>;
};

export enum OnboardingPricingFieldTieredTypeConfigRangeType {
  Amount = 'amount',
  Percentage = 'percentage',
  Value = 'value'
}

export enum OnboardingPricingFieldType {
  AlternativePaymentMethods = 'alternative_payment_methods',
  PricingFields = 'pricing_fields',
  Static = 'static'
}

export type OnboardingPricingInFilterInputValues = {
  contractType?: InputMaybe<Array<OnboardingPricingContractType>>;
  currency?: InputMaybe<Array<CurrencyAlpha3>>;
  pricingType?: InputMaybe<Array<OnboardingPricingType>>;
  region?: InputMaybe<Array<OnboardingPricingRegion>>;
  settlementTerms?: InputMaybe<OnboardingPricingSettlementTermsFilterInput>;
  status?: InputMaybe<Array<OnboardingPricingStatus>>;
};

export type OnboardingPricingInputFilter = {
  and?: InputMaybe<Array<InputMaybe<OnboardingPricingInputFilter>>>;
  between?: InputMaybe<OnboardingPricingRangeFilterInputValues>;
  equal?: InputMaybe<OnboardingPricingExactFilterInputValues>;
  greater?: InputMaybe<OnboardingPricingExactFilterInputValues>;
  greaterOrEquals?: InputMaybe<OnboardingPricingExactFilterInputValues>;
  iLike?: InputMaybe<OnboardingPricingExactFilterInputValues>;
  in?: InputMaybe<OnboardingPricingInFilterInputValues>;
  less?: InputMaybe<OnboardingPricingExactFilterInputValues>;
  lessOrEquals?: InputMaybe<OnboardingPricingExactFilterInputValues>;
  like?: InputMaybe<OnboardingPricingExactFilterInputValues>;
  notBetween?: InputMaybe<OnboardingPricingRangeFilterInputValues>;
  notEqual?: InputMaybe<OnboardingPricingExactFilterInputValues>;
  notIn?: InputMaybe<OnboardingPricingInFilterInputValues>;
  notLike?: InputMaybe<OnboardingPricingExactFilterInputValues>;
  or?: InputMaybe<Array<OnboardingPricingInputFilter>>;
};

export type OnboardingPricingListQueryInput = {
  filter?: InputMaybe<OnboardingPricingInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type OnboardingPricingMutationResponse = {
  __typename?: 'OnboardingPricingMutationResponse';
  success: Scalars['Boolean']['output'];
};

export type OnboardingPricingPrimaryContact = {
  __typename?: 'OnboardingPricingPrimaryContact';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OnboardingPricingPrimaryContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingPricingRangeFilterInputValues = {
  createdAt?: InputMaybe<DateRange>;
  updatedAt?: InputMaybe<DateRange>;
};

export enum OnboardingPricingRegion {
  Eu = 'eu',
  Us = 'us'
}

export type OnboardingPricingResponse = {
  __typename?: 'OnboardingPricingResponse';
  onboardingPricing?: Maybe<Array<OnboardingPricing>>;
  pageInfo: PageInfo;
};

export type OnboardingPricingSettlementTerms = {
  __typename?: 'OnboardingPricingSettlementTerms';
  fee?: Maybe<Scalars['String']['output']>;
  fundingDelay?: Maybe<Scalars['Int']['output']>;
  scheduleConfig?: Maybe<SettlementScheduleConfigPreview>;
};

export type OnboardingPricingSettlementTermsFilterInput = {
  fee?: InputMaybe<Scalars['Float']['input']>;
  fundingDelay?: InputMaybe<Scalars['Int']['input']>;
  scheduleConfig?: InputMaybe<SettlementScheduleConfigInputFilterValues>;
};

export type OnboardingPricingSettlementTermsInput = {
  fee?: InputMaybe<Scalars['String']['input']>;
  fundingDelay?: InputMaybe<Scalars['Int']['input']>;
  scheduleConfig?: InputMaybe<SettlementScheduleConfigInput>;
};

export enum OnboardingPricingStatus {
  Abandoned = 'abandoned',
  Approved = 'approved',
  Completed = 'completed',
  InProgress = 'in_progress',
  MerchantSigned = 'merchant_signed',
  New = 'new',
  Synced = 'synced'
}

export type OnboardingPricingSubcategory = {
  __typename?: 'OnboardingPricingSubcategory';
  fields?: Maybe<Array<OnboardingPricingFieldData>>;
  name: Scalars['String']['output'];
};

export type OnboardingPricingSubcategoryInput = {
  fields?: InputMaybe<Array<OnboardingPricingFieldDataInput>>;
  name: Scalars['String']['input'];
};

export type OnboardingPricingTieredValue = {
  __typename?: 'OnboardingPricingTieredValue';
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  value?: Maybe<OnboardingPricingTieredValueValue>;
};

export type OnboardingPricingTieredValueInput = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<OnboardingPricingTieredValueValueInput>;
};

export type OnboardingPricingTieredValueValue = {
  __typename?: 'OnboardingPricingTieredValueValue';
  amount?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<CurrencyAlpha3>;
  frequency?: Maybe<OnboardingPricingFieldFrequency>;
  key: Scalars['String']['output'];
  percentage?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OnboardingPricingFieldFieldType>;
};

export type OnboardingPricingTieredValueValueInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<OnboardingPricingFieldFrequency>;
  key: Scalars['String']['input'];
  percentage?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OnboardingPricingFieldFieldType>;
};

export enum OnboardingPricingType {
  Blended = 'blended',
  IcPlusPlus = 'ic_plus_plus'
}

export type OnboardingProviderErrors = {
  __typename?: 'OnboardingProviderErrors';
  applicationError?: Maybe<Scalars['String']['output']>;
  fieldErrors?: Maybe<Array<OnboardingProviderFieldError>>;
};

export type OnboardingProviderFieldError = {
  __typename?: 'OnboardingProviderFieldError';
  errorMessage?: Maybe<Scalars['String']['output']>;
  fieldPath?: Maybe<Scalars['String']['output']>;
};

export type OnboardingRiskRule = {
  __typename?: 'OnboardingRiskRule';
  alertFrequency?: Maybe<Scalars['String']['output']>;
  alertUniquenessParams?: Maybe<Array<Scalars['String']['output']>>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  category: Scalars['String']['output'];
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  defaultRiskAlertCategory?: Maybe<RiskAlertCategory>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  entityId: Scalars['ID']['output'];
  excludable: Scalars['Boolean']['output'];
  failureCode?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  feesActions?: Maybe<Array<Scalars['String']['output']>>;
  globalAggregation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  internalRule: Scalars['Boolean']['output'];
  logic: Scalars['String']['output'];
  logicClient?: Maybe<Scalars['String']['output']>;
  outcomeDetails?: Maybe<OutcomeDetails>;
  outcomeDetailsByRange?: Maybe<Array<OutcomeDetailsByRangeItem>>;
  outcomes?: Maybe<Array<RiskRuleOutcome>>;
  postExternalRiskCheck?: Maybe<Scalars['Boolean']['output']>;
  riskScoreModifier?: Maybe<Scalars['String']['output']>;
  routingPriority?: Maybe<Scalars['Int']['output']>;
  rulePriority?: Maybe<Scalars['Float']['output']>;
  scopingLogic?: Maybe<Scalars['String']['output']>;
  systemRule: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
};

export type OnboardingRiskRuleCreateInput = {
  alertFrequency?: InputMaybe<Scalars['String']['input']>;
  alertUniquenessParams?: InputMaybe<Array<Scalars['String']['input']>>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  category: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  defaultRiskAlertCategory?: InputMaybe<RiskAlertCategory>;
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  entityId: Scalars['ID']['input'];
  excludable: Scalars['Boolean']['input'];
  failureCode?: InputMaybe<Scalars['String']['input']>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  feesActions?: InputMaybe<Array<Scalars['String']['input']>>;
  globalAggregation?: InputMaybe<Scalars['Boolean']['input']>;
  internalRule: Scalars['Boolean']['input'];
  logic: Scalars['String']['input'];
  logicClient?: InputMaybe<Scalars['String']['input']>;
  outcomeDetails?: InputMaybe<OutcomeDetailsInput>;
  outcomeDetailsByRange?: InputMaybe<Array<OutcomeDetailsByRangeItemInput>>;
  outcomes?: InputMaybe<Array<RiskRuleOutcome>>;
  postExternalRiskCheck?: InputMaybe<Scalars['Boolean']['input']>;
  riskScoreModifier?: InputMaybe<Scalars['String']['input']>;
  routingPriority?: InputMaybe<Scalars['Int']['input']>;
  rulePriority?: InputMaybe<Scalars['Float']['input']>;
  scopingLogic?: InputMaybe<Scalars['String']['input']>;
  systemRule: Scalars['Boolean']['input'];
};

export type OnboardingRiskRuleInput = {
  companyId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type OnboardingRiskRuleUpdateInput = {
  alertFrequency?: InputMaybe<Scalars['String']['input']>;
  alertUniquenessParams?: InputMaybe<Array<Scalars['String']['input']>>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  defaultRiskAlertCategory?: InputMaybe<RiskAlertCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId: Scalars['ID']['input'];
  excludable?: InputMaybe<Scalars['Boolean']['input']>;
  failureCode?: InputMaybe<Scalars['String']['input']>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  feesActions?: InputMaybe<Array<Scalars['String']['input']>>;
  globalAggregation?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  internalRule?: InputMaybe<Scalars['Boolean']['input']>;
  logic?: InputMaybe<Scalars['String']['input']>;
  logicClient?: InputMaybe<Scalars['String']['input']>;
  outcomeDetails?: InputMaybe<OutcomeDetailsInput>;
  outcomeDetailsByRange?: InputMaybe<Array<OutcomeDetailsByRangeItemInput>>;
  outcomes?: InputMaybe<Array<RiskRuleOutcome>>;
  postExternalRiskCheck?: InputMaybe<Scalars['Boolean']['input']>;
  riskScoreModifier?: InputMaybe<Scalars['String']['input']>;
  routingPriority?: InputMaybe<Scalars['Int']['input']>;
  rulePriority?: InputMaybe<Scalars['Float']['input']>;
  scopingLogic?: InputMaybe<Scalars['String']['input']>;
  systemRule?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnboardingRiskRules = {
  __typename?: 'OnboardingRiskRules';
  pageInfo: PageInfo;
  rules: Array<OnboardingRiskRule>;
};

export type OnboardingRiskRulesMutationResponse = {
  __typename?: 'OnboardingRiskRulesMutationResponse';
  companyId: Scalars['ID']['output'];
  entityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type OnboardingRiskRulesQueryExactInputFilter = {
  alertFrequency?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  defaultRiskAlertCategory?: InputMaybe<RiskAlertCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  excludable?: InputMaybe<Scalars['Boolean']['input']>;
  failureCode?: InputMaybe<Scalars['String']['input']>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  globalAggregation?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internalRule?: InputMaybe<Scalars['Boolean']['input']>;
  logic?: InputMaybe<Scalars['String']['input']>;
  logicClient?: InputMaybe<Scalars['String']['input']>;
  postExternalRiskCheck?: InputMaybe<Scalars['Boolean']['input']>;
  riskScoreModifier?: InputMaybe<Scalars['String']['input']>;
  routingPriority?: InputMaybe<Scalars['Int']['input']>;
  rulePriority?: InputMaybe<Scalars['Float']['input']>;
  scopingLogic?: InputMaybe<Scalars['String']['input']>;
  systemRule?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingRiskRulesQueryInFilterInputValues = {
  alertUniquenessParams?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultRiskAlertCategory?: InputMaybe<RiskAlertCategory>;
  entityId?: InputMaybe<Array<Scalars['String']['input']>>;
  feesActions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  outcomes?: InputMaybe<Array<InputMaybe<RiskRuleOutcome>>>;
};

export type OnboardingRiskRulesQueryInput = {
  filter?: InputMaybe<OnboardingRiskRulesQueryInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type OnboardingRiskRulesQueryInputFilter = {
  and?: InputMaybe<Array<InputMaybe<OnboardingRiskRulesQueryInputFilter>>>;
  between?: InputMaybe<OnboardingRiskRulesQueryRangeInputFilter>;
  equal?: InputMaybe<OnboardingRiskRulesQueryExactInputFilter>;
  hasAny?: InputMaybe<OnboardingRiskRulesQueryInFilterInputValues>;
  iLike?: InputMaybe<OnboardingRiskRulesQueryExactInputFilter>;
  in?: InputMaybe<OnboardingRiskRulesQueryInFilterInputValues>;
  notEqual?: InputMaybe<OnboardingRiskRulesQueryExactInputFilter>;
  notIn?: InputMaybe<OnboardingRiskRulesQueryInFilterInputValues>;
  or?: InputMaybe<Array<OnboardingRiskRulesQueryInputFilter>>;
  textSearchCaseInsensitive?: InputMaybe<OnboardingRiskRulesQueryExactInputFilter>;
};

export type OnboardingRiskRulesQueryRangeInputFilter = {
  createdAt?: InputMaybe<StringRangeInput>;
  routingPriority?: InputMaybe<IntRangeInput>;
  rulePriority?: InputMaybe<FloatRangeInput>;
  updatedAt?: InputMaybe<StringRangeInput>;
};

export enum OnboardingSystem {
  Backoffice = 'backoffice',
  Dashboard = 'dashboard',
  Hubspot = 'hubspot',
  Paypass = 'paypass'
}

export type OnfidoCheckResult = {
  __typename?: 'OnfidoCheckResult';
  id?: Maybe<Scalars['String']['output']>;
  result?: Maybe<OnfidoResult>;
  subCategories?: Maybe<Array<OnfidoSubCategoryEntry>>;
  type?: Maybe<OnfidoResultType>;
  verificationCheckId?: Maybe<Scalars['String']['output']>;
};

export type OnfidoCheckResultInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<OnfidoResult>;
  subCategories?: InputMaybe<Array<OnfidoSubCategoryEntryInput>>;
  type?: InputMaybe<OnfidoResultType>;
  verificationCheckId?: InputMaybe<Scalars['String']['input']>;
};

export enum OnfidoResult {
  Caution = 'caution',
  Clear = 'clear',
  Consider = 'consider',
  Rejected = 'rejected',
  Suspected = 'suspected',
  Unidentified = 'unidentified',
  Unknown = 'unknown'
}

export enum OnfidoResultType {
  DeviceIntelligence = 'device_intelligence',
  Document = 'document',
  DocumentVideo = 'document_video',
  DocumentWithAddressInformation = 'document_with_address_information',
  DocumentWithDriverVerification = 'document_with_driver_verification',
  DocumentWithDrivingLicenceInformation = 'document_with_driving_licence_information',
  FacialSimilarityMotion = 'facial_similarity_motion',
  FacialSimilarityPhoto = 'facial_similarity_photo',
  FacialSimilarityPhotoFullyAuto = 'facial_similarity_photo_fully_auto',
  FacialSimilarityVideo = 'facial_similarity_video',
  IdentityEnhanced = 'identity_enhanced',
  KnownFaces = 'known_faces',
  ProofOfAddress = 'proof_of_address',
  Unknown = 'unknown',
  UsDrivingLicence = 'us_driving_licence',
  WatchlistAml = 'watchlist_aml',
  WatchlistEnhanced = 'watchlist_enhanced',
  WatchlistPepsOnly = 'watchlist_peps_only',
  WatchlistSanctionsOnly = 'watchlist_sanctions_only',
  WatchlistStandard = 'watchlist_standard'
}

export type OnfidoSubCategoryEntry = {
  __typename?: 'OnfidoSubCategoryEntry';
  key: Scalars['String']['output'];
  value: OnfidoResult;
};

export type OnfidoSubCategoryEntryInput = {
  key: Scalars['String']['input'];
  value: OnfidoResult;
};

export type OrderBy = {
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
};

export enum OriginType {
  Api = 'API',
  Dashboard = 'DASHBOARD'
}

export type OutcomeDetails = {
  __typename?: 'OutcomeDetails';
  fallbackConfig?: Maybe<Array<FallbackConfigItem>>;
  fallbackRouting?: Maybe<FallbackRouting>;
  paymentMethodConfigId?: Maybe<Scalars['String']['output']>;
  processorConfig?: Maybe<ProcessorConfig>;
};

export type OutcomeDetailsByRangeItem = {
  __typename?: 'OutcomeDetailsByRangeItem';
  end: Scalars['Int']['output'];
  outcomeDetails: OutcomeDetails;
  start: Scalars['Int']['output'];
};

export type OutcomeDetailsByRangeItemInput = {
  end: Scalars['Int']['input'];
  outcomeDetails: OutcomeDetailsInput;
  start: Scalars['Int']['input'];
};

export type OutcomeDetailsInput = {
  fallbackConfig?: InputMaybe<Array<FallbackConfigItemInput>>;
  fallbackRouting?: InputMaybe<FallbackRoutingInput>;
  paymentMethodConfigId?: InputMaybe<Scalars['String']['input']>;
  processorConfig?: InputMaybe<ProcessorConfigInput>;
};

export type PackageOrSubscriptionAudit = {
  __typename?: 'PackageOrSubscriptionAudit';
  action: Scalars['String']['output'];
  date?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  resource: PackageOrSubscriptionAuditResourceTypeEnum;
  resourceId: Scalars['String']['output'];
  system?: Maybe<Scalars['String']['output']>;
};

export type PackageOrSubscriptionAuditQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  resource: PackageOrSubscriptionAuditResourceTypeEnum;
  resourceId: Scalars['ID']['input'];
};

export enum PackageOrSubscriptionAuditResourceTypeEnum {
  Subscription = 'subscription',
  SubscriptionPackage = 'subscription_package'
}

export type PackageOrSubscriptionAuditsQueryResponse = {
  __typename?: 'PackageOrSubscriptionAuditsQueryResponse';
  audits: Array<PackageOrSubscriptionAudit>;
  pageInfo: PageInfo;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  isLastPage: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  total?: Maybe<Scalars['Int']['output']>;
};

export type ParsedEnabledReportsInput = {
  disputes: Scalars['Boolean']['input'];
  fraud: Scalars['Boolean']['input'];
  fx: Scalars['Boolean']['input'];
  settlement: Scalars['Boolean']['input'];
  transaction_reconciliation: Scalars['Boolean']['input'];
};

export type PasswordProtectedApiKeyIdInput = {
  id: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export enum PauseEnum {
  Draft = 'draft',
  Void = 'void'
}

export enum PayLegalEntityType {
  PayTechCy = 'pay_tech_cy',
  Paycomcy = 'paycomcy',
  Paycomus = 'paycomus'
}

export type PaymentCancellationMutationInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  relatedTransactionId: Scalars['String']['input'];
};

export type PaymentCancellationMutationResponse = {
  __typename?: 'PaymentCancellationMutationResponse';
  finalize?: Maybe<Finalize>;
  processorTransactionId: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
  transactionStatus: TransactionStatus;
};

export type PaymentCaptureMutationInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  deviceIpAddress?: InputMaybe<Scalars['String']['input']>;
  final: Scalars['Boolean']['input'];
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  relatedTransactionId: Scalars['String']['input'];
};

export enum PaymentChannel {
  CreatePaymentPage = 'create_payment_page',
  DirectApiIntegration = 'direct_api_integration',
  PayByLink = 'pay_by_link',
  PayCheckout = 'pay_checkout',
  PayComponents = 'pay_components'
}

export type PaymentFee = {
  __typename?: 'PaymentFee';
  bankTransferReference?: Maybe<Scalars['String']['output']>;
  basisPoints?: Maybe<Scalars['String']['output']>;
  blended?: Maybe<Scalars['Boolean']['output']>;
  clearingDate?: Maybe<Scalars['String']['output']>;
  collected?: Maybe<Scalars['Boolean']['output']>;
  commissionId?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  conversionRate?: Maybe<Scalars['String']['output']>;
  costType?: Maybe<CostType>;
  createdAt?: Maybe<Scalars['String']['output']>;
  estimated?: Maybe<Scalars['Boolean']['output']>;
  feeDescription?: Maybe<Scalars['String']['output']>;
  feeIdentifier: Scalars['String']['output'];
  feeType: FeeType;
  gross?: Maybe<Scalars['Boolean']['output']>;
  grossInvoiceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isBasisPoints?: Maybe<Scalars['Boolean']['output']>;
  merchantId: Scalars['String']['output'];
  paymentId: Scalars['String']['output'];
  pricingSegmentCode?: Maybe<PricingSegmentCode>;
  processingCurrency: Scalars['String']['output'];
  processingCurrencyAmount: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  recurring?: Maybe<Scalars['Boolean']['output']>;
  referralId?: Maybe<Scalars['String']['output']>;
  referralRevShareTierBasisPoints?: Maybe<Scalars['String']['output']>;
  referralRevShareTierName?: Maybe<Scalars['String']['output']>;
  settlementCurrency?: Maybe<Scalars['String']['output']>;
  settlementCurrencyAmount?: Maybe<Scalars['String']['output']>;
  settlementId?: Maybe<Scalars['String']['output']>;
  transactionAttemptId: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
  transactionKey?: Maybe<Scalars['String']['output']>;
  transactionTimestamp?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<TransactionTypes>;
};

export type PaymentFeesPaginated = {
  __typename?: 'PaymentFeesPaginated';
  fees: Array<PaymentFee>;
  pageInfo: PageInfo;
};

export type PaymentLinkAmountLimitsField = {
  __typename?: 'PaymentLinkAmountLimitsField';
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
};

export type PaymentLinkCollectionField = {
  __typename?: 'PaymentLinkCollectionField';
  billingAddress?: Maybe<PaymentLinkEnabledField>;
  emailAddress?: Maybe<PaymentLinkEnabledField>;
  fullName?: Maybe<PaymentLinkEnabledField>;
  phoneNumber?: Maybe<PaymentLinkEnabledField>;
  shippingAddress?: Maybe<PaymentLinkShippingAddressField>;
  taxId?: Maybe<PaymentLinkEnabledField>;
};

export type PaymentLinkEnabledField = {
  __typename?: 'PaymentLinkEnabledField';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentLinkObject = {
  __typename?: 'PaymentLinkObject';
  amount: Scalars['String']['output'];
  amountLimits?: Maybe<PaymentLinkAmountLimitsField>;
  availablePaymentMethods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  collection?: Maybe<PaymentLinkCollectionField>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  maxAttempts?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sendReceipt?: Maybe<Scalars['Boolean']['output']>;
  statementDescriptorSuffix?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PaymentLinkType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type PaymentLinkPerformance = {
  __typename?: 'PaymentLinkPerformance';
  performance: Array<Maybe<PaymentLinkPerformanceObject>>;
};

export type PaymentLinkPerformanceObject = {
  __typename?: 'PaymentLinkPerformanceObject';
  revenue: Scalars['Float']['output'];
  submittedPayments: Scalars['Int']['output'];
  successfulPayments: Scalars['Int']['output'];
  transactionDate: Scalars['String']['output'];
  views: Scalars['Int']['output'];
};

export type PaymentLinkPerformanceQueryInput = {
  dateRange?: InputMaybe<StringRangeInput>;
  id: Scalars['String']['input'];
};

export type PaymentLinkQueryInput = {
  id: Scalars['ID']['input'];
};

export type PaymentLinkShippingAddressField = {
  __typename?: 'PaymentLinkShippingAddressField';
  allowedCountries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentLinkStatusMutationInput = {
  id: Scalars['String']['input'];
  isDeleted: Scalars['Boolean']['input'];
};

export type PaymentLinkStatusMutationPayload = {
  __typename?: 'PaymentLinkStatusMutationPayload';
  id: Scalars['String']['output'];
};

export type PaymentLinkStatusMutationResponse = {
  __typename?: 'PaymentLinkStatusMutationResponse';
  payload: PaymentLinkStatusMutationPayload;
  success: Scalars['Boolean']['output'];
};

/** REFERENCE: https://github.com/pay-com/grpc-core-paymentlinks/blob/d1bce68dd76665ca79dbdf5e69c8254f1b2f24da/service.proto#L16 */
export enum PaymentLinkType {
  Dynamic = 'dynamic',
  Fixed = 'fixed'
}

export type PaymentLinksQueryExactInputFilter = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  statementDescriptorSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentLinksQueryInFilterInputValues = {
  currency?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDeleted?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type PaymentLinksQueryInput = {
  filter?: InputMaybe<PaymentLinksQueryInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentLinksQueryInputFilter = {
  and?: InputMaybe<Array<InputMaybe<PaymentLinksQueryInputFilter>>>;
  between?: InputMaybe<PaymentLinksQueryRangeFilterInputValues>;
  equal?: InputMaybe<PaymentLinksQueryExactInputFilter>;
  iLike?: InputMaybe<PaymentLinksQueryExactInputFilter>;
  in?: InputMaybe<PaymentLinksQueryInFilterInputValues>;
  notBetween?: InputMaybe<PaymentLinksQueryRangeFilterInputValues>;
  notEqual?: InputMaybe<PaymentLinksQueryExactInputFilter>;
  notIn?: InputMaybe<PaymentLinksQueryInFilterInputValues>;
  notLike?: InputMaybe<PaymentLinksQueryExactInputFilter>;
  or?: InputMaybe<Array<PaymentLinksQueryInputFilter>>;
  textSearchCaseInsensitive?: InputMaybe<PaymentLinksQueryExactInputFilter>;
};

export type PaymentLinksQueryRangeFilterInputValues = {
  amount?: InputMaybe<FloatRangeInput>;
  createdAt?: InputMaybe<StringRangeInput>;
};

export type PaymentLinksQueryResponse = {
  __typename?: 'PaymentLinksQueryResponse';
  links: Array<Maybe<PaymentLinkObject>>;
  pageInfo: PageInfo;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  applepay?: Maybe<PaymentMethodCard>;
  card?: Maybe<PaymentMethodCard>;
  crypto?: Maybe<PaymentMethodCrypto>;
  generic?: Maybe<PaymentMethodGeneric>;
  googlepay?: Maybe<PaymentMethodCard>;
  id?: Maybe<Scalars['String']['output']>;
  netbanking?: Maybe<PaymentMethodNetbanking>;
  neteller?: Maybe<PaymentMethodNeteller>;
  paypal?: Maybe<PaymentMethodPaypal>;
  paypalBillingAgreement?: Maybe<PaymentMethodPaypalBillingAgreement>;
  paysafecard?: Maybe<PaymentMethodPaysafecard>;
  paysafecash?: Maybe<PaymentMethodPaysafecash>;
  skrill?: Maybe<PaymentMethodSkrill>;
  type?: Maybe<Scalars['String']['output']>;
  uniqueIdentifier?: Maybe<Scalars['String']['output']>;
  upi?: Maybe<PaymentMethodUpi>;
  zimpler?: Maybe<PaymentMethodZimpler>;
};

export type PaymentMethodApplePayCertificate = {
  __typename?: 'PaymentMethodApplePayCertificate';
  certificateDescription?: Maybe<Scalars['String']['output']>;
  certificateNotAfter?: Maybe<Scalars['String']['output']>;
  certificateNotBefore?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type PaymentMethodApplePayCertificates = {
  __typename?: 'PaymentMethodApplePayCertificates';
  items?: Maybe<Array<PaymentMethodApplePayCertificate>>;
};

export type PaymentMethodApplePayDomain = {
  __typename?: 'PaymentMethodApplePayDomain';
  domain: Scalars['String']['output'];
};

export type PaymentMethodApplePayDomainAssociationCertificate = {
  __typename?: 'PaymentMethodApplePayDomainAssociationCertificate';
  certificate: Scalars['String']['output'];
};

export type PaymentMethodApplePayDomains = {
  __typename?: 'PaymentMethodApplePayDomains';
  items?: Maybe<Array<PaymentMethodApplePayDomain>>;
};

export type PaymentMethodCard = {
  __typename?: 'PaymentMethodCard';
  addressLine1Check?: Maybe<VerificationResult>;
  addressPostalCodeCheck?: Maybe<VerificationResult>;
  bin?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  cardCategory?: Maybe<CardCategory>;
  cardType?: Maybe<CardType>;
  cvcCheck?: Maybe<VerificationResult>;
  expiryMonth: Scalars['String']['output'];
  expiryYear: Scalars['String']['output'];
  fingerprint?: Maybe<Scalars['String']['output']>;
  funding?: Maybe<Scalars['String']['output']>;
  issuerCountry?: Maybe<Country>;
  issuerName?: Maybe<Scalars['String']['output']>;
  lastFourDigits?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationalIdentificationNumber?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  wallet?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodCardInput = {
  bin?: InputMaybe<Scalars['String']['input']>;
  cardCategory?: InputMaybe<CardCategory>;
  cardType?: InputMaybe<CardType>;
  expiryMonth?: InputMaybe<Scalars['String']['input']>;
  expiryYear?: InputMaybe<Scalars['String']['input']>;
  fingerprint?: InputMaybe<Scalars['String']['input']>;
  issuerCountry?: InputMaybe<CountryAlpha2>;
  issuerName?: InputMaybe<Scalars['String']['input']>;
  lastFourDigits?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationalIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentMethodCardListInput = {
  addressLine1Check?: InputMaybe<Array<VerificationResult>>;
  addressPostalCodeCheck?: InputMaybe<Array<VerificationResult>>;
  bin?: InputMaybe<Array<Scalars['String']['input']>>;
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  cardCategory?: InputMaybe<Array<CardCategory>>;
  cardType?: InputMaybe<Array<CardType>>;
  cvcCheck?: InputMaybe<Array<VerificationResult>>;
  expiryMonth?: InputMaybe<Array<Scalars['String']['input']>>;
  expiryYear?: InputMaybe<Array<Scalars['String']['input']>>;
  issuerCountry?: InputMaybe<Array<CountryAlpha2>>;
  issuerName?: InputMaybe<Array<Scalars['String']['input']>>;
  lastFourDigits?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nationalIdentificationNumber?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PaymentMethodCrypto = {
  __typename?: 'PaymentMethodCrypto';
  address: Scalars['String']['output'];
  amount: Scalars['String']['output'];
  cryptoCurrency: Scalars['String']['output'];
  senderAddresses?: Maybe<Array<Scalars['String']['output']>>;
};

export type PaymentMethodGeneric = {
  __typename?: 'PaymentMethodGeneric';
  details?: Maybe<Scalars['JSON']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodGenericInput = {
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentMethodGenericListInput = {
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PaymentMethodInput = {
  card?: InputMaybe<PaymentMethodCardInput>;
  generic?: InputMaybe<PaymentMethodGenericInput>;
  paypal?: InputMaybe<PaymentMethodPaypalInput>;
  paypalBillingAgreement?: InputMaybe<PaymentMethodPaypalBillingAgreementInput>;
  paysafecard?: InputMaybe<PaymentMethodPaysafecardInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  uniqueIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentMethodListInput = {
  card?: InputMaybe<PaymentMethodCardListInput>;
  generic?: InputMaybe<PaymentMethodGenericListInput>;
  paypal?: InputMaybe<PaymentMethodPaypalListInput>;
  paypalBillingAgreement?: InputMaybe<PaymentMethodPaypalBillingAgreementListInput>;
  paysafecard?: InputMaybe<PaymentMethodPaysafecardListInput>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
  uniqueIdentifier?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PaymentMethodNetbanking = {
  __typename?: 'PaymentMethodNetbanking';
  bankCode?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodNeteller = {
  __typename?: 'PaymentMethodNeteller';
  country: Country;
  customerId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type PaymentMethodOptionsCollectionItem = {
  __typename?: 'PaymentMethodOptionsCollectionItem';
  enabled: Scalars['Boolean']['output'];
};

export type PaymentMethodPaypal = {
  __typename?: 'PaymentMethodPaypal';
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  payerId: Scalars['ID']['output'];
};

export type PaymentMethodPaypalBillingAgreement = {
  __typename?: 'PaymentMethodPaypalBillingAgreement';
  /** @deprecated use id instead */
  baId?: Maybe<Scalars['String']['output']>;
  /** @deprecated use token instead */
  baToken?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  payerId: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type PaymentMethodPaypalBillingAgreementInput = {
  baId?: InputMaybe<Scalars['String']['input']>;
  baToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  payerId?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentMethodPaypalBillingAgreementListInput = {
  baId?: InputMaybe<Array<Scalars['String']['input']>>;
  baToken?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Array<Scalars['String']['input']>>;
  payerId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PaymentMethodPaypalInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  payerId?: InputMaybe<Scalars['ID']['input']>;
};

export type PaymentMethodPaypalListInput = {
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Array<Scalars['String']['input']>>;
  payerId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PaymentMethodPaysafecard = {
  __typename?: 'PaymentMethodPaysafecard';
  amount: Scalars['Float']['output'];
  country: Country;
  currency: CurrencyAlpha3;
  customerId: Scalars['String']['output'];
  serial?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodPaysafecardInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryAlpha2>;
  currency?: InputMaybe<CurrencyAlpha3>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  serial?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentMethodPaysafecardListInput = {
  amount?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Array<CountryAlpha2>>;
  currency?: InputMaybe<Array<CurrencyAlpha3>>;
  customerId?: InputMaybe<Array<Scalars['String']['input']>>;
  serial?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PaymentMethodPaysafecash = {
  __typename?: 'PaymentMethodPaysafecash';
  customerId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type PaymentMethodSkrill = {
  __typename?: 'PaymentMethodSkrill';
  customerId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  mbTransactionId: Scalars['ID']['output'];
};

export enum PaymentMethodType {
  Applepay = 'applepay',
  Blik = 'blik',
  Card = 'card',
  Crypto = 'crypto',
  Eps = 'eps',
  Generic = 'generic',
  Giropay = 'giropay',
  Googlepay = 'googlepay',
  Ideal = 'ideal',
  Interac = 'interac',
  KlarnaPayNow = 'klarna_pay_now',
  Netbanking = 'netbanking',
  Neteller = 'neteller',
  OktoCash = 'okto_cash',
  Paypal = 'paypal',
  PaypalBillingAgreement = 'paypal_billing_agreement',
  Paysafecard = 'paysafecard',
  Paysafecash = 'paysafecash',
  Skrill = 'skrill',
  Upi = 'upi',
  Vyne = 'vyne',
  Zimpler = 'zimpler'
}

export type PaymentMethodUpi = {
  __typename?: 'PaymentMethodUpi';
  vpa?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodZimpler = {
  __typename?: 'PaymentMethodZimpler';
  accountNumber: Scalars['String']['output'];
  country: Country;
  nationalIdentificationNumber: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type PaymentMutationResponse = {
  __typename?: 'PaymentMutationResponse';
  finalize?: Maybe<Finalize>;
  transactionId: Scalars['String']['output'];
  transactionStatus: TransactionStatus;
};

export type PaymentPartial = {
  __typename?: 'PaymentPartial';
  allowPartialApproval?: Maybe<Scalars['Boolean']['output']>;
  amountCancelled?: Maybe<Scalars['Float']['output']>;
  amountCapturable?: Maybe<Scalars['Float']['output']>;
  amountReceived?: Maybe<Scalars['Float']['output']>;
  amountRefunded?: Maybe<Scalars['Float']['output']>;
  approvedAmount?: Maybe<Scalars['Float']['output']>;
  attempt?: Maybe<Scalars['Int']['output']>;
  attemptId?: Maybe<Scalars['String']['output']>;
  availablePaymentMethods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  billingDetails?: Maybe<Address>;
  billingDetailsAddressId?: Maybe<Scalars['String']['output']>;
  captureDelay?: Maybe<Scalars['String']['output']>;
  checkout?: Maybe<Scalars['Boolean']['output']>;
  checkoutCashier?: Maybe<Scalars['Boolean']['output']>;
  checkoutCashierBalance?: Maybe<Scalars['Float']['output']>;
  checkoutCashierDepositLimit?: Maybe<Scalars['Float']['output']>;
  checkoutCashierPresetAmounts?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  checkoutCashierWithdrawLimit?: Maybe<Scalars['Float']['output']>;
  checkoutLocale?: Maybe<Scalars['String']['output']>;
  checkoutSetupFutureUsage?: Maybe<Scalars['Boolean']['output']>;
  clientIp?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  consumerEmail?: Maybe<Scalars['String']['output']>;
  consumerFirstName?: Maybe<Scalars['String']['output']>;
  consumerId: Scalars['ID']['output'];
  consumerLastName?: Maybe<Scalars['String']['output']>;
  consumerMerchantConsumerId?: Maybe<Scalars['String']['output']>;
  consumerPhone?: Maybe<Scalars['String']['output']>;
  currency: CurrencyAlpha3;
  dateTime: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  finalize?: Maybe<FinalizeReadOnly>;
  id: Scalars['ID']['output'];
  lastVisitedStep?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['ID']['output'];
  merchantLegalName?: Maybe<Scalars['String']['output']>;
  mit?: Maybe<Scalars['Boolean']['output']>;
  mitReason?: Maybe<MitReason>;
  networkTransactionId?: Maybe<Scalars['String']['output']>;
  notificationUrl?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentStatus?: Maybe<PaymentStatus>;
  processor?: Maybe<Scalars['String']['output']>;
  processorTransactionId?: Maybe<Scalars['String']['output']>;
  proxyProcessor?: Maybe<Scalars['String']['output']>;
  reconciliationDate?: Maybe<Scalars['String']['output']>;
  reconciliationFailureReason?: Maybe<Scalars['String']['output']>;
  reconciliationId?: Maybe<Scalars['String']['output']>;
  reconciliationStatus?: Maybe<ReconciliationStatusEnum>;
  reconciliations?: Maybe<Array<Maybe<ReconciliationInfo>>>;
  redirectUrlFailure?: Maybe<Scalars['String']['output']>;
  redirectUrlSuccess?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  relatedRecurringTransaction?: Maybe<Scalars['String']['output']>;
  relatedTransaction?: Maybe<Scalars['String']['output']>;
  requestedAmount: Scalars['Float']['output'];
  settlement?: Maybe<PaymentSettlement>;
  settlementConversionRate?: Maybe<Scalars['Float']['output']>;
  settlementCurrency?: Maybe<Scalars['String']['output']>;
  settlementCurrencyAmount?: Maybe<Scalars['Float']['output']>;
  settlementDate?: Maybe<Scalars['String']['output']>;
  settlementId?: Maybe<Scalars['String']['output']>;
  shippingDetails?: Maybe<Address>;
  shippingDetailsAddressId?: Maybe<Scalars['String']['output']>;
  shippingFirstName?: Maybe<Scalars['String']['output']>;
  shippingLastName?: Maybe<Scalars['String']['output']>;
  shippingPhone?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['String']['output'];
  status?: Maybe<TransactionStatus>;
  subType: PaymentSubType;
  summableAmount?: Maybe<Scalars['Float']['output']>;
  termsAndConditionsAccepted?: Maybe<Scalars['Boolean']['output']>;
  termsAndConditionsAcceptedOnTransaction?: Maybe<Scalars['String']['output']>;
  threeDsAcsOperatorId?: Maybe<Scalars['String']['output']>;
  threeDsAcsReferenceNumber?: Maybe<Scalars['String']['output']>;
  threeDsAcsTransactionId?: Maybe<Scalars['String']['output']>;
  threeDsAcsUrl?: Maybe<Scalars['String']['output']>;
  threeDsAuthenticationFlow?: Maybe<Scalars['String']['output']>;
  threeDsCardHolderInfo?: Maybe<Scalars['String']['output']>;
  threeDsCavv?: Maybe<Scalars['String']['output']>;
  threeDsChallengeIndicator?: Maybe<Scalars['String']['output']>;
  threeDsChallengeRequired?: Maybe<Scalars['Boolean']['output']>;
  threeDsDsTransactionId?: Maybe<Scalars['String']['output']>;
  threeDsEci?: Maybe<Scalars['String']['output']>;
  threeDsEnrolled?: Maybe<Scalars['Boolean']['output']>;
  threeDsErrorCode?: Maybe<Scalars['String']['output']>;
  threeDsErrorDescription?: Maybe<Scalars['String']['output']>;
  threeDsPaResStatus?: Maybe<Scalars['String']['output']>;
  threeDsPayload?: Maybe<Scalars['String']['output']>;
  threeDsReasonCode?: Maybe<Scalars['String']['output']>;
  threeDsReasonDescription?: Maybe<Scalars['String']['output']>;
  threeDsResult?: Maybe<Scalars['String']['output']>;
  threeDsServerTransactionId?: Maybe<Scalars['String']['output']>;
  threeDsVersion?: Maybe<Scalars['String']['output']>;
  threeDsXid?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type PaymentRefundMutationInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  relatedTransactionId: Scalars['String']['input'];
};

export type PaymentSettlement = {
  __typename?: 'PaymentSettlement';
  amount?: Maybe<Scalars['String']['output']>;
  availableOn?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  estimated?: Maybe<Scalars['Boolean']['output']>;
  exchangeRate?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['String']['output']>;
  rollingReserve?: Maybe<RollingReserve>;
  settled?: Maybe<Scalars['Boolean']['output']>;
  settlementId?: Maybe<Scalars['String']['output']>;
};

export enum PaymentStatus {
  AuthorizationExpired = 'AUTHORIZATION_EXPIRED',
  Authorized = 'AUTHORIZED',
  Cancelled = 'CANCELLED',
  Captured = 'CAPTURED',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Error = 'ERROR',
  Expired = 'EXPIRED',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

export enum PaymentSubType {
  Independent = 'INDEPENDENT',
  Installment = 'INSTALLMENT',
  Moto = 'MOTO',
  Recurring = 'RECURRING',
  Referenced = 'REFERENCED',
  Regular = 'REGULAR'
}

export enum PaymentTypeNew {
  Authorization = 'authorization',
  Cancellation = 'cancellation',
  Chargeback = 'chargeback',
  Completion = 'completion',
  Payout = 'payout',
  Refund = 'refund',
  Representment = 'representment',
  Sale = 'sale',
  Subsequent = 'subsequent',
  Verification = 'verification'
}

export type PaymentWithTransactionsQueryResponse = {
  __typename?: 'PaymentWithTransactionsQueryResponse';
  payment: Transaction;
  transactions: Array<Transaction>;
};

export type PaymentsBreakdownByDate = {
  __typename?: 'PaymentsBreakdownByDate';
  count: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  volume: Scalars['Float']['output'];
};

export type PaymentsPrimaryKeysParams = {
  __typename?: 'PaymentsPrimaryKeysParams';
  companyIds: Array<Scalars['ID']['output']>;
  maxDate: Scalars['String']['output'];
  merchantIds: Array<Scalars['ID']['output']>;
  minDate: Scalars['String']['output'];
};

export type PaymentsPrimaryKeysParamsInput = {
  maxDate: Scalars['String']['input'];
  minDate: Scalars['String']['input'];
};

export type PaymentsResponse = {
  __typename?: 'PaymentsResponse';
  pageInfo: PageInfo;
  payments: Array<PaymentPartial>;
  primaryKeysParams?: Maybe<PaymentsPrimaryKeysParams>;
  stats?: Maybe<Array<PaymentsStats>>;
};

export type PaymentsStats = {
  __typename?: 'PaymentsStats';
  avg?: Maybe<PaymentsStatsAggregateResponseValues>;
  count?: Maybe<PaymentsStatsAggregateResponseValues>;
  currency?: Maybe<CurrencyAlpha3>;
  dateByDay?: Maybe<PaymentsStatsAggregateResponseDate>;
  dateByHour?: Maybe<PaymentsStatsAggregateResponseDate>;
  dateByMinute?: Maybe<PaymentsStatsAggregateResponseDate>;
  dateByMonth?: Maybe<PaymentsStatsAggregateResponseDate>;
  dateBySecond?: Maybe<PaymentsStatsAggregateResponseDate>;
  dateByWeek?: Maybe<PaymentsStatsAggregateResponseDate>;
  dateByYear?: Maybe<PaymentsStatsAggregateResponseDate>;
  finalize?: Maybe<Finalize>;
  lastVisitedStep?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  status?: Maybe<TransactionStatus>;
  sum?: Maybe<PaymentsStatsAggregateResponseValues>;
};

export type PaymentsStatsAggregateResponseDate = {
  __typename?: 'PaymentsStatsAggregateResponseDate';
  dateTime: Scalars['String']['output'];
};

export type PaymentsStatsAggregateResponseValues = {
  __typename?: 'PaymentsStatsAggregateResponseValues';
  amount?: Maybe<Scalars['Float']['output']>;
  amountCancelled?: Maybe<Scalars['Float']['output']>;
  amountCapturable?: Maybe<Scalars['Float']['output']>;
  amountReceived?: Maybe<Scalars['Float']['output']>;
  amountRefunded?: Maybe<Scalars['Float']['output']>;
  approvedAmount?: Maybe<Scalars['Float']['output']>;
  requestedAmount?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type Payout = {
  __typename?: 'Payout';
  id: Scalars['String']['output'];
};

export type PaypalPaymentMethodOptions = {
  __typename?: 'PaypalPaymentMethodOptions';
  nameVerification: Scalars['Boolean']['output'];
};

export type Permission = {
  __typename?: 'Permission';
  category: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type PotentialDuplicateIndividualsResponse = {
  __typename?: 'PotentialDuplicateIndividualsResponse';
  pageInfo: PageInfo;
  rows?: Maybe<Array<IndividualsPair>>;
};

export type PricingAction = {
  __typename?: 'PricingAction';
  action: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  forbiddenWith?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type PricingActionInput = {
  action: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  forbiddenWith?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PricingActions = {
  __typename?: 'PricingActions';
  pricingActions: Array<PricingAction>;
};

export type PricingConfigAction = {
  __typename?: 'PricingConfigAction';
  applyAsApplicationFee?: Maybe<Scalars['Boolean']['output']>;
  applyAsNetworkFee?: Maybe<Scalars['Boolean']['output']>;
  basisFeeDescription?: Maybe<Scalars['String']['output']>;
  basisPoints?: Maybe<Scalars['String']['output']>;
  fixedFee?: Maybe<Scalars['String']['output']>;
  fixedFeeDescription?: Maybe<Scalars['String']['output']>;
  grossBasisPoints?: Maybe<Scalars['Boolean']['output']>;
  grossFixed?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
};

export type PricingConfigActionInput = {
  applyAsApplicationFee?: InputMaybe<Scalars['Boolean']['input']>;
  applyAsNetworkFee?: InputMaybe<Scalars['Boolean']['input']>;
  basisFeeDescription?: InputMaybe<Scalars['String']['input']>;
  basisPoints?: InputMaybe<Scalars['String']['input']>;
  fixedFee?: InputMaybe<Scalars['String']['input']>;
  fixedFeeDescription?: InputMaybe<Scalars['String']['input']>;
  grossBasisPoints?: InputMaybe<Scalars['Boolean']['input']>;
  grossFixed?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
};

export type PricingConfigAlternativeCurrency = {
  __typename?: 'PricingConfigAlternativeCurrency';
  actions?: Maybe<Array<PricingConfigAction>>;
  alternativePaymentMethods?: Maybe<Array<PricingConfigAlternativePaymentMethod>>;
  key: Scalars['String']['output'];
  settlementFees?: Maybe<Array<PricingConfigAction>>;
};

export type PricingConfigAlternativeCurrencyInput = {
  actions?: InputMaybe<Array<PricingConfigActionInput>>;
  alternativePaymentMethods?: InputMaybe<Array<PricingConfigAlternativePaymentMethodInput>>;
  key: Scalars['String']['input'];
  settlementFees?: InputMaybe<Array<PricingConfigActionInput>>;
};

export type PricingConfigAlternativePaymentMethod = {
  __typename?: 'PricingConfigAlternativePaymentMethod';
  actions?: Maybe<Array<PricingConfigAction>>;
  blended?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
};

export type PricingConfigAlternativePaymentMethodInput = {
  actions?: InputMaybe<Array<PricingConfigActionInput>>;
  blended?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
};

export type PricingConfigSettlementFee = {
  __typename?: 'PricingConfigSettlementFee';
  actions?: Maybe<Array<PricingConfigAction>>;
  key: Scalars['String']['output'];
};

export type PricingConfigSettlementFeeInput = {
  actions?: InputMaybe<Array<PricingConfigActionInput>>;
  key: Scalars['String']['input'];
};

export type PricingInput = {
  actions?: InputMaybe<Array<PricingConfigActionInput>>;
  alternativeCurrencies?: InputMaybe<Array<PricingConfigAlternativeCurrencyInput>>;
  alternativePaymentMethods?: InputMaybe<Array<PricingConfigAlternativePaymentMethodInput>>;
  blended?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  fundingDelay?: InputMaybe<Scalars['String']['input']>;
  maximumHeldReserve?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  monthlyMerchantFee?: InputMaybe<Scalars['String']['input']>;
  monthlyMinimumFee?: InputMaybe<Scalars['String']['input']>;
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  rollingReserveAmount?: InputMaybe<Scalars['String']['input']>;
  rollingReserveDuration?: InputMaybe<Scalars['String']['input']>;
  rollingReserveEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  rollingReserveType?: InputMaybe<RollingReserveTypes>;
  settlementAccountId: Scalars['String']['input'];
  settlementDay?: InputMaybe<Scalars['Int']['input']>;
  settlementFees?: InputMaybe<Array<PricingConfigSettlementFeeInput>>;
  settlementSchedule?: InputMaybe<SettlementScheduleConfigEnum>;
};

export type PricingList = {
  __typename?: 'PricingList';
  pricingConfigs?: Maybe<Array<PricingObject>>;
};

export type PricingObject = {
  __typename?: 'PricingObject';
  actions?: Maybe<Array<PricingConfigAction>>;
  alternativeCurrencies?: Maybe<Array<PricingConfigAlternativeCurrency>>;
  alternativePaymentMethods?: Maybe<Array<PricingConfigAlternativePaymentMethod>>;
  blended?: Maybe<Scalars['Boolean']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  fundingDelay?: Maybe<Scalars['String']['output']>;
  maximumHeldReserve?: Maybe<Scalars['String']['output']>;
  monthlyMerchantFee?: Maybe<Scalars['String']['output']>;
  monthlyMinimumFee?: Maybe<Scalars['String']['output']>;
  paymentMethodType?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  rollingReserveAmount?: Maybe<Scalars['String']['output']>;
  rollingReserveDuration?: Maybe<Scalars['String']['output']>;
  rollingReserveEnabled?: Maybe<Scalars['Boolean']['output']>;
  rollingReserveType?: Maybe<RollingReserveTypes>;
  settlementAccountId?: Maybe<Scalars['String']['output']>;
  settlementDay?: Maybe<Scalars['Int']['output']>;
  settlementFees?: Maybe<Array<PricingConfigSettlementFee>>;
  settlementSchedule?: Maybe<SettlementScheduleConfigEnum>;
};

export enum PricingSegmentCode {
  AllStar = 'all_star',
  AmericanExpress = 'american_express',
  Amex = 'amex',
  Discover = 'discover',
  DiscoverDinersClub = 'discover_diners_club',
  Jcb = 'jcb',
  Keyfuels = 'keyfuels',
  Laser = 'laser',
  Mastercard = 'mastercard',
  MastercardBusiness = 'mastercard_business',
  MastercardCommercial = 'mastercard_commercial',
  MastercardCorporate = 'mastercard_corporate',
  MastercardCreditPersonal = 'mastercard_credit_personal',
  MastercardDebitCommercial = 'mastercard_debit_commercial',
  MastercardDebitPersonalInternational = 'mastercard_debit_personal_international',
  MastercardDirectCommercialInternational = 'mastercard_direct_commercial_international',
  MastercardDirectEea = 'mastercard_direct_eea',
  MastercardDirectPersonalInternational = 'mastercard_direct_personal_international',
  MastercardFleet = 'mastercard_fleet',
  MastercardMaestroCommercial = 'mastercard_maestro_commercial',
  MastercardMaestroInternationalCommercial = 'mastercard_maestro_international_commercial',
  MastercardMaestroInternationalPersonal = 'mastercard_maestro_international_personal',
  MastercardMaestroPersonal = 'mastercard_maestro_personal',
  MastercardPurchase = 'mastercard_purchase',
  MastercardSignia = 'mastercard_signia',
  MastercardWorld = 'mastercard_world',
  Overdrive = 'overdrive',
  Sears = 'sears',
  Supercharge = 'supercharge',
  Visa = 'visa',
  VisaBusiness = 'visa_business',
  VisaCommerce = 'visa_commerce',
  VisaCorporate = 'visa_corporate',
  VisaCreditPersonal = 'visa_credit_personal',
  VisaDebitCommercial = 'visa_debit_commercial',
  VisaDebitPersonal = 'visa_debit_personal',
  VisaDirectCommercialInternational = 'visa_direct_commercial_international',
  VisaDirectPersonalInternational = 'visa_direct_personal_international',
  VisaElectron = 'visa_electron',
  VisaElectronCredit = 'visa_electron_credit',
  VisaElectronPersonalInternational = 'visa_electron_personal_international',
  VisaPurchasing = 'visa_purchasing'
}

export type ProcessingFeesBreakdown = {
  __typename?: 'ProcessingFeesBreakdown';
  amex?: Maybe<SettlementFeesDetails>;
  discover?: Maybe<SettlementFeesDetails>;
  mastercard?: Maybe<SettlementFeesDetails>;
  visa?: Maybe<SettlementFeesDetails>;
};

export type ProcessingFeesBreakdownByCardProduct = {
  __typename?: 'ProcessingFeesBreakdownByCardProduct';
  business?: Maybe<SettlementFeesDetails>;
  consumer?: Maybe<SettlementFeesDetails>;
  unknown?: Maybe<SettlementFeesDetails>;
};

export type ProcessingFeesBreakdownByCardProductInput = {
  business?: InputMaybe<SettlementFeesDetailsInput>;
  consumer?: InputMaybe<SettlementFeesDetailsInput>;
  unknown?: InputMaybe<SettlementFeesDetailsInput>;
};

export type ProcessingFeesBreakdownByCardType = {
  __typename?: 'ProcessingFeesBreakdownByCardType';
  credit?: Maybe<ProcessingFeesBreakdownByCardProduct>;
  debit?: Maybe<ProcessingFeesBreakdownByCardProduct>;
  prepaid?: Maybe<ProcessingFeesBreakdownByCardProduct>;
  unknown?: Maybe<ProcessingFeesBreakdownByCardProduct>;
};

export type ProcessingFeesBreakdownByCardTypeInput = {
  credit?: InputMaybe<ProcessingFeesBreakdownByCardProductInput>;
  debit?: InputMaybe<ProcessingFeesBreakdownByCardProductInput>;
  prepaid?: InputMaybe<ProcessingFeesBreakdownByCardProductInput>;
  unknown?: InputMaybe<ProcessingFeesBreakdownByCardProductInput>;
};

export type ProcessingFeesBreakdownByJurisdiction = {
  __typename?: 'ProcessingFeesBreakdownByJurisdiction';
  domestic?: Maybe<ProcessingFeesBreakdownByCardType>;
  international?: Maybe<ProcessingFeesBreakdownByCardType>;
  intraregional?: Maybe<ProcessingFeesBreakdownByCardType>;
};

export type ProcessingFeesBreakdownByJurisdictionInput = {
  domestic?: InputMaybe<ProcessingFeesBreakdownByCardTypeInput>;
  international?: InputMaybe<ProcessingFeesBreakdownByCardTypeInput>;
  intraregional?: InputMaybe<ProcessingFeesBreakdownByCardTypeInput>;
};

export type ProcessingFeesBreakdownDetailed = {
  __typename?: 'ProcessingFeesBreakdownDetailed';
  amex?: Maybe<ProcessingFeesBreakdownByJurisdiction>;
  discover?: Maybe<ProcessingFeesBreakdownByJurisdiction>;
  mastercard?: Maybe<ProcessingFeesBreakdownByJurisdiction>;
  visa?: Maybe<ProcessingFeesBreakdownByJurisdiction>;
};

export type ProcessingFeesBreakdownDetailedInput = {
  amex?: InputMaybe<ProcessingFeesBreakdownByJurisdictionInput>;
  discover?: InputMaybe<ProcessingFeesBreakdownByJurisdictionInput>;
  mastercard?: InputMaybe<ProcessingFeesBreakdownByJurisdictionInput>;
  visa?: InputMaybe<ProcessingFeesBreakdownByJurisdictionInput>;
};

export type ProcessingFeesBreakdownInput = {
  amex?: InputMaybe<SettlementFeesDetailsInput>;
  discover?: InputMaybe<SettlementFeesDetailsInput>;
  mastercard?: InputMaybe<SettlementFeesDetailsInput>;
  visa?: InputMaybe<SettlementFeesDetailsInput>;
};

export type ProcessorConfig = {
  __typename?: 'ProcessorConfig';
  retryProviders?: Maybe<Array<Scalars['String']['output']>>;
  settlementAccountId?: Maybe<Scalars['String']['output']>;
};

export type ProcessorConfigInput = {
  retryProviders?: InputMaybe<Array<Scalars['String']['input']>>;
  settlementAccountId?: InputMaybe<Scalars['String']['input']>;
};

export enum ProductSupplyTimeRange {
  EightToFifteenBusinessDays = 'eight_to_fifteen_business_days',
  FourToSevenBusinessDays = 'four_to_seven_business_days',
  Immediate = 'immediate',
  OneToThreeBusinessDays = 'one_to_three_business_days',
  SixteenToTwentyBusinessDays = 'sixteen_to_twenty_business_days',
  TwentyOnePlusBusinessDays = 'twenty_one_plus_business_days'
}

export enum ProofOfResidenceDocumentType {
  BankStatement = 'bank_statement',
  DrivingLicense = 'driving_license',
  HouseInsurance = 'house_insurance',
  LeaseRentalAgreement = 'lease_rental_agreement',
  LocalTaxBill = 'local_tax_bill',
  MortgageStatement = 'mortgage_statement',
  UtilityBill = 'utility_bill'
}

export type ProviderData = {
  __typename?: 'ProviderData';
  infinicept?: Maybe<ProviderMethodInfinicept>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  providerErrors?: Maybe<OnboardingProviderErrors>;
  providerMaId?: Maybe<Scalars['String']['output']>;
  providerMerchantId?: Maybe<Scalars['String']['output']>;
  providerStatus?: Maybe<Scalars['String']['output']>;
  underwritingResultsUrl?: Maybe<Scalars['String']['output']>;
};

export type ProviderDataInput = {
  infinicept?: InputMaybe<ProviderMethodInfiniceptInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  providerMaId?: InputMaybe<Scalars['String']['input']>;
  providerMerchantId?: InputMaybe<Scalars['String']['input']>;
  providerResponse?: InputMaybe<Scalars['String']['input']>;
  providerStatus?: InputMaybe<Scalars['String']['input']>;
  underwritingResultsUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderFeatures = {
  __typename?: 'ProviderFeatures';
  amex: Scalars['Boolean']['output'];
  authorization: Scalars['Boolean']['output'];
  cancelMultiple: Scalars['Boolean']['output'];
  cancelPartial: Scalars['Boolean']['output'];
  captureMultiple: Scalars['Boolean']['output'];
  capturePartial: Scalars['Boolean']['output'];
  defaultPrecision: Scalars['String']['output'];
  discover: Scalars['Boolean']['output'];
  externalSettlement: Scalars['Boolean']['output'];
  incrementalAuthorization: Scalars['Boolean']['output'];
  interchangeFeeCostType: Scalars['String']['output'];
  internalSettlement: Scalars['Boolean']['output'];
  mastercard: Scalars['Boolean']['output'];
  networkFeeCostType: Scalars['String']['output'];
  paymentMethodType: Scalars['String']['output'];
  payout: Scalars['Boolean']['output'];
  processingCurrencyCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** map<string, string> */
  processingToSettlementsCurrencyCodes?: Maybe<Scalars['JSON']['output']>;
  provider: Scalars['String']['output'];
  refundMultiple: Scalars['Boolean']['output'];
  refundPartial: Scalars['Boolean']['output'];
  sale: Scalars['Boolean']['output'];
  settlementCurrencyCodes?: Maybe<Array<Scalars['String']['output']>>;
  verification: Scalars['Boolean']['output'];
  visa: Scalars['Boolean']['output'];
};

export type ProviderFeaturesMutationResponse = {
  __typename?: 'ProviderFeaturesMutationResponse';
  payload: ProviderFeaturesPayload;
  success: Scalars['Boolean']['output'];
};

export type ProviderFeaturesPayload = {
  __typename?: 'ProviderFeaturesPayload';
  provider: Scalars['String']['output'];
};

export type ProviderFeaturesQueryInput = {
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
};

export type ProviderMethodInfinicept = {
  __typename?: 'ProviderMethodInfinicept';
  acceptableUse?: Maybe<InfiniceptCategory>;
  credit?: Maybe<InfiniceptCategory>;
  fraud?: Maybe<InfiniceptCategory>;
  kycBusiness?: Maybe<InfiniceptCategory>;
  kycPersonal?: Maybe<InfiniceptCategory>;
  social?: Maybe<InfiniceptCategory>;
};

export type ProviderMethodInfiniceptInput = {
  acceptableUse?: InputMaybe<InfiniceptCategoryInput>;
  credit?: InputMaybe<InfiniceptCategoryInput>;
  fraud?: InputMaybe<InfiniceptCategoryInput>;
  kycBusiness?: InputMaybe<InfiniceptCategoryInput>;
  kycPersonal?: InputMaybe<InfiniceptCategoryInput>;
  social?: InputMaybe<InfiniceptCategoryInput>;
};

export type ProviderRequestsQueryInput = {
  transactionId: Scalars['ID']['input'];
};

export type ProviderRequestsQueryResponse = {
  __typename?: 'ProviderRequestsQueryResponse';
  requests: Array<LogEntry>;
};

export type Provisioning = {
  __typename?: 'Provisioning';
  companyId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['ID']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  merchants?: Maybe<Array<Maybe<ProvisioningMerchant>>>;
  onboardingPricingId?: Maybe<Scalars['ID']['output']>;
  pricingActions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  settlementAccountId?: Maybe<Scalars['ID']['output']>;
  settlementCurrency?: Maybe<CurrencyAlpha3>;
  shouldCreateNewMerchants?: Maybe<Scalars['Boolean']['output']>;
  shouldCreateSettlementAccount?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<ProvisioningStatus>;
  submissionValues?: Maybe<Array<Maybe<ProvisioningValue>>>;
  templateId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  workflowId?: Maybe<Scalars['String']['output']>;
  workflowName?: Maybe<Scalars['String']['output']>;
};

export type ProvisioningMerchant = {
  __typename?: 'ProvisioningMerchant';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProvisioningMerchantInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProvisioningQueryInput = {
  id: Scalars['ID']['input'];
};

export enum ProvisioningStatus {
  Created = 'created',
  Failed = 'failed',
  Succeeded = 'succeeded'
}

export type ProvisioningTemplate = {
  __typename?: 'ProvisioningTemplate';
  archived?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  disposable?: Maybe<Scalars['Boolean']['output']>;
  fields?: Maybe<Array<TaskField>>;
  groups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  merchantFacing?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  requirePricingActions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requirePricingOnboarding?: Maybe<Scalars['Boolean']['output']>;
  shouldCreateSettlementAccount?: Maybe<Scalars['Boolean']['output']>;
  validationConfig?: Maybe<Array<ValidationConfig>>;
  workflowName: Scalars['String']['output'];
};

export type ProvisioningTemplates = {
  __typename?: 'ProvisioningTemplates';
  provisioningTemplates?: Maybe<Array<Maybe<ProvisioningTemplate>>>;
};

export type ProvisioningTemplatesQueryInput = {
  disposable?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Array<Scalars['String']['input']>>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  merchantFacing?: InputMaybe<Scalars['Boolean']['input']>;
  shouldCreateSettlementAccount?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProvisioningValue = {
  __typename?: 'ProvisioningValue';
  key: Scalars['String']['output'];
  value: TaskFieldValue;
};

export type ProvisioningsQueryInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  settlementAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type ProvisioningsQueryResponse = {
  __typename?: 'ProvisioningsQueryResponse';
  provisionings: Array<Provisioning>;
};

export enum PsdTwoClassification {
  MicroEnterprise = 'micro_enterprise',
  NonMicroEnterprise = 'non_micro_enterprise'
}

export type Query = {
  __typename?: 'Query';
  accountNotifications?: Maybe<Array<NotificationGroupObject>>;
  adjustmentBreakdown: AdjustmentBreakdownQueryResponse;
  allDashboards: GetAllDashboardsResponse;
  allEmployees: AllEmployeesResponse;
  allowedEndpoints?: Maybe<Array<Scalars['String']['output']>>;
  apiKeys: ApiKeysQueryResponse;
  apmConfigurations: ApmConfigurationQueryResponse;
  applePayCertificates: PaymentMethodApplePayCertificates;
  applePayDomainAssociationCertificate: PaymentMethodApplePayDomainAssociationCertificate;
  applePayDomains: PaymentMethodApplePayDomains;
  bankAccountByType: BankAccount;
  bankAccounts: Array<BankAccount>;
  bankAccountsByParams: BankAccountsByParamsResponse;
  bankCountries: Array<BankCountryOption>;
  bankTransfers: BankTransfersResponse;
  browserIpAddress?: Maybe<Scalars['String']['output']>;
  chargebackReason?: Maybe<ChargebackReason>;
  chargebackReasons: ChargebackReasonsQueryResponse;
  checkTenantAuth: CheckTenantAuthResponse;
  collaborations: CollaborationsQueryResponse;
  collaborationsCsvReport: CollaborationsCsvReportResponse;
  commissions: Array<Commission>;
  consumer: ConsumerObject;
  consumerBlocked: ConsumerBlockedQueryResponse;
  consumerExcludedFromAllRules: ConsumerExcludedFromAllRulesQueryResponse;
  consumerInsights: ConsumerInsightsResponse;
  consumerRuleExclusions: ConsumerRuleExclusionsQueryResponse;
  consumerRuleExclusionsCsvReport: ConsumerRuleExclusionsCsvReportResponse;
  consumers: ConsumersResponse;
  cost: Cost;
  costs: Array<Cost>;
  countries: Array<Country>;
  country: Country;
  crmField: CrmField;
  crmFieldsDefinitions: CrmFields;
  csvReport: CreateCsvReportQueryResponse;
  currencies: Array<Currency>;
  customers: CustomersResponse;
  dashboardAudits: DashboardAuditsResponse;
  dashboardFeatureFlags: Array<DashboardFeatureFlagsResponse>;
  declineMessages: DeclineMessages;
  dispute?: Maybe<Dispute>;
  disputes: DisputesQueryResponse;
  disputesByMerchants: DisputesByMerchantsQueryResponse;
  disputesCsvReport: DisputesCsvReportResponse;
  disputesFraudOverview: DisputesFraudQueryResponse;
  disputesLite: DisputesQueryResponse;
  disputesOverview: DisputesOverviewQueryResponse;
  documentUploadToken: DocumentUploadToken;
  documentUrl: DocumentUploadUrl;
  documents: Documents;
  documentsByIds: Documents;
  documentsFindByParams: DocumentsFindByParamsQueryResponse;
  doesPaypassNeedCodeAuthentication?: Maybe<DoesPaypassNeedCodeAuthenticationPayload>;
  downloadAllLegalEntityDocuments: DownloadAllLegalEntityDocumentsResponse;
  employeeGroups: EmployeesGroupsResponse;
  employeesByGroupValue: EmployeesByGroupResponse;
  employeesByGroupValues: EmployeesByGroupsResponse;
  employeesGroups: EmployeesGroupsResponse;
  entityMccs?: Maybe<GetEntityMccsResponse>;
  entityOnboardingPricingList?: Maybe<GetEntityOnboardingPricingListResponse>;
  entityPrimaryContact: IndividualObject;
  entityWebsites?: Maybe<GetEntityWebsitesResponse>;
  envFeatureFlags: Array<FeatureFlag>;
  exportFields: ExportFields;
  exportTableFields: ExportTableFieldsQueryResponse;
  featureFlag: FeatureFlag;
  featureFlags: Array<FeatureFlag>;
  finance: FinanceObject;
  getAllDocumentTypes: DocumentTypesList;
  getAllFailureCodeMessages: GetAllFailureCodeMessagesQueryResponse;
  getCustomerSupportLink: GetCustomerSupportLinkResponse;
  getDocumentType?: Maybe<DocumentType>;
  getDocumentTypesByTypeAndRegion: DocumentTypesList;
  getIndividualApplicableVerificationCheck?: Maybe<VerificationChecksList>;
  getIndividualsVerificationChecks?: Maybe<VerificationChecksList>;
  getMerchantApplicableVerificationChecks?: Maybe<VerificationChecksList>;
  getProvisioning?: Maybe<Provisioning>;
  getProvisioningTemplate?: Maybe<ProvisioningTemplate>;
  getProvisioningTemplates?: Maybe<ProvisioningTemplates>;
  getProvisionings?: Maybe<ProvisioningsQueryResponse>;
  getRulesForMerchant: RiskRulesForMerchantQueryResponse;
  googlepayConfig: GooglepayConfigQueryResponse;
  individual: IndividualObject;
  individualRelations: IndividualRelationsResponse;
  individuals: IndividualsResponse;
  isPaypassStandaloneSetupCompleted?: Maybe<IsPaypassStandaloneSetupCompletedPayload>;
  isPublicKeyExist: Scalars['Boolean']['output'];
  latestRiskCalculation?: Maybe<RiskCalculation>;
  logs: LogsQueryResponse;
  logsByTransactionId?: Maybe<LogsByTransactionIdResponse>;
  manualSettlementBalance: ManualSettlementBalanceResponse;
  mcc: Mcc;
  mccs?: Maybe<MccsQueryResponse>;
  merchant: Merchant;
  merchantApplication?: Maybe<MerchantApplication>;
  merchantApplications: MerchantApplicationResponse;
  merchantApprovals: MerchantApprovalsQueryResponse;
  merchantConnections: MerchantConnectionsQueryResponse;
  merchantCrmFieldValue: MerchantCrmFieldValue;
  merchantCrmFieldsValues: MerchantCrmFieldsValues;
  merchantDashboardToken: GetMerchantDashboardTokenResponse;
  merchantDashboards: GetMerchantDashboardsResponse;
  merchantDefaultExportFields: ExportFields;
  merchantFilteredRules: MerchantFilteredRulesResponse;
  merchantInsights: MerchantInsightsObject;
  merchantLists: RiskMerchantListsQueryResponse;
  merchantLogicFields: LogicFields;
  merchantPaymentMethodConfigs: Array<MerchantPaymentMethodConfig>;
  merchantPricingConfigs: PricingList;
  merchantSettings: MerchantSettings;
  merchants: MerchantsResponse;
  merchantsUnderRule: MerchantsResponse;
  nestedIndividuals: NestedIndividualsResponse;
  nextSettlement: NextSettlementQueryResponse;
  notes: Array<NoteObject>;
  onboardingEvents: OnboardingEventsResponse;
  onboardingPricing?: Maybe<OnboardingPricing>;
  onboardingPricingFields?: Maybe<GetOnboardingPricingFieldsResponse>;
  onboardingPricingList: OnboardingPricingResponse;
  onboardingRiskRule: OnboardingRiskRule;
  onboardingRiskRules: OnboardingRiskRules;
  openPrs?: Maybe<GitHubPullRequestResponse>;
  packageOrSubscriptionAudits: PackageOrSubscriptionAuditsQueryResponse;
  paymentFees?: Maybe<Array<PaymentFee>>;
  paymentFeesByParams: PaymentFeesPaginated;
  paymentLink: PaymentLinkObject;
  paymentLinkPerformance: PaymentLinkPerformance;
  paymentLinks: PaymentLinksQueryResponse;
  paymentWithTransactions: PaymentWithTransactionsQueryResponse;
  payments: PaymentsResponse;
  potentialDuplicateIndividuals: PotentialDuplicateIndividualsResponse;
  pricing?: Maybe<PricingObject>;
  pricingAction: PricingAction;
  pricingActions: PricingActions;
  providerFeatures: ProviderFeatures;
  providerRequests?: Maybe<ProviderRequestsQueryResponse>;
  providersFeatures: Array<ProviderFeatures>;
  rawReportDownloadUrl?: Maybe<Scalars['String']['output']>;
  rawReports?: Maybe<RawReports>;
  reconciliationConfigs: ReconciliationConfigQueryResponse;
  referral: ReferralObject;
  referrals: Array<ReferralObject>;
  reportsConfig: ReportsConfig;
  reserves: ReservesResponse;
  reservesBySettlementId: ReservesBySettlementIdResponse;
  reservesNextRelease: ReservesNextReleaseResponse;
  reservesTotalAmount: Scalars['Float']['output'];
  revealApiKey: RevealApiKeyResponse;
  riskAlert: RiskAlert;
  riskAlerts: RiskAlertsQueryResponse;
  riskAlertsByIds: RiskAlertsByIdsQueryResponse;
  riskAlertsByMerchants: RiskAlertsByMerchantsQueryResponse;
  riskAllListValues: RiskAllListsValuesQueryResponse;
  riskCalculations: Array<RiskCalculation>;
  riskCalculatorConfig: RiskCalculatorConfig;
  riskList: RiskList;
  riskListValues: RiskListsValuesQueryResponse;
  riskListValuesSearch: RiskListValuesSearchQueryResponse;
  riskLists: RiskListsQueryResponse;
  riskReviews: RiskReviewQueryResponse;
  riskReviewsByReference: RiskReviewsByReferenceResponse;
  roles: RolesQueryResponse;
  routineLogs: RoutineLogsResponse;
  routineTemplate?: Maybe<RoutineTemplateDetails>;
  routineTemplates?: Maybe<RoutineTemplates>;
  rule: RuleQueryResponse;
  ruleLogs: RiskRuleLogsQueryResponse;
  ruleNumericValues: MerchantsUnderRuleResponse;
  rules: RiskRulesQueryResponse;
  rulesByResourceType: RulesByResourceTypeQueryResponse;
  sdkEvents: SdkEventsQueryResponse;
  settlement: SettlementObject;
  settlementAccounts: SettlementAccountsQueryResponse;
  settlementAccountsWithTasks: Array<Scalars['String']['output']>;
  settlementStatement: SettlementStatementQueryResponse;
  settlementTransactionsStats: SettlementTransactionsStatsQueryResponse;
  settlements: SettlementsResponse;
  sources: CustomerPaymentSourceResponse;
  structure: Structure;
  structures: StructuresQueryResponse;
  structuresByCountry: StructuresQueryResponse;
  subscription: Subscription;
  subscriptionPackage: SubscriptionPackage;
  subscriptionPackages: SubscriptionPackagesQueryResponse;
  subscriptions: SubscriptionsQueryResponse;
  task: TaskDetail;
  taskCategories: TaskCategoriesResponse;
  taskGroupTemplates: TaskGroupTemplatesQueryResponse;
  taskTemplate: TaskTemplateDetail;
  taskTemplates: TaskTemplatesQueryResponse;
  tasks: TasksQueryResponse;
  traceIds?: Maybe<TraceIds>;
  transaction: Transaction;
  transactions: TransactionsQueryResponse;
  transactionsBalance: TransactionsBalanceQueryResponse;
  transactionsCsvReport?: Maybe<TransactionsCsvReport>;
  uniqueIssuerResponseCodes: Array<Scalars['String']['output']>;
  user: User;
  userInfo: UserInfo;
  userManagementAudits: UserManagementAuditsQueryResponse;
  users: UsersQueryResponse;
  vatInfo: VatInfo;
  webhook: Webhook;
  webhookEventTypes: WebhookEventTypesQueryResponse;
  webhooks: WebhooksQueryResponse;
  workflows?: Maybe<Array<Workflow>>;
};


export type QueryAdjustmentBreakdownArgs = {
  input: AdjustmentBreakdownQueryInput;
};


export type QueryBankAccountByTypeArgs = {
  input: BankAccountByTypeQueryInput;
};


export type QueryBankAccountsArgs = {
  input?: InputMaybe<BankAccountsQueryInput>;
};


export type QueryBankAccountsByParamsArgs = {
  input: BankAccountsByParamsQueryInput;
};


export type QueryBankTransfersArgs = {
  input: BankTransfersQueryInput;
};


export type QueryChargebackReasonArgs = {
  input: ChargebackReasonQueryInput;
};


export type QueryCheckTenantAuthArgs = {
  input: CheckTenantAuthInput;
};


export type QueryCollaborationsArgs = {
  input: CollaborationsQueryInput;
};


export type QueryCollaborationsCsvReportArgs = {
  input: CollaborationsCsvReportQueryInput;
};


export type QueryConsumerArgs = {
  input: ConsumerQueryInput;
};


export type QueryConsumerBlockedArgs = {
  input: ConsumerBlockedQueryInput;
};


export type QueryConsumerExcludedFromAllRulesArgs = {
  input: ConsumerExcludedFromAllRulesQueryInput;
};


export type QueryConsumerInsightsArgs = {
  input: ConsumerInsightsQueryInput;
};


export type QueryConsumerRuleExclusionsArgs = {
  input: ConsumerRuleExclusionsQueryInput;
};


export type QueryConsumerRuleExclusionsCsvReportArgs = {
  input: ConsumerRuleExclusionsCsvReportQueryInput;
};


export type QueryConsumersArgs = {
  input: ConsumersQueryInput;
};


export type QueryCostArgs = {
  input: CostQueryInput;
};


export type QueryCountryArgs = {
  input: CountryQueryInput;
};


export type QueryCrmFieldArgs = {
  input: GetCrmFieldRequest;
};


export type QueryCsvReportArgs = {
  input?: InputMaybe<CreateCsvReportFilterInputValues>;
};


export type QueryCustomersArgs = {
  input: CustomersQueryInput;
};


export type QueryDashboardAuditsArgs = {
  input: DashboardAuditsInput;
};


export type QueryDisputeArgs = {
  input: DisputeQueryInput;
};


export type QueryDisputesArgs = {
  input?: InputMaybe<DisputesQueryInput>;
};


export type QueryDisputesByMerchantsArgs = {
  input?: InputMaybe<DisputesByMerchantsQueryInput>;
};


export type QueryDisputesCsvReportArgs = {
  input: DisputesCsvReportQueryInput;
};


export type QueryDisputesLiteArgs = {
  input?: InputMaybe<DisputesQueryInput>;
};


export type QueryDisputesOverviewArgs = {
  input?: InputMaybe<DisputesOverviewQueryInput>;
};


export type QueryDocumentUrlArgs = {
  input: DocumentUrlQueryInput;
};


export type QueryDocumentsArgs = {
  input: DocumentsList;
};


export type QueryDocumentsByIdsArgs = {
  input: DocumentsByIdsInput;
};


export type QueryDocumentsFindByParamsArgs = {
  input?: InputMaybe<DocumentsFindByParamsQueryInput>;
};


export type QueryDownloadAllLegalEntityDocumentsArgs = {
  input: DownloadAllLegalEntityDocumentsInput;
};


export type QueryEmployeeGroupsArgs = {
  input: EmployeeGroupsInput;
};


export type QueryEmployeesByGroupValueArgs = {
  input: EmployeesByGroupValueInput;
};


export type QueryEmployeesByGroupValuesArgs = {
  input: EmployeesByGroupValuesInput;
};


export type QueryEntityMccsArgs = {
  input?: InputMaybe<GetEntityMccsInput>;
};


export type QueryEntityPrimaryContactArgs = {
  input: GetEntityPrimaryContactInput;
};


export type QueryEntityWebsitesArgs = {
  input: GetEntityWebsitesInput;
};


export type QueryExportTableFieldsArgs = {
  input: ExportTableFieldsQueryInput;
};


export type QueryFeatureFlagArgs = {
  input: FeatureFlagQueryInput;
};


export type QueryFinanceArgs = {
  input: GetFinanceInput;
};


export type QueryGetDocumentTypeArgs = {
  input: GetDocumentTypeInput;
};


export type QueryGetDocumentTypesByTypeAndRegionArgs = {
  input: GetDocumentTypesByTypeAndRegionInput;
};


export type QueryGetIndividualApplicableVerificationCheckArgs = {
  input: CompanyMerchantIndividualInput;
};


export type QueryGetIndividualsVerificationChecksArgs = {
  input: IndividualsVerificationChecksInput;
};


export type QueryGetMerchantApplicableVerificationChecksArgs = {
  input: CompanyAndMerchantInput;
};


export type QueryGetProvisioningArgs = {
  input: ProvisioningQueryInput;
};


export type QueryGetProvisioningTemplateArgs = {
  input: GetProvisioningTemplateQueryInput;
};


export type QueryGetProvisioningTemplatesArgs = {
  input?: InputMaybe<ProvisioningTemplatesQueryInput>;
};


export type QueryGetProvisioningsArgs = {
  input: ProvisioningsQueryInput;
};


export type QueryGetRulesForMerchantArgs = {
  input?: InputMaybe<RiskRulesQueryInput>;
};


export type QueryIndividualArgs = {
  input: GetIndividualInput;
};


export type QueryIndividualRelationsArgs = {
  input: GetIndividualRelationsInput;
};


export type QueryIndividualsArgs = {
  input: GetIndividualsQueryInput;
};


export type QueryLatestRiskCalculationArgs = {
  input: RiskCalculationQueryInput;
};


export type QueryLogsArgs = {
  input?: InputMaybe<LogsQueryInput>;
};


export type QueryLogsByTransactionIdArgs = {
  input?: InputMaybe<LogsByTransactionIdQueryInput>;
};


export type QueryManualSettlementBalanceArgs = {
  input: ManualSettlementInput;
};


export type QueryMccArgs = {
  input: MccQueryInput;
};


export type QueryMerchantApplicationArgs = {
  input?: InputMaybe<MerchantApplicationQueryInput>;
};


export type QueryMerchantApplicationsArgs = {
  input?: InputMaybe<MerchantApplicationsQueryInput>;
};


export type QueryMerchantApprovalsArgs = {
  input?: InputMaybe<MerchantApprovalsQueryInput>;
};


export type QueryMerchantConnectionsArgs = {
  input: MerchantConnectionsQueryInput;
};


export type QueryMerchantCrmFieldValueArgs = {
  input: MerchantFieldValueInput;
};


export type QueryMerchantCrmFieldsValuesArgs = {
  input: MerchantFieldsValuesInput;
};


export type QueryMerchantDashboardTokenArgs = {
  input: GetMerchantDashboardTokenInput;
};


export type QueryMerchantDefaultExportFieldsArgs = {
  input: MerchantDefaultExportFieldsPayload;
};


export type QueryMerchantFilteredRulesArgs = {
  input: MerchantFilteredRulesInput;
};


export type QueryMerchantInsightsArgs = {
  input: MerchantInsightsInput;
};


export type QueryMerchantPricingConfigsArgs = {
  input: MerchantAndCompanyInput;
};


export type QueryMerchantSettingsArgs = {
  input?: InputMaybe<MerchantSettingsQueryInput>;
};


export type QueryMerchantsArgs = {
  input?: InputMaybe<MerchantsQueryInput>;
};


export type QueryMerchantsUnderRuleArgs = {
  input: MerchantsUnderRuleInput;
};


export type QueryNextSettlementArgs = {
  input: NextSettlementQueryInput;
};


export type QueryNotesArgs = {
  input: NotesQueryInput;
};


export type QueryOnboardingEventsArgs = {
  input?: InputMaybe<OnboardingEventsQueryInput>;
};


export type QueryOnboardingPricingArgs = {
  input: GetOnboardingPricingInput;
};


export type QueryOnboardingPricingFieldsArgs = {
  input?: InputMaybe<GetOnboardingPricingFieldsInput>;
};


export type QueryOnboardingPricingListArgs = {
  input: OnboardingPricingListQueryInput;
};


export type QueryOnboardingRiskRuleArgs = {
  input: OnboardingRiskRuleInput;
};


export type QueryOnboardingRiskRulesArgs = {
  input: OnboardingRiskRulesQueryInput;
};


export type QueryPackageOrSubscriptionAuditsArgs = {
  input: PackageOrSubscriptionAuditQueryInput;
};


export type QueryPaymentFeesArgs = {
  input: PaymentFeesQueryInput;
};


export type QueryPaymentFeesByParamsArgs = {
  input?: InputMaybe<PaymentFeesByParamsQueryInput>;
};


export type QueryPaymentLinkArgs = {
  input: PaymentLinkQueryInput;
};


export type QueryPaymentLinkPerformanceArgs = {
  input: PaymentLinkPerformanceQueryInput;
};


export type QueryPaymentLinksArgs = {
  input?: InputMaybe<PaymentLinksQueryInput>;
};


export type QueryPaymentWithTransactionsArgs = {
  input: TransactionQueryInput;
};


export type QueryPaymentsArgs = {
  input?: InputMaybe<PaymentsQueryInput>;
};


export type QueryPotentialDuplicateIndividualsArgs = {
  input: GetPotentialDuplicateIndividualsInput;
};


export type QueryPricingActionArgs = {
  input: GetPricingActionInput;
};


export type QueryProviderFeaturesArgs = {
  input?: InputMaybe<ProviderFeaturesQueryInput>;
};


export type QueryProviderRequestsArgs = {
  input?: InputMaybe<ProviderRequestsQueryInput>;
};


export type QueryRawReportDownloadUrlArgs = {
  input: RawReportDownloadUrlInput;
};


export type QueryRawReportsArgs = {
  input: RawReportsInput;
};


export type QueryReferralArgs = {
  input: GetReferralInput;
};


export type QueryReportsConfigArgs = {
  input: GetReportsConfigQueryInput;
};


export type QueryReservesArgs = {
  input: ReservesQueryInput;
};


export type QueryReservesBySettlementIdArgs = {
  input: ReservesBySettlementIdQueryInput;
};


export type QueryReservesNextReleaseArgs = {
  input: ReservesNextReleaseQueryInput;
};


export type QueryReservesTotalAmountArgs = {
  input: ReservesTotalQueryInput;
};


export type QueryRevealApiKeyArgs = {
  input: PasswordProtectedApiKeyIdInput;
};


export type QueryRiskAlertArgs = {
  input: RiskAlertQueryInput;
};


export type QueryRiskAlertsArgs = {
  input?: InputMaybe<RiskAlertsQueryInput>;
};


export type QueryRiskAlertsByIdsArgs = {
  input: RiskAlertsByIdsQueryInput;
};


export type QueryRiskAlertsByMerchantsArgs = {
  input?: InputMaybe<RiskAlertsQueryInput>;
};


export type QueryRiskAllListValuesArgs = {
  input: RiskAllListValuesQueryInput;
};


export type QueryRiskCalculationsArgs = {
  input: RiskCalculationQueryInput;
};


export type QueryRiskListArgs = {
  input: RiskListQueryInput;
};


export type QueryRiskListValuesArgs = {
  input: RiskListValuesQueryInput;
};


export type QueryRiskListValuesSearchArgs = {
  input: RiskListValuesSearchQueryInput;
};


export type QueryRiskListsArgs = {
  input?: InputMaybe<RiskListsQueryInput>;
};


export type QueryRiskReviewsArgs = {
  input?: InputMaybe<RiskReviewsQueryInput>;
};


export type QueryRiskReviewsByReferenceArgs = {
  input: RiskReviewsByReferenceInput;
};


export type QueryRoutineLogsArgs = {
  input: RoutineLogsInput;
};


export type QueryRoutineTemplateArgs = {
  input: RoutineTemplateInput;
};


export type QueryRuleArgs = {
  input?: InputMaybe<RuleQueryInput>;
};


export type QueryRuleLogsArgs = {
  input?: InputMaybe<RiskRulesQueryInput>;
};


export type QueryRuleNumericValuesArgs = {
  input: NumberMerchantsUnderRuleInput;
};


export type QueryRulesArgs = {
  input?: InputMaybe<RiskRulesQueryInput>;
};


export type QueryRulesByResourceTypeArgs = {
  input: RulesByResourceTypeInput;
};


export type QuerySdkEventsArgs = {
  input?: InputMaybe<SdkEventsQueryInput>;
};


export type QuerySettlementArgs = {
  input: SettlementQueryInput;
};


export type QuerySettlementStatementArgs = {
  input: SettlementStatementQueryInput;
};


export type QuerySettlementTransactionsStatsArgs = {
  input: SettlementTransactionsStatsQueryInput;
};


export type QuerySettlementsArgs = {
  input: SettlementsQueryInput;
};


export type QuerySourcesArgs = {
  input: CustomerPaymentSourceQueryInput;
};


export type QueryStructureArgs = {
  input: StructureQueryInput;
};


export type QueryStructuresByCountryArgs = {
  input: StructuresByCountryQueryInput;
};


export type QuerySubscriptionArgs = {
  input: SubscriptionQueryInput;
};


export type QuerySubscriptionPackageArgs = {
  input: SubscriptionPackageQueryInput;
};


export type QuerySubscriptionPackagesArgs = {
  input?: InputMaybe<SubscriptionPackagesQueryInput>;
};


export type QuerySubscriptionsArgs = {
  input?: InputMaybe<SubscriptionsQueryInput>;
};


export type QueryTaskArgs = {
  input: TaskQueryInput;
};


export type QueryTaskGroupTemplatesArgs = {
  input: TaskGroupTemplateQueryInput;
};


export type QueryTaskTemplateArgs = {
  input: TaskTemplateQueryInput;
};


export type QueryTasksArgs = {
  input?: InputMaybe<TasksQueryInput>;
};


export type QueryTraceIdsArgs = {
  input?: InputMaybe<TraceIdsQueryInput>;
};


export type QueryTransactionArgs = {
  input: TransactionQueryInput;
};


export type QueryTransactionsArgs = {
  input?: InputMaybe<TransactionsQueryInput>;
};


export type QueryTransactionsBalanceArgs = {
  input?: InputMaybe<TransactionsBalanceQueryInput>;
};


export type QueryTransactionsCsvReportArgs = {
  input: TransactionsCsvReportQueryInput;
};


export type QueryUserArgs = {
  input: UserQueryInput;
};


export type QueryUserManagementAuditsArgs = {
  input: UserManagementAuditsQueryInput;
};


export type QueryUsersArgs = {
  input?: InputMaybe<UsersQueryInput>;
};


export type QueryVatInfoArgs = {
  input: VatInfoPayload;
};


export type QueryWebhookArgs = {
  input: WebhookIdInput;
};

export type RawReport = {
  __typename?: 'RawReport';
  ETag?: Maybe<Scalars['String']['output']>;
  Key?: Maybe<Scalars['String']['output']>;
  LastModified?: Maybe<Scalars['String']['output']>;
  Owner?: Maybe<RawReportOwner>;
  Size?: Maybe<Scalars['String']['output']>;
  StorageClass?: Maybe<Scalars['String']['output']>;
};

export type RawReportDownloadUrlInput = {
  bucket?: InputMaybe<ReportsBuckets>;
  reportKey: Scalars['String']['input'];
};

export type RawReportOwner = {
  __typename?: 'RawReportOwner';
  DisplayName?: Maybe<Scalars['String']['output']>;
  ID?: Maybe<Scalars['String']['output']>;
};

export type RawReports = {
  __typename?: 'RawReports';
  reports: Array<RawReport>;
};

export type RawReportsInput = {
  bucket?: InputMaybe<ReportsBuckets>;
  prefixes: Array<InputMaybe<Scalars['String']['input']>>;
};

export type ReconciliationConfig = {
  __typename?: 'ReconciliationConfig';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  example?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  reconciliationType?: Maybe<Scalars['String']['output']>;
  regex: Scalars['String']['output'];
  workflow: Scalars['String']['output'];
};

export type ReconciliationConfigMutationResponse = {
  __typename?: 'ReconciliationConfigMutationResponse';
  payload: ReconciliationPayload;
  success: Scalars['Boolean']['output'];
};

export type ReconciliationConfigQueryResponse = {
  __typename?: 'ReconciliationConfigQueryResponse';
  reconciliationConfigs?: Maybe<Array<ReconciliationConfig>>;
};

export type ReconciliationInfo = {
  __typename?: 'ReconciliationInfo';
  reconciliationDate?: Maybe<Scalars['String']['output']>;
  reconciliationFailureReason?: Maybe<Scalars['String']['output']>;
  reconciliationId?: Maybe<Scalars['String']['output']>;
  reconciliationStatus?: Maybe<ReconciliationStatusEnum>;
};

export type ReconciliationPayload = {
  __typename?: 'ReconciliationPayload';
  regex: Scalars['String']['output'];
};

export enum ReconciliationStatusEnum {
  Failure = 'FAILURE',
  None = 'NONE',
  Success = 'SUCCESS'
}

export type ReferralObject = {
  __typename?: 'ReferralObject';
  alternativeCurrencies?: Maybe<Array<AlternativeCurrencies>>;
  commissionSetup?: Maybe<Array<EntityShareSetup>>;
  currency?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  expiresInYears?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  periodCountStartsFrom?: Maybe<Scalars['String']['output']>;
  revShareTiers?: Maybe<Array<RevShareTiers>>;
};

export type RegisterApplePayDomainInput = {
  domainNames: Array<Scalars['String']['input']>;
};

export type RegisterApplePayDomainResponse = {
  __typename?: 'RegisterApplePayDomainResponse';
  errors?: Maybe<Array<ApplePayDomainError>>;
  success: Scalars['Boolean']['output'];
};

export type RemoveApiKeyMutationResponse = {
  __typename?: 'RemoveApiKeyMutationResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveApplePayCertificate = {
  __typename?: 'RemoveApplePayCertificate';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RemoveApplePayCertificateInput = {
  id: Scalars['String']['input'];
};

export type RemoveChargebackReasonMutationInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveConsumerRuleExclusionInput = {
  id: Scalars['String']['input'];
};

/** REFERENCE: https://github.com/pay-com/grpc-core-costs/blob/main/service.proto#L31 */
export type RemoveCostMutationInput = {
  action: Scalars['String']['input'];
  currency: CurrencyAlpha3;
  paymentMethodType: Scalars['String']['input'];
  provider: Scalars['String']['input'];
};

export type RemoveDeclineMessageInput = {
  declineCode: Scalars['String']['input'];
};

export type RemoveFailureCodeMessageQueryInput = {
  errorCode: Scalars['String']['input'];
};

export type RemoveFromListMutationInput = {
  alias: ListAlias;
  itemId?: InputMaybe<Scalars['String']['input']>;
  listValueId?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveIssuerResponseCodeQueryInput = {
  code: Scalars['String']['input'];
  subType: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type RemoveNoteMutationInput = {
  id: Scalars['ID']['input'];
};

export type RemoveNoteMutationResponse = {
  __typename?: 'RemoveNoteMutationResponse';
  success: Scalars['Boolean']['output'];
};

export type RemovePricingInput = {
  companyId: Scalars['ID']['input'];
  currency: Scalars['String']['input'];
  merchantId: Scalars['ID']['input'];
  paymentMethodType: Scalars['String']['input'];
  settlementAccountId: Scalars['ID']['input'];
};

export type RemoveReconciliationConfigInput = {
  regex: Scalars['String']['input'];
};

export type RemoveRoutineTemplateMutationInput = {
  id: Scalars['ID']['input'];
};

export type RemoveSourceInput = {
  consumerId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type RemoveSourceResponse = {
  __typename?: 'RemoveSourceResponse';
  success: Scalars['Boolean']['output'];
};

export type RemoveStructureMutationInput = {
  countryAlpha2: CountryAlpha2;
  key: Scalars['String']['input'];
};

export enum ReportsBuckets {
  S3BucketRawReports = 'S3_BUCKET_RAW_REPORTS',
  S3BucketReports = 'S3_BUCKET_REPORTS'
}

export type ReportsConfig = {
  __typename?: 'ReportsConfig';
  companyId: Scalars['String']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  defaultConfig: Config;
  enabledReports?: Maybe<EnabledReportsGraphqlStructure>;
  excludeFields?: Maybe<Scalars['JSON']['output']>;
  exists?: Maybe<Scalars['Boolean']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  perReportConfigOverride?: Maybe<Scalars['JSON']['output']>;
  renameFields?: Maybe<Scalars['JSON']['output']>;
};

export type ReportsConfigInput = {
  companyId: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  defaultConfig: ConfigInput;
  enabledReports?: InputMaybe<ParsedEnabledReportsInput>;
  excludeFields?: InputMaybe<Scalars['JSON']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  perReportConfigOverride?: InputMaybe<Scalars['JSON']['input']>;
  renameFields?: InputMaybe<Scalars['JSON']['input']>;
};

export type RequestBlockingMutationInput = {
  companyId: Scalars['ID']['input'];
  settlementAccountDisablingOptions: Array<DisablingOptionInput>;
  settlementAccountId: Scalars['String']['input'];
};

export type RequestBlockingMutationResponse = {
  __typename?: 'RequestBlockingMutationResponse';
  success: Scalars['Boolean']['output'];
};

export enum RequestDirection {
  Incoming = 'INCOMING',
  Outgoing = 'OUTGOING'
}

export enum RequestInformationDataCategory {
  BeneficialOwner = 'beneficial_owner',
  BusinessActivity = 'business_activity',
  Directors = 'directors',
  GeneralInformation = 'general_information',
  Individuals = 'individuals',
  Other = 'other',
  SettlementBankAccount = 'settlement_bank_account',
  Shareholders = 'shareholders',
  WebsiteProcessingInfo = 'website_processing_info'
}

export type RequestInformationInput = {
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<RequestInformationDataCategory>;
  clarificationType?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  creatorNote?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  individualId?: InputMaybe<Scalars['ID']['input']>;
  merchantId: Scalars['ID']['input'];
  requestReason: Scalars['String']['input'];
  source: DocumentSource;
  subType?: InputMaybe<Scalars['String']['input']>;
  type: RequestInformationType;
};

export type RequestInformationResponse = {
  __typename?: 'RequestInformationResponse';
  success: Scalars['Boolean']['output'];
};

export enum RequestInformationType {
  Clarification = 'clarification',
  ClarificationWithDocument = 'clarificationWithDocument',
  Document = 'document'
}

export type RerollApiKeyResponse = {
  __typename?: 'RerollApiKeyResponse';
  apiKey?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResendWebhookEventMutationInput = {
  requestId: Scalars['ID']['input'];
  webhookId: Scalars['ID']['input'];
};

export type ResendWebhookEventMutationResponse = {
  __typename?: 'ResendWebhookEventMutationResponse';
  success: Scalars['Boolean']['output'];
};

/** REFERENCE: https://github.com/pay-com/grpc-core-reserves/blob/main/service.proto#L37 */
export type ReserveObject = {
  __typename?: 'ReserveObject';
  amount: Scalars['String']['output'];
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  currency: CurrencyAlpha3;
  id: Scalars['ID']['output'];
  merchantId?: Maybe<Scalars['ID']['output']>;
  plannedReleaseDate?: Maybe<Scalars['String']['output']>;
  releasedAt?: Maybe<Scalars['String']['output']>;
  releasedSettlementId?: Maybe<Scalars['ID']['output']>;
  settlementId?: Maybe<Scalars['ID']['output']>;
  status: ReserveStatus;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum ReserveStatus {
  AdjsutmentApplied = 'ADJSUTMENT_APPLIED',
  Adjustment = 'ADJUSTMENT',
  EarlyRelease = 'EARLY_RELEASE',
  Released = 'RELEASED',
  Reserved = 'RESERVED'
}

export type ReservesBySettlementIdQueryInput = {
  id: Scalars['ID']['input'];
};

/** REFERENCE: https://github.com/pay-com/grpc-core-reserves/blob/main/service.proto#L86 */
export type ReservesBySettlementIdResponse = {
  __typename?: 'ReservesBySettlementIdResponse';
  deduct?: Maybe<Array<Maybe<ReserveObject>>>;
  release?: Maybe<Array<Maybe<ReserveObject>>>;
};

export type ReservesNextReleaseQueryInput = {
  dateTime: StringRangeInput;
};

export type ReservesQueryExactFilterInputValues = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CurrencyAlpha3>;
  id?: InputMaybe<Scalars['ID']['input']>;
  plannedReleaseDate?: InputMaybe<Scalars['String']['input']>;
  releasedAt?: InputMaybe<Scalars['String']['input']>;
  releasedSettlementId?: InputMaybe<Scalars['ID']['input']>;
  settlementId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ReserveStatus>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type ReservesQueryInFilterInputValues = {
  amount?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency?: InputMaybe<Array<InputMaybe<CurrencyAlpha3>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  plannedReleaseDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  releasedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  releasedSettlementId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  settlementId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<ReserveStatus>>>;
  updatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReservesQueryInput = {
  filter?: InputMaybe<ReservesQueryInputFilter>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ReserveStatus>;
};

export type ReservesQueryInputFilter = {
  and?: InputMaybe<Array<ReservesQueryInputFilter>>;
  between?: InputMaybe<ReservesQueryRangeFilterInputValues>;
  equal?: InputMaybe<ReservesQueryExactFilterInputValues>;
  greater?: InputMaybe<ReservesQueryExactFilterInputValues>;
  greaterOrEquals?: InputMaybe<ReservesQueryExactFilterInputValues>;
  iLike?: InputMaybe<ReservesQueryExactFilterInputValues>;
  in?: InputMaybe<ReservesQueryInFilterInputValues>;
  less?: InputMaybe<ReservesQueryExactFilterInputValues>;
  lessOrEquals?: InputMaybe<ReservesQueryExactFilterInputValues>;
  like?: InputMaybe<ReservesQueryExactFilterInputValues>;
  notBetween?: InputMaybe<ReservesQueryRangeFilterInputValues>;
  notEqual?: InputMaybe<ReservesQueryExactFilterInputValues>;
  notIn?: InputMaybe<ReservesQueryInFilterInputValues>;
  notLike?: InputMaybe<ReservesQueryExactFilterInputValues>;
};

export type ReservesQueryRangeFilterInputValues = {
  amount?: InputMaybe<FloatRangeInput>;
  createdAt?: InputMaybe<StringRangeInput>;
  plannedReleaseDate?: InputMaybe<StringRangeInput>;
  releasedAt?: InputMaybe<StringRangeInput>;
  updatedAt?: InputMaybe<StringRangeInput>;
};

export type ReservesResponse = {
  __typename?: 'ReservesResponse';
  pageInfo: PageInfo;
  reserves: Array<ReserveObject>;
};

export type ReservesTotalQueryInput = {
  filter?: InputMaybe<ReservesQueryInputFilter>;
};

export type ResetRulePrioritiesMutationInput = {
  ruleIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ResourceType {
  LogicKey = 'logic_key',
  PaymentMethodConfig = 'payment_method_config',
  RiskList = 'risk_list',
  SettlementAccountFallback = 'settlement_account_fallback'
}

export enum ResponseContentDisposition {
  Attachment = 'attachment',
  Inline = 'inline'
}

export type RetrySubscriptionInput = {
  id: Scalars['ID']['input'];
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  updateSourceId: Scalars['Boolean']['input'];
};

export type RevShareTiers = {
  __typename?: 'RevShareTiers';
  basisPoints?: Maybe<Scalars['String']['output']>;
  fromVolume?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  toVolume?: Maybe<Scalars['String']['output']>;
};

export type RevShareTiersInput = {
  basisPoints?: InputMaybe<Scalars['String']['input']>;
  fromVolume?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  toVolume?: InputMaybe<Scalars['String']['input']>;
};

export type RevealApiKeyResponse = {
  __typename?: 'RevealApiKeyResponse';
  apiKey?: Maybe<Scalars['String']['output']>;
};

export enum ReviewStatuses {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotRelevant = 'NOT_RELEVANT',
  Pending = 'PENDING'
}

export type Risk = {
  __typename?: 'Risk';
  amlRisk?: Maybe<AmlRisk>;
  exposureRisk?: Maybe<ExposureRisk>;
  isOverridden?: Maybe<Scalars['Boolean']['output']>;
  renewalDate?: Maybe<Scalars['String']['output']>;
};

export type RiskAlert = {
  __typename?: 'RiskAlert';
  actionsToBeTaken?: Maybe<Scalars['String']['output']>;
  alertName?: Maybe<Scalars['String']['output']>;
  alertNotes?: Maybe<Array<Note>>;
  alertSource?: Maybe<Scalars['String']['output']>;
  category?: Maybe<RiskAlertCategory>;
  companyId: Scalars['String']['output'];
  consumerId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryAlpha2>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currentAssignee?: Maybe<Scalars['String']['output']>;
  currentStatus?: Maybe<Scalars['String']['output']>;
  escalationReason?: Maybe<Scalars['String']['output']>;
  evaluatedAt?: Maybe<Scalars['String']['output']>;
  evaluationReport?: Maybe<RiskAlertEvaluationReport>;
  id: Scalars['String']['output'];
  issueLink?: Maybe<Scalars['String']['output']>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  lastUpdatedOn?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['String']['output'];
  merchantLegalName?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<RiskAlertPriority>;
  resolveReason?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
  seen?: Maybe<Scalars['Boolean']['output']>;
  statusList?: Maybe<Array<RiskAlertStatusDetails>>;
  suspicionReport?: Maybe<RiskAlertSuspicionReport>;
  triggeredPreviously?: Maybe<Scalars['Int']['output']>;
  triggeringTransactionId?: Maybe<Scalars['String']['output']>;
  uniquenessParams?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum RiskAlertAmlcoDecision {
  CaseNonSuspicious = 'CASE_NON_SUSPICIOUS',
  SuspiciousCaseSubmitted = 'SUSPICIOUS_CASE_SUBMITTED'
}

export type RiskAlertByMerchant = {
  __typename?: 'RiskAlertByMerchant';
  count?: Maybe<Scalars['Int']['output']>;
  merchantId: Scalars['String']['output'];
  merchantLegalName?: Maybe<Scalars['String']['output']>;
};

export enum RiskAlertCategory {
  Compliance = 'COMPLIANCE',
  Risk = 'RISK',
  RiskOrCompliance = 'RISK_OR_COMPLIANCE'
}

export type RiskAlertEvaluationReport = {
  __typename?: 'RiskAlertEvaluationReport';
  attachedDocumentIds?: Maybe<Array<Scalars['String']['output']>>;
  attachedDocumentsDescription?: Maybe<Scalars['String']['output']>;
  decisionDescription?: Maybe<Scalars['String']['output']>;
  decisionOfTheAmlco?: Maybe<RiskAlertAmlcoDecision>;
  documentsReference?: Maybe<Scalars['String']['output']>;
  enquiriesUndertaken?: Maybe<Scalars['String']['output']>;
  evaluationDate?: Maybe<Scalars['String']['output']>;
  evaluationReportId?: Maybe<Scalars['String']['output']>;
  externalReportReference?: Maybe<Scalars['String']['output']>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  lastUpdatedOn?: Maybe<Scalars['String']['output']>;
};

export type RiskAlertEvaluationReportInput = {
  attachedDocumentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  attachedDocumentsDescription?: InputMaybe<Scalars['String']['input']>;
  decisionDescription?: InputMaybe<Scalars['String']['input']>;
  decisionOfTheAmlco?: InputMaybe<RiskAlertAmlcoDecision>;
  documentsReference?: InputMaybe<Scalars['String']['input']>;
  enquiriesUndertaken?: InputMaybe<Scalars['String']['input']>;
  evaluationDate?: InputMaybe<Scalars['String']['input']>;
  evaluationReportId?: InputMaybe<Scalars['String']['input']>;
  externalReportReference?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['String']['input']>;
};

export enum RiskAlertPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type RiskAlertQueryInput = {
  id: Scalars['ID']['input'];
};

export enum RiskAlertStatus {
  ClosedByAmlco = 'CLOSED_BY_AMLCO',
  FalsePositive = 'FALSE_POSITIVE',
  InReview_1St = 'IN_REVIEW_1ST',
  InReview_2Nd = 'IN_REVIEW_2ND',
  Pending_1St = 'PENDING_1ST',
  Pending_2Nd = 'PENDING_2ND',
  PendingInformation = 'PENDING_INFORMATION',
  ResolvedActionsTaken = 'RESOLVED_ACTIONS_TAKEN',
  ResolvedSuspicious = 'RESOLVED_SUSPICIOUS',
  ResolvedUnsuspicious = 'RESOLVED_UNSUSPICIOUS'
}

export type RiskAlertStatusDetails = {
  __typename?: 'RiskAlertStatusDetails';
  assignee?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Scalars['String']['output']>>;
  notes?: Maybe<Array<Note>>;
  status: RiskAlertStatus;
};

export type RiskAlertStatusDetailsInput = {
  assignee?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Array<NoteInput>>;
  status: RiskAlertStatus;
};

export type RiskAlertSuspicionReport = {
  __typename?: 'RiskAlertSuspicionReport';
  id?: Maybe<Scalars['String']['output']>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  lastUpdatedOn?: Maybe<Scalars['String']['output']>;
  reporter?: Maybe<RiskAlertSuspicionReporter>;
  suspicionDescription?: Maybe<Scalars['String']['output']>;
  suspicionReason?: Maybe<Scalars['String']['output']>;
};

export type RiskAlertSuspicionReportInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['String']['input']>;
  reporter?: InputMaybe<RiskAlertSuspicionReporterInput>;
  suspicionDescription?: InputMaybe<Scalars['String']['input']>;
  suspicionReason?: InputMaybe<Scalars['String']['input']>;
};

export type RiskAlertSuspicionReporter = {
  __typename?: 'RiskAlertSuspicionReporter';
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
};

export type RiskAlertSuspicionReporterInput = {
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
};

export type RiskAlertUpdateMutationResponse = {
  __typename?: 'RiskAlertUpdateMutationResponse';
  id: Scalars['ID']['output'];
};

export type RiskAlertsByIdsQueryInput = {
  riskAlerts?: InputMaybe<Array<RiskAlertQueryInput>>;
};

export type RiskAlertsByIdsQueryResponse = {
  __typename?: 'RiskAlertsByIdsQueryResponse';
  alerts: Array<RiskAlert>;
};

export type RiskAlertsByMerchantsQueryResponse = {
  __typename?: 'RiskAlertsByMerchantsQueryResponse';
  alertsByMerchants: Array<RiskAlertByMerchant>;
  pageInfo: PageInfo;
};

export type RiskAlertsQueryExactInputFilter = {
  actionsToBeTaken?: InputMaybe<Scalars['String']['input']>;
  alertName?: InputMaybe<Scalars['String']['input']>;
  alertSource?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<RiskAlertCategory>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  consumerId?: InputMaybe<Scalars['String']['input']>;
  currentAssignee?: InputMaybe<Scalars['String']['input']>;
  currentStatus?: InputMaybe<Scalars['String']['input']>;
  escalationReason?: InputMaybe<Scalars['String']['input']>;
  evaluationReport?: InputMaybe<RiskAlertEvaluationReportInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  issueLink?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  merchantLegalName?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<RiskAlertPriority>;
  resolveReason?: InputMaybe<Scalars['String']['input']>;
  ruleId?: InputMaybe<Scalars['String']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  suspicionReport?: InputMaybe<RiskAlertSuspicionReportInput>;
  triggeredPreviously?: InputMaybe<Scalars['Int']['input']>;
  triggeringTransactionId?: InputMaybe<Scalars['String']['input']>;
};

export type RiskAlertsQueryInFilterInputValues = {
  alertName?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Array<RiskAlertCategory>>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  consumerId?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Array<CountryAlpha2>>;
  currentAssignee?: InputMaybe<Array<Scalars['String']['input']>>;
  currentStatus?: InputMaybe<Array<RiskAlertStatus>>;
  escalationReason?: InputMaybe<Array<Scalars['String']['input']>>;
  evaluationReport?: InputMaybe<Array<RiskAlertEvaluationReportInput>>;
  id?: InputMaybe<Array<Scalars['String']['input']>>;
  issueLink?: InputMaybe<Array<Scalars['String']['input']>>;
  lastUpdatedBy?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantId?: InputMaybe<Array<Scalars['String']['input']>>;
  priority?: InputMaybe<Array<RiskAlertPriority>>;
  resolveReason?: InputMaybe<Array<Scalars['String']['input']>>;
  ruleId?: InputMaybe<Array<Scalars['String']['input']>>;
  seen?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  suspicionReport?: InputMaybe<Array<RiskAlertSuspicionReportInput>>;
  triggeredPreviously?: InputMaybe<Array<Scalars['Int']['input']>>;
  triggeringTransactionId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RiskAlertsQueryInput = {
  filter?: InputMaybe<RiskAlertsQueryInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type RiskAlertsQueryInputFilter = {
  and?: InputMaybe<Array<InputMaybe<RiskAlertsQueryInputFilter>>>;
  between?: InputMaybe<RiskAlertsQueryRangeFilterInput>;
  equal?: InputMaybe<RiskAlertsQueryExactInputFilter>;
  iLike?: InputMaybe<RiskAlertsQueryExactInputFilter>;
  in?: InputMaybe<RiskAlertsQueryInFilterInputValues>;
  notEqual?: InputMaybe<RiskAlertsQueryExactInputFilter>;
  notIn?: InputMaybe<RiskAlertsQueryInFilterInputValues>;
  or?: InputMaybe<Array<RiskAlertsQueryInputFilter>>;
  textSearchCaseInsensitive?: InputMaybe<RiskAlertsQueryExactInputFilter>;
};

export type RiskAlertsQueryRangeFilterInput = {
  createdAt?: InputMaybe<StringRangeInput>;
  evaluatedAt?: InputMaybe<StringRangeInput>;
  updatedAt?: InputMaybe<StringRangeInput>;
};

export type RiskAlertsQueryResponse = {
  __typename?: 'RiskAlertsQueryResponse';
  alerts: Array<RiskAlert>;
  pageInfo: PageInfo;
};

export type RiskAlertsUpdateMutationResponse = {
  __typename?: 'RiskAlertsUpdateMutationResponse';
  ids?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type RiskAllListValuesQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  listId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RiskAllListsValuesQueryResponse = {
  __typename?: 'RiskAllListsValuesQueryResponse';
  listValues: Array<RiskListValue>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
  pageInfo: PageInfo;
};

export type RiskCalculation = {
  __typename?: 'RiskCalculation';
  amlRiskCategory?: Maybe<AmlRiskCategory>;
  calculatedAt?: Maybe<Scalars['String']['output']>;
  calculatedBy?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  details?: Maybe<Array<RiskCalculationDetails>>;
  id: Scalars['String']['output'];
  isHighRiskOverriden?: Maybe<Scalars['Boolean']['output']>;
  manualHighRiskOverridenReason?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  riskScoreLabel?: Maybe<MerchantApplicationRiskScores>;
  score?: Maybe<Scalars['String']['output']>;
  scoreType?: Maybe<Scalars['String']['output']>;
};

export type RiskCalculationDetails = {
  __typename?: 'RiskCalculationDetails';
  parameter?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type RiskCalculationQueryInput = {
  companyId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};

export type RiskCalculatorConfig = {
  __typename?: 'RiskCalculatorConfig';
  activityWeightPercentage?: Maybe<Scalars['StringifiedNumber']['output']>;
  channelWeightPercentage?: Maybe<Scalars['StringifiedNumber']['output']>;
  geographyWeightPercentage?: Maybe<Scalars['StringifiedNumber']['output']>;
  industryWeightPercentage?: Maybe<Scalars['StringifiedNumber']['output']>;
  lowRiskMaxScore?: Maybe<Scalars['StringifiedNumber']['output']>;
  mediumRiskMaxScore?: Maybe<Scalars['StringifiedNumber']['output']>;
  productWeightPercentage?: Maybe<Scalars['StringifiedNumber']['output']>;
  structureWeightPercentage?: Maybe<Scalars['StringifiedNumber']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum RiskDecisionsEnum {
  Allow = 'ALLOW',
  Block = 'BLOCK',
  ThreedsChallenge = 'THREEDS_CHALLENGE',
  ThreedsExemption = 'THREEDS_EXEMPTION',
  ThreedsNotRequired = 'THREEDS_NOT_REQUIRED',
  ThreedsRequired = 'THREEDS_REQUIRED'
}

export type RiskFilterInput = {
  amlRisk?: InputMaybe<AmlRisFilterInput>;
  exposureRisk?: InputMaybe<ExposureRiskFilterInput>;
  isOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  processingRiskScore?: InputMaybe<Scalars['String']['input']>;
  renewalDate?: InputMaybe<StringRangeInput>;
  renewalDateReason?: InputMaybe<Scalars['String']['input']>;
};

export type RiskInput = {
  amlRisk?: InputMaybe<AmlRiskInput>;
  exposureRisk?: InputMaybe<ExposureRiskInput>;
  isOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  renewalDate?: InputMaybe<Scalars['String']['input']>;
};

/** REFERENCE: https://github.com/pay-com/grpc-risk-lists/blob/main/service.proto#L40 */
export type RiskList = {
  __typename?: 'RiskList';
  alias?: Maybe<Scalars['String']['output']>;
  allowUpdatesToGroups?: Maybe<Array<Scalars['String']['output']>>;
  companyId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isUserGenerated?: Maybe<Scalars['Boolean']['output']>;
  /** items list length */
  items?: Maybe<Scalars['Int']['output']>;
  merchantId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: RiskListType;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RiskListMutationResponse = {
  __typename?: 'RiskListMutationResponse';
  id: Scalars['String']['output'];
};

export type RiskListQueryInput = {
  id: Scalars['ID']['input'];
};

export enum RiskListType {
  BillingAddress = 'billing_address',
  Bin = 'bin',
  Card = 'card',
  CardName = 'card_name',
  Custom = 'custom',
  CustomerId = 'customer_id',
  Email = 'email',
  EmailDomain = 'email_domain',
  IpAddress = 'ip_address',
  IssuerCountry = 'issuer_country',
  PhoneNumber = 'phone_number'
}

/** REFERENCE: https://github.com/pay-com/grpc-risk-lists/blob/main/service.proto#L81 */
export type RiskListValue = {
  __typename?: 'RiskListValue';
  companyId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  listId: Scalars['ID']['output'];
  merchantId: Scalars['ID']['output'];
  metadata?: Maybe<ListValueMetadata>;
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type RiskListValuesQueryExactInputFilter = {
  listId: Scalars['String']['input'];
};

export type RiskListValuesQueryInput = {
  filter?: InputMaybe<RiskListValuesQueryInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type RiskListValuesQueryInputFilter = {
  equal?: InputMaybe<RiskListValuesQueryExactInputFilter>;
};

export type RiskListValuesSearchQueryInput = {
  listId: Scalars['ID']['input'];
  values: Array<Scalars['String']['input']>;
};

export type RiskListValuesSearchQueryResponse = {
  __typename?: 'RiskListValuesSearchQueryResponse';
  exists: Scalars['Boolean']['output'];
  foundValues?: Maybe<Array<Scalars['String']['output']>>;
};

export type RiskListsQueryBetweenInputFilter = {
  createdAt?: InputMaybe<StringRangeInput>;
  updatedAt?: InputMaybe<StringRangeInput>;
};

export type RiskListsQueryExactInputFilter = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type RiskListsQueryInFilterInputValues = {
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantId?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RiskListsQueryInput = {
  filter?: InputMaybe<RiskListsQueryInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type RiskListsQueryInputFilter = {
  and?: InputMaybe<Array<RiskListsQueryInputFilter>>;
  between?: InputMaybe<RiskListsQueryBetweenInputFilter>;
  equal?: InputMaybe<RiskListsQueryExactInputFilter>;
  iLike?: InputMaybe<RiskListsQueryExactInputFilter>;
  in?: InputMaybe<RiskListsQueryInFilterInputValues>;
  notEqual?: InputMaybe<RiskListsQueryExactInputFilter>;
  notIn?: InputMaybe<RiskListsQueryInFilterInputValues>;
  or?: InputMaybe<Array<RiskListsQueryInputFilter>>;
  textSearchCaseInsensitive?: InputMaybe<RiskListsQueryExactInputFilter>;
};

export type RiskListsQueryResponse = {
  __typename?: 'RiskListsQueryResponse';
  lists: Array<RiskList>;
  pageInfo: PageInfo;
};

export type RiskListsValuesQueryResponse = {
  __typename?: 'RiskListsValuesQueryResponse';
  listValues: Array<RiskListValue>;
  pageInfo: PageInfo;
};

export type RiskMerchantListsQueryResponse = {
  __typename?: 'RiskMerchantListsQueryResponse';
  lists: Array<RiskList>;
};

export type RiskPreview = {
  __typename?: 'RiskPreview';
  amlRisk?: Maybe<AmlRisk>;
  exposureRisk?: Maybe<ExposureRiskPreview>;
  isOverridden?: Maybe<Scalars['Boolean']['output']>;
  processingRiskScore?: Maybe<Scalars['String']['output']>;
  renewalDate?: Maybe<Scalars['String']['output']>;
  renewalDateReason?: Maybe<Scalars['String']['output']>;
};

export type RiskReviewObject = {
  __typename?: 'RiskReviewObject';
  checkout?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  originalTransaction?: Maybe<Scalars['Boolean']['output']>;
  paymentAttempt?: Maybe<Scalars['Int']['output']>;
  reference: Scalars['String']['output'];
  resolvedBy?: Maybe<Scalars['String']['output']>;
  resolvedDate?: Maybe<Scalars['String']['output']>;
  retryAttemptCounter?: Maybe<Scalars['Int']['output']>;
  reviewerIdentifier?: Maybe<Scalars['String']['output']>;
  reviewerOrigin?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<RiskReviewStatus>;
  statusReason?: Maybe<Scalars['String']['output']>;
  transactionAttemptId?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<TransactionTypes>;
  type?: Maybe<RiskReviewType>;
};

export type RiskReviewQueryResponse = {
  __typename?: 'RiskReviewQueryResponse';
  pageInfo: PageInfo;
  reviews: Array<RiskReviewObject>;
};

export enum RiskReviewStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  PendingReview = 'PENDING_REVIEW'
}

export enum RiskReviewType {
  Customer = 'CUSTOMER',
  Transaction = 'TRANSACTION'
}

export type RiskReviewsByReferenceInput = {
  reference: Scalars['String']['input'];
};

export type RiskReviewsByReferenceResponse = {
  __typename?: 'RiskReviewsByReferenceResponse';
  reviews: Array<RiskReviewObject>;
};

export type RiskReviewsQueryExactInputFilter = {
  checkout?: InputMaybe<Scalars['Boolean']['input']>;
  originalTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  paymentAttempt?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  retryAttemptCounter?: InputMaybe<Scalars['Int']['input']>;
  ruleId?: InputMaybe<Scalars['String']['input']>;
  transactionAttemptId?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<TransactionTypes>;
  type?: InputMaybe<RiskReviewType>;
};

export type RiskReviewsQueryInInputFilter = {
  reference?: InputMaybe<Array<Scalars['String']['input']>>;
  ruleId?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<InputMaybe<RiskReviewStatus>>>;
};

export type RiskReviewsQueryInput = {
  filter?: InputMaybe<RiskReviewsQueryInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type RiskReviewsQueryInputFilter = {
  and?: InputMaybe<Array<InputMaybe<RiskReviewsQueryInputFilter>>>;
  between?: InputMaybe<RiskReviewsQueryRangeFilterInputValues>;
  equal?: InputMaybe<RiskReviewsQueryExactInputFilter>;
  greater?: InputMaybe<RiskReviewsQueryExactInputFilter>;
  greaterOrEquals?: InputMaybe<RiskReviewsQueryExactInputFilter>;
  iLike?: InputMaybe<RiskReviewsQueryExactInputFilter>;
  in?: InputMaybe<RiskReviewsQueryInInputFilter>;
  less?: InputMaybe<RiskReviewsQueryExactInputFilter>;
  lessOrEquals?: InputMaybe<RiskReviewsQueryExactInputFilter>;
  notBetween?: InputMaybe<RiskReviewsQueryRangeFilterInputValues>;
  notEqual?: InputMaybe<RiskReviewsQueryExactInputFilter>;
  notIn?: InputMaybe<RiskReviewsQueryInInputFilter>;
  or?: InputMaybe<Array<InputMaybe<RiskReviewsQueryInputFilter>>>;
};

export type RiskReviewsQueryRangeFilterInputValues = {
  createdAt?: InputMaybe<StringRangeInput>;
};

export type RiskRuleLogsQueryResponse = {
  __typename?: 'RiskRuleLogsQueryResponse';
  pageInfo: PageInfo;
  rules: Array<RuleLogObject>;
};

export enum RiskRuleOutcome {
  AddToList = 'ADD_TO_LIST',
  Alert = 'ALERT',
  Allow = 'ALLOW',
  Block = 'BLOCK',
  CancelAuth = 'CANCEL_AUTH',
  Config = 'CONFIG',
  Fee = 'FEE',
  RefundChargeback = 'REFUND_CHARGEBACK',
  RemoveFromList = 'REMOVE_FROM_LIST',
  Review = 'REVIEW',
  ReviewCustomer = 'REVIEW_CUSTOMER',
  Routing = 'ROUTING',
  ThreedsChallenge = 'THREEDS_CHALLENGE',
  ThreedsExemption = 'THREEDS_EXEMPTION',
  ThreedsNotRequired = 'THREEDS_NOT_REQUIRED',
  ThreedsRequired = 'THREEDS_REQUIRED',
  UpdateFeatureFlag = 'UPDATE_FEATURE_FLAG'
}

export type RiskRulesForMerchantQueryResponse = {
  __typename?: 'RiskRulesForMerchantQueryResponse';
  rules: Array<RuleObject>;
};

export type RiskRulesQueryExactInputFilter = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  attemptId?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internalRule?: InputMaybe<Scalars['Boolean']['input']>;
  result?: InputMaybe<Scalars['Int']['input']>;
  ruleId?: InputMaybe<Scalars['ID']['input']>;
  rulePriority?: InputMaybe<Scalars['Float']['input']>;
  systemRule?: InputMaybe<Scalars['Boolean']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};

export type RiskRulesQueryInFilterInputValues = {
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enabled?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  outcome?: InputMaybe<Array<InputMaybe<RiskRuleOutcome>>>;
  outcomes?: InputMaybe<Array<InputMaybe<RiskRuleOutcome>>>;
  result?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RiskRulesQueryInput = {
  filter?: InputMaybe<RiskRulesQueryInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type RiskRulesQueryInputFilter = {
  and?: InputMaybe<Array<InputMaybe<RiskRulesQueryInputFilter>>>;
  between?: InputMaybe<RiskRulesQueryRangeInputFilter>;
  equal?: InputMaybe<RiskRulesQueryExactInputFilter>;
  hasAny?: InputMaybe<RiskRulesQueryInFilterInputValues>;
  iLike?: InputMaybe<RiskRulesQueryExactInputFilter>;
  in?: InputMaybe<RiskRulesQueryInFilterInputValues>;
  notEqual?: InputMaybe<RiskRulesQueryExactInputFilter>;
  notIn?: InputMaybe<RiskRulesQueryInFilterInputValues>;
  or?: InputMaybe<Array<RiskRulesQueryInputFilter>>;
  textSearchCaseInsensitive?: InputMaybe<RiskRulesQueryExactInputFilter>;
};

export type RiskRulesQueryRangeInputFilter = {
  evaluatedAt?: InputMaybe<StringRangeInput>;
  lastUpdated?: InputMaybe<StringRangeInput>;
};

export type RiskRulesQueryResponse = {
  __typename?: 'RiskRulesQueryResponse';
  pageInfo: PageInfo;
  rules: Array<RuleObject>;
};

export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  type: RoleType;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type RoleQueryResponse = {
  __typename?: 'RoleQueryResponse';
  role: Role;
};

export enum RoleType {
  Custom = 'custom',
  Internal = 'internal'
}

export type RolesQueryResponse = {
  __typename?: 'RolesQueryResponse';
  permissions: Array<Permission>;
  roles: Array<Role>;
};

export type RollingReserve = {
  __typename?: 'RollingReserve';
  amount?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  releasedOn?: Maybe<Scalars['String']['output']>;
};

export enum RollingReserveTypeEnum {
  BasisPoints = 'BASIS_POINTS',
  Fixed = 'FIXED'
}

export enum RollingReserveTypes {
  BasisPoints = 'BASIS_POINTS',
  Fixed = 'FIXED'
}

export type RoutineIdResponse = {
  __typename?: 'RoutineIdResponse';
  id?: Maybe<Scalars['ID']['output']>;
};

export type RoutineLog = {
  __typename?: 'RoutineLog';
  category?: Maybe<RoutineTemplateCategory>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  params?: Maybe<Scalars['JSON']['output']>;
  resourceId?: Maybe<Scalars['String']['output']>;
  routineTemplateId: Scalars['ID']['output'];
  routineTemplateName: Scalars['String']['output'];
  stepResults?: Maybe<WorkflowStep>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  workflowId: Scalars['ID']['output'];
};

export type RoutineLogsExactFilterInputValues = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  routineTemplateId?: InputMaybe<Scalars['ID']['input']>;
  routineTemplateName?: InputMaybe<Scalars['String']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
};

export type RoutineLogsInFilterInputValues = {
  category?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RoutineLogsInput = {
  filter?: InputMaybe<RoutineLogsInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type RoutineLogsInputFilter = {
  between?: InputMaybe<RoutineLogsRangeFilterInputValues>;
  equal?: InputMaybe<RoutineLogsExactFilterInputValues>;
  iLike?: InputMaybe<RoutineLogsExactFilterInputValues>;
  in?: InputMaybe<RoutineLogsInFilterInputValues>;
  like?: InputMaybe<RoutineLogsExactFilterInputValues>;
  notBetween?: InputMaybe<RoutineLogsRangeFilterInputValues>;
  notEqual?: InputMaybe<RoutineLogsExactFilterInputValues>;
  notIn?: InputMaybe<RoutineLogsInFilterInputValues>;
  notLike?: InputMaybe<RoutineLogsExactFilterInputValues>;
};

export type RoutineLogsRangeFilterInputValues = {
  completedAt?: InputMaybe<StringRangeInput>;
  createdAt?: InputMaybe<StringRangeInput>;
  updatedAt?: InputMaybe<StringRangeInput>;
};

export type RoutineLogsResponse = {
  __typename?: 'RoutineLogsResponse';
  pageInfo: PageInfo;
  routineLogs?: Maybe<Array<RoutineLog>>;
};

export type RoutineTemplate = {
  __typename?: 'RoutineTemplate';
  category?: Maybe<RoutineTemplateCategory>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  defaultValues: Array<TaskValue>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<TaskField>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: RoutinesTemplateStatuses;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userGroups: Array<Scalars['String']['output']>;
  validationConfigs?: Maybe<Array<ValidationConfig>>;
  workflowSteps: Array<WorkflowStep>;
};

export enum RoutineTemplateCategory {
  SettlementAccount = 'settlement_account'
}

export type RoutineTemplateDetails = {
  __typename?: 'RoutineTemplateDetails';
  category?: Maybe<RoutineTemplateCategory>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  defaultValues: Array<TaskValue>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<TaskField>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: RoutinesTemplateStatuses;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userGroups: Array<Scalars['String']['output']>;
  validationConfigs?: Maybe<Array<ValidationConfig>>;
  workflowSteps: Array<WorkflowStep>;
};

export type RoutineTemplateInput = {
  id: Scalars['ID']['input'];
};

export type RoutineTemplates = {
  __typename?: 'RoutineTemplates';
  routineTemplates: Array<RoutineTemplate>;
};

export enum RoutinesTemplateStatuses {
  RoutinesTemplatesStatusActive = 'routines_templates_status_active',
  RoutinesTemplatesStatusDraft = 'routines_templates_status_draft',
  RoutinesTemplatesStatusInactive = 'routines_templates_status_inactive',
  RoutinesTemplatesStatusUnspecified = 'routines_templates_status_unspecified'
}

export type RuleLogObject = {
  __typename?: 'RuleLogObject';
  attemptId?: Maybe<Scalars['ID']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['ID']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  evaluatedAt?: Maybe<Scalars['String']['output']>;
  internalRule?: Maybe<Scalars['Boolean']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['ID']['output'];
  outcome?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['Int']['output']>;
  ruleId: Scalars['ID']['output'];
  systemRule?: Maybe<Scalars['Boolean']['output']>;
  transactionId: Scalars['ID']['output'];
  values?: Maybe<Scalars['JSON']['output']>;
};

export type RuleObject = {
  __typename?: 'RuleObject';
  allowUpdatesToGroups?: Maybe<Array<Scalars['String']['output']>>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  defaultRiskAlertCategory?: Maybe<RiskAlertCategory>;
  description?: Maybe<Scalars['String']['output']>;
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  excludable?: Maybe<Scalars['Boolean']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalRule?: Maybe<Scalars['Boolean']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  logic?: Maybe<Scalars['String']['output']>;
  logicClient?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['ID']['output'];
  merchantLegalName?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<RiskRuleOutcome>;
  outcomeDetailsByRange?: Maybe<Array<Maybe<OutcomeDetailsByRangeItem>>>;
  outcomes?: Maybe<Array<RiskRuleOutcome>>;
  rulePriority?: Maybe<Scalars['Float']['output']>;
  scopingLogic?: Maybe<Scalars['String']['output']>;
  systemRule?: Maybe<Scalars['Boolean']['output']>;
};

export type RuleQueryInput = {
  id: Scalars['ID']['input'];
};

export type RuleQueryResponse = {
  __typename?: 'RuleQueryResponse';
  rule: SingleRuleObject;
};

export type RulesByResourceTypeInput = {
  resourceId: Scalars['ID']['input'];
  resourceType: ResourceType;
};

export type RulesByResourceTypeQueryResponse = {
  __typename?: 'RulesByResourceTypeQueryResponse';
  rules: Array<RuleObject>;
};

export type S3 = {
  __typename?: 'S3';
  bucket: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  folder?: Maybe<Scalars['String']['output']>;
};

export type S3Input = {
  bucket: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  folder?: InputMaybe<Scalars['String']['input']>;
};

export type SalesInfo = {
  __typename?: 'SalesInfo';
  externalSalesAgent?: Maybe<Scalars['String']['output']>;
  externalSalesOffice?: Maybe<Scalars['String']['output']>;
};

export type SalesInfoFilterInput = {
  externalSalesAgent?: InputMaybe<Scalars['String']['input']>;
  externalSalesOffice?: InputMaybe<Scalars['String']['input']>;
};

export enum SaqType {
  SaqA = 'saq_a',
  SaqD = 'saq_d'
}

export type SaveMutationResponse = {
  __typename?: 'SaveMutationResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveRole = {
  name: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']>;
};

export type SaveRoleMutationResponse = {
  __typename?: 'SaveRoleMutationResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum ScoreType {
  Initial = 'INITIAL',
  Ongoing = 'ONGOING'
}

export type ScreeningCallRequestParams = {
  __typename?: 'ScreeningCallRequestParams';
  address?: Maybe<AddressMatchFormat>;
  altPhoneNumber?: Maybe<Scalars['String']['output']>;
  doingBusinessAsName?: Maybe<Scalars['String']['output']>;
  merchantCategory: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  principals?: Maybe<Array<MatchRequestPrincipals>>;
  urls?: Maybe<Array<Scalars['String']['output']>>;
};

export type ScreeningMatchDetails = {
  __typename?: 'ScreeningMatchDetails';
  matchType: MatchType;
  value?: Maybe<Scalars['String']['output']>;
};

export type ScreeningMatchDetailsInput = {
  matchType: MatchType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ScreeningTerminatedMerchantResult = {
  __typename?: 'ScreeningTerminatedMerchantResult';
  terminatedMerchant?: Maybe<Array<TerminatedMerchantEntry>>;
  terminatedMerchantAddress?: Maybe<TerminatedMerchantAddress>;
  terminatedMerchantPrincipals?: Maybe<Array<TerminatedMerchantPrincipal>>;
  terminatedMerchantUrls?: Maybe<Array<ScreeningMatchDetails>>;
};

export type ScreeningTerminatedMerchantResultInput = {
  terminatedMerchant?: InputMaybe<Array<TerminatedMerchantEntryInput>>;
  terminatedMerchantAddress?: InputMaybe<TerminatedMerchantAddressInput>;
  terminatedMerchantPrincipals?: InputMaybe<Array<TerminatedMerchantPrincipalInput>>;
  terminatedMerchantUrls?: InputMaybe<Array<ScreeningMatchDetailsInput>>;
};

export type SdkEvent = {
  __typename?: 'SdkEvent';
  attemptId?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  consumerId?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  failure?: Maybe<Scalars['Boolean']['output']>;
  flow?: Maybe<SdkEventsFlow>;
  id?: Maybe<Scalars['String']['output']>;
  instance?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export enum SdkEventsFlow {
  Authorization = 'AUTHORIZATION',
  Checkout = 'CHECKOUT',
  Sale = 'SALE',
  Tokenization = 'TOKENIZATION',
  Verification = 'VERIFICATION'
}

export type SdkEventsQueryExactFilterInputValues = {
  attemptId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  consumerId?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  failure?: InputMaybe<Scalars['Boolean']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type SdkEventsQueryFilterInput = {
  between?: InputMaybe<SdkEventsQueryRangeFilterInputValues>;
  equal?: InputMaybe<SdkEventsQueryExactFilterInputValues>;
  greater?: InputMaybe<SdkEventsQueryExactFilterInputValues>;
  greaterOrEquals?: InputMaybe<SdkEventsQueryExactFilterInputValues>;
  iLike?: InputMaybe<SdkEventsQueryExactFilterInputValues>;
  in?: InputMaybe<SdkEventsQueryInFilterInputValues>;
  less?: InputMaybe<SdkEventsQueryExactFilterInputValues>;
  lessOrEquals?: InputMaybe<SdkEventsQueryExactFilterInputValues>;
  like?: InputMaybe<SdkEventsQueryExactFilterInputValues>;
  notBetween?: InputMaybe<SdkEventsQueryRangeFilterInputValues>;
  notEqual?: InputMaybe<SdkEventsQueryExactFilterInputValues>;
  notIn?: InputMaybe<SdkEventsQueryInFilterInputValues>;
  notLike?: InputMaybe<SdkEventsQueryExactFilterInputValues>;
};

export type SdkEventsQueryInFilterInputValues = {
  flow?: InputMaybe<Array<SdkEventsFlow>>;
};

export type SdkEventsQueryInput = {
  filter?: InputMaybe<SdkEventsQueryFilterInput>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type SdkEventsQueryRangeFilterInputValues = {
  time?: InputMaybe<StringRangeInput>;
};

export type SdkEventsQueryResponse = {
  __typename?: 'SdkEventsQueryResponse';
  pageInfo: PageInfo;
  sdkEvents: Array<SdkEvent>;
};

export type SecurityChecksOptions = {
  __typename?: 'SecurityChecksOptions';
  addressLine1Check: Scalars['Boolean']['output'];
  addressPostalCodeCheck: Scalars['Boolean']['output'];
  cvvCheck: Scalars['Boolean']['output'];
};

export type SendCustomerSupportEmailInput = {
  message: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type SendCustomerSupportEmailResponse = {
  __typename?: 'SendCustomerSupportEmailResponse';
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendVerificationCodePayload = {
  __typename?: 'SendVerificationCodePayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ServiceFees = {
  __typename?: 'ServiceFees';
  amount: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  feeDescription?: Maybe<Scalars['String']['output']>;
  feeIdentifier: Scalars['String']['output'];
  gross?: Maybe<Scalars['Boolean']['output']>;
  grossInvoiceId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  settlementId?: Maybe<Scalars['String']['output']>;
};

export type SetDefaultSettlementAccountMutationInput = {
  id: Scalars['String']['input'];
};

export type SetDefaultSettlementAccountMutationResponse = {
  __typename?: 'SetDefaultSettlementAccountMutationResponse';
  success: Scalars['Boolean']['output'];
};

export type SettingsPaymentMethodOptions = {
  __typename?: 'SettingsPaymentMethodOptions';
  applepay?: Maybe<ApplepayPaymentMethodOptions>;
  bankAccount?: Maybe<BankPaymentMethodOptions>;
  card?: Maybe<CardPaymentMethodOptions>;
  disabledPaymentMethodsTypes?: Maybe<Array<Scalars['String']['output']>>;
  googlepay?: Maybe<GooglepayPaymentMethodOptions>;
  paypal?: Maybe<PaypalPaymentMethodOptions>;
  riskControl?: Maybe<Array<DefaultRiskControl>>;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  usBankAccount?: Maybe<UsBankAccountOptions>;
};

export type SettlementAccount = {
  __typename?: 'SettlementAccount';
  acceptanceCurrencies?: Maybe<Array<CurrencyAlpha3>>;
  bankAccount?: Maybe<BankAccount>;
  bankAccountId?: Maybe<Scalars['ID']['output']>;
  currency: CurrencyAlpha3;
  defaultAccount?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
  enabledTransferTypes?: Maybe<Array<SettlementTransferTypeEnum>>;
  external?: Maybe<Scalars['Boolean']['output']>;
  fallbackFailureCodes?: Maybe<Array<Scalars['String']['output']>>;
  fallbackSettlementAccountId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mcc?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentSettlementAccount?: Maybe<Scalars['String']['output']>;
  paymentMethodProcessorMap?: Maybe<Scalars['JSON']['output']>;
  processingDisabled?: Maybe<Scalars['Boolean']['output']>;
  provider: Scalars['String']['output'];
  providerDisplayName?: Maybe<Scalars['String']['output']>;
  rollingReserveAmount?: Maybe<Scalars['String']['output']>;
  rollingReserveDuration?: Maybe<Scalars['Int']['output']>;
  rollingReserveType?: Maybe<RollingReserveTypeEnum>;
  routable?: Maybe<Scalars['Boolean']['output']>;
  scheduleConfig: SettlementScheduleConfig;
  settlementFees?: Maybe<Array<SettlementFees>>;
  settlementTransferType?: Maybe<SettlementTransferTypeEnum>;
  suspended?: Maybe<Scalars['Boolean']['output']>;
  virtual?: Maybe<Scalars['Boolean']['output']>;
};

export enum SettlementAccountDisablingOptionsTypeEnum {
  Deposits = 'deposits',
  Payouts = 'payouts',
  Refunds = 'refunds',
  Settlements = 'settlements'
}

export type SettlementAccountsQueryResponse = {
  __typename?: 'SettlementAccountsQueryResponse';
  settlementAccounts?: Maybe<Array<SettlementAccount>>;
};

export type SettlementBankAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  bankCountry?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  region?: InputMaybe<BankAccountRegion>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
  swiftBic?: InputMaybe<Scalars['String']['input']>;
};

export type SettlementFees = {
  __typename?: 'SettlementFees';
  basisFeeDescription?: Maybe<Scalars['String']['output']>;
  basisPoints?: Maybe<Scalars['String']['output']>;
  fixedFee?: Maybe<Scalars['String']['output']>;
  fixedFeeDescription?: Maybe<Scalars['String']['output']>;
  grossBasisPoints?: Maybe<Scalars['Boolean']['output']>;
  grossFixed?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
};

export type SettlementFeesDetails = {
  __typename?: 'SettlementFeesDetails';
  interchangeFees: Scalars['Float']['output'];
  networkFees: Scalars['Float']['output'];
  processedAmount: Scalars['Float']['output'];
  processedCount: Scalars['Int']['output'];
  processingFees: Scalars['Float']['output'];
  totalFees: Scalars['Float']['output'];
};

export type SettlementFeesDetailsInput = {
  interchangeFees?: InputMaybe<Scalars['Float']['input']>;
  networkFees?: InputMaybe<Scalars['Float']['input']>;
  processedAmount?: InputMaybe<Scalars['Float']['input']>;
  processedCount?: InputMaybe<Scalars['Int']['input']>;
  processingFees?: InputMaybe<Scalars['Float']['input']>;
  totalFees?: InputMaybe<Scalars['Float']['input']>;
};

export enum SettlementMethodTypes {
  Ach = 'ACH',
  CardPayout = 'CARD_PAYOUT',
  Rtp = 'RTP',
  Sepa = 'SEPA',
  Wire = 'WIRE'
}

export type SettlementObject = {
  __typename?: 'SettlementObject';
  bankReferenceNumber?: Maybe<Scalars['String']['output']>;
  blended?: Maybe<Scalars['Boolean']['output']>;
  chargeAmount?: Maybe<Scalars['Float']['output']>;
  chargeCount?: Maybe<Scalars['Int']['output']>;
  chargebackAmount?: Maybe<Scalars['Float']['output']>;
  chargebackBreakdown?: Maybe<ChargebackBreakdown>;
  chargebackCount?: Maybe<Scalars['Int']['output']>;
  chargebackFees?: Maybe<Scalars['Float']['output']>;
  companyId: Scalars['ID']['output'];
  currency: CurrencyAlpha3;
  dateFrom?: Maybe<Scalars['String']['output']>;
  dateTo?: Maybe<Scalars['String']['output']>;
  declineCount?: Maybe<Scalars['Int']['output']>;
  generalAdjustments?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  interchangeFees?: Maybe<Scalars['Float']['output']>;
  interchangeReturned?: Maybe<Scalars['Float']['output']>;
  merchantBankAccount?: Maybe<Scalars['String']['output']>;
  merchantBankName?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['ID']['output'];
  merchantLegalName?: Maybe<Scalars['String']['output']>;
  merchantStatementFile?: Maybe<Scalars['String']['output']>;
  merchantStatementFileCsv?: Maybe<Scalars['String']['output']>;
  netAmount?: Maybe<Scalars['Float']['output']>;
  networkFees?: Maybe<Scalars['Float']['output']>;
  paymentDate?: Maybe<Scalars['String']['output']>;
  payoutAmount?: Maybe<Scalars['Float']['output']>;
  payoutCount?: Maybe<Scalars['Int']['output']>;
  processedAmount?: Maybe<Scalars['Float']['output']>;
  processedCount?: Maybe<Scalars['Int']['output']>;
  processingFees?: Maybe<Scalars['Float']['output']>;
  processingFeesBreakdown?: Maybe<ProcessingFeesBreakdown>;
  processingFeesBreakdownDetailed?: Maybe<ProcessingFeesBreakdownDetailed>;
  refundAmount?: Maybe<Scalars['Float']['output']>;
  refundCount?: Maybe<Scalars['Int']['output']>;
  rollingReserveAdjustment?: Maybe<Scalars['Float']['output']>;
  rollingReserveAmount?: Maybe<Scalars['Float']['output']>;
  rollingReserveReleasedAmount?: Maybe<Scalars['Float']['output']>;
  serviceFees?: Maybe<Scalars['Float']['output']>;
  /** COMPUTED_FIELD: represents settlement service fees list */
  serviceFeesBreakdown?: Maybe<Array<ServiceFees>>;
  settlementAccountName?: Maybe<Scalars['String']['output']>;
  settlementFee?: Maybe<Scalars['Float']['output']>;
  settlementMethod?: Maybe<SettlementMethodTypes>;
  settlingEntity?: Maybe<Scalars['String']['output']>;
  settlingEntityId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalFees?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
};

export type SettlementQueryInput = {
  currency: CurrencyAlpha3;
  id: Scalars['ID']['input'];
};

export type SettlementScheduleConfig = {
  __typename?: 'SettlementScheduleConfig';
  day?: Maybe<Scalars['Int']['output']>;
  schedule: SettlementScheduleConfigEnum;
};

export enum SettlementScheduleConfigEnum {
  Daily = 'daily',
  Manual = 'manual',
  Monthly = 'monthly',
  Weekly = 'weekly'
}

export type SettlementScheduleConfigInput = {
  day?: InputMaybe<Scalars['Int']['input']>;
  schedule: SettlementScheduleConfigEnum;
};

export type SettlementScheduleConfigInputFilterValues = {
  day?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<Array<SettlementScheduleConfigEnum>>;
};

export type SettlementScheduleConfigPreview = {
  __typename?: 'SettlementScheduleConfigPreview';
  day?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<SettlementScheduleConfigEnum>;
};

export type SettlementScheduleFilterInput = {
  day?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<Array<InputMaybe<SettlementScheduleConfigEnum>>>;
};

export type SettlementStatementQueryInput = {
  id: Scalars['ID']['input'];
  type: StatementType;
};

export type SettlementStatementQueryResponse = {
  __typename?: 'SettlementStatementQueryResponse';
  downloadUrl?: Maybe<Scalars['String']['output']>;
};

export type SettlementTerms = {
  __typename?: 'SettlementTerms';
  currencies?: Maybe<Array<CurrencyAlpha3>>;
  fundingDelay?: Maybe<Scalars['Int']['output']>;
  maximumHeldReserve?: Maybe<Scalars['String']['output']>;
  maximumHeldReserveCurrency?: Maybe<CurrencyAlpha3>;
  rollingReserveAmount?: Maybe<Scalars['String']['output']>;
  rollingReserveAmountCurrency?: Maybe<CurrencyAlpha3>;
  rollingReserveDuration?: Maybe<Scalars['Int']['output']>;
  rollingReserveType?: Maybe<RollingReserveTypeEnum>;
  scheduleConfig?: Maybe<SettlementScheduleConfig>;
  securityDepositAmount?: Maybe<Scalars['String']['output']>;
  securityDepositAmountCurrency?: Maybe<CurrencyAlpha3>;
};

export type SettlementTermsFilterInput = {
  currencies?: InputMaybe<Array<CurrencyAlpha3>>;
  fundingDelay?: InputMaybe<Scalars['Int']['input']>;
  maximumHeldReserve?: InputMaybe<Scalars['String']['input']>;
  maximumHeldReserveCurrency?: InputMaybe<CurrencyAlpha3>;
  rollingReserveAmount?: InputMaybe<Scalars['Float']['input']>;
  rollingReserveAmountCurrency?: InputMaybe<CurrencyAlpha3>;
  rollingReserveDuration?: InputMaybe<Scalars['Int']['input']>;
  rollingReserveType?: InputMaybe<Array<InputMaybe<RollingReserveTypeEnum>>>;
  scheduleConfig?: InputMaybe<SettlementScheduleFilterInput>;
  securityDepositAmount?: InputMaybe<Scalars['Float']['input']>;
  securityDepositAmountCurrency?: InputMaybe<CurrencyAlpha3>;
};

export type SettlementTermsInput = {
  currencies?: InputMaybe<Array<CurrencyAlpha3>>;
  fundingDelay?: InputMaybe<Scalars['Int']['input']>;
  maximumHeldReserve?: InputMaybe<Scalars['String']['input']>;
  maximumHeldReserveCurrency?: InputMaybe<CurrencyAlpha3>;
  rollingReserveAmount?: InputMaybe<Scalars['String']['input']>;
  rollingReserveAmountCurrency?: InputMaybe<CurrencyAlpha3>;
  rollingReserveDuration?: InputMaybe<Scalars['Int']['input']>;
  rollingReserveType?: InputMaybe<RollingReserveTypeEnum>;
  scheduleConfig?: InputMaybe<SettlementScheduleConfigInput>;
  securityDepositAmount?: InputMaybe<Scalars['String']['input']>;
  securityDepositAmountCurrency?: InputMaybe<CurrencyAlpha3>;
};

export type SettlementTermsPreview = {
  __typename?: 'SettlementTermsPreview';
  currencies?: Maybe<Array<CurrencyAlpha3>>;
  fundingDelay?: Maybe<Scalars['Int']['output']>;
  maximumHeldReserve?: Maybe<Scalars['String']['output']>;
  maximumHeldReserveCurrency?: Maybe<CurrencyAlpha3>;
  rollingReserveAmount?: Maybe<Scalars['String']['output']>;
  rollingReserveAmountCurrency?: Maybe<CurrencyAlpha3>;
  rollingReserveDuration?: Maybe<Scalars['Int']['output']>;
  rollingReserveType?: Maybe<RollingReserveTypeEnum>;
  scheduleConfig?: Maybe<SettlementScheduleConfigPreview>;
  securityDepositAmount?: Maybe<Scalars['String']['output']>;
  securityDepositAmountCurrency?: Maybe<CurrencyAlpha3>;
};

export type SettlementTransactionsStatsQueryInput = {
  dateTime?: InputMaybe<StringRangeInput>;
  settlementId: Scalars['ID']['input'];
};

export type SettlementTransactionsStatsQueryResponse = {
  __typename?: 'SettlementTransactionsStatsQueryResponse';
  chargebacksCount: Scalars['Int']['output'];
  chargesCount: Scalars['Int']['output'];
  declinesCount: Scalars['Int']['output'];
  holdsCount: Scalars['Int']['output'];
  payoutsCount: Scalars['Int']['output'];
  refundsCount: Scalars['Int']['output'];
  representmentsCount: Scalars['Int']['output'];
};

export enum SettlementTransferTypeEnum {
  AchNextDay = 'ach_next_day',
  AchSameDay = 'ach_same_day',
  Bank = 'bank',
  BankInstant = 'bank_instant',
  Card = 'card',
  FedNow = 'fed_now',
  Rtp = 'rtp',
  Sepa = 'sepa',
  SepaInstant = 'sepa_instant'
}

export type SettlementsQueryExactFilterInputValues = {
  bankReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  blended?: InputMaybe<Scalars['Boolean']['input']>;
  chargebackAmount?: InputMaybe<Scalars['Float']['input']>;
  chargebackBreakdown?: InputMaybe<ChargebackBreakdownInput>;
  chargebackCount?: InputMaybe<Scalars['Int']['input']>;
  chargebackFees?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<CurrencyAlpha3>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  generalAdjustments?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  interchangeFees?: InputMaybe<Scalars['Float']['input']>;
  interchangeReturned?: InputMaybe<Scalars['Float']['input']>;
  merchantBankAccount?: InputMaybe<Scalars['String']['input']>;
  merchantBankName?: InputMaybe<Scalars['String']['input']>;
  merchantStatementFile?: InputMaybe<Scalars['String']['input']>;
  netAmount?: InputMaybe<Scalars['Float']['input']>;
  networkFees?: InputMaybe<Scalars['Float']['input']>;
  paymentDate?: InputMaybe<Scalars['String']['input']>;
  processedAmount?: InputMaybe<Scalars['Float']['input']>;
  processedCount?: InputMaybe<Scalars['Int']['input']>;
  processingFees?: InputMaybe<Scalars['Float']['input']>;
  processingFeesBreakdown?: InputMaybe<ProcessingFeesBreakdownInput>;
  processingFeesBreakdownDetailed?: InputMaybe<ProcessingFeesBreakdownDetailedInput>;
  refundAmount?: InputMaybe<Scalars['Float']['input']>;
  refundCount?: InputMaybe<Scalars['Int']['input']>;
  rollingReserveAdjustment?: InputMaybe<Scalars['Float']['input']>;
  rollingReserveAmount?: InputMaybe<Scalars['Float']['input']>;
  rollingReserveReleasedAmount?: InputMaybe<Scalars['Float']['input']>;
  serviceFees?: InputMaybe<Scalars['Float']['input']>;
  settlementFee?: InputMaybe<Scalars['Float']['input']>;
  settlementMethod?: InputMaybe<SettlementMethodTypes>;
  settlingEntity?: InputMaybe<Scalars['String']['input']>;
  settlingEntityId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  totalFees?: InputMaybe<Scalars['Float']['input']>;
};

export type SettlementsQueryInFilterInputValues = {
  bankReferenceNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blended?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  chargebackAmount?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  chargebackBreakdown?: InputMaybe<Array<InputMaybe<ChargebackBreakdownInput>>>;
  chargebackCount?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  chargebackFees?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  currency?: InputMaybe<Array<InputMaybe<CurrencyAlpha3>>>;
  dateFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  generalAdjustments?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  interchangeFees?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  interchangeReturned?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  merchantBankAccount?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  merchantBankName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  merchantStatementFile?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  netAmount?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  networkFees?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  paymentDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  processedAmount?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  processedCount?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  processingFees?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  processingFeesBreakdown?: InputMaybe<Array<InputMaybe<ProcessingFeesBreakdownInput>>>;
  processingFeesBreakdownDetailed?: InputMaybe<Array<InputMaybe<ProcessingFeesBreakdownDetailedInput>>>;
  refundAmount?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  refundCount?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rollingReserveAdjustment?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  rollingReserveAmount?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  rollingReserveReleasedAmount?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  serviceFees?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  settlementAccountId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settlementFee?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  settlementMethod?: InputMaybe<Array<InputMaybe<SettlementMethodTypes>>>;
  settlingEntity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settlingEntityId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  totalFees?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type SettlementsQueryInput = {
  filter?: InputMaybe<SettlementsQueryInputFilter>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type SettlementsQueryInputFilter = {
  and?: InputMaybe<Array<SettlementsQueryInputFilter>>;
  between?: InputMaybe<SettlementsQueryRangeFilterInputValues>;
  equal?: InputMaybe<SettlementsQueryExactFilterInputValues>;
  greater?: InputMaybe<SettlementsQueryExactFilterInputValues>;
  greaterOrEquals?: InputMaybe<SettlementsQueryExactFilterInputValues>;
  iLike?: InputMaybe<SettlementsQueryExactFilterInputValues>;
  in?: InputMaybe<SettlementsQueryInFilterInputValues>;
  less?: InputMaybe<SettlementsQueryExactFilterInputValues>;
  lessOrEquals?: InputMaybe<SettlementsQueryExactFilterInputValues>;
  like?: InputMaybe<SettlementsQueryExactFilterInputValues>;
  notBetween?: InputMaybe<SettlementsQueryRangeFilterInputValues>;
  notEqual?: InputMaybe<SettlementsQueryExactFilterInputValues>;
  notIn?: InputMaybe<SettlementsQueryInFilterInputValues>;
  notLike?: InputMaybe<SettlementsQueryExactFilterInputValues>;
};

export type SettlementsQueryRangeFilterInputValues = {
  chargebackAmount?: InputMaybe<FloatRangeInput>;
  chargebackCount?: InputMaybe<IntRangeInput>;
  chargebackFees?: InputMaybe<FloatRangeInput>;
  dateFrom?: InputMaybe<StringRangeInput>;
  dateTo?: InputMaybe<StringRangeInput>;
  generalAdjustments?: InputMaybe<FloatRangeInput>;
  interchangeFees?: InputMaybe<FloatRangeInput>;
  interchangeReturned?: InputMaybe<FloatRangeInput>;
  netAmount?: InputMaybe<FloatRangeInput>;
  networkFees?: InputMaybe<FloatRangeInput>;
  paymentDate?: InputMaybe<StringRangeInput>;
  processedAmount?: InputMaybe<FloatRangeInput>;
  processedCount?: InputMaybe<IntRangeInput>;
  processingFees?: InputMaybe<FloatRangeInput>;
  refundAmount?: InputMaybe<FloatRangeInput>;
  refundCount?: InputMaybe<IntRangeInput>;
  rollingReserveAdjustment?: InputMaybe<FloatRangeInput>;
  rollingReserveAmount?: InputMaybe<FloatRangeInput>;
  rollingReserveReleasedAmount?: InputMaybe<FloatRangeInput>;
  serviceFees?: InputMaybe<FloatRangeInput>;
  settlementFee?: InputMaybe<FloatRangeInput>;
  totalFees?: InputMaybe<FloatRangeInput>;
};

export type SettlementsResponse = {
  __typename?: 'SettlementsResponse';
  pageInfo: PageInfo;
  settlements: Array<SettlementObject>;
};

export type SetupPasswordInput = {
  password: Scalars['String']['input'];
};

export type SetupPasswordPayload = {
  __typename?: 'SetupPasswordPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Sftp = {
  __typename?: 'Sftp';
  enabled: Scalars['Boolean']['output'];
  host: Scalars['String']['output'];
  port: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type SftpInput = {
  enabled: Scalars['Boolean']['input'];
  host: Scalars['String']['input'];
  port: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type ShippingDetails = {
  __typename?: 'ShippingDetails';
  address?: Maybe<Address>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type SignupMerchantMutationResponse = {
  __typename?: 'SignupMerchantMutationResponse';
  success: Scalars['Boolean']['output'];
};

export type SingleRuleObject = {
  __typename?: 'SingleRuleObject';
  allowUpdatesToGroups?: Maybe<Array<Scalars['String']['output']>>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  category: Scalars['String']['output'];
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  defaultRiskAlertCategory?: Maybe<RiskAlertCategory>;
  description: Scalars['String']['output'];
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
  excludable?: Maybe<Scalars['Boolean']['output']>;
  failureCode?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalRule: Scalars['Boolean']['output'];
  lastUpdated: Scalars['String']['output'];
  logic: Scalars['String']['output'];
  logicClient?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['ID']['output'];
  outcome?: Maybe<RiskRuleOutcome>;
  outcomeDetails?: Maybe<OutcomeDetails>;
  outcomeDetailsByRange?: Maybe<Array<OutcomeDetailsByRangeItem>>;
  outcomes?: Maybe<Array<RiskRuleOutcome>>;
  postExternalRiskCheck?: Maybe<Scalars['Boolean']['output']>;
  rulePriority?: Maybe<Scalars['Float']['output']>;
  scopingLogic?: Maybe<Scalars['String']['output']>;
  systemRule: Scalars['Boolean']['output'];
};

export type SocialMedia = {
  __typename?: 'SocialMedia';
  type: SocialMediaLinkType;
  value: Scalars['String']['output'];
};

export type SocialMediaInput = {
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export enum SocialMediaLinkType {
  App = 'app',
  Facebook = 'facebook',
  Instagram = 'instagram',
  Twitter = 'twitter'
}

export type SocialMediaObject = {
  __typename?: 'SocialMediaObject';
  type: SocialMediaLinkType;
  updatedAt?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export enum Solicitor {
  EmployeeReferral = 'EMPLOYEE_REFERRAL',
  None = 'NONE',
  PartnerReferral = 'PARTNER_REFERRAL',
  SalesConversion = 'SALES_CONVERSION'
}

export type SourceObject = {
  __typename?: 'SourceObject';
  billingDetails?: Maybe<Address>;
  billingDetailsId?: Maybe<Scalars['ID']['output']>;
  companyId: Scalars['ID']['output'];
  consumerId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lastTransactionDate?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['ID']['output'];
  paymentMethodDetails?: Maybe<PaymentMethod>;
  phone?: Maybe<Scalars['String']['output']>;
  reusablePayments: Scalars['Boolean']['output'];
  reusablePayouts: Scalars['Boolean']['output'];
  siteId?: Maybe<Scalars['ID']['output']>;
  type: Scalars['String']['output'];
  uniqueIdentifier: Scalars['String']['output'];
  validUntilDate?: Maybe<Scalars['String']['output']>;
};

export enum SourceOfIncome {
  CapitalGainsIncome = 'capital_gains_income',
  DividendIncome = 'dividend_income',
  Employment = 'employment',
  Loan = 'loan',
  Other = 'other',
  RentalIncome = 'rental_income',
  RetirementIncome = 'retirement_income'
}

export enum SourceOfWealth {
  CompanyProfits = 'company_profits',
  CompanySale = 'company_sale',
  Gifts = 'gifts',
  Inheritance = 'inheritance',
  Investments = 'investments',
  InvestmentsSale = 'investments_sale',
  Other = 'other',
  PropertySale = 'property_sale',
  RedemptionOfInvestment = 'redemption_of_investment',
  Salary = 'salary',
  Savings = 'savings'
}

export type StandaloneMerchantSignupMutationInput = {
  companyRegistrationCountry: Scalars['String']['input'];
  email: Scalars['String']['input'];
  emailNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  leadSource: MerchantLeadSource;
  merchantName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  solicitorEmail?: InputMaybe<Scalars['String']['input']>;
  testMerchant: Scalars['Boolean']['input'];
};

export type StartProvisioningMutationInput = {
  companyId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  merchants?: InputMaybe<Array<ProvisioningMerchantInput>>;
  onboardingPricingId?: InputMaybe<Scalars['ID']['input']>;
  pricingActions?: InputMaybe<Array<Scalars['String']['input']>>;
  settlementAccountId?: InputMaybe<Scalars['ID']['input']>;
  settlementCurrency?: InputMaybe<CurrencyAlpha3>;
  shouldCreateNewMerchants?: InputMaybe<Scalars['Boolean']['input']>;
  shouldCreateSettlementAccount?: InputMaybe<Scalars['Boolean']['input']>;
  submissionValues?: InputMaybe<Array<TaskFieldInput>>;
  templateId: Scalars['ID']['input'];
};

export type StartProvisioningResponse = {
  __typename?: 'StartProvisioningResponse';
  id: Scalars['ID']['output'];
};

export type StartRoutineMutationInput = {
  id: Scalars['ID']['input'];
  params?: InputMaybe<Array<TaskFieldInput>>;
  resourceId: Scalars['String']['input'];
};

export type StartRoutineResponse = {
  __typename?: 'StartRoutineResponse';
  workflowId?: Maybe<Scalars['String']['output']>;
};

/** REFERENCE: https://github.com/pay-com/node-libs-common/blob/92feccf89fda3ec71974262af42e2d855f6787b4/enums/common-enums/statement-types.js */
export enum StatementType {
  Balance = 'balance',
  CreditNote = 'credit_note',
  CreditNoteBefore_30thDec_2024 = 'credit_note_before_30th_dec_2024',
  Receipt = 'receipt',
  Reserve = 'reserve',
  Settlement = 'settlement',
  SettlementWithConfig = 'settlement_with_config',
  TaxInvoice = 'tax_invoice',
  TaxInvoiceBefore_30thDec_2024 = 'tax_invoice_before_30th_dec_2024',
  TaxInvoiceWithConfig = 'tax_invoice_with_config'
}

export type StringRangeInput = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type Structure = {
  __typename?: 'Structure';
  amlRiskScore?: Maybe<Scalars['Int']['output']>;
  countryAlpha2: CountryAlpha2;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  localName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type StructureMutationResponse = {
  __typename?: 'StructureMutationResponse';
  payload?: Maybe<StructurePayload>;
  success: Scalars['Boolean']['output'];
};

export type StructurePayload = {
  __typename?: 'StructurePayload';
  countryAlpha2: CountryAlpha2;
  key: Scalars['String']['output'];
};

export type StructureQueryInput = {
  countryAlpha2: CountryAlpha2;
  key: Scalars['String']['input'];
};

export type StructuresByCountryQueryInput = {
  countryAlpha2: CountryAlpha2;
};

export type StructuresQueryResponse = {
  __typename?: 'StructuresQueryResponse';
  structures: Array<Structure>;
};

export type SubmitEvidenceMutationInput = {
  disputeId: Scalars['String']['input'];
  files: Array<Scalars['String']['input']>;
  receivedOn: Scalars['String']['input'];
  text: Scalars['String']['input'];
  type: EvidenceType;
};

export type SubmitEvidenceMutationPayload = {
  __typename?: 'SubmitEvidenceMutationPayload';
  disputeId: Scalars['String']['output'];
  status: DisputeStatus;
};

export type SubmitEvidenceMutationResponse = {
  __typename?: 'SubmitEvidenceMutationResponse';
  payload: SubmitEvidenceMutationPayload;
  success: Scalars['Boolean']['output'];
};

export type SubmitMerchantApprovalMutationInput = {
  comments: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  conditions?: InputMaybe<Scalars['String']['input']>;
  groupsAssigned?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  merchantId: Scalars['String']['input'];
  status: OnboardingApprovalStatus;
};

export type SubmitTask = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  signal?: InputMaybe<Scalars['String']['input']>;
  values: Array<TaskFieldInput>;
};

export type Subscription = {
  __typename?: 'Subscription';
  blacklistedCards?: Maybe<Array<Scalars['String']['output']>>;
  cancelAt?: Maybe<Scalars['String']['output']>;
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  cancellationReason?: Maybe<CancellationReasonEnum>;
  consumer?: Maybe<SubscriptionConsumer>;
  consumerEmail?: Maybe<Scalars['String']['output']>;
  consumerId: Scalars['String']['output'];
  consumerRegion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currentPeriodEndDate?: Maybe<Scalars['String']['output']>;
  currentPeriodStartDate?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['String']['output']>;
  failedChargingAttempts?: Maybe<Scalars['Int']['output']>;
  failedNextChargeAttemptDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  initialSubscriptionSession?: Maybe<Scalars['String']['output']>;
  latestSuccessfulAmount?: Maybe<Scalars['String']['output']>;
  latestSuccessfulCharge?: Maybe<Scalars['String']['output']>;
  previousSources?: Maybe<Array<Maybe<SubscriptionSourceObject>>>;
  reference?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<CustomSettingsObject>;
  sourceId: Scalars['String']['output'];
  sources?: Maybe<Array<Maybe<SubscriptionSourceObject>>>;
  status?: Maybe<SubscriptionStatusEnum>;
  to?: Maybe<Scalars['JSON']['output']>;
  totalCollectedAmount?: Maybe<Scalars['Float']['output']>;
  transactionsCount?: Maybe<Scalars['Int']['output']>;
  trialPeriodEndDate?: Maybe<Scalars['String']['output']>;
  trialPeriodStartDate?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionAddressObject = {
  __typename?: 'SubscriptionAddressObject';
  address: Address;
  id: Scalars['ID']['output'];
};

export type SubscriptionConsumer = {
  __typename?: 'SubscriptionConsumer';
  billingDetails: Array<Maybe<SubscriptionAddressObject>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  defaultSource?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  merchantConsumerId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  shippingDetails: Array<Maybe<SubscriptionAddressObject>>;
};

export type SubscriptionListItem = {
  __typename?: 'SubscriptionListItem';
  blacklistedCards?: Maybe<Array<Scalars['String']['output']>>;
  cancelAt?: Maybe<Scalars['String']['output']>;
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  cancellationReason?: Maybe<CancellationReasonEnum>;
  consumerEmail?: Maybe<Scalars['String']['output']>;
  consumerId: Scalars['String']['output'];
  consumerRegion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currentPeriodEndDate?: Maybe<Scalars['String']['output']>;
  currentPeriodStartDate?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['String']['output']>;
  failedChargingAttempts?: Maybe<Scalars['Int']['output']>;
  failedNextChargeAttemptDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  initialSubscriptionSession?: Maybe<Scalars['String']['output']>;
  latestSuccessfulAmount?: Maybe<Scalars['String']['output']>;
  latestSuccessfulCharge?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<CustomSettingsObject>;
  sourceId: Scalars['String']['output'];
  status?: Maybe<SubscriptionStatusEnum>;
  to?: Maybe<Scalars['JSON']['output']>;
  totalCollectedAmount?: Maybe<Scalars['Float']['output']>;
  transactionsCount?: Maybe<Scalars['Int']['output']>;
  trialPeriodEndDate?: Maybe<Scalars['String']['output']>;
  trialPeriodStartDate?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionPackage = {
  __typename?: 'SubscriptionPackage';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['String']['output'];
  currency?: Maybe<CurrencyAlpha3>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  latestCollectedAmount?: Maybe<Scalars['Float']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  settings: CommonSettingsObject;
  totalCollectedAmount?: Maybe<Scalars['Float']['output']>;
  totalSubscriptions?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type SubscriptionPackageQueryInput = {
  id: Scalars['ID']['input'];
};

export type SubscriptionPackagesQueryExactFilterInputValues = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPackagesQueryInFilterInputValues = {
  active?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  settings__amount__type?: InputMaybe<Array<InputMaybe<AmountTypeEnum>>>;
  settings__currency?: InputMaybe<Array<InputMaybe<CurrencyAlpha3>>>;
};

export type SubscriptionPackagesQueryInput = {
  filter?: InputMaybe<SubscriptionPackagesQueryInputFilter>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type SubscriptionPackagesQueryInputFilter = {
  and?: InputMaybe<Array<SubscriptionPackagesQueryInputFilter>>;
  between?: InputMaybe<SubscriptionPackagesQueryRangeFilterInputValues>;
  equal?: InputMaybe<SubscriptionPackagesQueryExactFilterInputValues>;
  greater?: InputMaybe<SubscriptionPackagesQueryExactFilterInputValues>;
  greaterOrEquals?: InputMaybe<SubscriptionPackagesQueryExactFilterInputValues>;
  iLike?: InputMaybe<SubscriptionPackagesQueryExactFilterInputValues>;
  in?: InputMaybe<SubscriptionPackagesQueryInFilterInputValues>;
  less?: InputMaybe<SubscriptionPackagesQueryExactFilterInputValues>;
  lessOrEquals?: InputMaybe<SubscriptionPackagesQueryExactFilterInputValues>;
  like?: InputMaybe<SubscriptionPackagesQueryExactFilterInputValues>;
  notBetween?: InputMaybe<SubscriptionPackagesQueryRangeFilterInputValues>;
  notEqual?: InputMaybe<SubscriptionPackagesQueryExactFilterInputValues>;
  notIn?: InputMaybe<SubscriptionPackagesQueryInFilterInputValues>;
  notLike?: InputMaybe<SubscriptionPackagesQueryExactFilterInputValues>;
  or?: InputMaybe<Array<SubscriptionPackagesQueryInputFilter>>;
  textSearchCaseInsensitive?: InputMaybe<SubscriptionPackagesQueryExactFilterInputValues>;
};

export type SubscriptionPackagesQueryRangeFilterInputValues = {
  createdAt?: InputMaybe<StringRangeInput>;
  lastCollectedAmount?: InputMaybe<IntRangeInput>;
};

export type SubscriptionPackagesQueryResponse = {
  __typename?: 'SubscriptionPackagesQueryResponse';
  pageInfo: PageInfo;
  subscriptionPackages: Array<SubscriptionPackage>;
};

export type SubscriptionQueryInput = {
  id: Scalars['ID']['input'];
};

export type SubscriptionSourceObject = {
  __typename?: 'SubscriptionSourceObject';
  id: Scalars['ID']['output'];
  paymentMethodDetails?: Maybe<PaymentMethod>;
  type?: Maybe<Scalars['String']['output']>;
  uniqueIdentifier?: Maybe<Scalars['String']['output']>;
};

export enum SubscriptionStatusEnum {
  Active = 'active',
  Canceled = 'canceled',
  Draft = 'draft',
  Failed = 'failed',
  Paused = 'paused',
  Trialing = 'trialing',
  Unpaid = 'unpaid'
}

export type SubscriptionsQueryExactFilterInputValues = {
  cancelAt?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<CancellationReasonEnum>;
  consumerFullName?: InputMaybe<Scalars['String']['input']>;
  consumerId?: InputMaybe<Scalars['String']['input']>;
  consumerRegion?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  initialSubscriptionSession?: InputMaybe<Scalars['String']['input']>;
  latestSuccessfulCharge?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  settings__description?: InputMaybe<Scalars['String']['input']>;
  settings__id?: InputMaybe<Scalars['String']['input']>;
  settings__settings__amount__amount?: InputMaybe<Scalars['Float']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SubscriptionStatusEnum>;
};

export type SubscriptionsQueryInFilterInputValues = {
  cancellationReason?: InputMaybe<Array<InputMaybe<CancellationReasonEnum>>>;
  settings__settings__currency?: InputMaybe<Array<InputMaybe<CurrencyAlpha3>>>;
  status?: InputMaybe<Array<InputMaybe<SubscriptionStatusEnum>>>;
};

export type SubscriptionsQueryInput = {
  filter?: InputMaybe<SubscriptionsQueryInputFilter>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type SubscriptionsQueryInputFilter = {
  and?: InputMaybe<Array<SubscriptionsQueryInputFilter>>;
  between?: InputMaybe<SubscriptionsQueryRangeFilterInputValues>;
  equal?: InputMaybe<SubscriptionsQueryExactFilterInputValues>;
  greater?: InputMaybe<SubscriptionsQueryExactFilterInputValues>;
  greaterOrEquals?: InputMaybe<SubscriptionsQueryExactFilterInputValues>;
  iLike?: InputMaybe<SubscriptionsQueryExactFilterInputValues>;
  in?: InputMaybe<SubscriptionsQueryInFilterInputValues>;
  less?: InputMaybe<SubscriptionsQueryExactFilterInputValues>;
  lessOrEquals?: InputMaybe<SubscriptionsQueryExactFilterInputValues>;
  like?: InputMaybe<SubscriptionsQueryExactFilterInputValues>;
  notBetween?: InputMaybe<SubscriptionsQueryRangeFilterInputValues>;
  notEqual?: InputMaybe<SubscriptionsQueryExactFilterInputValues>;
  notIn?: InputMaybe<SubscriptionsQueryInFilterInputValues>;
  notLike?: InputMaybe<SubscriptionsQueryExactFilterInputValues>;
  or?: InputMaybe<Array<SubscriptionsQueryInputFilter>>;
  textSearchCaseInsensitive?: InputMaybe<SubscriptionsQueryExactFilterInputValues>;
};

export type SubscriptionsQueryRangeFilterInputValues = {
  cancelAt?: InputMaybe<StringRangeInput>;
  createdAt?: InputMaybe<StringRangeInput>;
  currentPeriodEndDate?: InputMaybe<StringRangeInput>;
  currentPeriodStartDate?: InputMaybe<StringRangeInput>;
  endedAt?: InputMaybe<StringRangeInput>;
  failedChargingAttempts?: InputMaybe<IntRangeInput>;
  failedNextChargeAttemptDate?: InputMaybe<StringRangeInput>;
  latestSuccessfulAmount?: InputMaybe<IntRangeInput>;
  settings__settings__amount__amount?: InputMaybe<FloatRangeInput>;
  trialPeriodEndDate?: InputMaybe<StringRangeInput>;
  trialPeriodStartDate?: InputMaybe<StringRangeInput>;
  updatedAt?: InputMaybe<IntRangeInput>;
};

export type SubscriptionsQueryResponse = {
  __typename?: 'SubscriptionsQueryResponse';
  pageInfo: PageInfo;
  subscriptions: Array<SubscriptionListItem>;
};

export type SupersetMutationResponse = {
  __typename?: 'SupersetMutationResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SyncOnboardingPricingInput = {
  id: Scalars['ID']['input'];
};

export type SyncOnboardingPricingMutationResponse = {
  __typename?: 'SyncOnboardingPricingMutationResponse';
  filename: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Task = {
  __typename?: 'Task';
  attachments?: Maybe<Array<Scalars['String']['output']>>;
  canceledAt?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiresOn?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  merchantGroupAssignee?: Maybe<Scalars['String']['output']>;
  requestReason?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  resourceId?: Maybe<Scalars['String']['output']>;
  signal?: Maybe<Scalars['String']['output']>;
  status: TaskStatus;
  title: Scalars['String']['output'];
  values?: Maybe<Array<TaskValue>>;
};

export type TaskActionButton = {
  __typename?: 'TaskActionButton';
  confirmationModalConfig?: Maybe<ConfirmationModalConfig>;
  label: Scalars['String']['output'];
  requiresConfirmation?: Maybe<Scalars['Boolean']['output']>;
  signal?: Maybe<Scalars['String']['output']>;
  style: TaskActionStyle;
  validationConfigs?: Maybe<Array<ValidationConfig>>;
};

export enum TaskActionStyle {
  Danger = 'danger',
  Inactive = 'inactive',
  Primary = 'primary',
  Secondary = 'secondary',
  SecondaryDanger = 'secondary_danger',
  Success = 'success',
  Text = 'text',
  Warning = 'warning'
}

export type TaskCategoriesResponse = {
  __typename?: 'TaskCategoriesResponse';
  categories: Array<TaskCategory>;
};

export type TaskCategory = {
  __typename?: 'TaskCategory';
  id?: Maybe<Scalars['ID']['output']>;
  subcategories?: Maybe<Array<TaskFieldsOption>>;
  title: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TaskCategoryInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TaskCategoryListInput = {
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Array<Scalars['String']['input']>>;
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TaskDetail = {
  __typename?: 'TaskDetail';
  actions: Array<TaskActionButton>;
  attachments?: Maybe<Array<Scalars['String']['output']>>;
  canceledAt?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiresOn?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<TaskField>>;
  id: Scalars['ID']['output'];
  merchantGroupAssignee?: Maybe<Scalars['String']['output']>;
  requestReason?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  resourceId?: Maybe<Scalars['String']['output']>;
  signal?: Maybe<Scalars['String']['output']>;
  status: TaskStatus;
  title: Scalars['String']['output'];
  values?: Maybe<Array<TaskValue>>;
};

export type TaskDisputeInFilterInput = {
  reasonCategory?: InputMaybe<Array<DisputeReason>>;
  status?: InputMaybe<Array<DisputeStatus>>;
};

export type TaskDisputeInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  processor?: InputMaybe<Scalars['String']['input']>;
  reasonCode?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type TaskField = {
  __typename?: 'TaskField';
  documentsFieldConfig?: Maybe<TaskFieldsDocumentConfig>;
  externalId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  options?: Maybe<Array<TaskFieldsOption>>;
  optionsFieldConfig?: Maybe<TaskFieldsOptionConfig>;
  placeholder?: Maybe<Scalars['String']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  tooltipText?: Maybe<Scalars['String']['output']>;
  type: TaskFieldType;
};

export type TaskFieldInput = {
  key: Scalars['String']['input'];
  value: InputTaskFieldGenericValue;
};

export enum TaskFieldType {
  AutoComplete = 'auto_complete',
  Boolean = 'boolean',
  Date = 'date',
  Documents = 'documents',
  Email = 'email',
  MultiSelect = 'multi_select',
  Number = 'number',
  RichText = 'rich_text',
  Select = 'select',
  StringifiedNumber = 'stringified_number',
  Text = 'text',
  TextArea = 'text_area',
  TextList = 'text_list'
}

export type TaskFieldValue = {
  __typename?: 'TaskFieldValue';
  boolValue?: Maybe<Scalars['Boolean']['output']>;
  jsonValue?: Maybe<Scalars['JSON']['output']>;
  listValue?: Maybe<Array<TaskFieldValue>>;
  numberValue?: Maybe<Scalars['Float']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
};

export type TaskFieldsDocumentConfig = {
  __typename?: 'TaskFieldsDocumentConfig';
  accept?: Maybe<Scalars['String']['output']>;
  autoUpload?: Maybe<Scalars['Boolean']['output']>;
  internalFileNamePrefix?: Maybe<Scalars['String']['output']>;
  labelFileNamePrefix?: Maybe<Scalars['String']['output']>;
  maxPageCount?: Maybe<Scalars['Int']['output']>;
  maxSizeMB?: Maybe<Scalars['Int']['output']>;
  multiple?: Maybe<Scalars['Boolean']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  validatePdfForLargeImages?: Maybe<Scalars['Boolean']['output']>;
  withModalConfirmation?: Maybe<Scalars['Boolean']['output']>;
  withProgressBar?: Maybe<Scalars['Boolean']['output']>;
};

export type TaskFieldsDocumentConfigInput = {
  accept?: InputMaybe<Scalars['String']['input']>;
  autoUpload?: InputMaybe<Scalars['Boolean']['input']>;
  internalFileNamePrefix?: InputMaybe<Scalars['String']['input']>;
  labelFileNamePrefix?: InputMaybe<Scalars['String']['input']>;
  maxPageCount?: InputMaybe<Scalars['Int']['input']>;
  maxSizeMB?: InputMaybe<Scalars['Int']['input']>;
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  validatePdfForLargeImages?: InputMaybe<Scalars['Boolean']['input']>;
  withModalConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  withProgressBar?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaskFieldsInput = {
  documentsFieldConfig?: InputMaybe<TaskFieldsDocumentConfigInput>;
  externalId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  options?: InputMaybe<Array<TaskFieldsOptionInput>>;
  optionsFieldConfig?: InputMaybe<TaskFieldsOptionConfigInput>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  tooltipText?: InputMaybe<Scalars['String']['input']>;
  type: TaskFieldType;
};

export type TaskFieldsOption = {
  __typename?: 'TaskFieldsOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TaskFieldsOptionConfig = {
  __typename?: 'TaskFieldsOptionConfig';
  creatable?: Maybe<Scalars['Boolean']['output']>;
  withClearButton?: Maybe<Scalars['Boolean']['output']>;
};

export type TaskFieldsOptionConfigInput = {
  creatable?: InputMaybe<Scalars['Boolean']['input']>;
  withClearButton?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaskFieldsOptionInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type TaskGroupTemplate = {
  __typename?: 'TaskGroupTemplate';
  archived?: Maybe<Scalars['Boolean']['output']>;
  categoryId?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type TaskGroupTemplateMutationResponse = {
  __typename?: 'TaskGroupTemplateMutationResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TaskGroupTemplateQueryInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
};

export type TaskGroupTemplatesQueryResponse = {
  __typename?: 'TaskGroupTemplatesQueryResponse';
  taskGroupTemplates: Array<TaskGroupTemplate>;
};

export type TaskMutationResponse = {
  __typename?: 'TaskMutationResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TaskQueryInput = {
  id: Scalars['ID']['input'];
};

export enum TaskStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Expired = 'expired',
  New = 'new'
}

export enum TaskSystem {
  Dashboard = 'dashboard',
  Hubspot = 'hubspot',
  Paypass = 'paypass'
}

export type TaskTemplate = {
  __typename?: 'TaskTemplate';
  category?: Maybe<TaskCategory>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  system?: Maybe<TaskSystem>;
  taskCategoryId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: TaskType;
  workflow?: Maybe<Scalars['String']['output']>;
};

export type TaskTemplateActionButtonInput = {
  confirmationModalConfig?: InputMaybe<ConfirmationModalConfigInput>;
  label: Scalars['String']['input'];
  requiresConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  signal?: InputMaybe<Scalars['String']['input']>;
  style: TaskActionStyle;
};

export type TaskTemplateDetail = {
  __typename?: 'TaskTemplateDetail';
  actions?: Maybe<Array<TaskActionButton>>;
  category?: Maybe<TaskCategory>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<TaskField>>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  system?: Maybe<TaskSystem>;
  taskCategoryId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TaskType>;
  workflow?: Maybe<Scalars['String']['output']>;
};

export type TaskTemplateQueryInput = {
  id: Scalars['ID']['input'];
};

export type TaskTemplateResponse = {
  __typename?: 'TaskTemplateResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TaskTemplatesQueryResponse = {
  __typename?: 'TaskTemplatesQueryResponse';
  categories?: Maybe<Array<TaskCategory>>;
  taskTemplates: Array<TaskTemplate>;
};

export enum TaskType {
  External = 'external',
  Internal = 'internal'
}

export type TaskValue = {
  __typename?: 'TaskValue';
  key: Scalars['ID']['output'];
  value: TaskFieldValue;
};

export type TasksQueryInput = {
  filter?: InputMaybe<TasksQueryInputFilter>;
  ignoreSelect?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type TasksQueryResponse = {
  __typename?: 'TasksQueryResponse';
  pageInfo: PageInfo;
  tasks: Array<Task>;
};

export type TaxInfo = {
  __typename?: 'TaxInfo';
  address?: Maybe<Address>;
  electronicTaxDocumentConsent?: Maybe<Scalars['Boolean']['output']>;
  exemptPayee?: Maybe<Scalars['Boolean']['output']>;
  taxAddressSameAsRegisteredBusinessAddress?: Maybe<Scalars['Boolean']['output']>;
  taxExempt501c?: Maybe<Scalars['Boolean']['output']>;
  taxpayerIdNumber?: Maybe<Scalars['String']['output']>;
  taxpayerIdType?: Maybe<TaxNumberType>;
  taxpayerName?: Maybe<Scalars['String']['output']>;
};

export type TaxInfoFilterInput = {
  address?: InputMaybe<AddressInput>;
  electronicTaxDocumentConsent?: InputMaybe<Scalars['Boolean']['input']>;
  exemptPayee?: InputMaybe<Scalars['Boolean']['input']>;
  taxAddressSameAsRegisteredBusinessAddress?: InputMaybe<Scalars['Boolean']['input']>;
  taxExempt501c?: InputMaybe<Scalars['Boolean']['input']>;
  taxpayerIdNumber?: InputMaybe<Scalars['String']['input']>;
  taxpayerIdType?: InputMaybe<Scalars['String']['input']>;
  taxpayerName?: InputMaybe<Scalars['String']['input']>;
};

export type TaxInfoInFilterInput = {
  address?: InputMaybe<AddressListInput>;
};

export type TaxInfoInput = {
  address?: InputMaybe<AddressInput>;
  electronicTaxDocumentConsent?: InputMaybe<Scalars['Boolean']['input']>;
  exemptPayee?: InputMaybe<Scalars['Boolean']['input']>;
  taxAddressSameAsRegisteredBusinessAddress?: InputMaybe<Scalars['Boolean']['input']>;
  taxExempt501c?: InputMaybe<Scalars['Boolean']['input']>;
  taxpayerIdNumber?: InputMaybe<Scalars['String']['input']>;
  taxpayerIdType?: InputMaybe<TaxNumberType>;
  taxpayerName?: InputMaybe<Scalars['String']['input']>;
};

export enum TaxNumberType {
  Ein = 'ein',
  Itin = 'itin',
  Ssn = 'ssn'
}

export type TerminatedMerchantAddress = {
  __typename?: 'TerminatedMerchantAddress';
  addressLine?: Maybe<ScreeningMatchDetails>;
  addressLine2?: Maybe<ScreeningMatchDetails>;
  city?: Maybe<ScreeningMatchDetails>;
  countryAlpha2?: Maybe<ScreeningMatchDetails>;
  state?: Maybe<ScreeningMatchDetails>;
  zip?: Maybe<ScreeningMatchDetails>;
};

export type TerminatedMerchantAddressInput = {
  addressLine?: InputMaybe<ScreeningMatchDetailsInput>;
  addressLine2?: InputMaybe<ScreeningMatchDetailsInput>;
  city?: InputMaybe<ScreeningMatchDetailsInput>;
  countryAlpha2?: InputMaybe<ScreeningMatchDetailsInput>;
  state?: InputMaybe<ScreeningMatchDetailsInput>;
  zip?: InputMaybe<ScreeningMatchDetailsInput>;
};

export type TerminatedMerchantEntry = {
  __typename?: 'TerminatedMerchantEntry';
  key: Scalars['String']['output'];
  matchType: MatchType;
  value?: Maybe<Scalars['String']['output']>;
};

export type TerminatedMerchantEntryInput = {
  key: Scalars['String']['input'];
  matchType: MatchType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TerminatedMerchantPrincipal = {
  __typename?: 'TerminatedMerchantPrincipal';
  address?: Maybe<TerminatedMerchantAddress>;
  dateOfBirth?: Maybe<ScreeningMatchDetails>;
  email?: Maybe<ScreeningMatchDetails>;
  firstName?: Maybe<ScreeningMatchDetails>;
  lastName?: Maybe<ScreeningMatchDetails>;
  nationalId?: Maybe<ScreeningMatchDetails>;
  phone?: Maybe<ScreeningMatchDetails>;
};

export type TerminatedMerchantPrincipalInput = {
  address?: InputMaybe<TerminatedMerchantAddressInput>;
  dateOfBirth?: InputMaybe<ScreeningMatchDetailsInput>;
  email?: InputMaybe<ScreeningMatchDetailsInput>;
  firstName?: InputMaybe<ScreeningMatchDetailsInput>;
  lastName?: InputMaybe<ScreeningMatchDetailsInput>;
  nationalId?: InputMaybe<ScreeningMatchDetailsInput>;
  phone?: InputMaybe<ScreeningMatchDetailsInput>;
};

export type TerminatedWithDetails = {
  __typename?: 'TerminatedWithDetails';
  addedByAcquirerId?: Maybe<Scalars['String']['output']>;
  address?: Maybe<AddressMatchFormat>;
  altPhoneNumber?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  countrySubdivisionTaxId?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  dateClosed?: Maybe<Scalars['String']['output']>;
  dateOpened?: Maybe<Scalars['String']['output']>;
  doingBusinessAsName?: Maybe<Scalars['String']['output']>;
  merchRefNum?: Maybe<Scalars['String']['output']>;
  merchantCategory?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationalTaxId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  principals?: Maybe<Array<MatchRequestPrincipals>>;
  reasonCode?: Maybe<Scalars['String']['output']>;
  reasonCodeDesc?: Maybe<Scalars['String']['output']>;
  subMerchantId?: Maybe<Scalars['String']['output']>;
  urlGroups?: Maybe<Array<UrlGroups>>;
  urls?: Maybe<Array<Scalars['String']['output']>>;
};

export enum TerminationReason {
  AccountDataCompromise = 'account_data_compromise',
  Coercion = 'coercion',
  CommonPointOfPurchase = 'common_point_of_purchase',
  DisqualifiedFromNetwork = 'disqualified_from_network',
  ExcessiveChargebacks = 'excessive_chargebacks',
  ExcessiveFraud = 'excessive_fraud',
  FraudConviction = 'fraud_conviction',
  IllegalTransactions = 'illegal_transactions',
  Insolvency = 'insolvency',
  ListingUnderPrivacyReview = 'listing_under_privacy_review',
  MastercardQuestionableMerchantAuditProgram = 'mastercard_questionable_merchant_audit_program',
  MerchantCollusion = 'merchant_collusion',
  MerchantIdentityTheft = 'merchant_identity_theft',
  NonF2fAdultContent = 'non_f2f_adult_content',
  PciNonCompliance = 'pci_non_compliance',
  TransactionLaundering = 'transaction_laundering',
  UnderInvestigation = 'under_investigation',
  ViolationOfAgreement = 'violation_of_agreement',
  ViolationOfRules = 'violation_of_rules',
  VisaComplianceProgram = 'visa_compliance_program'
}

export type TestWebhookMutationInput = {
  eventType: NotificationType;
  webhookId: Scalars['ID']['input'];
};

export type TestWebhookMutationResponse = {
  __typename?: 'TestWebhookMutationResponse';
  success: Scalars['Boolean']['output'];
};

export enum ThirdPartyIntegrationEnum {
  Bridgerpay = 'Bridgerpay',
  Chargebee = 'Chargebee',
  Checkoutchamp = 'Checkoutchamp',
  Konnektive = 'Konnektive',
  Omegasys = 'Omegasys',
  Openpath = 'Openpath',
  Other = 'Other',
  Paymentiq = 'Paymentiq',
  Praxis = 'Praxis',
  Shopify = 'Shopify',
  Shopline = 'Shopline',
  Worldcard = 'Worldcard'
}

export enum ThreeDsAuthenticationFlow {
  Challenge = 'challenge',
  Exemption = 'exemption',
  External = 'external',
  Frictionless = 'frictionless'
}

export enum ThreeDsResultExtended {
  Abandoned = 'abandoned',
  AttemptAcknowledged = 'attempt_acknowledged',
  Authenticated = 'authenticated',
  Denied = 'denied',
  NotSupported = 'not_supported',
  ProcessingError = 'processing_error',
  Rejected = 'rejected'
}

export type ToggleArchiveBankAccountInput = {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  merchantId: Scalars['ID']['input'];
};

export type ToggleRuleEnabledMutationInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type ToggleSandboxMutationResponse = {
  __typename?: 'ToggleSandboxMutationResponse';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TraceIds = {
  __typename?: 'TraceIds';
  traceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TraceIdsQueryInput = {
  attemptId?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};

export type TraderAddressComponents = {
  __typename?: 'TraderAddressComponents';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  other?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  acquiringSetup?: Maybe<TransactionAcquiringSetup>;
  amount?: Maybe<Scalars['Float']['output']>;
  amountCancelled?: Maybe<Scalars['Float']['output']>;
  amountCapturable?: Maybe<Scalars['Float']['output']>;
  amountReceived?: Maybe<Scalars['Float']['output']>;
  amountRefunded?: Maybe<Scalars['Float']['output']>;
  approved?: Maybe<Scalars['Boolean']['output']>;
  approvedAmount?: Maybe<Scalars['Float']['output']>;
  atLeastOneCapture?: Maybe<Scalars['Boolean']['output']>;
  attempt?: Maybe<Scalars['String']['output']>;
  attemptId?: Maybe<Scalars['String']['output']>;
  billing?: Maybe<Address>;
  billingDetails?: Maybe<Address>;
  blendedPricing?: Maybe<Scalars['Boolean']['output']>;
  calculatedStatementDescriptor?: Maybe<Scalars['String']['output']>;
  captureMethod?: Maybe<TransactionCaptureMethod>;
  checkout?: Maybe<Scalars['Boolean']['output']>;
  checkoutLink?: Maybe<Scalars['String']['output']>;
  checkoutSessionDuration?: Maybe<Scalars['Int']['output']>;
  checkoutSessionType?: Maybe<CheckoutSessionType>;
  clearingDate?: Maybe<Scalars['String']['output']>;
  clientCountry?: Maybe<Country>;
  clientIp?: Maybe<Scalars['String']['output']>;
  collaborationStatus?: Maybe<Scalars['String']['output']>;
  consumer?: Maybe<TransactionConsumer>;
  consumerEmail?: Maybe<Scalars['String']['output']>;
  consumerFirstName?: Maybe<Scalars['String']['output']>;
  consumerId: Scalars['ID']['output'];
  consumerLastName?: Maybe<Scalars['String']['output']>;
  consumerMerchantConsumerId?: Maybe<Scalars['String']['output']>;
  consumerPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency: CurrencyAlpha3;
  dateTime?: Maybe<Scalars['String']['output']>;
  declinedAttempts?: Maybe<Array<TransactionDeclineAttempt>>;
  description?: Maybe<Scalars['String']['output']>;
  dispute?: Maybe<Dispute>;
  disputeAcceptedOrLostAt?: Maybe<Scalars['String']['output']>;
  disputeAmount?: Maybe<Scalars['Float']['output']>;
  disputeId?: Maybe<Scalars['String']['output']>;
  disputeStatus?: Maybe<DisputeStatus>;
  disputeWonAt?: Maybe<Scalars['String']['output']>;
  estimatedSettlementDate?: Maybe<Scalars['String']['output']>;
  externalSettlement?: Maybe<Scalars['Boolean']['output']>;
  feeCurrency?: Maybe<CurrencyAlpha3>;
  /** COMPUTED_FIELD: represents transaction fees list */
  fees?: Maybe<Array<TransactionFee>>;
  finalize?: Maybe<TransactionFinalizeReadOnly>;
  fraud?: Maybe<Scalars['Boolean']['output']>;
  fraudActionable?: Maybe<Scalars['Boolean']['output']>;
  fraudDateTime?: Maybe<Scalars['String']['output']>;
  fraudInputMethod?: Maybe<FraudInputMethod>;
  fraudType?: Maybe<FraudType>;
  grossFee?: Maybe<Scalars['Float']['output']>;
  /** COMPUTED_FIELD: represents transaction gross fees list */
  grossFees?: Maybe<Array<TransactionFee>>;
  id: Scalars['String']['output'];
  interchangeCurrency?: Maybe<CurrencyAlpha3>;
  interchangeFeeFinal?: Maybe<Scalars['Float']['output']>;
  isRetryAttempt?: Maybe<Scalars['Boolean']['output']>;
  jurisdiction?: Maybe<TransactionJurisdiction>;
  manualReview?: Maybe<Scalars['Boolean']['output']>;
  manualReviewStatus?: Maybe<TransactionManualReviewStatus>;
  manualReviewStatusReason?: Maybe<Scalars['String']['output']>;
  merchantDbaName?: Maybe<Scalars['String']['output']>;
  merchantFee?: Maybe<Scalars['Float']['output']>;
  merchantFeeFinal?: Maybe<Scalars['Float']['output']>;
  merchantLegalName?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  netAmountCurrency?: Maybe<CurrencyAlpha3>;
  netAmountFinal?: Maybe<Scalars['Float']['output']>;
  networkFeeCurrency?: Maybe<CurrencyAlpha3>;
  networkFeeFinal?: Maybe<Scalars['Float']['output']>;
  networkTransactionId?: Maybe<Scalars['String']['output']>;
  originalTransaction?: Maybe<Scalars['Boolean']['output']>;
  partial?: Maybe<Scalars['Boolean']['output']>;
  partiallyRefunded?: Maybe<Scalars['Boolean']['output']>;
  paymentAttempt?: Maybe<Scalars['Int']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  paymentLinkId?: Maybe<Scalars['String']['output']>;
  paymentLinkName?: Maybe<Scalars['String']['output']>;
  /** use as paymentMethod[paymentMethod.type] */
  paymentMethod?: Maybe<PaymentMethod>;
  paymentStatus?: Maybe<TransactionPaymentStatus>;
  processor?: Maybe<Scalars['String']['output']>;
  recurringType?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  refunded?: Maybe<Scalars['Boolean']['output']>;
  requestedAmount: Scalars['Float']['output'];
  requestorIdentifier?: Maybe<Scalars['String']['output']>;
  requestorOrigin?: Maybe<Scalars['String']['output']>;
  /** Custom field for conditionally modified requestor api key last six digits - used for portal activity single payment */
  requestorOriginApi?: Maybe<CustomRequestorOriginApiType>;
  resource?: Maybe<Scalars['String']['output']>;
  result?: Maybe<TransactionResult>;
  retryAttemptCounter?: Maybe<Scalars['Int']['output']>;
  riskAssessmentDecision?: Maybe<Scalars['String']['output']>;
  riskAssessmentScore?: Maybe<Scalars['Int']['output']>;
  routingKey?: Maybe<Scalars['String']['output']>;
  ruleData?: Maybe<TransactionRuleData>;
  ruleIdMatched?: Maybe<Scalars['String']['output']>;
  settled?: Maybe<Scalars['Boolean']['output']>;
  settlement?: Maybe<TransactionSettlement>;
  settlementAccountName?: Maybe<Scalars['String']['output']>;
  settlementConversionRate?: Maybe<Scalars['Float']['output']>;
  settlementCurrency?: Maybe<CurrencyAlpha3>;
  settlementCurrencyAmount?: Maybe<Scalars['Float']['output']>;
  settlementId?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<ShippingDetails>;
  shippingDetails?: Maybe<Address>;
  shippingFirstName?: Maybe<Scalars['String']['output']>;
  shippingLastName?: Maybe<Scalars['String']['output']>;
  shippingPhone?: Maybe<Scalars['String']['output']>;
  source?: Maybe<TransactionSource>;
  sourceBlocked?: Maybe<Scalars['Boolean']['output']>;
  statementDescriptor?: Maybe<Scalars['String']['output']>;
  status: TransactionStatus;
  subType: TransactionSubType;
  threeDs?: Maybe<TransactionThreeDs>;
  threeDsAuthenticationFlow?: Maybe<ThreeDsAuthenticationFlow>;
  threeDsEci?: Maybe<Scalars['String']['output']>;
  threeDsErrorCode?: Maybe<Scalars['String']['output']>;
  threeDsErrorDescription?: Maybe<Scalars['String']['output']>;
  threeDsReasonDescription?: Maybe<Scalars['String']['output']>;
  threeDsResult?: Maybe<TransactionThreeDsResult>;
  threeDsResultExtended?: Maybe<ThreeDsResultExtended>;
  threeDsVersion?: Maybe<Scalars['String']['output']>;
  threeRiIndicator?: Maybe<Scalars['String']['output']>;
  transactionFeeFinal?: Maybe<Scalars['Float']['output']>;
  type: TransactionTypes;
  userAgent?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export enum TransactionAcquiringSetup {
  Acquirer = 'acquirer',
  Gateway = 'gateway',
  Payfac = 'payfac'
}

export enum TransactionCaptureMethod {
  Immediately = 'IMMEDIATELY',
  Manual = 'MANUAL'
}

export enum TransactionCodeSubType {
  AccountToAccount = 'ACCOUNT_TO_ACCOUNT',
  BankInitiatedMoneyTransfer = 'BANK_INITIATED_MONEY_TRANSFER',
  BusinessToBusiness = 'BUSINESS_TO_BUSINESS',
  CashDeposit = 'CASH_DEPOSIT',
  CreditCardBill = 'CREDIT_CARD_BILL',
  FasterRefunds = 'FASTER_REFUNDS',
  FundsTransfer = 'FUNDS_TRANSFER',
  GamblingOrGamingPayouts = 'GAMBLING_OR_GAMING_PAYOUTS',
  GeneralFundsOrBusinessDisbursement = 'GENERAL_FUNDS_OR_BUSINESS_DISBURSEMENT',
  GovernmentDisbursements = 'GOVERNMENT_DISBURSEMENTS',
  LiquidAssets = 'LIQUID_ASSETS',
  LoyaltyPayments = 'LOYALTY_PAYMENTS',
  MerchantDisbursementOrSettlement = 'MERCHANT_DISBURSEMENT_OR_SETTLEMENT',
  NonCardBillPay = 'NON_CARD_BILL_PAY',
  OnlineGambling = 'ONLINE_GAMBLING',
  PayrollAndPensionsDisbursements = 'PAYROLL_AND_PENSIONS_DISBURSEMENTS',
  PersonToPerson = 'PERSON_TO_PERSON',
  PrepaidCardLoad = 'PREPAID_CARD_LOAD',
  RequestToPayService = 'REQUEST_TO_PAY_SERVICE',
  TopUp = 'TOP_UP',
  WalletTransfer = 'WALLET_TRANSFER'
}

export type TransactionConsumer = {
  __typename?: 'TransactionConsumer';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

export type TransactionDeclineAttempt = {
  __typename?: 'TransactionDeclineAttempt';
  attempt: Scalars['Int']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
  processedAt: Scalars['String']['output'];
  result?: Maybe<TransactionResult>;
  threeDs?: Maybe<TransactionThreeDs>;
};

export type TransactionFee = {
  __typename?: 'TransactionFee';
  createdAt?: Maybe<Scalars['String']['output']>;
  feeDescription?: Maybe<Scalars['String']['output']>;
  feeType: TransactionFeeType;
  id?: Maybe<Scalars['String']['output']>;
  processingCurrency: Scalars['String']['output'];
  processingCurrencyAmount: Scalars['String']['output'];
  settlementCurrency?: Maybe<Scalars['String']['output']>;
  settlementCurrencyAmount?: Maybe<Scalars['String']['output']>;
};

export enum TransactionFeeType {
  Interchange = 'INTERCHANGE',
  Merchant = 'MERCHANT',
  Network = 'NETWORK',
  Provider = 'PROVIDER'
}

export type TransactionFinalize = {
  __typename?: 'TransactionFinalize';
  authCode?: Maybe<Scalars['String']['output']>;
  eci?: Maybe<Scalars['String']['output']>;
  issuerResponseCode?: Maybe<Scalars['String']['output']>;
  issuerResponseText?: Maybe<Scalars['String']['output']>;
  networkCode?: Maybe<Scalars['String']['output']>;
  networkSpecificFields?: Maybe<Array<Maybe<FinalizeNetworkSpecificFields>>>;
  resultSource?: Maybe<Scalars['String']['output']>;
  systemTraceAuditNumber?: Maybe<Scalars['String']['output']>;
  transactionResult?: Maybe<Scalars['String']['output']>;
  transactionRrn?: Maybe<Scalars['String']['output']>;
  transactionTimestamp?: Maybe<Scalars['String']['output']>;
};

export type TransactionFinalizeInput = {
  authCode?: InputMaybe<Scalars['String']['input']>;
  eci?: InputMaybe<Scalars['String']['input']>;
  issuerResponseCode?: InputMaybe<Scalars['String']['input']>;
  issuerResponseText?: InputMaybe<Scalars['String']['input']>;
  networkCode?: InputMaybe<Scalars['String']['input']>;
  resultSource?: InputMaybe<Scalars['String']['input']>;
  systemTraceAuditNumber?: InputMaybe<Scalars['String']['input']>;
  transactionResult?: InputMaybe<Scalars['String']['input']>;
  transactionRrn?: InputMaybe<Scalars['String']['input']>;
  transactionTimestamp?: InputMaybe<Scalars['String']['input']>;
};

export type TransactionFinalizeListInput = {
  authCode?: InputMaybe<Array<Scalars['String']['input']>>;
  eci?: InputMaybe<Array<Scalars['String']['input']>>;
  issuerResponseCode?: InputMaybe<Array<Scalars['String']['input']>>;
  issuerResponseText?: InputMaybe<Array<Scalars['String']['input']>>;
  networkCode?: InputMaybe<Array<Scalars['String']['input']>>;
  resultSource?: InputMaybe<Array<Scalars['String']['input']>>;
  systemTraceAuditNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionResult?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionRrn?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionTimestamp?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TransactionFinalizeReadOnly = {
  __typename?: 'TransactionFinalizeReadOnly';
  authCode?: Maybe<Scalars['String']['output']>;
  eci?: Maybe<Scalars['String']['output']>;
  failureCode?: Maybe<Scalars['String']['output']>;
  issuerResponseCode?: Maybe<Scalars['String']['output']>;
  issuerResponseErrorDescription?: Maybe<Scalars['String']['output']>;
  issuerResponseErrorText?: Maybe<Scalars['String']['output']>;
  issuerResponseText?: Maybe<Scalars['String']['output']>;
  networkCode?: Maybe<Scalars['String']['output']>;
  networkSpecificFields?: Maybe<Array<FinalizeNetworkSpecificFields>>;
  resultSource?: Maybe<Scalars['String']['output']>;
  systemTraceAuditNumber?: Maybe<Scalars['String']['output']>;
  transactionResult?: Maybe<Scalars['String']['output']>;
  transactionRrn?: Maybe<Scalars['String']['output']>;
  transactionTimestamp?: Maybe<Scalars['String']['output']>;
};

export enum TransactionJurisdiction {
  Domestic = 'domestic',
  International = 'international',
  Intraregional = 'intraregional'
}

/** REFERENCE: https://github.com/pay-com/libs-types/blob/main/protos/common.proto#L1338C1-L1343C2 */
export enum TransactionManualReviewStatus {
  Approved = 'approved',
  Declined = 'declined',
  Expired = 'expired',
  PendingReview = 'pending_review'
}

export type TransactionPaymentMethodCardInput = {
  bin?: InputMaybe<Scalars['String']['input']>;
  expiryMonth?: InputMaybe<Scalars['String']['input']>;
  expiryYear?: InputMaybe<Scalars['String']['input']>;
  issuerName?: InputMaybe<Scalars['String']['input']>;
  lastFourDigits?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationalIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TransactionPaymentMethodCardListInput = {
  bin?: InputMaybe<Array<Scalars['String']['input']>>;
  expiryMonth?: InputMaybe<Array<Scalars['String']['input']>>;
  expiryYear?: InputMaybe<Array<Scalars['String']['input']>>;
  issuerName?: InputMaybe<Array<Scalars['String']['input']>>;
  lastFourDigits?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nationalIdentificationNumber?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TransactionPaymentMethodInput = {
  card?: InputMaybe<TransactionPaymentMethodCardInput>;
  paypal?: InputMaybe<TransactionPaymentMethodPaypalInput>;
  paypalBillingAgreement?: InputMaybe<TransactionPaymentMethodPaypalBillingAgreementInput>;
  paysafecard?: InputMaybe<TransactionPaymentMethodPaysafecardInput>;
  type?: InputMaybe<TransactionPaymentMethodType>;
  uniqueIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type TransactionPaymentMethodListInput = {
  card?: InputMaybe<TransactionPaymentMethodCardListInput>;
  paypal?: InputMaybe<TransactionPaymentMethodPaypalListInput>;
  paypalBillingAgreement?: InputMaybe<TransactionPaymentMethodPaypalBillingAgreementListInput>;
  paysafecard?: InputMaybe<TransactionPaymentMethodPaysafecardListInput>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
  uniqueIdentifier?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TransactionPaymentMethodPaypalBillingAgreementInput = {
  baId?: InputMaybe<Scalars['String']['input']>;
  baToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  payerId?: InputMaybe<Scalars['String']['input']>;
};

export type TransactionPaymentMethodPaypalBillingAgreementListInput = {
  baId?: InputMaybe<Array<Scalars['String']['input']>>;
  baToken?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Array<Scalars['String']['input']>>;
  payerId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TransactionPaymentMethodPaypalInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  payerId?: InputMaybe<Scalars['ID']['input']>;
};

export type TransactionPaymentMethodPaypalListInput = {
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Array<Scalars['String']['input']>>;
  payerId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TransactionPaymentMethodPaysafecardInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryAlpha2>;
  currency?: InputMaybe<CurrencyAlpha3>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  serial?: InputMaybe<Scalars['String']['input']>;
};

export type TransactionPaymentMethodPaysafecardListInput = {
  amount?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Array<CountryAlpha2>>;
  currency?: InputMaybe<Array<CurrencyAlpha3>>;
  customerId?: InputMaybe<Array<Scalars['String']['input']>>;
  serial?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum TransactionPaymentMethodType {
  Applepay = 'applepay',
  Blik = 'blik',
  Card = 'card',
  Crypto = 'crypto',
  Eps = 'eps',
  Generic = 'generic',
  Giropay = 'giropay',
  Googlepay = 'googlepay',
  Ideal = 'ideal',
  Interac = 'interac',
  KlarnaPayNow = 'klarna_pay_now',
  Netbanking = 'netbanking',
  Neteller = 'neteller',
  OktoCash = 'okto_cash',
  Paypal = 'paypal',
  PaypalBillingAgreement = 'paypal_billing_agreement',
  Paysafecard = 'paysafecard',
  Paysafecash = 'paysafecash',
  Skrill = 'skrill',
  Upi = 'upi',
  Vyne = 'vyne',
  Zimpler = 'zimpler'
}

export enum TransactionPaymentStatus {
  AuthorizationExpired = 'AUTHORIZATION_EXPIRED',
  Authorized = 'AUTHORIZED',
  Cancelled = 'CANCELLED',
  Captured = 'CAPTURED',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Error = 'ERROR',
  Expired = 'EXPIRED',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

export type TransactionQueryInput = {
  id: Scalars['ID']['input'];
};

export enum TransactionReconciliationStatus {
  Failure = 'FAILURE',
  None = 'NONE',
  Success = 'SUCCESS'
}

export type TransactionResult = {
  __typename?: 'TransactionResult';
  authCode?: Maybe<Scalars['String']['output']>;
  retrievalReferenceNumber?: Maybe<Scalars['String']['output']>;
  schemeId?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
};

export type TransactionReviewStatusSuccessMutationResponse = {
  __typename?: 'TransactionReviewStatusSuccessMutationResponse';
  success: Scalars['Boolean']['output'];
};

export type TransactionRollingReserve = {
  __typename?: 'TransactionRollingReserve';
  amount?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  releasedOn?: Maybe<Scalars['String']['output']>;
};

export type TransactionRuleData = {
  __typename?: 'TransactionRuleData';
  bypassed?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  matchedButWasOutprioritized?: Maybe<Scalars['Boolean']['output']>;
  outcomeDetailsByRange?: Maybe<Array<Maybe<OutcomeDetailsByRangeItem>>>;
  outcomes?: Maybe<Array<RiskRuleOutcome>>;
  result?: Maybe<Scalars['Int']['output']>;
};

export type TransactionSettlement = {
  __typename?: 'TransactionSettlement';
  amount?: Maybe<Scalars['String']['output']>;
  availableOn?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  estimated?: Maybe<Scalars['Boolean']['output']>;
  exchangeRate?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['String']['output']>;
  rollingReserve?: Maybe<TransactionRollingReserve>;
  settled?: Maybe<Scalars['Boolean']['output']>;
  settlementId?: Maybe<Scalars['String']['output']>;
};

export enum TransactionSource {
  Checkout = 'CHECKOUT',
  PaymentMethod = 'PAYMENT_METHOD'
}

export type TransactionStatsAggregateResponseValues = {
  __typename?: 'TransactionStatsAggregateResponseValues';
  amount?: Maybe<Scalars['Float']['output']>;
  amountCancelled?: Maybe<Scalars['Float']['output']>;
  amountCapturable?: Maybe<Scalars['Float']['output']>;
  amountReceived?: Maybe<Scalars['Float']['output']>;
  amountRefunded?: Maybe<Scalars['Float']['output']>;
  approvedAmount?: Maybe<Scalars['Float']['output']>;
  disputeAmount?: Maybe<Scalars['Float']['output']>;
  requestedAmount?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export enum TransactionStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Error = 'ERROR',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  PendingDecline = 'PENDING_DECLINE'
}

export enum TransactionSubType {
  CardPresent = 'CARD_PRESENT',
  Funding = 'FUNDING',
  Independent = 'INDEPENDENT',
  Installment = 'INSTALLMENT',
  Moto = 'MOTO',
  Payment = 'PAYMENT',
  Recurring = 'RECURRING',
  Referenced = 'REFERENCED',
  Regular = 'REGULAR',
  Setup = 'SETUP'
}

/**  REFERENCE: https://github.com/pay-com/node-libs-common/blob/main/enums/common-enums/three-ds-result.js */
export type TransactionThreeDs = {
  __typename?: 'TransactionThreeDs';
  authenticationFlow?: Maybe<ThreeDsAuthenticationFlow>;
  rawData?: Maybe<TransactionThreeDsRawData>;
  result?: Maybe<TransactionThreeDsResult>;
  version?: Maybe<Scalars['String']['output']>;
};

export type TransactionThreeDsRawData = {
  __typename?: 'TransactionThreeDsRawData';
  challengeIndicator?: Maybe<Scalars['String']['output']>;
  dsTransactionId?: Maybe<Scalars['ID']['output']>;
  eci?: Maybe<Scalars['String']['output']>;
  enrolled: Scalars['Boolean']['output'];
  exemption?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum TransactionThreeDsResult {
  Bypassed = 'bypassed',
  Error = 'error',
  Failure = 'failure',
  Success = 'success'
}

export type TransactionTypeCodes = {
  __typename?: 'TransactionTypeCodes';
  bai?: Maybe<MccBai>;
  subType: TransactionCodeSubType;
  tti?: Maybe<MccTti>;
};

export type TransactionTypeCodesInput = {
  bai?: InputMaybe<MccBai>;
  subType: TransactionCodeSubType;
  tti?: InputMaybe<MccTti>;
};

export enum TransactionTypes {
  Authentication = 'authentication',
  Authorization = 'authorization',
  Cancellation = 'cancellation',
  Chargeback = 'chargeback',
  ChargebackReversal = 'chargeback_reversal',
  Completion = 'completion',
  Payout = 'payout',
  Refund = 'refund',
  Representment = 'representment',
  Risk = 'risk',
  Sale = 'sale',
  SecondChargeback = 'second_chargeback',
  SecondRepresentment = 'second_representment',
  Subsequent = 'subsequent',
  Verification = 'verification'
}

export type TransactionsBalanceQueryInput = {
  filter?: InputMaybe<TransactionsQueryInputFilter>;
};

export type TransactionsBalanceQueryResponse = {
  __typename?: 'TransactionsBalanceQueryResponse';
  currentBalance?: Maybe<Scalars['Float']['output']>;
};

export type TransactionsCsvReport = {
  __typename?: 'TransactionsCsvReport';
  url: Scalars['String']['output'];
};

export type TransactionsCsvReportQueryInput = {
  aggregate?: InputMaybe<TransactionsQueryInputAggregate>;
  filter?: InputMaybe<TransactionsQueryInputFilter>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  reportName: Scalars['String']['input'];
  select: Array<Scalars['String']['input']>;
};

export type TransactionsQueryInFilterInputValues = {
  acquiringSetup?: InputMaybe<Array<InputMaybe<TransactionAcquiringSetup>>>;
  amountCancelled?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountCapturable?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountReceived?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountRefunded?: InputMaybe<Array<Scalars['Float']['input']>>;
  approvedAmount?: InputMaybe<Array<Scalars['Float']['input']>>;
  attempt?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  attemptId?: InputMaybe<Array<Scalars['String']['input']>>;
  availablePaymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  billingDetails?: InputMaybe<AddressListInput>;
  billingDetailsAddressId?: InputMaybe<Array<Scalars['String']['input']>>;
  captureDelay?: InputMaybe<Array<Scalars['String']['input']>>;
  checkoutCashierBalance?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkoutCashierDepositLimit?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkoutCashierPresetAmounts?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkoutCashierWithdrawLimit?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkoutLocale?: InputMaybe<Array<Scalars['String']['input']>>;
  checkoutSessionType?: InputMaybe<Array<CheckoutSessionType>>;
  clientIp?: InputMaybe<Array<Scalars['String']['input']>>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  consumerEmail?: InputMaybe<Array<Scalars['String']['input']>>;
  consumerFirstName?: InputMaybe<Array<Scalars['String']['input']>>;
  consumerId?: InputMaybe<Array<Scalars['ID']['input']>>;
  consumerLastName?: InputMaybe<Array<Scalars['String']['input']>>;
  consumerMerchantConsumerId?: InputMaybe<Array<Scalars['String']['input']>>;
  consumerPhone?: InputMaybe<Array<Scalars['String']['input']>>;
  currency?: InputMaybe<Array<CurrencyAlpha3>>;
  dateTime?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptor?: InputMaybe<Array<Scalars['String']['input']>>;
  disputeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disputeStatus?: InputMaybe<Array<InputMaybe<DisputeStatus>>>;
  failure_code?: InputMaybe<Array<Scalars['String']['input']>>;
  finalize?: InputMaybe<TransactionFinalizeListInput>;
  finalize__issuerResponseCode?: InputMaybe<Array<Scalars['String']['input']>>;
  finalize__partial_approval__status?: InputMaybe<Array<Scalars['String']['input']>>;
  finalize__transactionTimestamp?: InputMaybe<Array<Scalars['String']['input']>>;
  fraudInputMethod?: InputMaybe<Array<FraudInputMethod>>;
  fraudType?: InputMaybe<Array<FraudType>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  jurisdiction?: InputMaybe<Array<TransactionJurisdiction>>;
  lastVisitedStep?: InputMaybe<Array<Scalars['String']['input']>>;
  manualReviewStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantId?: InputMaybe<Array<Scalars['ID']['input']>>;
  mitReason?: InputMaybe<Array<MitReason>>;
  networkTransactionId?: InputMaybe<Array<Scalars['String']['input']>>;
  notificationUrl?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentId?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod?: InputMaybe<TransactionPaymentMethodListInput>;
  paymentMethod__applepay__addressLine1Check?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__addressPostalCodeCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__brand?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__cardCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__cardType?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__cvcCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__applepay__network?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__addressLine1Check?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__addressPostalCodeCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__brand?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__cardCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__cardType?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__cvcCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__network?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__card__wallet?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__generic__type?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__addressLine1Check?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__addressPostalCodeCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__brand?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__cardCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__cardType?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__cvcCheck?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__googlepay__network?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod__type?: InputMaybe<Array<Scalars['String']['input']>>;
  processor?: InputMaybe<Array<Scalars['String']['input']>>;
  processorTransactionId?: InputMaybe<Array<Scalars['String']['input']>>;
  proxyProcessor?: InputMaybe<Array<Scalars['String']['input']>>;
  reconciliationDate?: InputMaybe<Array<Scalars['String']['input']>>;
  reconciliationFailureReason?: InputMaybe<Array<Scalars['String']['input']>>;
  reconciliationId?: InputMaybe<Array<Scalars['String']['input']>>;
  reconciliationStatus?: InputMaybe<Array<TransactionReconciliationStatus>>;
  redirectUrlFailure?: InputMaybe<Array<Scalars['String']['input']>>;
  redirectUrlSuccess?: InputMaybe<Array<Scalars['String']['input']>>;
  reference?: InputMaybe<Array<Scalars['String']['input']>>;
  relatedRecurringTransaction?: InputMaybe<Array<Scalars['String']['input']>>;
  relatedTransaction?: InputMaybe<Array<Scalars['String']['input']>>;
  requestedAmount?: InputMaybe<Array<Scalars['Float']['input']>>;
  riskAssessmentRuleIdExternal?: InputMaybe<Array<Scalars['String']['input']>>;
  riskEngineId?: InputMaybe<Array<Scalars['String']['input']>>;
  settlementAccountId?: InputMaybe<Array<Scalars['String']['input']>>;
  shippingDetails?: InputMaybe<AddressListInput>;
  shippingDetailsAddressId?: InputMaybe<Array<Scalars['String']['input']>>;
  shippingFirstName?: InputMaybe<Array<Scalars['String']['input']>>;
  shippingLastName?: InputMaybe<Array<Scalars['String']['input']>>;
  shippingPhone?: InputMaybe<Array<Scalars['String']['input']>>;
  siteId?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<TransactionStatus>>;
  subType?: InputMaybe<Array<Scalars['String']['input']>>;
  summableAmount?: InputMaybe<Array<Scalars['Float']['input']>>;
  termsAndConditionsAcceptedOnTransaction?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsAcsOperatorId?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsAcsReferenceNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsAcsTransactionId?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsAcsUrl?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsAuthenticationFlow?: InputMaybe<Array<ThreeDsAuthenticationFlow>>;
  threeDsCardHolderInfo?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsCavv?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsChallengeIndicator?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsDsTransactionId?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsEci?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsErrorCode?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsErrorDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsPaResStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsPayload?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsReasonCode?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsReasonDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsResult?: InputMaybe<Array<TransactionThreeDsResult>>;
  threeDsResultExtended?: InputMaybe<Array<ThreeDsResultExtended>>;
  threeDsServerTransactionId?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsVersion?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsXid?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionStatus?: InputMaybe<Array<InputMaybe<TransactionStatus>>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TransactionsQueryInput = {
  aggregate?: InputMaybe<TransactionsQueryInputAggregate>;
  filter?: InputMaybe<TransactionsQueryInputFilter>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  includeMerchantId?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  primaryKeysParams?: InputMaybe<PaymentsPrimaryKeysParamsInput>;
};

export type TransactionsQueryInputAggregate = {
  avg?: InputMaybe<Array<Scalars['String']['input']>>;
  count?: InputMaybe<Array<Scalars['String']['input']>>;
  sum?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TransactionsQueryInputFilter = {
  and?: InputMaybe<Array<TransactionsQueryInputFilter>>;
  between?: InputMaybe<TransactionsQueryRangeFilterInputValues>;
  equal?: InputMaybe<TransactionsQueryExactFilterInputValues>;
  greater?: InputMaybe<TransactionsQueryExactFilterInputValues>;
  greaterOrEquals?: InputMaybe<TransactionsQueryExactFilterInputValues>;
  iLike?: InputMaybe<TransactionsQueryExactFilterInputValues>;
  in?: InputMaybe<TransactionsQueryInFilterInputValues>;
  less?: InputMaybe<TransactionsQueryExactFilterInputValues>;
  lessOrEquals?: InputMaybe<TransactionsQueryExactFilterInputValues>;
  like?: InputMaybe<TransactionsQueryExactFilterInputValues>;
  notBetween?: InputMaybe<TransactionsQueryRangeFilterInputValues>;
  notEqual?: InputMaybe<TransactionsQueryExactFilterInputValues>;
  notIn?: InputMaybe<TransactionsQueryInFilterInputValues>;
  notLike?: InputMaybe<TransactionsQueryExactFilterInputValues>;
  or?: InputMaybe<Array<TransactionsQueryInputFilter>>;
  textSearchCaseInsensitive?: InputMaybe<TransactionsQueryExactFilterInputValues>;
};

export type TransactionsQueryRangeFilterInputValues = {
  amountCancelled?: InputMaybe<FloatRangeInput>;
  amountCapturable?: InputMaybe<FloatRangeInput>;
  amountReceived?: InputMaybe<FloatRangeInput>;
  amountRefunded?: InputMaybe<FloatRangeInput>;
  approvedAmount?: InputMaybe<FloatRangeInput>;
  attempt?: InputMaybe<IntRangeInput>;
  bankSettlementSummableAmount?: InputMaybe<FloatRangeInput>;
  checkoutCashierBalance?: InputMaybe<FloatRangeInput>;
  checkoutCashierDepositLimit?: InputMaybe<FloatRangeInput>;
  checkoutCashierPresetAmounts?: InputMaybe<Array<InputMaybe<FloatRangeInput>>>;
  checkoutCashierWithdrawLimit?: InputMaybe<FloatRangeInput>;
  checkoutSessionDuration?: InputMaybe<IntRangeInput>;
  clearingDate?: InputMaybe<StringRangeInput>;
  commission?: InputMaybe<FloatRangeInput>;
  dateTime?: InputMaybe<StringRangeInput>;
  dccRevenue?: InputMaybe<FloatRangeInput>;
  disputeAmount?: InputMaybe<FloatRangeInput>;
  endUserAmount?: InputMaybe<FloatRangeInput>;
  endUserConversionRate?: InputMaybe<FloatRangeInput>;
  finalize__transactionTimestamp?: InputMaybe<StringRangeInput>;
  fraudDateTime?: InputMaybe<StringRangeInput>;
  interchangeFeeEstimated?: InputMaybe<FloatRangeInput>;
  interchangeFeeFinal?: InputMaybe<FloatRangeInput>;
  internalCost?: InputMaybe<FloatRangeInput>;
  internalCostAcquiring?: InputMaybe<FloatRangeInput>;
  internalCostAcquiringBasisPoints?: InputMaybe<FloatRangeInput>;
  internalCostCommission?: InputMaybe<FloatRangeInput>;
  internalCostFixed?: InputMaybe<FloatRangeInput>;
  internalCostFixedProcessor?: InputMaybe<FloatRangeInput>;
  internalCostProvider?: InputMaybe<FloatRangeInput>;
  internalCostReferral?: InputMaybe<FloatRangeInput>;
  internalRevenueEstimated?: InputMaybe<FloatRangeInput>;
  internalRevenueFinal?: InputMaybe<FloatRangeInput>;
  merchantFee?: InputMaybe<FloatRangeInput>;
  netAmountEstimated?: InputMaybe<FloatRangeInput>;
  netAmountFinal?: InputMaybe<FloatRangeInput>;
  networkFeeEstimated?: InputMaybe<FloatRangeInput>;
  networkFeeFinal?: InputMaybe<FloatRangeInput>;
  referralFee?: InputMaybe<FloatRangeInput>;
  requestedAmount?: InputMaybe<FloatRangeInput>;
  riskAssessmentScore?: InputMaybe<IntRangeInput>;
  rollingReserveAmount?: InputMaybe<FloatRangeInput>;
  rollingReserveConfigAmount?: InputMaybe<FloatRangeInput>;
  schemeFeeEstimated?: InputMaybe<FloatRangeInput>;
  schemeFeeFinal?: InputMaybe<FloatRangeInput>;
  summableAmount?: InputMaybe<FloatRangeInput>;
  transactionFeeEstimated?: InputMaybe<FloatRangeInput>;
  transactionFeeFinal?: InputMaybe<FloatRangeInput>;
};

export type TransactionsQueryResponse = {
  __typename?: 'TransactionsQueryResponse';
  pageInfo: PageInfo;
  primaryKeysParams?: Maybe<PaymentsPrimaryKeysParams>;
  ruleTotalHitsCount?: Maybe<Scalars['Int']['output']>;
  stats?: Maybe<Array<TransactionsStats>>;
  transactions: Array<Transaction>;
};

export type TransactionsRefundMutationInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  transactionsIds: Array<Scalars['String']['input']>;
};

export type TransactionsRefundMutationResponse = {
  __typename?: 'TransactionsRefundMutationResponse';
  success: Scalars['Boolean']['output'];
};

export type TransactionsStats = {
  __typename?: 'TransactionsStats';
  avg?: Maybe<TransactionStatsAggregateResponseValues>;
  count?: Maybe<TransactionStatsAggregateResponseValues>;
  currency?: Maybe<CurrencyAlpha3>;
  dateByDay?: Maybe<TransactionsStatsAggregateResponseDate>;
  dateByHour?: Maybe<TransactionsStatsAggregateResponseDate>;
  dateByMinute?: Maybe<TransactionsStatsAggregateResponseDate>;
  dateByMonth?: Maybe<TransactionsStatsAggregateResponseDate>;
  dateBySecond?: Maybe<TransactionsStatsAggregateResponseDate>;
  dateByWeek?: Maybe<TransactionsStatsAggregateResponseDate>;
  dateByYear?: Maybe<TransactionsStatsAggregateResponseDate>;
  finalize?: Maybe<TransactionFinalize>;
  lastVisitedStep?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  status?: Maybe<TransactionStatus>;
  sum?: Maybe<TransactionStatsAggregateResponseValues>;
};

export type TransactionsStatsAggregateResponseDate = {
  __typename?: 'TransactionsStatsAggregateResponseDate';
  dateTime: Scalars['String']['output'];
};

export type TransferAccount = {
  __typename?: 'TransferAccount';
  accountIdentifier?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  swiftBic?: Maybe<Scalars['String']['output']>;
};

export type TransferAccountInput = {
  accountIdentifier?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  swiftBic?: InputMaybe<Scalars['String']['input']>;
};

export type UrlResult = {
  __typename?: 'URLResult';
  urls?: Maybe<Array<Scalars['String']['output']>>;
};

export type UsBankAccountOptions = {
  __typename?: 'USBankAccountOptions';
  achPaymentType: AchPaymentTypeEnum;
};

export type UnderwritingInfo = {
  __typename?: 'UnderwritingInfo';
  closeRelationWithPayEmployees?: Maybe<Scalars['Boolean']['output']>;
  closeRelationWithPayEmployeesDescription?: Maybe<Scalars['String']['output']>;
};

export type UnderwritingInfoFilterInput = {
  closeRelationWithPayEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  closeRelationWithPayEmployeesDesc?: InputMaybe<Scalars['String']['input']>;
};

export type UnderwritingInfoInput = {
  closeRelationWithPayEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  closeRelationWithPayEmployeesDescription?: InputMaybe<Scalars['String']['input']>;
};

export type UnderwritingInfoPreview = {
  __typename?: 'UnderwritingInfoPreview';
  closeRelationWithPayEmployees?: Maybe<Scalars['Boolean']['output']>;
  closeRelationWithPayEmployeesDesc?: Maybe<Scalars['String']['output']>;
};

export type UnregisterApplePayDomainInput = {
  domainNames: Array<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccountNotificationInput = {
  deliveryConfig: DeliveryConfigInputObject;
  notificationType: NotificationType;
};

export type UpdateAccountNotificationResponse = {
  __typename?: 'UpdateAccountNotificationResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateApiKeyMutationInput = {
  allowedEndpoints?: InputMaybe<Array<ApiKeyEndpointPermissionInput>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  ipRanges?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pciCompliant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateApiKeyResponse = {
  __typename?: 'UpdateApiKeyResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateArchiveMccInput = {
  archived: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type UpdateBankAccountInput = {
  accountHolderName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountType?: InputMaybe<AccountType>;
  bankCountry?: InputMaybe<CountryAlpha2>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
  swiftBic?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChargebackReasonMutationInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
  reasonTitle?: InputMaybe<Scalars['String']['input']>;
  requiredDocumentation?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommissionInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConsumerMutationInput = {
  billingDetails: Array<InputMaybe<AddressInput>>;
  defaultSource?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastTransactionDate?: InputMaybe<Scalars['String']['input']>;
  merchantConsumerId?: InputMaybe<Scalars['ID']['input']>;
  nationalIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  shippingDetails: Array<InputMaybe<AddressInput>>;
  taxId?: InputMaybe<Scalars['ID']['input']>;
  termsAndConditionsAcceptedOnTransaction?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConsumerMutationResponse = {
  __typename?: 'UpdateConsumerMutationResponse';
  billingDetails: Array<Maybe<AddressObject>>;
  companyId: Scalars['String']['output'];
  defaultSource?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastTransactionDate?: Maybe<Scalars['String']['output']>;
  merchantConsumerId?: Maybe<Scalars['ID']['output']>;
  merchantId: Scalars['String']['output'];
  nationalIdentificationNumber?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  shippingDetails: Array<Maybe<AddressObject>>;
  taxId?: Maybe<Scalars['ID']['output']>;
  termsAndConditionsAcceptedOnTransaction?: Maybe<Scalars['String']['output']>;
};

export enum UpdateConsumerRuleExclusionStatusAction {
  Excluded = 'excluded',
  Ignore = 'ignore'
}

export type UpdateConsumerRuleExclusionStatusInput = {
  action: UpdateConsumerRuleExclusionStatusAction;
  excludedUntilDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  ignoredUntilDate?: InputMaybe<Scalars['String']['input']>;
};

/** REFERENCE: https://github.com/pay-com/grpc-core-costs/blob/main/service.proto#L52 */
export type UpdateCostMutationInput = {
  action: Scalars['String']['input'];
  basisFeeDescription?: InputMaybe<Scalars['String']['input']>;
  basisPoints?: InputMaybe<Scalars['String']['input']>;
  costTypeBasisPoints?: InputMaybe<CostType>;
  costTypeFixed?: InputMaybe<CostType>;
  currency: CurrencyAlpha3;
  fixedFee?: InputMaybe<Scalars['String']['input']>;
  fixedFeeDescription?: InputMaybe<Scalars['String']['input']>;
  paymentMethodType: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  revShareFixedPercentage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCountryInput = {
  alpha2: CountryAlpha2;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  highRiskBin?: InputMaybe<Scalars['Boolean']['input']>;
  highRiskIp?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ofacSanctionProgram?: InputMaybe<Scalars['Boolean']['input']>;
  prohibited?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  riskLevel?: InputMaybe<Scalars['Int']['input']>;
  subcontinent?: InputMaybe<Scalars['String']['input']>;
  supportedMerchantJurisdiction?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDashboard = {
  dashboardId?: InputMaybe<Scalars['String']['input']>;
  dashboardUiConfig?: InputMaybe<Scalars['JSON']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  merchantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  rls?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<DashboardType>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDisputeMutationInput = {
  acceptedReason?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['String']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  attempt?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  consumerId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  disputeNetworkReference?: InputMaybe<Scalars['String']['input']>;
  disputedPayment?: InputMaybe<Scalars['String']['input']>;
  evidenceRequiredBy?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isPartial?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdate?: InputMaybe<Scalars['String']['input']>;
  merchantId: Scalars['String']['input'];
  mid?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  networkDisputeId?: InputMaybe<Scalars['String']['input']>;
  processor?: InputMaybe<Scalars['String']['input']>;
  processorDisputeId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<DisputeReason>;
  reasonCode?: InputMaybe<Scalars['String']['input']>;
  receivedOn?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DisputeStatus>;
};

export type UpdateDisputeMutationPayload = {
  __typename?: 'UpdateDisputeMutationPayload';
  id: Scalars['String']['output'];
  merchantId: Scalars['String']['output'];
};

export type UpdateDisputeMutationResponse = {
  __typename?: 'UpdateDisputeMutationResponse';
  payload: UpdateDisputeMutationPayload;
  success: Scalars['Boolean']['output'];
};

export type UpdateDocumentMutationInput = {
  archiveStatus?: InputMaybe<DocumentArchiveStatus>;
  category?: InputMaybe<Scalars['String']['input']>;
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  issuingDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  reviewStatus?: InputMaybe<DocumentReviewType>;
  status?: InputMaybe<DocumentUploadStatus>;
  subType?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDocumentTypeInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  defaultDocumentTags?: InputMaybe<Array<Scalars['String']['input']>>;
  label?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<Array<DocumentTypeRegion>>;
  type: DocumentEntityType;
  value: Scalars['String']['input'];
};

export type UpdateFeatureFlagMutationInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateFinanceInput = {
  commissionSetup?: InputMaybe<Array<EntityShareSetupInput>>;
  companyId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
  referralId?: InputMaybe<Scalars['String']['input']>;
  revShareTiers?: InputMaybe<Array<RevShareTiersInput>>;
};

export type UpdateGooglepayConfigMutationInput = {
  googlepayMerchantId: Scalars['String']['input'];
};

export type UpdateGooglepayConfigMutationResponse = {
  __typename?: 'UpdateGooglepayConfigMutationResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateIndividualInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  idNumber?: InputMaybe<Scalars['String']['input']>;
  identificationDocumentType?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  nationalities?: InputMaybe<Array<CountryAlpha2>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  residentialAddress?: InputMaybe<AddressInput>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IndividualType>;
};

export type UpdateListMutationResponse = {
  __typename?: 'UpdateListMutationResponse';
  id: Scalars['String']['output'];
};

export type UpdateLogicFieldInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<LogicFieldOptionInput>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  regex?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LogicType>;
  valueFieldType?: InputMaybe<LogicFieldsValueFieldType>;
};

export type UpdateManualSettlementStatusInput = {
  approved: Scalars['Boolean']['input'];
  settlementAccountId: Scalars['String']['input'];
};

export type UpdateMccInput = {
  cardSchemas?: InputMaybe<Array<MccCardScheme>>;
  id: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  transactionTypeCodes?: InputMaybe<Array<TransactionTypeCodesInput>>;
};

export type UpdateMccMutationInput = {
  amlRank?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  exposureFactor?: InputMaybe<Scalars['Float']['input']>;
  exposureRiskCategory?: InputMaybe<ExposureRiskCategory>;
  mcc: Scalars['Int']['input'];
  primaryCategory?: InputMaybe<Scalars['String']['input']>;
  riskTier?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMerchantApplicationMutationInput = {
  acquiringProviders?: InputMaybe<Array<AcquiringProvider>>;
  acquiringServices?: InputMaybe<Array<AcquiringService>>;
  approvalDate?: InputMaybe<Scalars['String']['input']>;
  automaticReview?: InputMaybe<Scalars['Boolean']['input']>;
  bankDetails?: InputMaybe<OnboardingBankDetailsInput>;
  businessActivity?: InputMaybe<OnboardingBusinessActivityInput>;
  businessDetails?: InputMaybe<OnboardingBusinessDetailsInput>;
  businessProcessingInfo?: InputMaybe<OnboardingBusinessProcessingInput>;
  businessReview?: InputMaybe<ReviewStatuses>;
  businessStructureDetails?: InputMaybe<BusinessStructureDetailsInput>;
  channel?: InputMaybe<OnboardingChannel>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  contractAgreementDate?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  customerSupport?: InputMaybe<CustomerSupportInput>;
  declineDetails?: InputMaybe<OnboardingDeclineDetailsInput>;
  enrollmentDate?: InputMaybe<Scalars['String']['input']>;
  fulfillmentDetails?: InputMaybe<FulfillmentDetailsInput>;
  heardOfPayFrom?: InputMaybe<Scalars['String']['input']>;
  individuals?: InputMaybe<Array<FlattenedIndividualInput>>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  onboardingChannel?: InputMaybe<ChannelOnboardingInput>;
  otherCommunications?: InputMaybe<Scalars['Boolean']['input']>;
  payLegalEntity?: InputMaybe<Array<PayLegalEntityType>>;
  paymentRequirements?: InputMaybe<Scalars['String']['input']>;
  primaryContact?: InputMaybe<FlattenedIndividualInput>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  privacyPolicyAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  providerData?: InputMaybe<ProviderDataInput>;
  risk?: InputMaybe<RiskInput>;
  riskScore?: InputMaybe<MerchantApplicationRiskScores>;
  salesAssignee?: InputMaybe<Scalars['String']['input']>;
  settlementTerms?: InputMaybe<SettlementTermsInput>;
  shadowPurchase?: InputMaybe<ReviewStatuses>;
  shortDescriptor?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<MerchantApplicationStatuses>;
  taxInfo?: InputMaybe<TaxInfoInput>;
  test?: InputMaybe<Scalars['Boolean']['input']>;
  underwritingAssignee?: InputMaybe<Scalars['String']['input']>;
  underwritingInfo?: InputMaybe<UnderwritingInfoInput>;
  version?: InputMaybe<Scalars['Int']['input']>;
  websites?: InputMaybe<Array<UpdateMerchantApplicationWebsitesMutationInput>>;
};

export type UpdateMerchantApplicationWebsitesMutationInput = {
  domain: Scalars['String']['input'];
  login?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  platformRequiresTestUser?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMerchantConnectionMutationInput = {
  enabled: Scalars['Boolean']['input'];
  partnerKey: Scalars['ID']['input'];
};

export type UpdateMerchantConnectionMutationResponse = {
  __typename?: 'UpdateMerchantConnectionMutationResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateMerchantCrmFieldInput = {
  closingOrTerminationDate?: InputMaybe<Scalars['String']['input']>;
  closingOrTerminationReason?: InputMaybe<Scalars['String']['input']>;
  terminationReasonOptions?: InputMaybe<Array<MerchantTerminationReason>>;
};

export type UpdateMerchantCrmFieldMutationInput = {
  companyId: Scalars['String']['input'];
  crmFields: UpdateMerchantCrmFieldInput;
  merchantId: Scalars['ID']['input'];
};

export type UpdateMerchantCrmFieldResponse = {
  __typename?: 'UpdateMerchantCrmFieldResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateMerchantDashboardInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateMerchantDashboardResponse = {
  __typename?: 'UpdateMerchantDashboardResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateMerchantDefaultExportFieldsPayload = {
  exportFieldsKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  tableName: Scalars['String']['input'];
};

export type UpdateMerchantMutationInput = {
  acquirer?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activationDate?: InputMaybe<Scalars['String']['input']>;
  applicationStatus?: InputMaybe<MerchantApplicationStatuses>;
  assignee?: InputMaybe<Scalars['String']['input']>;
  automaticReview?: InputMaybe<Scalars['Boolean']['input']>;
  billingDetails?: InputMaybe<AddressInput>;
  branding?: InputMaybe<BrandingInput>;
  businessDetails?: InputMaybe<BusinessDetailsInput>;
  companyId: Scalars['String']['input'];
  consumerPayoutsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  contactInfo?: InputMaybe<ContactInfoInput>;
  continent?: InputMaybe<ContinentAlpha2>;
  costsProviderOverride?: InputMaybe<Scalars['JSON']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  default3DsProcessor?: InputMaybe<Scalars['String']['input']>;
  defaultProcessor?: InputMaybe<Scalars['String']['input']>;
  defaultProcessorAmex?: InputMaybe<Scalars['String']['input']>;
  defaultProcessorDiscover?: InputMaybe<Scalars['String']['input']>;
  defaultProcessorMastercard?: InputMaybe<Scalars['String']['input']>;
  defaultProcessorVisa?: InputMaybe<Scalars['String']['input']>;
  descriptor?: InputMaybe<Scalars['String']['input']>;
  doingBusinessAs?: InputMaybe<Scalars['String']['input']>;
  featureFlags?: InputMaybe<Array<InputMaybe<FeatureFlagQueryInput>>>;
  fronteggTenantId?: InputMaybe<Scalars['String']['input']>;
  gateway?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['String']['input'];
  lastUpdated?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payfac?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  processingCurrencyCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  processingRiskScore?: InputMaybe<MerchantApplicationRiskScores>;
  processingToSettlementsCurrencyCodes?: InputMaybe<Scalars['JSON']['input']>;
  settlementCurrencyCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<MerchantStatus>;
  testMerchant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMerchantMutationResponse = {
  __typename?: 'UpdateMerchantMutationResponse';
  merchant: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateMerchantSettingsInput = {
  defaultRiskControl?: InputMaybe<Array<DefaultRiskControlInput>>;
};

export type UpdateMerchantSettingsResponse = {
  __typename?: 'UpdateMerchantSettingsResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateNoteMutationInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateNoteMutationResponse = {
  __typename?: 'UpdateNoteMutationResponse';
  id: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
};

export type UpdateOnboardingApprovalMutationResponse = {
  __typename?: 'UpdateOnboardingApprovalMutationResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateOnboardingPricingFieldInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  categories?: InputMaybe<Array<OnboardingPricingFieldCategory>>;
  contractTypes?: InputMaybe<Array<OnboardingPricingContractType>>;
  fieldTypes?: InputMaybe<Array<OnboardingPricingFieldFieldType>>;
  frequency?: InputMaybe<Array<OnboardingPricingFieldFrequency>>;
  key: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<Array<OnboardingPricingRegion>>;
  tieredTypeConfig?: InputMaybe<OnboardingPricingFieldTieredTypeConfigInput>;
  type?: InputMaybe<OnboardingPricingFieldType>;
};

export type UpdateOnboardingPricingInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  categories?: InputMaybe<Array<OnboardingPricingCategoryInput>>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contractType?: InputMaybe<OnboardingPricingContractType>;
  currency?: InputMaybe<CurrencyAlpha3>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pricingType?: InputMaybe<OnboardingPricingType>;
  primaryContact?: InputMaybe<OnboardingPricingPrimaryContactInput>;
  region?: InputMaybe<OnboardingPricingRegion>;
  salesAssignee?: InputMaybe<Scalars['String']['input']>;
  settlementTerms?: InputMaybe<OnboardingPricingSettlementTermsInput>;
  status?: InputMaybe<OnboardingPricingStatus>;
};

export type UpdateProviderFeaturesMutationInput = {
  amex?: InputMaybe<Scalars['Boolean']['input']>;
  authorization?: InputMaybe<Scalars['Boolean']['input']>;
  cancelMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  cancelPartial?: InputMaybe<Scalars['Boolean']['input']>;
  captureMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  capturePartial?: InputMaybe<Scalars['Boolean']['input']>;
  defaultPrecision?: InputMaybe<Scalars['String']['input']>;
  discover?: InputMaybe<Scalars['Boolean']['input']>;
  externalSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  incrementalAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  interchangeFeeCostType?: InputMaybe<Scalars['String']['input']>;
  internalSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  mastercard?: InputMaybe<Scalars['Boolean']['input']>;
  networkFeeCostType?: InputMaybe<Scalars['String']['input']>;
  paymentMethodType: Scalars['String']['input'];
  payout?: InputMaybe<Scalars['Boolean']['input']>;
  processingCurrencyCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** map<string, string> */
  processingToSettlementsCurrencyCodes?: InputMaybe<Scalars['JSON']['input']>;
  provider: Scalars['String']['input'];
  refundMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  refundPartial?: InputMaybe<Scalars['Boolean']['input']>;
  sale?: InputMaybe<Scalars['Boolean']['input']>;
  settlementCurrencyCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  verification?: InputMaybe<Scalars['Boolean']['input']>;
  visa?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProvisioningTemplateMutationInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disposable?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Array<TaskFieldsInput>>;
  groups?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  merchantFacing?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requirePricingActions?: InputMaybe<Array<Scalars['String']['input']>>;
  requirePricingOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  shouldCreateSettlementAccount?: InputMaybe<Scalars['Boolean']['input']>;
  validationConfig?: InputMaybe<Array<ValidationConfigInput>>;
  workflowName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProvisioningTemplateMutationResponse = {
  __typename?: 'UpdateProvisioningTemplateMutationResponse';
  id: Scalars['ID']['output'];
};

export type UpdateReconciliationConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  example?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  reconciliationType?: InputMaybe<Scalars['String']['input']>;
  regex: Scalars['String']['input'];
  workflow?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReferralInput = {
  alternativeCurrencies?: InputMaybe<Array<AlternativeCurrenciesInput>>;
  commissionSetup?: InputMaybe<Array<EntityShareSetupInput>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expiresInYears?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  periodCountStartsFrom?: InputMaybe<Scalars['String']['input']>;
  revShareTiers?: InputMaybe<Array<RevShareTiersInput>>;
};

export type UpdateRiskAlertInput = {
  actionsToBeTaken?: InputMaybe<Scalars['String']['input']>;
  alertName?: InputMaybe<Scalars['String']['input']>;
  alertNotes?: InputMaybe<Array<NoteInput>>;
  category?: InputMaybe<RiskAlertCategory>;
  companyId: Scalars['String']['input'];
  escalationReason?: InputMaybe<Scalars['String']['input']>;
  evaluatedAt?: InputMaybe<Scalars['String']['input']>;
  evaluationReport?: InputMaybe<RiskAlertEvaluationReportInput>;
  id: Scalars['String']['input'];
  issueLink?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['String']['input']>;
  merchantId: Scalars['String']['input'];
  priority?: InputMaybe<RiskAlertPriority>;
  resolveReason?: InputMaybe<Scalars['String']['input']>;
  ruleId?: InputMaybe<Scalars['String']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  statusList?: InputMaybe<Array<RiskAlertStatusDetailsInput>>;
  suspicionReport?: InputMaybe<RiskAlertSuspicionReportInput>;
  triggeredPreviously?: InputMaybe<Scalars['Int']['input']>;
  triggeringTransactionId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRiskAlertsInput = {
  riskAlerts: Array<UpdateRiskAlertInput>;
};

export type UpdateRiskCalculatorConfigInput = {
  activityWeightPercentage?: InputMaybe<Scalars['StringifiedNumber']['input']>;
  channelWeightPercentage?: InputMaybe<Scalars['StringifiedNumber']['input']>;
  geographyWeightPercentage?: InputMaybe<Scalars['StringifiedNumber']['input']>;
  industryWeightPercentage?: InputMaybe<Scalars['StringifiedNumber']['input']>;
  lowRiskMaxScore?: InputMaybe<Scalars['StringifiedNumber']['input']>;
  mediumRiskMaxScore?: InputMaybe<Scalars['StringifiedNumber']['input']>;
  productWeightPercentage?: InputMaybe<Scalars['StringifiedNumber']['input']>;
  structureWeightPercentage?: InputMaybe<Scalars['StringifiedNumber']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRiskCalculatorMutationResponse = {
  __typename?: 'UpdateRiskCalculatorMutationResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateRiskListMutationInput = {
  allowUpdatesToGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
};

export type UpdateRiskListMutationResponse = {
  __typename?: 'UpdateRiskListMutationResponse';
  listId: Scalars['String']['output'];
};

export type UpdateRiskReviewMutationInput = {
  reference?: InputMaybe<Scalars['String']['input']>;
  reviewIds: Array<Scalars['String']['input']>;
  reviewerIdentifier?: InputMaybe<Scalars['String']['input']>;
  reviewerOrigin?: InputMaybe<Scalars['String']['input']>;
  status: RiskReviewStatus;
  statusReason?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<InputMaybe<RiskReviewType>>>;
};

export type UpdateRiskReviewMutationResponse = {
  __typename?: 'UpdateRiskReviewMutationResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateRiskRuleMutationInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  defaultRiskAlertCategory?: InputMaybe<RiskAlertCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  internalRule?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdated?: InputMaybe<Scalars['String']['input']>;
  logic?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<RiskRuleOutcome>;
  outcomes?: InputMaybe<Array<RiskRuleOutcome>>;
  rulePriority?: InputMaybe<Scalars['Float']['input']>;
  scopingLogic?: InputMaybe<Scalars['String']['input']>;
  systemRule?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateRiskRuleMutationResponse = {
  __typename?: 'UpdateRiskRuleMutationResponse';
  ruleId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateRoutineTemplateMutationInput = {
  category?: InputMaybe<RoutineTemplateCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<TaskFieldsInput>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RoutinesTemplateStatuses>;
  userGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  validationConfigs?: InputMaybe<Array<ValidationConfigInput>>;
  workflowSteps?: InputMaybe<Array<WorkflowStepInput>>;
};

export type UpdateRulePriorityMutationInput = {
  id: Scalars['String']['input'];
  rulePriority: Scalars['Float']['input'];
};

export type UpdateSettlementAccountBankTaskMutationInput = {
  bankAccount: SettlementBankAccountInput;
  documentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type UpdateSettlementAccountMutationInput = {
  bankAccount?: InputMaybe<SettlementBankAccountInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fallbackFailureCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  fallbackSettlementAccountId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  processingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleConfig?: InputMaybe<SettlementScheduleConfigInput>;
  settlementTransferType?: InputMaybe<SettlementTransferTypeEnum>;
  suspended?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSettlementAccountMutationResponse = {
  __typename?: 'UpdateSettlementAccountMutationResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateSubscriptionInput = {
  cancelAt?: InputMaybe<Scalars['String']['input']>;
  consumerId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  settings?: InputMaybe<CustomSettingsInputObject>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SubscriptionStatusEnum>;
};

export type UpdateSubscriptionPackageInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  settings: CommonSettingsInputObject;
};

export type UpdateSubscriptionPackageStatusInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateTaskTemplateInput = {
  actions: Array<TaskTemplateActionButtonInput>;
  fields?: InputMaybe<Array<FieldInput>>;
  id: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
  system?: InputMaybe<TaskSystem>;
  taskCategoryId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: TaskType;
  workflow?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTransactionReviewStatusMutationInput = {
  id: Scalars['String']['input'];
  manualReviewStatus?: InputMaybe<TransactionManualReviewStatus>;
  manualReviewStatusReason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUser = {
  countryAlpha2?: InputMaybe<CountryAlpha2>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVerificationCheckObjectInput = {
  applicableTo?: InputMaybe<VerificationCheckApplicableTo>;
  checkProcessingType?: InputMaybe<VerificationCheckProcessingType>;
  checkProviderReference?: InputMaybe<Scalars['String']['input']>;
  checkResults?: InputMaybe<VerificationCheckResultsInput>;
  checkStage?: InputMaybe<VerificationCheckStage>;
  checkStatus?: InputMaybe<Scalars['String']['input']>;
  checkType?: InputMaybe<VerificationCheckType>;
  comments?: InputMaybe<Array<VerificationCheckCommentInput>>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  providerName?: InputMaybe<VerificationCheckProviderName>;
  summary?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWebhookMutationInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventTypes?: InputMaybe<Array<NotificationType>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWebsiteInput = {
  acquiringServices?: InputMaybe<Array<WebsiteAcquiringSetup>>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  dba?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  login?: InputMaybe<Scalars['String']['input']>;
  mccs?: InputMaybe<Array<Scalars['Int']['input']>>;
  msaSignedAt?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  platformRequiresTestUser?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<WebsiteStatus>;
  terminationDescription?: InputMaybe<Scalars['String']['input']>;
  terminationReason?: InputMaybe<WebsiteTerminationReason>;
  underwritingDescription?: InputMaybe<Scalars['String']['input']>;
  underwritingStatus?: InputMaybe<WebsiteUnderwritingStatus>;
};

export type UpdateWebsitesBulkInput = {
  websites: Array<UpdateWebsiteInput>;
};

export type UpdatedStructureMutationInput = {
  amlRiskScore?: InputMaybe<Scalars['Int']['input']>;
  countryAlpha2: CountryAlpha2;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  localName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type UploadApplePayCertificate = {
  __typename?: 'UploadApplePayCertificate';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UploadApplePayCertificateInput = {
  base64Certificate: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UrlGroups = {
  __typename?: 'UrlGroups';
  closeMatchUrls?: Maybe<UrlResult>;
  exactMatchUrls?: Maybe<UrlResult>;
  noMatchUrls?: Maybe<UrlResult>;
};

export type User = {
  __typename?: 'User';
  countryAlpha2?: Maybe<CountryAlpha2>;
  description?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastLogin?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mfaEnrolled?: Maybe<Scalars['Boolean']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  phone?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  status: UserStatus;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  avatar: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserManagementAudit = {
  __typename?: 'UserManagementAudit';
  action: Scalars['String']['output'];
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  resourceId: Scalars['String']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
  userRole?: Maybe<Scalars['String']['output']>;
  userStatus?: Maybe<UserStatus>;
};

export type UserManagementAuditsQueryFilterInputValues = {
  action?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type UserManagementAuditsQueryInFilterInputValues = {
  userRole?: InputMaybe<Array<Scalars['String']['input']>>;
  userStatus?: InputMaybe<Array<UserStatus>>;
};

export type UserManagementAuditsQueryInput = {
  filter?: InputMaybe<UserManagementAuditsQueryInputFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type UserManagementAuditsQueryInputFilter = {
  between?: InputMaybe<UserManagementAuditsQueryRangeFilterInputValues>;
  equal?: InputMaybe<UserManagementAuditsQueryFilterInputValues>;
  iLike?: InputMaybe<UserManagementAuditsQueryFilterInputValues>;
  in?: InputMaybe<UserManagementAuditsQueryInFilterInputValues>;
  like?: InputMaybe<UserManagementAuditsQueryFilterInputValues>;
  notBetween?: InputMaybe<UserManagementAuditsQueryRangeFilterInputValues>;
  notEqual?: InputMaybe<UserManagementAuditsQueryFilterInputValues>;
  notIn?: InputMaybe<UserManagementAuditsQueryInFilterInputValues>;
  notLike?: InputMaybe<UserManagementAuditsQueryFilterInputValues>;
  textSearchCaseInsensitive?: InputMaybe<UserManagementAuditsQueryFilterInputValues>;
};

export type UserManagementAuditsQueryRangeFilterInputValues = {
  date?: InputMaybe<StringRangeInput>;
};

export type UserManagementAuditsQueryResponse = {
  __typename?: 'UserManagementAuditsQueryResponse';
  audits: Array<UserManagementAudit>;
  pageInfo: PageInfo;
};

export type UserQueryInput = {
  id: Scalars['String']['input'];
};

export enum UserStatus {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending'
}

export type UsersQueryExactFilterInputValues = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type UsersQueryInput = {
  filter?: InputMaybe<UsersQueryInputFilter>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type UsersQueryInputFilter = {
  and?: InputMaybe<Array<UsersQueryInputFilter>>;
  or?: InputMaybe<Array<UsersQueryInputFilter>>;
  textSearchCaseInsensitive?: InputMaybe<UsersQueryExactFilterInputValues>;
};

export type UsersQueryResponse = {
  __typename?: 'UsersQueryResponse';
  users: Array<User>;
};

export type ValidationConfig = {
  __typename?: 'ValidationConfig';
  errorMessage?: Maybe<Scalars['String']['output']>;
  key: Scalars['ID']['output'];
  maxLength?: Maybe<Scalars['Int']['output']>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  minLength?: Maybe<Scalars['Int']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type ValidationConfigInput = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['ID']['input'];
  maxLength?: InputMaybe<Scalars['Int']['input']>;
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  minLength?: InputMaybe<Scalars['Int']['input']>;
  minValue?: InputMaybe<Scalars['Float']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VatInfo = {
  __typename?: 'VatInfo';
  countryCode?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  traderAddress?: Maybe<Scalars['String']['output']>;
  traderAddressComponents?: Maybe<TraderAddressComponents>;
  traderCompanyType?: Maybe<Scalars['String']['output']>;
  traderName?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type VatInfoPayload = {
  vatNumber: Scalars['String']['input'];
};

export enum VerificationCheckApplicableTo {
  BankAccount = 'bank_account',
  Individual = 'individual',
  Merchant = 'merchant',
  Partner = 'partner',
  Website = 'website'
}

export type VerificationCheckComment = {
  __typename?: 'VerificationCheckComment';
  addedAt?: Maybe<Scalars['String']['output']>;
  addedBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  verificationCheckId?: Maybe<Scalars['String']['output']>;
};

export type VerificationCheckCommentInput = {
  addedAt?: InputMaybe<Scalars['String']['input']>;
  addedBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verificationCheckId?: InputMaybe<Scalars['String']['input']>;
};

export type VerificationCheckObject = {
  __typename?: 'VerificationCheckObject';
  applicableTo: VerificationCheckApplicableTo;
  bankAccountId?: Maybe<Scalars['String']['output']>;
  checkProcessingType: VerificationCheckProcessingType;
  checkProviderReference?: Maybe<Scalars['String']['output']>;
  checkResults?: Maybe<VerificationCheckResults>;
  checkStage: VerificationCheckStage;
  checkStatus?: Maybe<Scalars['String']['output']>;
  checkType: VerificationCheckType;
  comments?: Maybe<Array<VerificationCheckComment>>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  individualId?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  providerRequestParams?: Maybe<ScreeningCallRequestParams>;
  summary?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  websiteId?: Maybe<Scalars['String']['output']>;
};

export enum VerificationCheckProcessingType {
  Automatic = 'automatic',
  Manual = 'manual'
}

export enum VerificationCheckProviderName {
  Everc = 'everc',
  Experian = 'experian',
  Giact = 'giact',
  Manual = 'manual',
  Match = 'match',
  Onfido = 'onfido',
  SimilarWeb = 'similar_web',
  TrueBiz = 'true_biz',
  Vmss = 'vmss',
  WebShield = 'web_shield',
  Worldcheck = 'worldcheck'
}

export type VerificationCheckResponse = {
  __typename?: 'VerificationCheckResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type VerificationCheckResults = {
  __typename?: 'VerificationCheckResults';
  everc?: Maybe<Array<EvercCheckResult>>;
  match?: Maybe<Array<CardSchemaProviderScreeningResult>>;
  onfido?: Maybe<Array<OnfidoCheckResult>>;
  vmss?: Maybe<Array<CardSchemaProviderScreeningResult>>;
  worldcheck?: Maybe<Array<WorldcheckResult>>;
};

export type VerificationCheckResultsInput = {
  everc?: InputMaybe<Array<EvercCheckResultInput>>;
  match?: InputMaybe<Array<CardSchemaProviderScreeningResultInput>>;
  onfido?: InputMaybe<Array<OnfidoCheckResultInput>>;
  vmss?: InputMaybe<Array<CardSchemaProviderScreeningResultInput>>;
  worldcheck?: InputMaybe<Array<WorldcheckResultInput>>;
};

export enum VerificationCheckStage {
  Initial = 'initial',
  Ongoing = 'ongoing'
}

export enum VerificationCheckType {
  BankVerification = 'bank_verification',
  Blacklist = 'blacklist',
  CommercialCreditReport = 'commercial_credit_report',
  ConsumerCreditReport = 'consumer_credit_report',
  FinancialReview = 'financial_review',
  Kyb = 'kyb',
  Kyc = 'kyc',
  OnlineChecks = 'online_checks',
  ProcessingReview = 'processing_review',
  Screening = 'screening',
  WebsiteCrawling = 'website_crawling'
}

export type VerificationChecksList = {
  __typename?: 'VerificationChecksList';
  verificationChecks?: Maybe<Array<VerificationCheckObject>>;
};

export enum VerificationResult {
  Fail = 'FAIL',
  Pass = 'PASS',
  Unavailable = 'UNAVAILABLE',
  Unchecked = 'UNCHECKED'
}

export type Webhook = {
  __typename?: 'Webhook';
  companyId: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  eventTypes: Array<NotificationType>;
  id: Scalars['ID']['output'];
  merchantId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  secretKey: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type WebhookEventTypesQueryResponse = {
  __typename?: 'WebhookEventTypesQueryResponse';
  eventTypes: Array<EventType>;
};

export type WebhookIdInput = {
  id: Scalars['ID']['input'];
};

export type WebhooksQueryResponse = {
  __typename?: 'WebhooksQueryResponse';
  webhooks?: Maybe<Array<Webhook>>;
};

export enum WebsiteAcquiringSetup {
  Acquirer = 'acquirer',
  Gateway = 'gateway',
  Payfac = 'payfac'
}

export type WebsiteEntry = {
  __typename?: 'WebsiteEntry';
  domain: Scalars['String']['output'];
  id: Scalars['String']['output'];
  login?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  platformRequiresTestUser: Scalars['Boolean']['output'];
};

export type WebsiteMutationResponse = {
  __typename?: 'WebsiteMutationResponse';
  success: Scalars['Boolean']['output'];
};

export enum WebsiteStatus {
  Active = 'active',
  BlockedSalesAndRefunds = 'blocked_sales_and_refunds',
  New = 'new',
  SalesBlock = 'sales_block',
  Terminated = 'terminated'
}

export enum WebsiteTerminationReason {
  ExcessiveCreditExposure = 'excessive_credit_exposure',
  ExcessiveDisputesRate = 'excessive_disputes_rate',
  ExcessiveFraudRate = 'excessive_fraud_rate',
  ExcessiveRefundsRate = 'excessive_refunds_rate',
  FraudulentActivity = 'fraudulent_activity',
  Other = 'other',
  OutsideOfRiskAppetite = 'outside_of_risk_appetite',
  ProhibitedActivity = 'prohibited_activity',
  SuspiciousActivity = 'suspicious_activity'
}

export enum WebsiteUnderwritingStatus {
  Approved = 'approved',
  InReview = 'in_review',
  PendingInfo = 'pending_info',
  Rejected = 'rejected',
  Submitted = 'submitted',
  Withdrawn = 'withdrawn'
}

export type Workflow = {
  __typename?: 'Workflow';
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  friendlyName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  params?: Maybe<Array<WorkflowParameters>>;
  signals?: Maybe<Array<Scalars['String']['output']>>;
  taskQueue: Scalars['String']['output'];
};

export type WorkflowParameters = {
  __typename?: 'WorkflowParameters';
  description?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
};

export type WorkflowStep = {
  __typename?: 'WorkflowStep';
  method?: Maybe<Scalars['String']['output']>;
  request?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['String']['output']>;
};

export type WorkflowStepInput = {
  method?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  step?: InputMaybe<Scalars['String']['input']>;
};

export type WorldcheckResult = {
  __typename?: 'WorldcheckResult';
  id?: Maybe<Scalars['String']['output']>;
  verificationCheckId?: Maybe<Scalars['String']['output']>;
};

export type WorldcheckResultInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  verificationCheckId?: InputMaybe<Scalars['String']['input']>;
};

export type ConsumerInsightsQueryInput = {
  consumerPayoutsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  currency: CurrencyAlpha3;
  id: Scalars['String']['input'];
};

export type CustomerPaymentSourceQueryInput = {
  consumerId: Scalars['String']['input'];
};

export type CustomerPaymentSourceResponse = {
  __typename?: 'customerPaymentSourceResponse';
  items?: Maybe<Array<Maybe<SourceObject>>>;
};

export enum FulfillmentMethod {
  ManagedByThirdParty = 'managed_by_third_party',
  ManagedInHouse = 'managed_in_house'
}

export type MerchantsQueryExactFilterInputValues = {
  applicationStatus?: InputMaybe<MerchantApplicationStatuses>;
  assignee?: InputMaybe<Scalars['String']['input']>;
  automaticReview?: InputMaybe<Scalars['Boolean']['input']>;
  billingDetails?: InputMaybe<AddressInput>;
  branding?: InputMaybe<BrandingInput>;
  businessDetails?: InputMaybe<BusinessDetailsInput>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  consumerPayoutsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  contactInfo?: InputMaybe<ContactInfoInput>;
  continent?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryAlpha2>;
  currencyCode?: InputMaybe<CurrencyAlpha3>;
  default3DsProcessor?: InputMaybe<Scalars['String']['input']>;
  defaultProcessor?: InputMaybe<Scalars['String']['input']>;
  defaultProcessorAmex?: InputMaybe<Scalars['String']['input']>;
  defaultProcessorDiscover?: InputMaybe<Scalars['String']['input']>;
  defaultProcessorMastercard?: InputMaybe<Scalars['String']['input']>;
  defaultProcessorVisa?: InputMaybe<Scalars['String']['input']>;
  descriptor?: InputMaybe<Scalars['String']['input']>;
  doingBusinessAs?: InputMaybe<Scalars['String']['input']>;
  fronteggTenantId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overrideOnboardingMerchantId?: InputMaybe<Scalars['ID']['input']>;
  processingRiskScore?: InputMaybe<MerchantApplicationRiskScores>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<MerchantStatus>;
  testMerchant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MerchantsQueryHasAnyFilterInputValues = {
  acquirer?: InputMaybe<Array<Scalars['String']['input']>>;
  gateway?: InputMaybe<Array<Scalars['String']['input']>>;
  payfac?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MerchantsQueryInFilterInputValues = {
  acquirer?: InputMaybe<Array<Scalars['String']['input']>>;
  applicationStatus?: InputMaybe<Array<InputMaybe<MerchantApplicationStatuses>>>;
  assignee?: InputMaybe<Array<Scalars['String']['input']>>;
  billingDetails?: InputMaybe<AddressListInput>;
  branding?: InputMaybe<BrandingListInput>;
  businessDetails?: InputMaybe<BusinessDetailsListInput>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  contactInfo?: InputMaybe<ContactInfoListInput>;
  continent?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Array<CountryAlpha2>>;
  currencyCode?: InputMaybe<Array<CurrencyAlpha3>>;
  default3DsProcessor?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultProcessor?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultProcessorAmex?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultProcessorDiscover?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultProcessorMastercard?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultProcessorVisa?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptor?: InputMaybe<Array<Scalars['String']['input']>>;
  fronteggTenantId?: InputMaybe<Array<Scalars['String']['input']>>;
  gateway?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  payfac?: InputMaybe<Array<Scalars['String']['input']>>;
  processingRiskScore?: InputMaybe<Array<MerchantApplicationRiskScores>>;
  stage?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Array<MerchantStatus>>;
};

export type MerchantsQueryInputFilter = {
  and?: InputMaybe<Array<MerchantsQueryInputFilter>>;
  between?: InputMaybe<MerchantsQueryRangeFilterInputValues>;
  equal?: InputMaybe<MerchantsQueryExactFilterInputValues>;
  greater?: InputMaybe<MerchantsQueryExactFilterInputValues>;
  greaterOrEquals?: InputMaybe<MerchantsQueryExactFilterInputValues>;
  hasAny?: InputMaybe<MerchantsQueryHasAnyFilterInputValues>;
  iLike?: InputMaybe<MerchantsQueryExactFilterInputValues>;
  in?: InputMaybe<MerchantsQueryInFilterInputValues>;
  less?: InputMaybe<MerchantsQueryExactFilterInputValues>;
  lessOrEquals?: InputMaybe<MerchantsQueryExactFilterInputValues>;
  like?: InputMaybe<MerchantsQueryExactFilterInputValues>;
  notBetween?: InputMaybe<MerchantsQueryRangeFilterInputValues>;
  notEqual?: InputMaybe<MerchantsQueryExactFilterInputValues>;
  notIn?: InputMaybe<MerchantsQueryInFilterInputValues>;
  notLike?: InputMaybe<MerchantsQueryExactFilterInputValues>;
  or?: InputMaybe<Array<MerchantsQueryInputFilter>>;
};

export type MerchantsQueryRangeFilterInputValues = {
  activationDate?: InputMaybe<StringRangeInput>;
  lastUpdated?: InputMaybe<StringRangeInput>;
  stage?: InputMaybe<IntRangeInput>;
};

export type OnboardingEventsExactFilterInputValues = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingEventsInputFilter = {
  equal?: InputMaybe<OnboardingEventsExactFilterInputValues>;
};

export type PaymentFeesByParamsQueryExactInputFilter = {
  feeType?: InputMaybe<FeeType>;
  paymentId: Scalars['String']['input'];
};

export type PaymentFeesByParamsQueryInInputFilter = {
  feeType?: InputMaybe<Array<FeeType>>;
};

export type PaymentFeesByParamsQueryInput = {
  filter?: InputMaybe<PaymentFeesByParamsQueryInputFilter>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentFeesByParamsQueryInputFilter = {
  equal?: InputMaybe<PaymentFeesByParamsQueryExactInputFilter>;
  in?: InputMaybe<PaymentFeesByParamsQueryInInputFilter>;
  notEqual?: InputMaybe<PaymentFeesByParamsQueryExactInputFilter>;
  notIn?: InputMaybe<PaymentFeesByParamsQueryInInputFilter>;
};

export type PaymentFeesQueryInput = {
  paymentId: Scalars['String']['input'];
};

export type PaymentsQueryExactFilterInputValues = {
  allowPartialApproval?: InputMaybe<Scalars['Boolean']['input']>;
  amountCancelled?: InputMaybe<Scalars['Float']['input']>;
  amountCapturable?: InputMaybe<Scalars['Float']['input']>;
  amountReceived?: InputMaybe<Scalars['Float']['input']>;
  amountRefunded?: InputMaybe<Scalars['Float']['input']>;
  approvedAmount?: InputMaybe<Scalars['Float']['input']>;
  attempt?: InputMaybe<Scalars['Int']['input']>;
  attemptId?: InputMaybe<Scalars['String']['input']>;
  availablePaymentMethod?: InputMaybe<Scalars['String']['input']>;
  billingDetails?: InputMaybe<AddressInput>;
  billingDetailsAddressId?: InputMaybe<Scalars['String']['input']>;
  captureDelay?: InputMaybe<Scalars['String']['input']>;
  checkout?: InputMaybe<Scalars['Boolean']['input']>;
  checkoutCashier?: InputMaybe<Scalars['Boolean']['input']>;
  checkoutCashierBalance?: InputMaybe<Scalars['Float']['input']>;
  checkoutCashierDepositLimit?: InputMaybe<Scalars['Float']['input']>;
  checkoutCashierPresetAmounts?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  checkoutCashierWithdrawLimit?: InputMaybe<Scalars['Float']['input']>;
  checkoutLocale?: InputMaybe<Scalars['String']['input']>;
  checkoutSetupFutureUsage?: InputMaybe<Scalars['Boolean']['input']>;
  clientIp?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  consumerEmail?: InputMaybe<Scalars['String']['input']>;
  consumerFirstName?: InputMaybe<Scalars['String']['input']>;
  consumerId?: InputMaybe<Scalars['ID']['input']>;
  consumerLastName?: InputMaybe<Scalars['String']['input']>;
  consumerMerchantConsumerId?: InputMaybe<Scalars['String']['input']>;
  consumerPhone?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CurrencyAlpha3>;
  dateTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptor?: InputMaybe<Scalars['String']['input']>;
  finalize?: InputMaybe<FinalizeInput>;
  finalize__authCode?: InputMaybe<Scalars['String']['input']>;
  finalize__transactionRrn?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastVisitedStep?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  merchantLegalName?: InputMaybe<Scalars['String']['input']>;
  mit?: InputMaybe<Scalars['Boolean']['input']>;
  mitReason?: InputMaybe<MitReason>;
  networkTransactionId?: InputMaybe<Scalars['String']['input']>;
  notificationUrl?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodInput>;
  paymentMethod__type?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  processor?: InputMaybe<Scalars['String']['input']>;
  processorTransactionId?: InputMaybe<Scalars['String']['input']>;
  proxyProcessor?: InputMaybe<Scalars['String']['input']>;
  reconciliationDate?: InputMaybe<Scalars['String']['input']>;
  reconciliationFailureReason?: InputMaybe<Scalars['String']['input']>;
  reconciliationId?: InputMaybe<Scalars['String']['input']>;
  reconciliationStatus?: InputMaybe<ReconciliationStatusEnum>;
  redirectUrlFailure?: InputMaybe<Scalars['String']['input']>;
  redirectUrlSuccess?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  relatedRecurringTransaction?: InputMaybe<Scalars['String']['input']>;
  relatedTransaction?: InputMaybe<Scalars['String']['input']>;
  requestedAmount?: InputMaybe<Scalars['Float']['input']>;
  settlementId?: InputMaybe<Scalars['String']['input']>;
  shippingDetails?: InputMaybe<AddressInput>;
  shippingDetailsAddressId?: InputMaybe<Scalars['String']['input']>;
  shippingFirstName?: InputMaybe<Scalars['String']['input']>;
  shippingLastName?: InputMaybe<Scalars['String']['input']>;
  shippingPhone?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TransactionStatus>;
  subType?: InputMaybe<Scalars['String']['input']>;
  summableAmount?: InputMaybe<Scalars['Float']['input']>;
  termsAndConditionsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  termsAndConditionsAcceptedOnTransaction?: InputMaybe<Scalars['String']['input']>;
  threeDsAcsOperatorId?: InputMaybe<Scalars['String']['input']>;
  threeDsAcsReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  threeDsAcsTransactionId?: InputMaybe<Scalars['String']['input']>;
  threeDsAcsUrl?: InputMaybe<Scalars['String']['input']>;
  threeDsAuthenticationFlow?: InputMaybe<Scalars['String']['input']>;
  threeDsCardHolderInfo?: InputMaybe<Scalars['String']['input']>;
  threeDsCavv?: InputMaybe<Scalars['String']['input']>;
  threeDsChallengeIndicator?: InputMaybe<Scalars['String']['input']>;
  threeDsChallengeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  threeDsDsTransactionId?: InputMaybe<Scalars['String']['input']>;
  threeDsEci?: InputMaybe<Scalars['String']['input']>;
  threeDsEnrolled?: InputMaybe<Scalars['Boolean']['input']>;
  threeDsErrorCode?: InputMaybe<Scalars['String']['input']>;
  threeDsErrorDescription?: InputMaybe<Scalars['String']['input']>;
  threeDsPaResStatus?: InputMaybe<Scalars['String']['input']>;
  threeDsPayload?: InputMaybe<Scalars['String']['input']>;
  threeDsReasonCode?: InputMaybe<Scalars['String']['input']>;
  threeDsReasonDescription?: InputMaybe<Scalars['String']['input']>;
  threeDsResult?: InputMaybe<Scalars['String']['input']>;
  threeDsServerTransactionId?: InputMaybe<Scalars['String']['input']>;
  threeDsVersion?: InputMaybe<Scalars['String']['input']>;
  threeDsXid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentsQueryInFilterInputValues = {
  amountCancelled?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountCapturable?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountReceived?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountRefunded?: InputMaybe<Array<Scalars['Float']['input']>>;
  approvedAmount?: InputMaybe<Array<Scalars['Float']['input']>>;
  attempt?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  attemptId?: InputMaybe<Array<Scalars['String']['input']>>;
  availablePaymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  billingDetails?: InputMaybe<AddressListInput>;
  billingDetailsAddressId?: InputMaybe<Array<Scalars['String']['input']>>;
  captureDelay?: InputMaybe<Array<Scalars['String']['input']>>;
  checkoutCashierBalance?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkoutCashierDepositLimit?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkoutCashierPresetAmounts?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkoutCashierWithdrawLimit?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkoutLocale?: InputMaybe<Array<Scalars['String']['input']>>;
  clientIp?: InputMaybe<Array<Scalars['String']['input']>>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  consumerEmail?: InputMaybe<Array<Scalars['String']['input']>>;
  consumerFirstName?: InputMaybe<Array<Scalars['String']['input']>>;
  consumerId?: InputMaybe<Array<Scalars['ID']['input']>>;
  consumerLastName?: InputMaybe<Array<Scalars['String']['input']>>;
  consumerMerchantConsumerId?: InputMaybe<Array<Scalars['String']['input']>>;
  consumerPhone?: InputMaybe<Array<Scalars['String']['input']>>;
  currency?: InputMaybe<Array<CurrencyAlpha3>>;
  dateTime?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptor?: InputMaybe<Array<Scalars['String']['input']>>;
  finalize__authCode?: InputMaybe<Array<Scalars['String']['input']>>;
  finalize__eci?: InputMaybe<Array<Scalars['String']['input']>>;
  finalize__issuerResponseCode?: InputMaybe<Array<Scalars['String']['input']>>;
  finalize__issuerResponseText?: InputMaybe<Array<Scalars['String']['input']>>;
  finalize__networkCode?: InputMaybe<Array<Scalars['String']['input']>>;
  finalize__resultSource?: InputMaybe<Array<Scalars['String']['input']>>;
  finalize__transactionResult?: InputMaybe<Array<Scalars['String']['input']>>;
  finalize__transactionRrn?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastVisitedStep?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantId?: InputMaybe<Array<Scalars['ID']['input']>>;
  merchantLegalName?: InputMaybe<Array<Scalars['String']['input']>>;
  mitReason?: InputMaybe<Array<MitReason>>;
  networkTransactionId?: InputMaybe<Array<Scalars['String']['input']>>;
  notificationUrl?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentId?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod?: InputMaybe<PaymentMethodListInput>;
  paymentStatus?: InputMaybe<Array<InputMaybe<PaymentStatus>>>;
  processor?: InputMaybe<Array<Scalars['String']['input']>>;
  processorTransactionId?: InputMaybe<Array<Scalars['String']['input']>>;
  proxyProcessor?: InputMaybe<Array<Scalars['String']['input']>>;
  reconciliationDate?: InputMaybe<Array<Scalars['String']['input']>>;
  reconciliationFailureReason?: InputMaybe<Array<Scalars['String']['input']>>;
  reconciliationId?: InputMaybe<Array<Scalars['String']['input']>>;
  reconciliationStatus?: InputMaybe<Array<ReconciliationStatusEnum>>;
  redirectUrlFailure?: InputMaybe<Array<Scalars['String']['input']>>;
  redirectUrlSuccess?: InputMaybe<Array<Scalars['String']['input']>>;
  reference?: InputMaybe<Array<Scalars['String']['input']>>;
  relatedRecurringTransaction?: InputMaybe<Array<Scalars['String']['input']>>;
  relatedTransaction?: InputMaybe<Array<Scalars['String']['input']>>;
  requestedAmount?: InputMaybe<Array<Scalars['Float']['input']>>;
  shippingDetails?: InputMaybe<AddressListInput>;
  shippingDetailsAddressId?: InputMaybe<Array<Scalars['String']['input']>>;
  shippingFirstName?: InputMaybe<Array<Scalars['String']['input']>>;
  shippingLastName?: InputMaybe<Array<Scalars['String']['input']>>;
  shippingPhone?: InputMaybe<Array<Scalars['String']['input']>>;
  siteId?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<TransactionStatus>>;
  subType?: InputMaybe<Array<Scalars['String']['input']>>;
  summableAmount?: InputMaybe<Array<Scalars['Float']['input']>>;
  termsAndConditionsAcceptedOnTransaction?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsAcsOperatorId?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsAcsReferenceNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsAcsTransactionId?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsAcsUrl?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsAuthenticationFlow?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsCardHolderInfo?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsCavv?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsChallengeIndicator?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsDsTransactionId?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsEci?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsErrorCode?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsErrorDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsPaResStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsPayload?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsReasonCode?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsReasonDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsResult?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsServerTransactionId?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsVersion?: InputMaybe<Array<Scalars['String']['input']>>;
  threeDsXid?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PaymentsQueryInput = {
  aggregate?: InputMaybe<PaymentsQueryInputAggregate>;
  filter?: InputMaybe<PaymentsQueryInputFilter>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  includeAttempts?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderBy>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  primaryKeysParams?: InputMaybe<PaymentsPrimaryKeysParamsInput>;
};

export type PaymentsQueryInputAggregate = {
  avg?: InputMaybe<Array<Scalars['String']['input']>>;
  count?: InputMaybe<Array<Scalars['String']['input']>>;
  sum?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PaymentsQueryInputFilter = {
  and?: InputMaybe<Array<PaymentsQueryInputFilter>>;
  between?: InputMaybe<PaymentsQueryRangeFilterInputValues>;
  equal?: InputMaybe<PaymentsQueryExactFilterInputValues>;
  greater?: InputMaybe<PaymentsQueryExactFilterInputValues>;
  greaterOrEquals?: InputMaybe<PaymentsQueryExactFilterInputValues>;
  iLike?: InputMaybe<PaymentsQueryExactFilterInputValues>;
  in?: InputMaybe<PaymentsQueryInFilterInputValues>;
  less?: InputMaybe<PaymentsQueryExactFilterInputValues>;
  lessOrEquals?: InputMaybe<PaymentsQueryExactFilterInputValues>;
  like?: InputMaybe<PaymentsQueryExactFilterInputValues>;
  notBetween?: InputMaybe<PaymentsQueryRangeFilterInputValues>;
  notEqual?: InputMaybe<PaymentsQueryExactFilterInputValues>;
  notIn?: InputMaybe<PaymentsQueryInFilterInputValues>;
  notLike?: InputMaybe<PaymentsQueryExactFilterInputValues>;
  or?: InputMaybe<Array<PaymentsQueryInputFilter>>;
};

export type PaymentsQueryRangeFilterInputValues = {
  amountCancelled?: InputMaybe<FloatRangeInput>;
  amountCapturable?: InputMaybe<FloatRangeInput>;
  amountReceived?: InputMaybe<FloatRangeInput>;
  amountRefunded?: InputMaybe<FloatRangeInput>;
  approvedAmount?: InputMaybe<FloatRangeInput>;
  attempt?: InputMaybe<IntRangeInput>;
  bankSettlementSummableAmount?: InputMaybe<FloatRangeInput>;
  checkoutCashierBalance?: InputMaybe<FloatRangeInput>;
  checkoutCashierDepositLimit?: InputMaybe<FloatRangeInput>;
  checkoutCashierPresetAmounts?: InputMaybe<Array<InputMaybe<FloatRangeInput>>>;
  checkoutCashierWithdrawLimit?: InputMaybe<FloatRangeInput>;
  clearingDate?: InputMaybe<StringRangeInput>;
  commission?: InputMaybe<FloatRangeInput>;
  dateTime?: InputMaybe<StringRangeInput>;
  dccRevenue?: InputMaybe<FloatRangeInput>;
  disputeAmount?: InputMaybe<FloatRangeInput>;
  endUserAmount?: InputMaybe<FloatRangeInput>;
  endUserConversionRate?: InputMaybe<FloatRangeInput>;
  fraudDateTime?: InputMaybe<FloatRangeInput>;
  interchangeFeeEstimated?: InputMaybe<FloatRangeInput>;
  interchangeFeeFinal?: InputMaybe<FloatRangeInput>;
  internalCost?: InputMaybe<FloatRangeInput>;
  internalCostAcquiring?: InputMaybe<FloatRangeInput>;
  internalCostAcquiringBasisPoints?: InputMaybe<FloatRangeInput>;
  internalCostCommission?: InputMaybe<FloatRangeInput>;
  internalCostFixed?: InputMaybe<FloatRangeInput>;
  internalCostFixedProcessor?: InputMaybe<FloatRangeInput>;
  internalCostProvider?: InputMaybe<FloatRangeInput>;
  internalCostReferral?: InputMaybe<FloatRangeInput>;
  internalRevenueEstimated?: InputMaybe<FloatRangeInput>;
  internalRevenueFinal?: InputMaybe<FloatRangeInput>;
  merchantFee?: InputMaybe<FloatRangeInput>;
  netAmountEstimated?: InputMaybe<FloatRangeInput>;
  netAmountFinal?: InputMaybe<FloatRangeInput>;
  networkFeeEstimated?: InputMaybe<FloatRangeInput>;
  networkFeeFinal?: InputMaybe<FloatRangeInput>;
  referralFee?: InputMaybe<FloatRangeInput>;
  requestedAmount?: InputMaybe<FloatRangeInput>;
  rollingReserveAmount?: InputMaybe<FloatRangeInput>;
  rollingReserveConfigAmount?: InputMaybe<FloatRangeInput>;
  schemeFeeEstimated?: InputMaybe<FloatRangeInput>;
  schemeFeeFinal?: InputMaybe<FloatRangeInput>;
  summableAmount?: InputMaybe<FloatRangeInput>;
  transactionFeeEstimated?: InputMaybe<FloatRangeInput>;
  transactionFeeFinal?: InputMaybe<FloatRangeInput>;
};

export type ReservesNextReleaseResponse = {
  __typename?: 'reservesNextReleaseResponse';
  releaseAmount?: Maybe<Scalars['String']['output']>;
  releaseDate?: Maybe<Scalars['String']['output']>;
};

export enum SpecialProducts {
  Cbd = 'cbd',
  DigitalWallet = 'digital_wallet',
  Other = 'other',
  Prepaid = 'prepaid'
}

export type TasksQueryExactFilterInputValues = {
  assignee?: InputMaybe<Scalars['String']['input']>;
  cancelReason?: InputMaybe<Scalars['String']['input']>;
  canceledAt?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<TaskCategoryInput>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  creatorNote?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispute?: InputMaybe<TaskDisputeInput>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  expiresOn?: InputMaybe<Scalars['String']['input']>;
  groupAssignee?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  merchantGroupAssignee?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  merchantName?: InputMaybe<Scalars['String']['input']>;
  requestReason?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  signal?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TaskStatus>;
  system?: InputMaybe<TaskSystem>;
  taskCategoryId?: InputMaybe<Scalars['String']['input']>;
  taskTemplateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TaskType>;
  workflow?: InputMaybe<Scalars['String']['input']>;
};

export type TasksQueryInFilterInputValues = {
  assignee?: InputMaybe<Array<Scalars['String']['input']>>;
  cancelReason?: InputMaybe<Array<Scalars['String']['input']>>;
  canceledAt?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<TaskCategoryListInput>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  completedAt?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Array<Scalars['String']['input']>>;
  createdBy?: InputMaybe<Array<Scalars['String']['input']>>;
  creatorNote?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Array<Scalars['String']['input']>>;
  dispute?: InputMaybe<TaskDisputeInFilterInput>;
  entityId?: InputMaybe<Array<Scalars['String']['input']>>;
  entityName?: InputMaybe<Array<Scalars['String']['input']>>;
  expiresOn?: InputMaybe<Array<Scalars['String']['input']>>;
  groupAssignee?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantGroupAssignee?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantId?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantName?: InputMaybe<Array<Scalars['String']['input']>>;
  requestReason?: InputMaybe<Array<Scalars['String']['input']>>;
  resource?: InputMaybe<Array<Scalars['String']['input']>>;
  resourceId?: InputMaybe<Array<Scalars['String']['input']>>;
  signal?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<TaskStatus>>;
  system?: InputMaybe<Array<TaskSystem>>;
  taskCategoryId?: InputMaybe<Array<Scalars['String']['input']>>;
  taskTemplateId?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<TaskType>>;
  workflow?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TasksQueryInputFilter = {
  and?: InputMaybe<Array<InputMaybe<TasksQueryInputFilter>>>;
  between?: InputMaybe<TasksQueryRangeFilterInputValues>;
  equal?: InputMaybe<TasksQueryExactFilterInputValues>;
  iLike?: InputMaybe<TasksQueryExactFilterInputValues>;
  in?: InputMaybe<TasksQueryInFilterInputValues>;
  like?: InputMaybe<TasksQueryExactFilterInputValues>;
  notBetween?: InputMaybe<TasksQueryRangeFilterInputValues>;
  notEqual?: InputMaybe<TasksQueryExactFilterInputValues>;
  notIn?: InputMaybe<TasksQueryInFilterInputValues>;
  notLike?: InputMaybe<TasksQueryExactFilterInputValues>;
  or?: InputMaybe<Array<TasksQueryInputFilter>>;
  textSearchCaseInsensitive?: InputMaybe<TasksQueryExactFilterInputValues>;
};

export type TasksQueryRangeFilterInputValues = {
  canceledAt?: InputMaybe<StringRangeInput>;
  completedAt?: InputMaybe<StringRangeInput>;
  createdAt?: InputMaybe<StringRangeInput>;
  expiresOn?: InputMaybe<StringRangeInput>;
};

export type TransactionsQueryExactFilterInputValues = {
  acquiringSetup?: InputMaybe<TransactionAcquiringSetup>;
  allowPartialApproval?: InputMaybe<Scalars['Boolean']['input']>;
  amountCancelled?: InputMaybe<Scalars['Float']['input']>;
  amountCapturable?: InputMaybe<Scalars['Float']['input']>;
  amountReceived?: InputMaybe<Scalars['Float']['input']>;
  amountRefunded?: InputMaybe<Scalars['Float']['input']>;
  approvedAmount?: InputMaybe<Scalars['Float']['input']>;
  attempt?: InputMaybe<Scalars['Int']['input']>;
  attemptId?: InputMaybe<Scalars['String']['input']>;
  availablePaymentMethod?: InputMaybe<Scalars['String']['input']>;
  billingDetails?: InputMaybe<AddressInput>;
  billingDetailsAddressId?: InputMaybe<Scalars['String']['input']>;
  billingDetails__countryAlpha2?: InputMaybe<Scalars['String']['input']>;
  billingDetails__state?: InputMaybe<Scalars['String']['input']>;
  billingDetails__zip?: InputMaybe<Scalars['String']['input']>;
  captureDelay?: InputMaybe<Scalars['String']['input']>;
  checkout?: InputMaybe<Scalars['Boolean']['input']>;
  checkoutCashier?: InputMaybe<Scalars['Boolean']['input']>;
  checkoutCashierBalance?: InputMaybe<Scalars['Float']['input']>;
  checkoutCashierDepositLimit?: InputMaybe<Scalars['Float']['input']>;
  checkoutCashierPresetAmounts?: InputMaybe<Scalars['Float']['input']>;
  checkoutCashierWithdrawLimit?: InputMaybe<Scalars['Float']['input']>;
  checkoutLocale?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionDuration?: InputMaybe<Scalars['Int']['input']>;
  checkoutSetupFutureUsage?: InputMaybe<Scalars['Boolean']['input']>;
  cleared?: InputMaybe<Scalars['Boolean']['input']>;
  clearingDate?: InputMaybe<Scalars['String']['input']>;
  clientIp?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  consumerEmail?: InputMaybe<Scalars['String']['input']>;
  consumerFirstName?: InputMaybe<Scalars['String']['input']>;
  consumerFullName?: InputMaybe<Scalars['String']['input']>;
  consumerId?: InputMaybe<Scalars['ID']['input']>;
  consumerLastName?: InputMaybe<Scalars['String']['input']>;
  consumerMerchantConsumerId?: InputMaybe<Scalars['String']['input']>;
  consumerPhone?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CurrencyAlpha3>;
  dateTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptor?: InputMaybe<Scalars['String']['input']>;
  disputeAcceptedOrLostAt?: InputMaybe<Scalars['String']['input']>;
  disputeAmount?: InputMaybe<Scalars['Float']['input']>;
  disputeId?: InputMaybe<Scalars['String']['input']>;
  disputeStatus?: InputMaybe<DisputeStatus>;
  disputeWonAt?: InputMaybe<Scalars['String']['input']>;
  externalSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  finalize?: InputMaybe<TransactionFinalizeInput>;
  finalize__authCode?: InputMaybe<Scalars['String']['input']>;
  finalize__issuerResponseCode?: InputMaybe<Scalars['String']['input']>;
  finalize__partial_approval__status?: InputMaybe<Scalars['String']['input']>;
  finalize__transactionRrn?: InputMaybe<Scalars['String']['input']>;
  finalize__transactionTimestamp?: InputMaybe<Scalars['String']['input']>;
  fraud?: InputMaybe<Scalars['Boolean']['input']>;
  fraudActionable?: InputMaybe<Scalars['Boolean']['input']>;
  fraudDateTime?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isRetryAttempt?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdiction?: InputMaybe<TransactionJurisdiction>;
  lastVisitedStep?: InputMaybe<Scalars['String']['input']>;
  manualReview?: InputMaybe<Scalars['Boolean']['input']>;
  maxAttempts?: InputMaybe<Scalars['Float']['input']>;
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  mit?: InputMaybe<Scalars['Boolean']['input']>;
  mitReason?: InputMaybe<MitReason>;
  netAmountFinal?: InputMaybe<Scalars['Float']['input']>;
  networkTransactionId?: InputMaybe<Scalars['String']['input']>;
  notificationUrl?: InputMaybe<Scalars['String']['input']>;
  originalTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  paymentAttempt?: InputMaybe<Scalars['Float']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentLinkId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<TransactionPaymentMethodInput>;
  paymentMethod__applepay__addressLine1Check?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__addressPostalCodeCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__bin?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__brand?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__cvcCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__expiryMonth?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__expiryYear?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__fingerprint?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__funding?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__issuerCountry?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__lastFourDigits?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__network?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__raw_details_provided?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__applepay__walletTokenizedCardLast4?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__addressLine1Check?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__addressPostalCodeCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__bin?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__brand?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__cvcCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__expiryMonth?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__expiryYear?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__fingerprint?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__funding?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__issuerCountry?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__lastFourDigits?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__network?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__raw_details_provided?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__card__wallet?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__generic__details?: InputMaybe<Scalars['JSON']['input']>;
  paymentMethod__generic__type?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__addressLine1Check?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__addressPostalCodeCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__bin?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__brand?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__cvcCheck?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__expiryMonth?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__expiryYear?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__fingerprint?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__funding?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__issuerCountry?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__lastFourDigits?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__network?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__raw_details_provided?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__googlepay__walletTokenizedCardLast4?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__paypal__email?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__paypal__firstName?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__paypal__isBillingAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod__paypal__lastName?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__paypal__payerId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod__type?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<TransactionPaymentStatus>;
  processor?: InputMaybe<Scalars['String']['input']>;
  processorTransactionId?: InputMaybe<Scalars['String']['input']>;
  proxyProcessor?: InputMaybe<Scalars['String']['input']>;
  reconciliationDate?: InputMaybe<Scalars['String']['input']>;
  reconciliationFailureReason?: InputMaybe<Scalars['String']['input']>;
  reconciliationId?: InputMaybe<Scalars['String']['input']>;
  reconciliationStatus?: InputMaybe<TransactionReconciliationStatus>;
  redirectUrlFailure?: InputMaybe<Scalars['String']['input']>;
  redirectUrlSuccess?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  relatedRecurringTransaction?: InputMaybe<Scalars['String']['input']>;
  relatedTransaction?: InputMaybe<Scalars['String']['input']>;
  requestedAmount?: InputMaybe<Scalars['Float']['input']>;
  retryAttemptCounter?: InputMaybe<Scalars['Int']['input']>;
  retryOfAttemptId?: InputMaybe<Scalars['String']['input']>;
  riskAssessmentDecision?: InputMaybe<Scalars['String']['input']>;
  riskAssessmentScore?: InputMaybe<Scalars['Int']['input']>;
  riskEngineId?: InputMaybe<Scalars['String']['input']>;
  routingKey?: InputMaybe<Scalars['String']['input']>;
  ruleId?: InputMaybe<Scalars['String']['input']>;
  ruleType?: InputMaybe<Scalars['String']['input']>;
  settled?: InputMaybe<Scalars['Boolean']['input']>;
  settlementCurrency?: InputMaybe<Scalars['String']['input']>;
  settlementId?: InputMaybe<Scalars['ID']['input']>;
  shippingDetails?: InputMaybe<AddressInput>;
  shippingDetailsAddressId?: InputMaybe<Scalars['String']['input']>;
  shippingFirstName?: InputMaybe<Scalars['String']['input']>;
  shippingLastName?: InputMaybe<Scalars['String']['input']>;
  shippingPhone?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TransactionStatus>;
  subType?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  summableAmount?: InputMaybe<Scalars['Float']['input']>;
  termsAndConditionsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  termsAndConditionsAcceptedOnTransaction?: InputMaybe<Scalars['String']['input']>;
  threeDsAcsOperatorId?: InputMaybe<Scalars['String']['input']>;
  threeDsAcsReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  threeDsAcsTransactionId?: InputMaybe<Scalars['String']['input']>;
  threeDsAcsUrl?: InputMaybe<Scalars['String']['input']>;
  threeDsAuthenticationFlow?: InputMaybe<ThreeDsAuthenticationFlow>;
  threeDsCardHolderInfo?: InputMaybe<Scalars['String']['input']>;
  threeDsCavv?: InputMaybe<Scalars['String']['input']>;
  threeDsChallengeIndicator?: InputMaybe<Scalars['String']['input']>;
  threeDsChallengeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  threeDsDsTransactionId?: InputMaybe<Scalars['String']['input']>;
  threeDsEci?: InputMaybe<Scalars['String']['input']>;
  threeDsEnrolled?: InputMaybe<Scalars['Boolean']['input']>;
  threeDsErrorCode?: InputMaybe<Scalars['String']['input']>;
  threeDsErrorDescription?: InputMaybe<Scalars['String']['input']>;
  threeDsPaResStatus?: InputMaybe<Scalars['String']['input']>;
  threeDsPayload?: InputMaybe<Scalars['String']['input']>;
  threeDsReasonCode?: InputMaybe<Scalars['String']['input']>;
  threeDsReasonDescription?: InputMaybe<Scalars['String']['input']>;
  threeDsResult?: InputMaybe<TransactionThreeDsResult>;
  threeDsServerTransactionId?: InputMaybe<Scalars['String']['input']>;
  threeDsVersion?: InputMaybe<Scalars['String']['input']>;
  threeDsXid?: InputMaybe<Scalars['String']['input']>;
  threeRiIndicator?: InputMaybe<Scalars['String']['input']>;
  transactionFeeFinal?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DoesPaypassNeedCodeAuthenticationQueryVariables = Exact<{ [key: string]: never; }>;


export type DoesPaypassNeedCodeAuthenticationQuery = { __typename?: 'Query', doesPaypassNeedCodeAuthentication?: { __typename?: 'DoesPaypassNeedCodeAuthenticationPayload', success: boolean, isCodeAuthenticationNeeded?: boolean | null } | null };

export type SendAuthorizationCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type SendAuthorizationCodeMutation = { __typename?: 'Mutation', sendPaypassVerificationCode?: { __typename?: 'SendVerificationCodePayload', success: boolean, message?: string | null } | null };

export type AuthenticatePaypassWithVerificationCodeMutationVariables = Exact<{
  input: AuthenticateWithVerificationCodeInput;
}>;


export type AuthenticatePaypassWithVerificationCodeMutation = { __typename?: 'Mutation', authenticatePaypassWithVerificationCode?: { __typename?: 'AuthenticateWithVerificationCodePayload', success: boolean, message?: string | null } | null };

export type UpdateBankAccountMutationVariables = Exact<{
  input: UpdateBankAccountInput;
}>;


export type UpdateBankAccountMutation = { __typename?: 'Mutation', updateBankAccount: { __typename?: 'BankAccount', id: string, bankName?: string | null, routingNumber?: string | null, accountNumber?: string | null, accountType?: AccountType | null } };

export type CreateBankAccountMutationVariables = Exact<{
  input: CreateBankAccountInput;
}>;


export type CreateBankAccountMutation = { __typename?: 'Mutation', createBankAccount: { __typename?: 'BankAccountMutationResponse', success?: boolean | null } };

export type GetAllCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', name: string, alpha2: CountryAlpha2, prohibited: boolean, riskLevel: number, enabled: boolean }> };

export type CreateDocumentUploadTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateDocumentUploadTokenQuery = { __typename?: 'Query', documentUploadToken: { __typename?: 'DocumentUploadToken', token: string } };

export type GetDocumentsByIdsQueryVariables = Exact<{
  input: DocumentsByIdsInput;
}>;


export type GetDocumentsByIdsQuery = { __typename?: 'Query', documentsByIds: { __typename?: 'Documents', documents?: Array<{ __typename?: 'Document', id: string, originalFilename: string, type: DocumentTypeEnum, contentType: string, contentLength?: string | null, status: DocumentUploadStatus, reference?: string | null, merchantId: string, companyId: string, url?: string | null, path?: string | null, lastModified?: string | null }> | null } };

export type GetDocumentUrlQueryVariables = Exact<{
  input: DocumentUrlQueryInput;
}>;


export type GetDocumentUrlQuery = { __typename?: 'Query', documentUrl: { __typename?: 'DocumentUploadUrl', url: string } };

export type CreateIndividualWithRelationMutationVariables = Exact<{
  input: CreateIndividualWithRelationInput;
}>;


export type CreateIndividualWithRelationMutation = { __typename?: 'Mutation', createIndividualWithRelation: { __typename?: 'CreateIndividualWithRelationResponse', success: boolean, id: string } };

export type UpdateIndividualMutationVariables = Exact<{
  input: UpdateIndividualInput;
}>;


export type UpdateIndividualMutation = { __typename?: 'Mutation', updateIndividual: { __typename?: 'IndividualsMutationResponse', success: boolean } };

export type UpdateIndividualRelationMutationVariables = Exact<{
  input: IndividualRelationInput;
}>;


export type UpdateIndividualRelationMutation = { __typename?: 'Mutation', updateIndividualRelation: { __typename?: 'IndividualsMutationResponse', success: boolean } };

export type RemoveIndividualMutationVariables = Exact<{
  input: GetIndividualInput;
}>;


export type RemoveIndividualMutation = { __typename?: 'Mutation', removeIndividual: { __typename?: 'IndividualsMutationResponse', success: boolean } };

export type GetMccsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMccsQuery = { __typename?: 'Query', mccs?: { __typename?: 'MccsQueryResponse', mccs: Array<{ __typename?: 'Mcc', mcc: number, description?: string | null }> } | null };

export type CreateEntityMccMutationVariables = Exact<{
  input: CreateMccInput;
}>;


export type CreateEntityMccMutation = { __typename?: 'Mutation', createEntityMcc?: { __typename?: 'MccEntryMutationResponse', success?: boolean | null } | null };

export type UpdateEntityArchiveMccMutationVariables = Exact<{
  input: UpdateArchiveMccInput;
}>;


export type UpdateEntityArchiveMccMutation = { __typename?: 'Mutation', updateEntityArchiveMcc?: { __typename?: 'MccEntryMutationResponse', success?: boolean | null } | null };

export type GetMerchantApplicationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMerchantApplicationQuery = { __typename?: 'Query', merchantApplication?: { __typename?: 'MerchantApplication', merchantId: string, companyId: string, heardOfPayFrom?: string | null, privacyPolicyAgreement?: boolean | null, otherCommunications?: boolean | null, status?: MerchantApplicationStatuses | null, businessStructureDetails?: { __typename?: 'BusinessStructureDetails', businessStructure?: string | null, businessEmail?: string | null, countryOfIncorporation?: CountryAlpha2 | null, businessPhoneNumber?: string | null, numberOfEmployees?: string | null, dateOfIncorporation?: string | null, companiesGroup?: boolean | null, businessConductionLocation?: string | null, groupName?: string | null, groupWebsite?: string | null, publicCompany?: boolean | null, bankruptcyProceedings?: boolean | null, businessType?: BusinessType | null, dbaPhoneNumber?: string | null, publiclyTradedCorporationSymbol?: string | null, publiclyTradedCorpExchange?: string | null, businessTypeDescription?: string | null, physicalAddrSameAsRegistered?: boolean | null, registeredBusinessAddress?: { __typename?: 'Address', addressLine?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: { __typename?: 'Country', alpha2: CountryAlpha2, name: string } | null } | null, physicalBusinessAddress?: { __typename?: 'Address', addressLine?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: { __typename?: 'Country', alpha2: CountryAlpha2 } | null } | null } | null, websites?: Array<{ __typename?: 'WebsiteEntry', domain: string, login?: string | null, password?: string | null, platformRequiresTestUser: boolean }> | null, businessDetails?: { __typename?: 'OnboardingBusinessDetails', legalBusinessName?: string | null, doingBusinessAs?: string | null, employerIdNumber?: string | null, companyRegistrationNumber?: string | null, industryDescription?: string | null, website?: string | null, noWebsite?: boolean | null, productDescription?: string | null, businessLicenseNumber?: string | null, monthlyProcessingVolume?: string | null, monthlyProcessingVolumeCurrency?: string | null, websiteUnderConstruction?: boolean | null, noOnlinePresence?: boolean | null, noVatNumber?: boolean | null, vatNumber?: string | null, issuingAuthority?: string | null, industry?: { __typename?: 'Mcc', mcc: number } | null, socialMedia?: Array<{ __typename?: 'SocialMediaObject', type: SocialMediaLinkType, value: string }> | null, implementation?: { __typename?: 'Implementation', predefinedTypes?: Array<ImplementationType> | null, customType?: string | null } | null } | null, fulfillmentDetails?: { __typename?: 'FulfillmentDetails', physicalGoods?: boolean | null, fulfillmentMethod?: FulfillmentMethod | null, deliveryTimeframe?: string | null, fulfillmentMethodDescription?: string | null } | null, customerSupport?: { __typename?: 'CustomerSupport', statementDescriptor?: string | null, phone?: string | null, email?: string | null, address?: { __typename?: 'Address', addressLine?: string | null, addressLine2?: string | null, zip?: string | null, city?: string | null, state?: string | null, country?: { __typename?: 'Country', alpha2: CountryAlpha2 } | null } | null } | null, businessActivity?: { __typename?: 'OnboardingBusinessActivity', yearlyVolumeCurrency?: string | null, yearlyVolume?: string | null, minimumTransactionCurrency?: string | null, minimumTransactionAmount?: string | null, averageTransactionCurrency?: string | null, averageTransactionAmount?: string | null, maximumTransactionCurrency?: string | null, maximumTransactionAmount?: string | null, sourcesOfFunds?: Array<string> | null, physicalProductsOrigins?: Array<string> | null, originsOfFunds?: Array<string> | null, customersAbroad?: boolean | null, customersAbroadCountries?: Array<CountryAlpha2> | null, highRiskCountries?: Array<string> | null, requiresAuthorizationFromAuthority?: boolean | null, productCompany?: boolean | null, licenseJurisdictionCountry?: CountryAlpha2 | null, licenseType?: string | null, projectedCardVolume?: string | null, projectedCardVolumeCurrency?: CurrencyAlpha3 | null, projectedCardTurnover?: string | null, requiresAuthorizationFromAuthorityDescription?: string | null, monthlyCardVolumeAmount?: string | null, monthlyCardVolumeCurrency?: CurrencyAlpha3 | null, monthlyAverageVolumeAmount?: string | null, monthlyAverageVolumeCurrency?: CurrencyAlpha3 | null, targetMarketsCountriesOnly?: boolean | null, processingCurrencies?: Array<CurrencyAlpha3> | null, settlementCurrencies?: Array<CurrencyAlpha3> | null, blacklistedCountries?: Array<CountryAlpha2> | null, currentPaymentProcessor?: string | null, applyingReason?: string | null, seasonalBusiness?: boolean | null, seasonalBusinessMonths?: Array<string> | null, annualAmexVolumeExceeds?: boolean | null, businessToBusinessBasisPoints?: string | null, maximumMonthlyCardVolumeAmount?: string | null, ecommerceBasisPoints?: string | null, manuallyKeyedCnpMotoBasisPoints?: string | null, manuallyKeyedCpImprintBasisPoints?: string | null, cardPresentBasisPoints?: string | null, esaNumber?: string | null, requestingPayoutsToCustomers?: boolean | null, volumeShareCountries?: Array<{ __typename?: 'CountryVolumeShare', region?: OnboardingCountryRegion | null, countries?: Array<CountryAlpha2> | null, percentage?: string | null }> | null } | null, businessProcessingInfo?: { __typename?: 'OnboardingBusinessProcessingInfo', isWebsitePciCompliant?: boolean | null, saqType?: SaqType | null, thirdPartyIntegration?: boolean | null, thirdPartyIntegrationDescription?: string | null, emailReceipts?: boolean | null, ordersFulfilledDirectly?: boolean | null, customerAccessType?: CustomerAccessPlatformType | null, fraudPreventionServiceUsed?: boolean | null, fraudPreventionServiceDescription?: string | null, chargebackProcedureDescription?: string | null, platformRequiresTestUser?: boolean | null, testUsername?: string | null, testPassword?: string | null, hasAcceptedCreditCardsBefore?: boolean | null, hasAcceptedCcBeforeDescription?: string | null, terminatedByPreviousProcessor?: boolean | null, existingPaycomMerchantId?: string | null, hasExistingPaycomMerchant?: boolean | null, numberOfPhysicalLocations?: number | null, applyingForAdditionalLocations?: boolean | null, returnAndRefundPolicy?: string | null, wantsAmexMarketingMaterials?: boolean | null } | null, documents?: Array<{ __typename?: 'Document', id: string, originalFilename: string, type: DocumentTypeEnum, contentType: string, contentLength?: string | null, status: DocumentUploadStatus, reference?: string | null, merchantId: string, companyId: string, url?: string | null, path?: string | null, lastModified?: string | null, name?: string | null, category?: string | null, uploadedOn?: string | null, uploadedBy?: string | null, archiveStatus?: DocumentArchiveStatus | null, expiryDate?: string | null, issuingDate?: string | null, tags?: Array<string> | null, reviewStatus?: DocumentReviewType | null, subType?: string | null, resource?: string | null, resourceId?: string | null }> | null, taxInfo?: { __typename?: 'TaxInfo', taxpayerIdType?: TaxNumberType | null, taxpayerIdNumber?: string | null, exemptPayee?: boolean | null, taxExempt501c?: boolean | null, taxpayerName?: string | null, taxAddressSameAsRegisteredBusinessAddress?: boolean | null, electronicTaxDocumentConsent?: boolean | null, address?: { __typename?: 'Address', addressLine?: string | null, addressLine2?: string | null, zip?: string | null, city?: string | null, state?: string | null, countryAlpha2?: CountryAlpha2 | null } | null } | null } | null, entityMccs?: { __typename?: 'GetEntityMccsResponse', mccs?: Array<{ __typename?: 'MccEntry', id: string, code: number, cardSchemas: Array<MccCardScheme>, archived: boolean }> | null } | null, bankAccounts: Array<{ __typename?: 'BankAccount', id: string, bankName?: string | null, routingNumber?: string | null, accountNumber?: string | null, accountType?: AccountType | null, currency?: string | null, bankCountry?: string | null }>, nestedIndividuals: { __typename?: 'NestedIndividualsResponse', individuals?: Array<{ __typename?: 'IndividualWithRelations', individual: { __typename?: 'IndividualObject', id: string, type: IndividualType, firstName?: string | null, middleName?: string | null, lastName?: string | null, dateOfBirth?: string | null, nationalities?: Array<CountryAlpha2> | null, ssn?: string | null, idNumber?: string | null, identificationDocumentType?: string | null, email?: string | null, phoneNumber?: string | null, residentialAddress?: { __typename?: 'Address', addressLine?: string | null, addressLine2?: string | null, city?: string | null, zip?: string | null, countryAlpha2?: CountryAlpha2 | null, state?: string | null } | null }, parentRelations?: Array<{ __typename?: 'IndividualRelationObject', individualId: string, title?: string | null, percentageOfShares?: string | null, isUbo?: boolean | null, isContact?: boolean | null, contactTypes?: Array<IndividualContactType> | null, signsTaxDocuments?: boolean | null, isPrimaryContact?: boolean | null }> | null }> | null } };

export type UpdateMerchantApplicationMutationVariables = Exact<{
  input: UpdateMerchantApplicationMutationInput;
}>;


export type UpdateMerchantApplicationMutation = { __typename?: 'Mutation', updateMerchantApplication: { __typename?: 'IdsVersionMutationResponse', success: boolean } };

export type SubmitMerchantApplicationMutationVariables = Exact<{ [key: string]: never; }>;


export type SubmitMerchantApplicationMutation = { __typename?: 'Mutation', submitMerchantApplication: { __typename?: 'IdsMutationResponse', success: boolean, payload: { __typename?: 'MerchantCompanyIdsPayload', companyId: string, merchantId: string } } };

export type EntityOnboardingPricingListQueryVariables = Exact<{ [key: string]: never; }>;


export type EntityOnboardingPricingListQuery = { __typename?: 'Query', entityOnboardingPricingList?: { __typename?: 'GetEntityOnboardingPricingListResponse', onboardingPricingList?: Array<{ __typename?: 'OnboardingPricing', id: string, name: string }> | null } | null };

export type GenerateOnboardingPricingSigningUrlMutationVariables = Exact<{
  input: GenerateOnboardingPricingSigningUrlInput;
}>;


export type GenerateOnboardingPricingSigningUrlMutation = { __typename?: 'Mutation', generateOnboardingPricingSigningUrl?: { __typename?: 'GenerateOnboardingPricingSigningUrlMutationResponse', url: string } | null };

export type GetStructuresByCountryQueryVariables = Exact<{
  input: StructuresByCountryQueryInput;
}>;


export type GetStructuresByCountryQuery = { __typename?: 'Query', structuresByCountry: { __typename?: 'StructuresQueryResponse', structures: Array<{ __typename?: 'Structure', key: string, name?: string | null }> } };

export type TasksQueryVariables = Exact<{
  input: TasksQueryInput;
}>;


export type TasksQuery = { __typename?: 'Query', tasks: { __typename?: 'TasksQueryResponse', tasks: Array<{ __typename?: 'Task', id: string, status: TaskStatus, description?: string | null, requestReason?: string | null, merchantGroupAssignee?: string | null, expiresOn?: string | null, createdAt?: string | null, completedAt?: string | null, signal?: string | null, values?: Array<{ __typename?: 'TaskValue', key: string, value: { __typename?: 'TaskFieldValue', stringValue?: string | null, jsonValue?: any | null, numberValue?: number | null, boolValue?: boolean | null } }> | null }> } };

export type TaskDetailsQueryVariables = Exact<{
  input: TaskQueryInput;
}>;


export type TaskDetailsQuery = { __typename?: 'Query', task: { __typename?: 'TaskDetail', id: string, title: string, createdAt?: string | null, status: TaskStatus, description?: string | null, requestReason?: string | null, expiresOn?: string | null, canceledAt?: string | null, completedAt?: string | null, attachments?: Array<string> | null, fields?: Array<{ __typename?: 'TaskField', id: string, externalId?: string | null, type: TaskFieldType, label: string, placeholder?: string | null, options?: Array<{ __typename?: 'TaskFieldsOption', label: string, value: string }> | null }> | null, actions: Array<{ __typename?: 'TaskActionButton', label: string, signal?: string | null, style: TaskActionStyle, validationConfigs?: Array<{ __typename?: 'ValidationConfig', key: string, errorMessage?: string | null, required?: boolean | null, minLength?: number | null, maxLength?: number | null, pattern?: string | null, minValue?: number | null, maxValue?: number | null }> | null }>, values?: Array<{ __typename?: 'TaskValue', key: string, value: { __typename?: 'TaskFieldValue', stringValue?: string | null, jsonValue?: any | null, numberValue?: number | null, boolValue?: boolean | null } }> | null } };

export type SubmitTaskMutationVariables = Exact<{
  input: SubmitTask;
}>;


export type SubmitTaskMutation = { __typename?: 'Mutation', submitTask: { __typename?: 'TaskMutationResponse', success?: boolean | null } };


export const DoesPaypassNeedCodeAuthenticationDocument = gql`
    query doesPaypassNeedCodeAuthentication {
  doesPaypassNeedCodeAuthentication {
    success
    isCodeAuthenticationNeeded
  }
}
    `;

/**
 * __useDoesPaypassNeedCodeAuthenticationQuery__
 *
 * To run a query within a React component, call `useDoesPaypassNeedCodeAuthenticationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoesPaypassNeedCodeAuthenticationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoesPaypassNeedCodeAuthenticationQuery({
 *   variables: {
 *   },
 * });
 */
export function useDoesPaypassNeedCodeAuthenticationQuery(baseOptions?: Apollo.QueryHookOptions<DoesPaypassNeedCodeAuthenticationQuery, DoesPaypassNeedCodeAuthenticationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoesPaypassNeedCodeAuthenticationQuery, DoesPaypassNeedCodeAuthenticationQueryVariables>(DoesPaypassNeedCodeAuthenticationDocument, options);
      }
export function useDoesPaypassNeedCodeAuthenticationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoesPaypassNeedCodeAuthenticationQuery, DoesPaypassNeedCodeAuthenticationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoesPaypassNeedCodeAuthenticationQuery, DoesPaypassNeedCodeAuthenticationQueryVariables>(DoesPaypassNeedCodeAuthenticationDocument, options);
        }
// @ts-ignore
export function useDoesPaypassNeedCodeAuthenticationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DoesPaypassNeedCodeAuthenticationQuery, DoesPaypassNeedCodeAuthenticationQueryVariables>): Apollo.UseSuspenseQueryResult<DoesPaypassNeedCodeAuthenticationQuery, DoesPaypassNeedCodeAuthenticationQueryVariables>;
export function useDoesPaypassNeedCodeAuthenticationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoesPaypassNeedCodeAuthenticationQuery, DoesPaypassNeedCodeAuthenticationQueryVariables>): Apollo.UseSuspenseQueryResult<DoesPaypassNeedCodeAuthenticationQuery | undefined, DoesPaypassNeedCodeAuthenticationQueryVariables>;
export function useDoesPaypassNeedCodeAuthenticationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoesPaypassNeedCodeAuthenticationQuery, DoesPaypassNeedCodeAuthenticationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoesPaypassNeedCodeAuthenticationQuery, DoesPaypassNeedCodeAuthenticationQueryVariables>(DoesPaypassNeedCodeAuthenticationDocument, options);
        }
export type DoesPaypassNeedCodeAuthenticationQueryHookResult = ReturnType<typeof useDoesPaypassNeedCodeAuthenticationQuery>;
export type DoesPaypassNeedCodeAuthenticationLazyQueryHookResult = ReturnType<typeof useDoesPaypassNeedCodeAuthenticationLazyQuery>;
export type DoesPaypassNeedCodeAuthenticationSuspenseQueryHookResult = ReturnType<typeof useDoesPaypassNeedCodeAuthenticationSuspenseQuery>;
export type DoesPaypassNeedCodeAuthenticationQueryResult = Apollo.QueryResult<DoesPaypassNeedCodeAuthenticationQuery, DoesPaypassNeedCodeAuthenticationQueryVariables>;
export const SendAuthorizationCodeDocument = gql`
    mutation sendAuthorizationCode {
  sendPaypassVerificationCode {
    success
    message
  }
}
    `;
export type SendAuthorizationCodeMutationFn = Apollo.MutationFunction<SendAuthorizationCodeMutation, SendAuthorizationCodeMutationVariables>;

/**
 * __useSendAuthorizationCodeMutation__
 *
 * To run a mutation, you first call `useSendAuthorizationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAuthorizationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAuthorizationCodeMutation, { data, loading, error }] = useSendAuthorizationCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendAuthorizationCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendAuthorizationCodeMutation, SendAuthorizationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAuthorizationCodeMutation, SendAuthorizationCodeMutationVariables>(SendAuthorizationCodeDocument, options);
      }
export type SendAuthorizationCodeMutationHookResult = ReturnType<typeof useSendAuthorizationCodeMutation>;
export type SendAuthorizationCodeMutationResult = Apollo.MutationResult<SendAuthorizationCodeMutation>;
export type SendAuthorizationCodeMutationOptions = Apollo.BaseMutationOptions<SendAuthorizationCodeMutation, SendAuthorizationCodeMutationVariables>;
export const AuthenticatePaypassWithVerificationCodeDocument = gql`
    mutation authenticatePaypassWithVerificationCode($input: AuthenticateWithVerificationCodeInput!) {
  authenticatePaypassWithVerificationCode(input: $input) {
    success
    message
  }
}
    `;
export type AuthenticatePaypassWithVerificationCodeMutationFn = Apollo.MutationFunction<AuthenticatePaypassWithVerificationCodeMutation, AuthenticatePaypassWithVerificationCodeMutationVariables>;

/**
 * __useAuthenticatePaypassWithVerificationCodeMutation__
 *
 * To run a mutation, you first call `useAuthenticatePaypassWithVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticatePaypassWithVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticatePaypassWithVerificationCodeMutation, { data, loading, error }] = useAuthenticatePaypassWithVerificationCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticatePaypassWithVerificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticatePaypassWithVerificationCodeMutation, AuthenticatePaypassWithVerificationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticatePaypassWithVerificationCodeMutation, AuthenticatePaypassWithVerificationCodeMutationVariables>(AuthenticatePaypassWithVerificationCodeDocument, options);
      }
export type AuthenticatePaypassWithVerificationCodeMutationHookResult = ReturnType<typeof useAuthenticatePaypassWithVerificationCodeMutation>;
export type AuthenticatePaypassWithVerificationCodeMutationResult = Apollo.MutationResult<AuthenticatePaypassWithVerificationCodeMutation>;
export type AuthenticatePaypassWithVerificationCodeMutationOptions = Apollo.BaseMutationOptions<AuthenticatePaypassWithVerificationCodeMutation, AuthenticatePaypassWithVerificationCodeMutationVariables>;
export const UpdateBankAccountDocument = gql`
    mutation updateBankAccount($input: UpdateBankAccountInput!) {
  updateBankAccount(input: $input) {
    id
    bankName
    routingNumber
    accountNumber
    accountType
  }
}
    `;
export type UpdateBankAccountMutationFn = Apollo.MutationFunction<UpdateBankAccountMutation, UpdateBankAccountMutationVariables>;

/**
 * __useUpdateBankAccountMutation__
 *
 * To run a mutation, you first call `useUpdateBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBankAccountMutation, { data, loading, error }] = useUpdateBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBankAccountMutation, UpdateBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBankAccountMutation, UpdateBankAccountMutationVariables>(UpdateBankAccountDocument, options);
      }
export type UpdateBankAccountMutationHookResult = ReturnType<typeof useUpdateBankAccountMutation>;
export type UpdateBankAccountMutationResult = Apollo.MutationResult<UpdateBankAccountMutation>;
export type UpdateBankAccountMutationOptions = Apollo.BaseMutationOptions<UpdateBankAccountMutation, UpdateBankAccountMutationVariables>;
export const CreateBankAccountDocument = gql`
    mutation createBankAccount($input: CreateBankAccountInput!) {
  createBankAccount(input: $input) {
    success
  }
}
    `;
export type CreateBankAccountMutationFn = Apollo.MutationFunction<CreateBankAccountMutation, CreateBankAccountMutationVariables>;

/**
 * __useCreateBankAccountMutation__
 *
 * To run a mutation, you first call `useCreateBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBankAccountMutation, { data, loading, error }] = useCreateBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateBankAccountMutation, CreateBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBankAccountMutation, CreateBankAccountMutationVariables>(CreateBankAccountDocument, options);
      }
export type CreateBankAccountMutationHookResult = ReturnType<typeof useCreateBankAccountMutation>;
export type CreateBankAccountMutationResult = Apollo.MutationResult<CreateBankAccountMutation>;
export type CreateBankAccountMutationOptions = Apollo.BaseMutationOptions<CreateBankAccountMutation, CreateBankAccountMutationVariables>;
export const GetAllCountriesDocument = gql`
    query getAllCountries {
  countries {
    name
    alpha2
    prohibited
    riskLevel
    enabled
  }
}
    `;

/**
 * __useGetAllCountriesQuery__
 *
 * To run a query within a React component, call `useGetAllCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCountriesQuery, GetAllCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCountriesQuery, GetAllCountriesQueryVariables>(GetAllCountriesDocument, options);
      }
export function useGetAllCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCountriesQuery, GetAllCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCountriesQuery, GetAllCountriesQueryVariables>(GetAllCountriesDocument, options);
        }
// @ts-ignore
export function useGetAllCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCountriesQuery, GetAllCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCountriesQuery, GetAllCountriesQueryVariables>;
export function useGetAllCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCountriesQuery, GetAllCountriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCountriesQuery | undefined, GetAllCountriesQueryVariables>;
export function useGetAllCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCountriesQuery, GetAllCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCountriesQuery, GetAllCountriesQueryVariables>(GetAllCountriesDocument, options);
        }
export type GetAllCountriesQueryHookResult = ReturnType<typeof useGetAllCountriesQuery>;
export type GetAllCountriesLazyQueryHookResult = ReturnType<typeof useGetAllCountriesLazyQuery>;
export type GetAllCountriesSuspenseQueryHookResult = ReturnType<typeof useGetAllCountriesSuspenseQuery>;
export type GetAllCountriesQueryResult = Apollo.QueryResult<GetAllCountriesQuery, GetAllCountriesQueryVariables>;
export const CreateDocumentUploadTokenDocument = gql`
    query createDocumentUploadToken {
  documentUploadToken {
    token
  }
}
    `;

/**
 * __useCreateDocumentUploadTokenQuery__
 *
 * To run a query within a React component, call `useCreateDocumentUploadTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentUploadTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateDocumentUploadTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateDocumentUploadTokenQuery(baseOptions?: Apollo.QueryHookOptions<CreateDocumentUploadTokenQuery, CreateDocumentUploadTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateDocumentUploadTokenQuery, CreateDocumentUploadTokenQueryVariables>(CreateDocumentUploadTokenDocument, options);
      }
export function useCreateDocumentUploadTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateDocumentUploadTokenQuery, CreateDocumentUploadTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateDocumentUploadTokenQuery, CreateDocumentUploadTokenQueryVariables>(CreateDocumentUploadTokenDocument, options);
        }
// @ts-ignore
export function useCreateDocumentUploadTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CreateDocumentUploadTokenQuery, CreateDocumentUploadTokenQueryVariables>): Apollo.UseSuspenseQueryResult<CreateDocumentUploadTokenQuery, CreateDocumentUploadTokenQueryVariables>;
export function useCreateDocumentUploadTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateDocumentUploadTokenQuery, CreateDocumentUploadTokenQueryVariables>): Apollo.UseSuspenseQueryResult<CreateDocumentUploadTokenQuery | undefined, CreateDocumentUploadTokenQueryVariables>;
export function useCreateDocumentUploadTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateDocumentUploadTokenQuery, CreateDocumentUploadTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateDocumentUploadTokenQuery, CreateDocumentUploadTokenQueryVariables>(CreateDocumentUploadTokenDocument, options);
        }
export type CreateDocumentUploadTokenQueryHookResult = ReturnType<typeof useCreateDocumentUploadTokenQuery>;
export type CreateDocumentUploadTokenLazyQueryHookResult = ReturnType<typeof useCreateDocumentUploadTokenLazyQuery>;
export type CreateDocumentUploadTokenSuspenseQueryHookResult = ReturnType<typeof useCreateDocumentUploadTokenSuspenseQuery>;
export type CreateDocumentUploadTokenQueryResult = Apollo.QueryResult<CreateDocumentUploadTokenQuery, CreateDocumentUploadTokenQueryVariables>;
export const GetDocumentsByIdsDocument = gql`
    query getDocumentsByIds($input: DocumentsByIdsInput!) {
  documentsByIds(input: $input) {
    documents {
      id
      originalFilename
      type
      contentType
      contentLength
      status
      reference
      merchantId
      companyId
      url
      path
      lastModified
    }
  }
}
    `;

/**
 * __useGetDocumentsByIdsQuery__
 *
 * To run a query within a React component, call `useGetDocumentsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsByIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDocumentsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentsByIdsQuery, GetDocumentsByIdsQueryVariables> & ({ variables: GetDocumentsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentsByIdsQuery, GetDocumentsByIdsQueryVariables>(GetDocumentsByIdsDocument, options);
      }
export function useGetDocumentsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentsByIdsQuery, GetDocumentsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentsByIdsQuery, GetDocumentsByIdsQueryVariables>(GetDocumentsByIdsDocument, options);
        }
// @ts-ignore
export function useGetDocumentsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentsByIdsQuery, GetDocumentsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentsByIdsQuery, GetDocumentsByIdsQueryVariables>;
export function useGetDocumentsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentsByIdsQuery, GetDocumentsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentsByIdsQuery | undefined, GetDocumentsByIdsQueryVariables>;
export function useGetDocumentsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentsByIdsQuery, GetDocumentsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentsByIdsQuery, GetDocumentsByIdsQueryVariables>(GetDocumentsByIdsDocument, options);
        }
export type GetDocumentsByIdsQueryHookResult = ReturnType<typeof useGetDocumentsByIdsQuery>;
export type GetDocumentsByIdsLazyQueryHookResult = ReturnType<typeof useGetDocumentsByIdsLazyQuery>;
export type GetDocumentsByIdsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentsByIdsSuspenseQuery>;
export type GetDocumentsByIdsQueryResult = Apollo.QueryResult<GetDocumentsByIdsQuery, GetDocumentsByIdsQueryVariables>;
export const GetDocumentUrlDocument = gql`
    query getDocumentUrl($input: DocumentUrlQueryInput!) {
  documentUrl(input: $input) {
    url
  }
}
    `;

/**
 * __useGetDocumentUrlQuery__
 *
 * To run a query within a React component, call `useGetDocumentUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDocumentUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentUrlQuery, GetDocumentUrlQueryVariables> & ({ variables: GetDocumentUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentUrlQuery, GetDocumentUrlQueryVariables>(GetDocumentUrlDocument, options);
      }
export function useGetDocumentUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentUrlQuery, GetDocumentUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentUrlQuery, GetDocumentUrlQueryVariables>(GetDocumentUrlDocument, options);
        }
// @ts-ignore
export function useGetDocumentUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentUrlQuery, GetDocumentUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentUrlQuery, GetDocumentUrlQueryVariables>;
export function useGetDocumentUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentUrlQuery, GetDocumentUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentUrlQuery | undefined, GetDocumentUrlQueryVariables>;
export function useGetDocumentUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentUrlQuery, GetDocumentUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentUrlQuery, GetDocumentUrlQueryVariables>(GetDocumentUrlDocument, options);
        }
export type GetDocumentUrlQueryHookResult = ReturnType<typeof useGetDocumentUrlQuery>;
export type GetDocumentUrlLazyQueryHookResult = ReturnType<typeof useGetDocumentUrlLazyQuery>;
export type GetDocumentUrlSuspenseQueryHookResult = ReturnType<typeof useGetDocumentUrlSuspenseQuery>;
export type GetDocumentUrlQueryResult = Apollo.QueryResult<GetDocumentUrlQuery, GetDocumentUrlQueryVariables>;
export const CreateIndividualWithRelationDocument = gql`
    mutation createIndividualWithRelation($input: CreateIndividualWithRelationInput!) {
  createIndividualWithRelation(input: $input) {
    success
    id
  }
}
    `;
export type CreateIndividualWithRelationMutationFn = Apollo.MutationFunction<CreateIndividualWithRelationMutation, CreateIndividualWithRelationMutationVariables>;

/**
 * __useCreateIndividualWithRelationMutation__
 *
 * To run a mutation, you first call `useCreateIndividualWithRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndividualWithRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndividualWithRelationMutation, { data, loading, error }] = useCreateIndividualWithRelationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIndividualWithRelationMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndividualWithRelationMutation, CreateIndividualWithRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIndividualWithRelationMutation, CreateIndividualWithRelationMutationVariables>(CreateIndividualWithRelationDocument, options);
      }
export type CreateIndividualWithRelationMutationHookResult = ReturnType<typeof useCreateIndividualWithRelationMutation>;
export type CreateIndividualWithRelationMutationResult = Apollo.MutationResult<CreateIndividualWithRelationMutation>;
export type CreateIndividualWithRelationMutationOptions = Apollo.BaseMutationOptions<CreateIndividualWithRelationMutation, CreateIndividualWithRelationMutationVariables>;
export const UpdateIndividualDocument = gql`
    mutation updateIndividual($input: UpdateIndividualInput!) {
  updateIndividual(input: $input) {
    success
  }
}
    `;
export type UpdateIndividualMutationFn = Apollo.MutationFunction<UpdateIndividualMutation, UpdateIndividualMutationVariables>;

/**
 * __useUpdateIndividualMutation__
 *
 * To run a mutation, you first call `useUpdateIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndividualMutation, { data, loading, error }] = useUpdateIndividualMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIndividualMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndividualMutation, UpdateIndividualMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndividualMutation, UpdateIndividualMutationVariables>(UpdateIndividualDocument, options);
      }
export type UpdateIndividualMutationHookResult = ReturnType<typeof useUpdateIndividualMutation>;
export type UpdateIndividualMutationResult = Apollo.MutationResult<UpdateIndividualMutation>;
export type UpdateIndividualMutationOptions = Apollo.BaseMutationOptions<UpdateIndividualMutation, UpdateIndividualMutationVariables>;
export const UpdateIndividualRelationDocument = gql`
    mutation updateIndividualRelation($input: IndividualRelationInput!) {
  updateIndividualRelation(input: $input) {
    success
  }
}
    `;
export type UpdateIndividualRelationMutationFn = Apollo.MutationFunction<UpdateIndividualRelationMutation, UpdateIndividualRelationMutationVariables>;

/**
 * __useUpdateIndividualRelationMutation__
 *
 * To run a mutation, you first call `useUpdateIndividualRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndividualRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndividualRelationMutation, { data, loading, error }] = useUpdateIndividualRelationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIndividualRelationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndividualRelationMutation, UpdateIndividualRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndividualRelationMutation, UpdateIndividualRelationMutationVariables>(UpdateIndividualRelationDocument, options);
      }
export type UpdateIndividualRelationMutationHookResult = ReturnType<typeof useUpdateIndividualRelationMutation>;
export type UpdateIndividualRelationMutationResult = Apollo.MutationResult<UpdateIndividualRelationMutation>;
export type UpdateIndividualRelationMutationOptions = Apollo.BaseMutationOptions<UpdateIndividualRelationMutation, UpdateIndividualRelationMutationVariables>;
export const RemoveIndividualDocument = gql`
    mutation removeIndividual($input: GetIndividualInput!) {
  removeIndividual(input: $input) {
    success
  }
}
    `;
export type RemoveIndividualMutationFn = Apollo.MutationFunction<RemoveIndividualMutation, RemoveIndividualMutationVariables>;

/**
 * __useRemoveIndividualMutation__
 *
 * To run a mutation, you first call `useRemoveIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIndividualMutation, { data, loading, error }] = useRemoveIndividualMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveIndividualMutation(baseOptions?: Apollo.MutationHookOptions<RemoveIndividualMutation, RemoveIndividualMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveIndividualMutation, RemoveIndividualMutationVariables>(RemoveIndividualDocument, options);
      }
export type RemoveIndividualMutationHookResult = ReturnType<typeof useRemoveIndividualMutation>;
export type RemoveIndividualMutationResult = Apollo.MutationResult<RemoveIndividualMutation>;
export type RemoveIndividualMutationOptions = Apollo.BaseMutationOptions<RemoveIndividualMutation, RemoveIndividualMutationVariables>;
export const GetMccsDocument = gql`
    query getMccs {
  mccs {
    mccs {
      mcc
      description
    }
  }
}
    `;

/**
 * __useGetMccsQuery__
 *
 * To run a query within a React component, call `useGetMccsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMccsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMccsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMccsQuery(baseOptions?: Apollo.QueryHookOptions<GetMccsQuery, GetMccsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMccsQuery, GetMccsQueryVariables>(GetMccsDocument, options);
      }
export function useGetMccsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMccsQuery, GetMccsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMccsQuery, GetMccsQueryVariables>(GetMccsDocument, options);
        }
// @ts-ignore
export function useGetMccsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMccsQuery, GetMccsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMccsQuery, GetMccsQueryVariables>;
export function useGetMccsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMccsQuery, GetMccsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMccsQuery | undefined, GetMccsQueryVariables>;
export function useGetMccsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMccsQuery, GetMccsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMccsQuery, GetMccsQueryVariables>(GetMccsDocument, options);
        }
export type GetMccsQueryHookResult = ReturnType<typeof useGetMccsQuery>;
export type GetMccsLazyQueryHookResult = ReturnType<typeof useGetMccsLazyQuery>;
export type GetMccsSuspenseQueryHookResult = ReturnType<typeof useGetMccsSuspenseQuery>;
export type GetMccsQueryResult = Apollo.QueryResult<GetMccsQuery, GetMccsQueryVariables>;
export const CreateEntityMccDocument = gql`
    mutation createEntityMcc($input: CreateMccInput!) {
  createEntityMcc(input: $input) {
    success
  }
}
    `;
export type CreateEntityMccMutationFn = Apollo.MutationFunction<CreateEntityMccMutation, CreateEntityMccMutationVariables>;

/**
 * __useCreateEntityMccMutation__
 *
 * To run a mutation, you first call `useCreateEntityMccMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityMccMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityMccMutation, { data, loading, error }] = useCreateEntityMccMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEntityMccMutation(baseOptions?: Apollo.MutationHookOptions<CreateEntityMccMutation, CreateEntityMccMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEntityMccMutation, CreateEntityMccMutationVariables>(CreateEntityMccDocument, options);
      }
export type CreateEntityMccMutationHookResult = ReturnType<typeof useCreateEntityMccMutation>;
export type CreateEntityMccMutationResult = Apollo.MutationResult<CreateEntityMccMutation>;
export type CreateEntityMccMutationOptions = Apollo.BaseMutationOptions<CreateEntityMccMutation, CreateEntityMccMutationVariables>;
export const UpdateEntityArchiveMccDocument = gql`
    mutation updateEntityArchiveMcc($input: UpdateArchiveMccInput!) {
  updateEntityArchiveMcc(input: $input) {
    success
  }
}
    `;
export type UpdateEntityArchiveMccMutationFn = Apollo.MutationFunction<UpdateEntityArchiveMccMutation, UpdateEntityArchiveMccMutationVariables>;

/**
 * __useUpdateEntityArchiveMccMutation__
 *
 * To run a mutation, you first call `useUpdateEntityArchiveMccMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityArchiveMccMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityArchiveMccMutation, { data, loading, error }] = useUpdateEntityArchiveMccMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityArchiveMccMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityArchiveMccMutation, UpdateEntityArchiveMccMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityArchiveMccMutation, UpdateEntityArchiveMccMutationVariables>(UpdateEntityArchiveMccDocument, options);
      }
export type UpdateEntityArchiveMccMutationHookResult = ReturnType<typeof useUpdateEntityArchiveMccMutation>;
export type UpdateEntityArchiveMccMutationResult = Apollo.MutationResult<UpdateEntityArchiveMccMutation>;
export type UpdateEntityArchiveMccMutationOptions = Apollo.BaseMutationOptions<UpdateEntityArchiveMccMutation, UpdateEntityArchiveMccMutationVariables>;
export const GetMerchantApplicationDocument = gql`
    query getMerchantApplication {
  merchantApplication {
    merchantId
    companyId
    heardOfPayFrom
    businessStructureDetails {
      businessStructure
      businessEmail
      countryOfIncorporation
      registeredBusinessAddress {
        addressLine
        addressLine2
        city
        state
        zip
        country {
          alpha2
          name
        }
      }
      physicalBusinessAddress {
        addressLine
        addressLine2
        city
        state
        zip
        country {
          alpha2
        }
      }
      businessPhoneNumber
      numberOfEmployees
      dateOfIncorporation
      companiesGroup
      businessConductionLocation
      groupName
      groupWebsite
      publicCompany
      bankruptcyProceedings
      businessType
      dbaPhoneNumber
      publiclyTradedCorporationSymbol
      publiclyTradedCorpExchange
      businessTypeDescription
      physicalAddrSameAsRegistered
    }
    websites {
      domain
      login
      password
      platformRequiresTestUser
    }
    businessDetails {
      legalBusinessName
      doingBusinessAs
      employerIdNumber
      companyRegistrationNumber
      industry {
        mcc
      }
      industryDescription
      website
      noWebsite
      productDescription
      businessLicenseNumber
      monthlyProcessingVolume
      monthlyProcessingVolumeCurrency
      noWebsite
      websiteUnderConstruction
      noOnlinePresence
      socialMedia {
        type
        value
      }
      implementation {
        predefinedTypes
        customType
      }
      noVatNumber
      vatNumber
      issuingAuthority
    }
    fulfillmentDetails {
      physicalGoods
      fulfillmentMethod
      deliveryTimeframe
      fulfillmentMethodDescription
    }
    customerSupport {
      statementDescriptor
      phone
      email
      address {
        addressLine
        addressLine2
        zip
        city
        state
        country {
          alpha2
        }
      }
    }
    businessActivity {
      yearlyVolumeCurrency
      yearlyVolume
      minimumTransactionCurrency
      minimumTransactionAmount
      averageTransactionCurrency
      averageTransactionAmount
      maximumTransactionCurrency
      maximumTransactionAmount
      sourcesOfFunds
      physicalProductsOrigins
      originsOfFunds
      customersAbroad
      customersAbroadCountries
      highRiskCountries
      requiresAuthorizationFromAuthority
      productCompany
      licenseJurisdictionCountry
      licenseType
      projectedCardVolume
      projectedCardVolumeCurrency
      projectedCardTurnover
      requiresAuthorizationFromAuthorityDescription
      monthlyCardVolumeAmount
      monthlyCardVolumeCurrency
      monthlyAverageVolumeAmount
      monthlyAverageVolumeCurrency
      targetMarketsCountriesOnly
      volumeShareCountries {
        region
        countries
        percentage
      }
      processingCurrencies
      settlementCurrencies
      blacklistedCountries
      currentPaymentProcessor
      applyingReason
      seasonalBusiness
      seasonalBusinessMonths
      annualAmexVolumeExceeds
      businessToBusinessBasisPoints
      maximumMonthlyCardVolumeAmount
      ecommerceBasisPoints
      manuallyKeyedCnpMotoBasisPoints
      manuallyKeyedCpImprintBasisPoints
      cardPresentBasisPoints
      esaNumber
      requestingPayoutsToCustomers
    }
    businessProcessingInfo {
      isWebsitePciCompliant
      saqType
      thirdPartyIntegration
      thirdPartyIntegrationDescription
      emailReceipts
      ordersFulfilledDirectly
      customerAccessType
      fraudPreventionServiceUsed
      fraudPreventionServiceDescription
      chargebackProcedureDescription
      platformRequiresTestUser
      testUsername
      testPassword
      hasAcceptedCreditCardsBefore
      hasAcceptedCcBeforeDescription
      terminatedByPreviousProcessor
      existingPaycomMerchantId
      hasExistingPaycomMerchant
      numberOfPhysicalLocations
      applyingForAdditionalLocations
      returnAndRefundPolicy
      wantsAmexMarketingMaterials
    }
    privacyPolicyAgreement
    otherCommunications
    status
    documents {
      id
      originalFilename
      type
      contentType
      contentLength
      status
      reference
      merchantId
      companyId
      url
      path
      lastModified
      name
      category
      uploadedOn
      uploadedBy
      archiveStatus
      expiryDate
      issuingDate
      tags
      reviewStatus
      subType
      resource
      resourceId
    }
    taxInfo {
      taxpayerIdType
      taxpayerIdNumber
      address {
        addressLine
        addressLine2
        zip
        city
        state
        countryAlpha2
      }
      exemptPayee
      taxExempt501c
      taxpayerName
      taxAddressSameAsRegisteredBusinessAddress
      electronicTaxDocumentConsent
    }
  }
  entityMccs {
    mccs {
      id
      code
      cardSchemas
      archived
    }
  }
  bankAccounts {
    id
    bankName
    routingNumber
    accountNumber
    accountType
    currency
    bankCountry
  }
  nestedIndividuals {
    individuals {
      individual {
        id
        type
        firstName
        middleName
        lastName
        dateOfBirth
        nationalities
        ssn
        idNumber
        identificationDocumentType
        email
        phoneNumber
        residentialAddress {
          addressLine
          addressLine2
          city
          zip
          countryAlpha2
          state
        }
      }
      parentRelations {
        individualId
        title
        percentageOfShares
        isUbo
        isContact
        contactTypes
        signsTaxDocuments
        isPrimaryContact
      }
    }
  }
}
    `;

/**
 * __useGetMerchantApplicationQuery__
 *
 * To run a query within a React component, call `useGetMerchantApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMerchantApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMerchantApplicationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMerchantApplicationQuery(baseOptions?: Apollo.QueryHookOptions<GetMerchantApplicationQuery, GetMerchantApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMerchantApplicationQuery, GetMerchantApplicationQueryVariables>(GetMerchantApplicationDocument, options);
      }
export function useGetMerchantApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMerchantApplicationQuery, GetMerchantApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMerchantApplicationQuery, GetMerchantApplicationQueryVariables>(GetMerchantApplicationDocument, options);
        }
// @ts-ignore
export function useGetMerchantApplicationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMerchantApplicationQuery, GetMerchantApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<GetMerchantApplicationQuery, GetMerchantApplicationQueryVariables>;
export function useGetMerchantApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMerchantApplicationQuery, GetMerchantApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<GetMerchantApplicationQuery | undefined, GetMerchantApplicationQueryVariables>;
export function useGetMerchantApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMerchantApplicationQuery, GetMerchantApplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMerchantApplicationQuery, GetMerchantApplicationQueryVariables>(GetMerchantApplicationDocument, options);
        }
export type GetMerchantApplicationQueryHookResult = ReturnType<typeof useGetMerchantApplicationQuery>;
export type GetMerchantApplicationLazyQueryHookResult = ReturnType<typeof useGetMerchantApplicationLazyQuery>;
export type GetMerchantApplicationSuspenseQueryHookResult = ReturnType<typeof useGetMerchantApplicationSuspenseQuery>;
export type GetMerchantApplicationQueryResult = Apollo.QueryResult<GetMerchantApplicationQuery, GetMerchantApplicationQueryVariables>;
export const UpdateMerchantApplicationDocument = gql`
    mutation updateMerchantApplication($input: UpdateMerchantApplicationMutationInput!) {
  updateMerchantApplication(input: $input) {
    success
  }
}
    `;
export type UpdateMerchantApplicationMutationFn = Apollo.MutationFunction<UpdateMerchantApplicationMutation, UpdateMerchantApplicationMutationVariables>;

/**
 * __useUpdateMerchantApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateMerchantApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMerchantApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMerchantApplicationMutation, { data, loading, error }] = useUpdateMerchantApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMerchantApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMerchantApplicationMutation, UpdateMerchantApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMerchantApplicationMutation, UpdateMerchantApplicationMutationVariables>(UpdateMerchantApplicationDocument, options);
      }
export type UpdateMerchantApplicationMutationHookResult = ReturnType<typeof useUpdateMerchantApplicationMutation>;
export type UpdateMerchantApplicationMutationResult = Apollo.MutationResult<UpdateMerchantApplicationMutation>;
export type UpdateMerchantApplicationMutationOptions = Apollo.BaseMutationOptions<UpdateMerchantApplicationMutation, UpdateMerchantApplicationMutationVariables>;
export const SubmitMerchantApplicationDocument = gql`
    mutation submitMerchantApplication {
  submitMerchantApplication {
    success
    payload {
      companyId
      merchantId
    }
  }
}
    `;
export type SubmitMerchantApplicationMutationFn = Apollo.MutationFunction<SubmitMerchantApplicationMutation, SubmitMerchantApplicationMutationVariables>;

/**
 * __useSubmitMerchantApplicationMutation__
 *
 * To run a mutation, you first call `useSubmitMerchantApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitMerchantApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitMerchantApplicationMutation, { data, loading, error }] = useSubmitMerchantApplicationMutation({
 *   variables: {
 *   },
 * });
 */
export function useSubmitMerchantApplicationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitMerchantApplicationMutation, SubmitMerchantApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitMerchantApplicationMutation, SubmitMerchantApplicationMutationVariables>(SubmitMerchantApplicationDocument, options);
      }
export type SubmitMerchantApplicationMutationHookResult = ReturnType<typeof useSubmitMerchantApplicationMutation>;
export type SubmitMerchantApplicationMutationResult = Apollo.MutationResult<SubmitMerchantApplicationMutation>;
export type SubmitMerchantApplicationMutationOptions = Apollo.BaseMutationOptions<SubmitMerchantApplicationMutation, SubmitMerchantApplicationMutationVariables>;
export const EntityOnboardingPricingListDocument = gql`
    query entityOnboardingPricingList {
  entityOnboardingPricingList {
    onboardingPricingList {
      id
      name
    }
  }
}
    `;

/**
 * __useEntityOnboardingPricingListQuery__
 *
 * To run a query within a React component, call `useEntityOnboardingPricingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityOnboardingPricingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityOnboardingPricingListQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntityOnboardingPricingListQuery(baseOptions?: Apollo.QueryHookOptions<EntityOnboardingPricingListQuery, EntityOnboardingPricingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityOnboardingPricingListQuery, EntityOnboardingPricingListQueryVariables>(EntityOnboardingPricingListDocument, options);
      }
export function useEntityOnboardingPricingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityOnboardingPricingListQuery, EntityOnboardingPricingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityOnboardingPricingListQuery, EntityOnboardingPricingListQueryVariables>(EntityOnboardingPricingListDocument, options);
        }
// @ts-ignore
export function useEntityOnboardingPricingListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntityOnboardingPricingListQuery, EntityOnboardingPricingListQueryVariables>): Apollo.UseSuspenseQueryResult<EntityOnboardingPricingListQuery, EntityOnboardingPricingListQueryVariables>;
export function useEntityOnboardingPricingListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityOnboardingPricingListQuery, EntityOnboardingPricingListQueryVariables>): Apollo.UseSuspenseQueryResult<EntityOnboardingPricingListQuery | undefined, EntityOnboardingPricingListQueryVariables>;
export function useEntityOnboardingPricingListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityOnboardingPricingListQuery, EntityOnboardingPricingListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityOnboardingPricingListQuery, EntityOnboardingPricingListQueryVariables>(EntityOnboardingPricingListDocument, options);
        }
export type EntityOnboardingPricingListQueryHookResult = ReturnType<typeof useEntityOnboardingPricingListQuery>;
export type EntityOnboardingPricingListLazyQueryHookResult = ReturnType<typeof useEntityOnboardingPricingListLazyQuery>;
export type EntityOnboardingPricingListSuspenseQueryHookResult = ReturnType<typeof useEntityOnboardingPricingListSuspenseQuery>;
export type EntityOnboardingPricingListQueryResult = Apollo.QueryResult<EntityOnboardingPricingListQuery, EntityOnboardingPricingListQueryVariables>;
export const GenerateOnboardingPricingSigningUrlDocument = gql`
    mutation generateOnboardingPricingSigningUrl($input: GenerateOnboardingPricingSigningUrlInput!) {
  generateOnboardingPricingSigningUrl(input: $input) {
    url
  }
}
    `;
export type GenerateOnboardingPricingSigningUrlMutationFn = Apollo.MutationFunction<GenerateOnboardingPricingSigningUrlMutation, GenerateOnboardingPricingSigningUrlMutationVariables>;

/**
 * __useGenerateOnboardingPricingSigningUrlMutation__
 *
 * To run a mutation, you first call `useGenerateOnboardingPricingSigningUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOnboardingPricingSigningUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOnboardingPricingSigningUrlMutation, { data, loading, error }] = useGenerateOnboardingPricingSigningUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateOnboardingPricingSigningUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOnboardingPricingSigningUrlMutation, GenerateOnboardingPricingSigningUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOnboardingPricingSigningUrlMutation, GenerateOnboardingPricingSigningUrlMutationVariables>(GenerateOnboardingPricingSigningUrlDocument, options);
      }
export type GenerateOnboardingPricingSigningUrlMutationHookResult = ReturnType<typeof useGenerateOnboardingPricingSigningUrlMutation>;
export type GenerateOnboardingPricingSigningUrlMutationResult = Apollo.MutationResult<GenerateOnboardingPricingSigningUrlMutation>;
export type GenerateOnboardingPricingSigningUrlMutationOptions = Apollo.BaseMutationOptions<GenerateOnboardingPricingSigningUrlMutation, GenerateOnboardingPricingSigningUrlMutationVariables>;
export const GetStructuresByCountryDocument = gql`
    query getStructuresByCountry($input: StructuresByCountryQueryInput!) {
  structuresByCountry(input: $input) {
    structures {
      key
      name
    }
  }
}
    `;

/**
 * __useGetStructuresByCountryQuery__
 *
 * To run a query within a React component, call `useGetStructuresByCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructuresByCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructuresByCountryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStructuresByCountryQuery(baseOptions: Apollo.QueryHookOptions<GetStructuresByCountryQuery, GetStructuresByCountryQueryVariables> & ({ variables: GetStructuresByCountryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructuresByCountryQuery, GetStructuresByCountryQueryVariables>(GetStructuresByCountryDocument, options);
      }
export function useGetStructuresByCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructuresByCountryQuery, GetStructuresByCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructuresByCountryQuery, GetStructuresByCountryQueryVariables>(GetStructuresByCountryDocument, options);
        }
// @ts-ignore
export function useGetStructuresByCountrySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStructuresByCountryQuery, GetStructuresByCountryQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructuresByCountryQuery, GetStructuresByCountryQueryVariables>;
export function useGetStructuresByCountrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructuresByCountryQuery, GetStructuresByCountryQueryVariables>): Apollo.UseSuspenseQueryResult<GetStructuresByCountryQuery | undefined, GetStructuresByCountryQueryVariables>;
export function useGetStructuresByCountrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructuresByCountryQuery, GetStructuresByCountryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructuresByCountryQuery, GetStructuresByCountryQueryVariables>(GetStructuresByCountryDocument, options);
        }
export type GetStructuresByCountryQueryHookResult = ReturnType<typeof useGetStructuresByCountryQuery>;
export type GetStructuresByCountryLazyQueryHookResult = ReturnType<typeof useGetStructuresByCountryLazyQuery>;
export type GetStructuresByCountrySuspenseQueryHookResult = ReturnType<typeof useGetStructuresByCountrySuspenseQuery>;
export type GetStructuresByCountryQueryResult = Apollo.QueryResult<GetStructuresByCountryQuery, GetStructuresByCountryQueryVariables>;
export const TasksDocument = gql`
    query tasks($input: TasksQueryInput!) {
  tasks(input: $input) {
    tasks {
      id
      status
      description
      requestReason
      merchantGroupAssignee
      expiresOn
      createdAt
      completedAt
      signal
      values {
        key
        value {
          stringValue
          jsonValue
          numberValue
          boolValue
        }
      }
    }
  }
}
    `;

/**
 * __useTasksQuery__
 *
 * To run a query within a React component, call `useTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTasksQuery(baseOptions: Apollo.QueryHookOptions<TasksQuery, TasksQueryVariables> & ({ variables: TasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options);
      }
export function useTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TasksQuery, TasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options);
        }
// @ts-ignore
export function useTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TasksQuery, TasksQueryVariables>): Apollo.UseSuspenseQueryResult<TasksQuery, TasksQueryVariables>;
export function useTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TasksQuery, TasksQueryVariables>): Apollo.UseSuspenseQueryResult<TasksQuery | undefined, TasksQueryVariables>;
export function useTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TasksQuery, TasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options);
        }
export type TasksQueryHookResult = ReturnType<typeof useTasksQuery>;
export type TasksLazyQueryHookResult = ReturnType<typeof useTasksLazyQuery>;
export type TasksSuspenseQueryHookResult = ReturnType<typeof useTasksSuspenseQuery>;
export type TasksQueryResult = Apollo.QueryResult<TasksQuery, TasksQueryVariables>;
export const TaskDetailsDocument = gql`
    query taskDetails($input: TaskQueryInput!) {
  task(input: $input) {
    id
    title
    createdAt
    status
    description
    requestReason
    expiresOn
    canceledAt
    completedAt
    attachments
    fields {
      id
      externalId
      type
      label
      placeholder
      options {
        label
        value
      }
    }
    actions {
      label
      signal
      style
      validationConfigs {
        key
        errorMessage
        required
        minLength
        maxLength
        pattern
        minValue
        maxValue
      }
    }
    values {
      key
      value {
        stringValue
        jsonValue
        numberValue
        boolValue
      }
    }
  }
}
    `;

/**
 * __useTaskDetailsQuery__
 *
 * To run a query within a React component, call `useTaskDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskDetailsQuery(baseOptions: Apollo.QueryHookOptions<TaskDetailsQuery, TaskDetailsQueryVariables> & ({ variables: TaskDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskDetailsQuery, TaskDetailsQueryVariables>(TaskDetailsDocument, options);
      }
export function useTaskDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskDetailsQuery, TaskDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskDetailsQuery, TaskDetailsQueryVariables>(TaskDetailsDocument, options);
        }
// @ts-ignore
export function useTaskDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskDetailsQuery, TaskDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<TaskDetailsQuery, TaskDetailsQueryVariables>;
export function useTaskDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskDetailsQuery, TaskDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<TaskDetailsQuery | undefined, TaskDetailsQueryVariables>;
export function useTaskDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskDetailsQuery, TaskDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskDetailsQuery, TaskDetailsQueryVariables>(TaskDetailsDocument, options);
        }
export type TaskDetailsQueryHookResult = ReturnType<typeof useTaskDetailsQuery>;
export type TaskDetailsLazyQueryHookResult = ReturnType<typeof useTaskDetailsLazyQuery>;
export type TaskDetailsSuspenseQueryHookResult = ReturnType<typeof useTaskDetailsSuspenseQuery>;
export type TaskDetailsQueryResult = Apollo.QueryResult<TaskDetailsQuery, TaskDetailsQueryVariables>;
export const SubmitTaskDocument = gql`
    mutation submitTask($input: SubmitTask!) {
  submitTask(input: $input) {
    success
  }
}
    `;
export type SubmitTaskMutationFn = Apollo.MutationFunction<SubmitTaskMutation, SubmitTaskMutationVariables>;

/**
 * __useSubmitTaskMutation__
 *
 * To run a mutation, you first call `useSubmitTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitTaskMutation, { data, loading, error }] = useSubmitTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitTaskMutation(baseOptions?: Apollo.MutationHookOptions<SubmitTaskMutation, SubmitTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitTaskMutation, SubmitTaskMutationVariables>(SubmitTaskDocument, options);
      }
export type SubmitTaskMutationHookResult = ReturnType<typeof useSubmitTaskMutation>;
export type SubmitTaskMutationResult = Apollo.MutationResult<SubmitTaskMutation>;
export type SubmitTaskMutationOptions = Apollo.BaseMutationOptions<SubmitTaskMutation, SubmitTaskMutationVariables>;